/* *****
This is an autogenerated, concatenated file. It is referenced by the theme by default, and you can make small edits to it directly if necessary.
 */
!function (e, t) { "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.AOS = t() : e.AOS = t() }(this, function () { return function (e) { function t(o) { if (n[o]) return n[o].exports; var i = n[o] = { exports: {}, id: o, loaded: !1 }; return e[o].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports } var n = {}; return t.m = e, t.c = n, t.p = "dist/", t(0) }([function (e, t, n) { "use strict"; function o(e) { return e && e.__esModule ? e : { default: e } } var i = Object.assign || function (e) { for (var t = 1; t < arguments.length; t++) { var n = arguments[t]; for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]) } return e }, r = n(1), a = (o(r), n(6)), u = o(a), c = n(7), s = o(c), f = n(8), d = o(f), l = n(9), p = o(l), m = n(10), b = o(m), v = n(11), y = o(v), g = n(14), h = o(g), w = [], k = !1, x = { offset: 120, delay: 0, easing: "ease", duration: 400, disable: !1, once: !1, startEvent: "DOMContentLoaded", throttleDelay: 99, debounceDelay: 50, disableMutationObserver: !1 }, j = function () { var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0]; if (e && (k = !0), k) return w = (0, y.default)(w, x), (0, b.default)(w, x.once), w }, O = function () { w = (0, h.default)(), j() }, M = function () { w.forEach(function (e, t) { e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay") }) }, S = function (e) { return e === !0 || "mobile" === e && p.default.mobile() || "phone" === e && p.default.phone() || "tablet" === e && p.default.tablet() || "function" == typeof e && e() === !0 }, _ = function (e) { x = i(x, e), w = (0, h.default)(); var t = document.all && !window.atob; return S(x.disable) || t ? M() : (x.disableMutationObserver || d.default.isSupported() || (console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '), x.disableMutationObserver = !0), document.querySelector("body").setAttribute("data-aos-easing", x.easing), document.querySelector("body").setAttribute("data-aos-duration", x.duration), document.querySelector("body").setAttribute("data-aos-delay", x.delay), "DOMContentLoaded" === x.startEvent && ["complete", "interactive"].indexOf(document.readyState) > -1 ? j(!0) : "load" === x.startEvent ? window.addEventListener(x.startEvent, function () { j(!0) }) : document.addEventListener(x.startEvent, function () { j(!0) }), window.addEventListener("resize", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("orientationchange", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("scroll", (0, u.default)(function () { (0, b.default)(w, x.once) }, x.throttleDelay)), x.disableMutationObserver || d.default.ready("[data-aos]", O), w) }; e.exports = { init: _, refresh: j, refreshHard: O } }, function (e, t) { }, , , , , function (e, t) { (function (t) { "use strict"; function n(e, t, n) { function o(t) { var n = b, o = v; return b = v = void 0, k = t, g = e.apply(o, n) } function r(e) { return k = e, h = setTimeout(f, t), M ? o(e) : g } function a(e) { var n = e - w, o = e - k, i = t - n; return S ? j(i, y - o) : i } function c(e) { var n = e - w, o = e - k; return void 0 === w || n >= t || n < 0 || S && o >= y } function f() { var e = O(); return c(e) ? d(e) : void (h = setTimeout(f, a(e))) } function d(e) { return h = void 0, _ && b ? o(e) : (b = v = void 0, g) } function l() { void 0 !== h && clearTimeout(h), k = 0, b = w = v = h = void 0 } function p() { return void 0 === h ? g : d(O()) } function m() { var e = O(), n = c(e); if (b = arguments, v = this, w = e, n) { if (void 0 === h) return r(w); if (S) return h = setTimeout(f, t), o(w) } return void 0 === h && (h = setTimeout(f, t)), g } var b, v, y, g, h, w, k = 0, M = !1, S = !1, _ = !0; if ("function" != typeof e) throw new TypeError(s); return t = u(t) || 0, i(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? x(u(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m } function o(e, t, o) { var r = !0, a = !0; if ("function" != typeof e) throw new TypeError(s); return i(o) && (r = "leading" in o ? !!o.leading : r, a = "trailing" in o ? !!o.trailing : a), n(e, t, { leading: r, maxWait: t, trailing: a }) } function i(e) { var t = "undefined" == typeof e ? "undefined" : c(e); return !!e && ("object" == t || "function" == t) } function r(e) { return !!e && "object" == ("undefined" == typeof e ? "undefined" : c(e)) } function a(e) { return "symbol" == ("undefined" == typeof e ? "undefined" : c(e)) || r(e) && k.call(e) == d } function u(e) { if ("number" == typeof e) return e; if (a(e)) return f; if (i(e)) { var t = "function" == typeof e.valueOf ? e.valueOf() : e; e = i(t) ? t + "" : t } if ("string" != typeof e) return 0 === e ? e : +e; e = e.replace(l, ""); var n = m.test(e); return n || b.test(e) ? v(e.slice(2), n ? 2 : 8) : p.test(e) ? f : +e } var c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) { return typeof e } : function (e) { return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e }, s = "Expected a function", f = NaN, d = "[object Symbol]", l = /^\s+|\s+$/g, p = /^[-+]0x[0-9a-f]+$/i, m = /^0b[01]+$/i, b = /^0o[0-7]+$/i, v = parseInt, y = "object" == ("undefined" == typeof t ? "undefined" : c(t)) && t && t.Object === Object && t, g = "object" == ("undefined" == typeof self ? "undefined" : c(self)) && self && self.Object === Object && self, h = y || g || Function("return this")(), w = Object.prototype, k = w.toString, x = Math.max, j = Math.min, O = function () { return h.Date.now() }; e.exports = o }).call(t, function () { return this }()) }, function (e, t) { (function (t) { "use strict"; function n(e, t, n) { function i(t) { var n = b, o = v; return b = v = void 0, O = t, g = e.apply(o, n) } function r(e) { return O = e, h = setTimeout(f, t), M ? i(e) : g } function u(e) { var n = e - w, o = e - O, i = t - n; return S ? x(i, y - o) : i } function s(e) { var n = e - w, o = e - O; return void 0 === w || n >= t || n < 0 || S && o >= y } function f() { var e = j(); return s(e) ? d(e) : void (h = setTimeout(f, u(e))) } function d(e) { return h = void 0, _ && b ? i(e) : (b = v = void 0, g) } function l() { void 0 !== h && clearTimeout(h), O = 0, b = w = v = h = void 0 } function p() { return void 0 === h ? g : d(j()) } function m() { var e = j(), n = s(e); if (b = arguments, v = this, w = e, n) { if (void 0 === h) return r(w); if (S) return h = setTimeout(f, t), i(w) } return void 0 === h && (h = setTimeout(f, t)), g } var b, v, y, g, h, w, O = 0, M = !1, S = !1, _ = !0; if ("function" != typeof e) throw new TypeError(c); return t = a(t) || 0, o(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? k(a(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m } function o(e) { var t = "undefined" == typeof e ? "undefined" : u(e); return !!e && ("object" == t || "function" == t) } function i(e) { return !!e && "object" == ("undefined" == typeof e ? "undefined" : u(e)) } function r(e) { return "symbol" == ("undefined" == typeof e ? "undefined" : u(e)) || i(e) && w.call(e) == f } function a(e) { if ("number" == typeof e) return e; if (r(e)) return s; if (o(e)) { var t = "function" == typeof e.valueOf ? e.valueOf() : e; e = o(t) ? t + "" : t } if ("string" != typeof e) return 0 === e ? e : +e; e = e.replace(d, ""); var n = p.test(e); return n || m.test(e) ? b(e.slice(2), n ? 2 : 8) : l.test(e) ? s : +e } var u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) { return typeof e } : function (e) { return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e }, c = "Expected a function", s = NaN, f = "[object Symbol]", d = /^\s+|\s+$/g, l = /^[-+]0x[0-9a-f]+$/i, p = /^0b[01]+$/i, m = /^0o[0-7]+$/i, b = parseInt, v = "object" == ("undefined" == typeof t ? "undefined" : u(t)) && t && t.Object === Object && t, y = "object" == ("undefined" == typeof self ? "undefined" : u(self)) && self && self.Object === Object && self, g = v || y || Function("return this")(), h = Object.prototype, w = h.toString, k = Math.max, x = Math.min, j = function () { return g.Date.now() }; e.exports = n }).call(t, function () { return this }()) }, function (e, t) { "use strict"; function n(e) { var t = void 0, o = void 0, i = void 0; for (t = 0; t < e.length; t += 1) { if (o = e[t], o.dataset && o.dataset.aos) return !0; if (i = o.children && n(o.children)) return !0 } return !1 } function o() { return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver } function i() { return !!o() } function r(e, t) { var n = window.document, i = o(), r = new i(a); u = t, r.observe(n.documentElement, { childList: !0, subtree: !0, removedNodes: !0 }) } function a(e) { e && e.forEach(function (e) { var t = Array.prototype.slice.call(e.addedNodes), o = Array.prototype.slice.call(e.removedNodes), i = t.concat(o); if (n(i)) return u() }) } Object.defineProperty(t, "__esModule", { value: !0 }); var u = function () { }; t.default = { isSupported: i, ready: r } }, function (e, t) { "use strict"; function n(e, t) { if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function") } function o() { return navigator.userAgent || navigator.vendor || window.opera || "" } Object.defineProperty(t, "__esModule", { value: !0 }); var i = function () { function e(e, t) { for (var n = 0; n < t.length; n++) { var o = t[n]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o) } } return function (t, n, o) { return n && e(t.prototype, n), o && e(t, o), t } }(), r = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i, a = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i, u = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i, c = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i, s = function () { function e() { n(this, e) } return i(e, [{ key: "phone", value: function () { var e = o(); return !(!r.test(e) && !a.test(e.substr(0, 4))) } }, { key: "mobile", value: function () { var e = o(); return !(!u.test(e) && !c.test(e.substr(0, 4))) } }, { key: "tablet", value: function () { return this.mobile() && !this.phone() } }]), e }(); t.default = new s }, function (e, t) { "use strict"; Object.defineProperty(t, "__esModule", { value: !0 }); var n = function (e, t, n) { var o = e.node.getAttribute("data-aos-once"); t > e.position ? e.node.classList.add("aos-animate") : "undefined" != typeof o && ("false" === o || !n && "true" !== o) && e.node.classList.remove("aos-animate") }, o = function (e, t) { var o = window.pageYOffset, i = window.innerHeight; e.forEach(function (e, r) { n(e, i + o, t) }) }; t.default = o }, function (e, t, n) { "use strict"; function o(e) { return e && e.__esModule ? e : { default: e } } Object.defineProperty(t, "__esModule", { value: !0 }); var i = n(12), r = o(i), a = function (e, t) { return e.forEach(function (e, n) { e.node.classList.add("aos-init"), e.position = (0, r.default)(e.node, t.offset) }), e }; t.default = a }, function (e, t, n) { "use strict"; function o(e) { return e && e.__esModule ? e : { default: e } } Object.defineProperty(t, "__esModule", { value: !0 }); var i = n(13), r = o(i), a = function (e, t) { var n = 0, o = 0, i = window.innerHeight, a = { offset: e.getAttribute("data-aos-offset"), anchor: e.getAttribute("data-aos-anchor"), anchorPlacement: e.getAttribute("data-aos-anchor-placement") }; switch (a.offset && !isNaN(a.offset) && (o = parseInt(a.offset)), a.anchor && document.querySelectorAll(a.anchor) && (e = document.querySelectorAll(a.anchor)[0]), n = (0, r.default)(e).top, a.anchorPlacement) { case "top-bottom": break; case "center-bottom": n += e.offsetHeight / 2; break; case "bottom-bottom": n += e.offsetHeight; break; case "top-center": n += i / 2; break; case "bottom-center": n += i / 2 + e.offsetHeight; break; case "center-center": n += i / 2 + e.offsetHeight / 2; break; case "top-top": n += i; break; case "bottom-top": n += e.offsetHeight + i; break; case "center-top": n += e.offsetHeight / 2 + i }return a.anchorPlacement || a.offset || isNaN(t) || (o = t), n + o }; t.default = a }, function (e, t) { "use strict"; Object.defineProperty(t, "__esModule", { value: !0 }); var n = function (e) { for (var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);)t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0), n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0), e = e.offsetParent; return { top: n, left: t } }; t.default = n }, function (e, t) { "use strict"; Object.defineProperty(t, "__esModule", { value: !0 }); var n = function (e) { return e = e || document.querySelectorAll("[data-aos]"), Array.prototype.map.call(e, function (e) { return { node: e } }) }; t.default = n }]) });
/*!
* FitVids 1.1
*
* Copyright 2013, Chris Coyier - http://css-tricks.com + Dave Rupert - http://daverupert.com
* Credit to Thierry Koblentz - http://www.alistapart.com/articles/creating-intrinsic-ratios-for-video/
* Released under the WTFPL license - http://sam.zoy.org/wtfpl/
*
*/
(function (a) { a.fn.fitVids = function (b) { var e = { customSelector: null, ignore: null }; if (!document.getElementById("fit-vids-style")) { var d = document.head || document.getElementsByTagName("head")[0]; var c = ".fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}"; var f = document.createElement("div"); f.innerHTML = '<p>x</p><style id="fit-vids-style">' + c + "</style>"; d.appendChild(f.childNodes[1]) } if (b) { a.extend(e, b) } return this.each(function () { var g = ['iframe[src*="player.vimeo.com"]', 'iframe[src*="youtube.com"]', 'iframe[src*="youtube-nocookie.com"]', 'iframe[src*="kickstarter.com"][src*="video.html"]', "object", "embed"]; if (e.customSelector) { g.push(e.customSelector) } var h = ".fitvidsignore"; if (e.ignore) { h = h + ", " + e.ignore } var i = a(this).find(g.join(",")); i = i.not("object object"); i = i.not(h); i.each(function () { var n = a(this); if (n.parents(h).length > 0) { return } if (this.tagName.toLowerCase() === "embed" && n.parent("object").length || n.parent(".fluid-width-video-wrapper").length) { return } if ((!n.css("height") && !n.css("width")) && (isNaN(n.attr("height")) || isNaN(n.attr("width")))) { n.attr("height", 9); n.attr("width", 16) } var j = (this.tagName.toLowerCase() === "object" || (n.attr("height") && !isNaN(parseInt(n.attr("height"), 10)))) ? parseInt(n.attr("height"), 10) : n.height(), k = !isNaN(parseInt(n.attr("width"), 10)) ? parseInt(n.attr("width"), 10) : n.width(), l = j / k; if (!n.attr("id")) { var m = "fitvid" + Math.floor(Math.random() * 999999); n.attr("id", m) } n.wrap('<div class="fluid-width-video-wrapper"></div>').parent(".fluid-width-video-wrapper").css("padding-top", (l * 100) + "%"); n.removeAttr("height").removeAttr("width") }) }) } })(window.jQuery || window.Zepto);

/*!
 * imagesLoaded PACKAGED v3.1.8
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

(function () { function e() { } function t(e, t) { for (var n = e.length; n--;)if (e[n].listener === t) return n; return -1 } function n(e) { return function () { return this[e].apply(this, arguments) } } var i = e.prototype, r = this, o = r.EventEmitter; i.getListeners = function (e) { var t, n, i = this._getEvents(); if ("object" == typeof e) { t = {}; for (n in i) i.hasOwnProperty(n) && e.test(n) && (t[n] = i[n]) } else t = i[e] || (i[e] = []); return t }, i.flattenListeners = function (e) { var t, n = []; for (t = 0; e.length > t; t += 1)n.push(e[t].listener); return n }, i.getListenersAsObject = function (e) { var t, n = this.getListeners(e); return n instanceof Array && (t = {}, t[e] = n), t || n }, i.addListener = function (e, n) { var i, r = this.getListenersAsObject(e), o = "object" == typeof n; for (i in r) r.hasOwnProperty(i) && -1 === t(r[i], n) && r[i].push(o ? n : { listener: n, once: !1 }); return this }, i.on = n("addListener"), i.addOnceListener = function (e, t) { return this.addListener(e, { listener: t, once: !0 }) }, i.once = n("addOnceListener"), i.defineEvent = function (e) { return this.getListeners(e), this }, i.defineEvents = function (e) { for (var t = 0; e.length > t; t += 1)this.defineEvent(e[t]); return this }, i.removeListener = function (e, n) { var i, r, o = this.getListenersAsObject(e); for (r in o) o.hasOwnProperty(r) && (i = t(o[r], n), -1 !== i && o[r].splice(i, 1)); return this }, i.off = n("removeListener"), i.addListeners = function (e, t) { return this.manipulateListeners(!1, e, t) }, i.removeListeners = function (e, t) { return this.manipulateListeners(!0, e, t) }, i.manipulateListeners = function (e, t, n) { var i, r, o = e ? this.removeListener : this.addListener, s = e ? this.removeListeners : this.addListeners; if ("object" != typeof t || t instanceof RegExp) for (i = n.length; i--;)o.call(this, t, n[i]); else for (i in t) t.hasOwnProperty(i) && (r = t[i]) && ("function" == typeof r ? o.call(this, i, r) : s.call(this, i, r)); return this }, i.removeEvent = function (e) { var t, n = typeof e, i = this._getEvents(); if ("string" === n) delete i[e]; else if ("object" === n) for (t in i) i.hasOwnProperty(t) && e.test(t) && delete i[t]; else delete this._events; return this }, i.removeAllListeners = n("removeEvent"), i.emitEvent = function (e, t) { var n, i, r, o, s = this.getListenersAsObject(e); for (r in s) if (s.hasOwnProperty(r)) for (i = s[r].length; i--;)n = s[r][i], n.once === !0 && this.removeListener(e, n.listener), o = n.listener.apply(this, t || []), o === this._getOnceReturnValue() && this.removeListener(e, n.listener); return this }, i.trigger = n("emitEvent"), i.emit = function (e) { var t = Array.prototype.slice.call(arguments, 1); return this.emitEvent(e, t) }, i.setOnceReturnValue = function (e) { return this._onceReturnValue = e, this }, i._getOnceReturnValue = function () { return this.hasOwnProperty("_onceReturnValue") ? this._onceReturnValue : !0 }, i._getEvents = function () { return this._events || (this._events = {}) }, e.noConflict = function () { return r.EventEmitter = o, e }, "function" == typeof define && define.amd ? define("eventEmitter/EventEmitter", [], function () { return e }) : "object" == typeof module && module.exports ? module.exports = e : this.EventEmitter = e }).call(this), function (e) { function t(t) { var n = e.event; return n.target = n.target || n.srcElement || t, n } var n = document.documentElement, i = function () { }; n.addEventListener ? i = function (e, t, n) { e.addEventListener(t, n, !1) } : n.attachEvent && (i = function (e, n, i) { e[n + i] = i.handleEvent ? function () { var n = t(e); i.handleEvent.call(i, n) } : function () { var n = t(e); i.call(e, n) }, e.attachEvent("on" + n, e[n + i]) }); var r = function () { }; n.removeEventListener ? r = function (e, t, n) { e.removeEventListener(t, n, !1) } : n.detachEvent && (r = function (e, t, n) { e.detachEvent("on" + t, e[t + n]); try { delete e[t + n] } catch (i) { e[t + n] = void 0 } }); var o = { bind: i, unbind: r }; "function" == typeof define && define.amd ? define("eventie/eventie", o) : e.eventie = o }(this), function (e, t) { "function" == typeof define && define.amd ? define(["eventEmitter/EventEmitter", "eventie/eventie"], function (n, i) { return t(e, n, i) }) : "object" == typeof exports ? module.exports = t(e, require("wolfy87-eventemitter"), require("eventie")) : e.imagesLoaded = t(e, e.EventEmitter, e.eventie) }(window, function (e, t, n) { function i(e, t) { for (var n in t) e[n] = t[n]; return e } function r(e) { return "[object Array]" === d.call(e) } function o(e) { var t = []; if (r(e)) t = e; else if ("number" == typeof e.length) for (var n = 0, i = e.length; i > n; n++)t.push(e[n]); else t.push(e); return t } function s(e, t, n) { if (!(this instanceof s)) return new s(e, t); "string" == typeof e && (e = document.querySelectorAll(e)), this.elements = o(e), this.options = i({}, this.options), "function" == typeof t ? n = t : i(this.options, t), n && this.on("always", n), this.getImages(), a && (this.jqDeferred = new a.Deferred); var r = this; setTimeout(function () { r.check() }) } function f(e) { this.img = e } function c(e) { this.src = e, v[e] = this } var a = e.jQuery, u = e.console, h = u !== void 0, d = Object.prototype.toString; s.prototype = new t, s.prototype.options = {}, s.prototype.getImages = function () { this.images = []; for (var e = 0, t = this.elements.length; t > e; e++) { var n = this.elements[e]; "IMG" === n.nodeName && this.addImage(n); var i = n.nodeType; if (i && (1 === i || 9 === i || 11 === i)) for (var r = n.querySelectorAll("img"), o = 0, s = r.length; s > o; o++) { var f = r[o]; this.addImage(f) } } }, s.prototype.addImage = function (e) { var t = new f(e); this.images.push(t) }, s.prototype.check = function () { function e(e, r) { return t.options.debug && h && u.log("confirm", e, r), t.progress(e), n++, n === i && t.complete(), !0 } var t = this, n = 0, i = this.images.length; if (this.hasAnyBroken = !1, !i) return this.complete(), void 0; for (var r = 0; i > r; r++) { var o = this.images[r]; o.on("confirm", e), o.check() } }, s.prototype.progress = function (e) { this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded; var t = this; setTimeout(function () { t.emit("progress", t, e), t.jqDeferred && t.jqDeferred.notify && t.jqDeferred.notify(t, e) }) }, s.prototype.complete = function () { var e = this.hasAnyBroken ? "fail" : "done"; this.isComplete = !0; var t = this; setTimeout(function () { if (t.emit(e, t), t.emit("always", t), t.jqDeferred) { var n = t.hasAnyBroken ? "reject" : "resolve"; t.jqDeferred[n](t) } }) }, a && (a.fn.imagesLoaded = function (e, t) { var n = new s(this, e, t); return n.jqDeferred.promise(a(this)) }), f.prototype = new t, f.prototype.check = function () { var e = v[this.img.src] || new c(this.img.src); if (e.isConfirmed) return this.confirm(e.isLoaded, "cached was confirmed"), void 0; if (this.img.complete && void 0 !== this.img.naturalWidth) return this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), void 0; var t = this; e.on("confirm", function (e, n) { return t.confirm(e.isLoaded, n), !0 }), e.check() }, f.prototype.confirm = function (e, t) { this.isLoaded = e, this.emit("confirm", this, t) }; var v = {}; return c.prototype = new t, c.prototype.check = function () { if (!this.isChecked) { var e = new Image; n.bind(e, "load", this), n.bind(e, "error", this), e.src = this.src, this.isChecked = !0 } }, c.prototype.handleEvent = function (e) { var t = "on" + e.type; this[t] && this[t](e) }, c.prototype.onload = function (e) { this.confirm(!0, "onload"), this.unbindProxyEvents(e) }, c.prototype.onerror = function (e) { this.confirm(!1, "onerror"), this.unbindProxyEvents(e) }, c.prototype.confirm = function (e, t) { this.isConfirmed = !0, this.isLoaded = e, this.emit("confirm", this, t) }, c.prototype.unbindProxyEvents = function (e) { n.unbind(e.target, "load", this), n.unbind(e.target, "error", this) }, s });

/**
 * Module to add a shipping rates calculator to cart page.
 *
 * Copyright (c) 2011-2012 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

if (typeof Countries === "object") { Countries.updateProvinceLabel = function (d, a) { if (typeof d === "string" && Countries[d] && Countries[d].provinces) { if (typeof a !== "object") { a = document.getElementById("address_province_label"); if (a === null) { return } } a.innerHTML = Countries[d].label; var c = $(a).parent(); var b = c.find("select"); c.find(".custom-style-select-box-inner").html(Countries[d].provinces[0]) } } } if (typeof Shopify.Cart === "undefined") { Shopify.Cart = {} } Shopify.Cart.ShippingCalculator = (function () { var _config = { submitButton: "Calculate shipping", submitButtonDisabled: "Calculating...", templateId: "shipping-calculator-response-template", wrapperId: "wrapper-response", customerIsLoggedIn: false, moneyFormat: "$ {{amount}}" }; var _render = function (response) { var template = jQuery("#" + _config.templateId); var wrapper = jQuery("#" + _config.wrapperId); if (template.length && wrapper.length) { template.tmpl(response).appendTo(wrapper); if (typeof Currency !== "undefined" && typeof Currency.convertAll === "function") { var newCurrency = ""; if (jQuery("[name=currencies]").size()) { newCurrency = jQuery("[name=currencies]").val() } else { if (jQuery("#currencies span.selected").size()) { newCurrency = jQuery("#currencies span.selected").attr("data-currency") } } if (newCurrency !== "") { Currency.convertAll(shopCurrency, newCurrency, "#wrapper-response span.money, #estimated-shipping em span.money") } } } }; var _enableButtons = function () { }; var _disableButtons = function () { }; var _getCartShippingRatesForDestination = function (shipping_address) { var params = { type: "GET", url: "/cart/shipping_rates.json", data: jQuery.param({ shipping_address: shipping_address }), dataType: "json", success: function (response) { rates = response.shipping_rates; _onCartShippingRatesUpdate(rates, shipping_address) }, error: function (XMLHttpRequest, textStatus) { _onError(XMLHttpRequest, textStatus) } }; jQuery.ajax(params) }; var _fullMessagesFromErrors = function (errors) { var fullMessages = []; jQuery.each(errors, function (attribute, messages) { jQuery.each(messages, function (index, message) { fullMessages.push(attribute + " " + message) }) }); return fullMessages }; var _onError = function (XMLHttpRequest, textStatus) { jQuery("#estimated-shipping").hide(); jQuery("#estimated-shipping em").empty(); _enableButtons(); var feedback = ""; var data = eval("(" + XMLHttpRequest.responseText + ")"); if (!!data.message) { feedback = data.message + "(" + data.status + "): " + data.description } else { feedback = "Error : " + _fullMessagesFromErrors(data).join("; ") } if (feedback === "Error : country is not supported.") { feedback = "We do not ship to this destination." } _render({ rates: [], errorFeedback: feedback, success: false }); jQuery("#" + _config.wrapperId).show() }; var _onCartShippingRatesUpdate = function (rates, shipping_address) { _enableButtons(); var readable_address = ""; if (shipping_address.zip) { readable_address += shipping_address.zip + ", " } if (shipping_address.province) { readable_address += shipping_address.province + ", " } readable_address += shipping_address.country; if (rates.length) { if (rates[0].price == "0.00") { jQuery("#estimated-shipping em").html("FREE") } else { jQuery("#estimated-shipping em").html(_formatRate(rates[0].price)) } } _render({ rates: rates, address: readable_address, success: true }); jQuery("#" + _config.wrapperId + ", #estimated-shipping").fadeIn() }; var _formatRate = function (cents) { if (typeof cents == "string") { cents = cents.replace(".", "") } var value = ""; var patt = /\{\{\s*(\w+)\s*\}\}/; var formatString = _config.moneyFormat; function addCommas(moneyString) { return moneyString.replace(/(\d+)(\d{3}[\.,]?)/, "$1,$2") } function floatToString(numeric, decimals) { var amount = numeric.toFixed(decimals).toString(); if (amount.match(/^\.\d+/)) { return "0" + amount } else { return amount } } switch (formatString.match(patt)[1]) { case "amount": value = addCommas(floatToString(cents / 100, 2)); break; case "amount_no_decimals": value = addCommas(floatToString(cents / 100, 0)); break; case "amount_with_comma_separator": value = floatToString(cents / 100, 2).replace(/\./, ","); break; case "amount_no_decimals_with_comma_separator": value = addCommas(floatToString(cents / 100, 0)).replace(/\./, ","); break }return formatString.replace(patt, value) }; _init = function () { new Shopify.CountryProvinceSelector("address_country", "address_province", { hideElement: "address_province_container" }); var countriesSelect = jQuery("#address_country"); var addressProvinceLabelEl = jQuery("#address_province_label").get(0); if (typeof Countries !== "undefined") { Countries.updateProvinceLabel(countriesSelect.val(), addressProvinceLabelEl); countriesSelect.change(function () { Countries.updateProvinceLabel(countriesSelect.val(), addressProvinceLabelEl) }) } jQuery(".get-rates").click(function () { _disableButtons(); jQuery("#" + _config.wrapperId).empty().hide(); var shippingAddress = {}; shippingAddress.zip = jQuery("#address_zip").val() || ""; shippingAddress.country = jQuery("#address_country").val() || ""; shippingAddress.province = jQuery("#address_province").val() || ""; _getCartShippingRatesForDestination(shippingAddress) }); }; return { show: function (params) { params = params || {}; jQuery.extend(_config, params); jQuery(function () { _init() }) }, getConfig: function () { return _config }, formatRate: function (cents) { return _formatRate(cents) } } })();
/*!
 * Revealer 2.0.0
 *
 * Copyright 2015, Pixel Union - http://pixelunion.net
 * Released under the MIT license
 */
(function ($) {
  // Simple requestAnimationFrame polyfill
  var raf = window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    function (fn) { window.setTimeout(fn, 1000 / 60); }


  // Public API
  var methods = {
    isVisible: function (el) {
      return !!el.data("revealer-visible");
    },

    show: function (el, force) {
      // Check state
      if (methods.isVisible(el)) {
        el.removeClass("animating animating-in");
        el.off("revealer-animating revealer-show");
        return;
      }

      // Remove previous event listeners
      el.data("revealer-visible", true);
      el.off("trend");

      if (force) {
        el.addClass("visible");
        el.trigger("revealer-show");
        return;
      }

      raf(function () {
        // Start animation state transition
        el.addClass("animating animating-in");
        el.trigger("revealer-animating");

        raf(function () {
          el.addClass("visible");

          el.one("trend", function () {
            el.removeClass("animating animating-in");
            el.trigger("revealer-show");
          });
        });
      });
    },

    hide: function (el, force) {
      // Check state
      if (!methods.isVisible(el)) {
        el.removeClass("animating animating-out visible");
        el.off("revealer-animating revealer-hide");
        return;
      }

      // Remove previous event listeners
      el.data("revealer-visible", false);
      el.off("trend");

      if (force) {
        el.removeClass("visible");
        el.trigger("revealer-hide");
        return;
      }

      raf(function () {
        el.addClass("animating animating-out");
        el.trigger("revealer-animating");

        raf(function () {
          el.removeClass("visible");

          el.one("trend", function () {
            el.removeClass("animating animating-in animating-out");
            el.trigger("revealer-hide");
          });
        });
      });
    },

    toggle: function (el, force) {
      if (methods.isVisible(el)) {
        methods.hide(el, force);
      } else {
        methods.show(el, force);
      }
    }
  };

  // jQuery plugin
  $.fn.revealer = function (method, force) {
    // Get action
    var action = methods[method || "toggle"];
    if (!action) return this;

    // Run action
    if (method === "isVisible") {
      return action(this);
    }

    return this.each(function () {
      action($(this), force);
    });
  };
})(jQuery);

/*!
 * Trend 0.2.0
 *
 * Fail-safe TransitionEnd event for jQuery.
 *
 * Adds a new "trend" event that can be used in browsers that don't
 * support "transitionend".
 *
 * NOTE: Only supports being bound with "jQuery.one".
 *
 * Copyright 2014, Pixel Union - http://pixelunion.net
 * Released under the MIT license
 */
; (function ($) {

  // Prefixed transitionend event names
  var transitionEndEvents =
    "webkitTransitionEnd " +
    "otransitionend " +
    "oTransitionEnd " +
    "msTransitionEnd " +
    "transitionend";

  // Prefixed transition duration property names
  var transitionDurationProperties = [
    "transition-duration",
    "-moz-transition-duration",
    "-webkit-transition-duration",
    "-ms-transition-duration",
    "-o-transition-duration",
    "-khtml-transition-duration"
  ];

  // Prefixed transition delay property names
  var transitionDelayProperties = [
    "transition-delay",
    "-moz-transition-delay",
    "-webkit-transition-delay",
    "-ms-transition-delay",
    "-o-transition-delay",
    "-khtml-transition-delay"
  ];

  // Parses a CSS time value into milliseconds.
  var parseTime = function (s) {
    s = s.replace(/\s/, "");
    var v = window.parseFloat(s);

    return s.match(/[^m]s$/i)
      ? v * 1000
      : v;
  };

  // Parses the longest time unit found in a series of CSS properties.
  // Returns a value in milliseconds.
  var parseProperties = function (el, properties) {
    var duration = 0;

    for (var i = 0; i < properties.length; i++) {
      // Get raw CSS value
      var value = el.css(properties[i]);
      if (!value) continue;

      // Multiple transitions--pick the longest
      if (value.indexOf(",") !== -1) {
        var values = value.split(",");
        var durations = (function () {
          var results = [];
          for (var i = 0; i < values.length; i++) {
            var duration = parseTime(values[i]);
            results.push(duration);
          }
          return results;
        })();

        duration = Math.max.apply(Math, durations);
      }

      // Single transition
      else {
        duration = parseTime(value);
      }

      // Accept first vaue
      break;
    }

    return duration;
  };

  $.event.special.trend = {
    // Triggers an event handler when an element is done transitioning.
    //
    // Handles browsers that don't support transitionend by adding a
    // timeout with the transition duration.
    add: function (handleObj) {
      var el = $(this);
      var fired = false;

      // Mark element as being in transition
      el.data("trend", true);

      // Calculate a fallback duration. + 20 because some browsers fire
      // timeouts faster than transitionend.
      var time =
        parseProperties(el, transitionDurationProperties) +
        parseProperties(el, transitionDelayProperties) +
        20;

      var cb = function (e) {
        // transitionend events can be sent for each property. Let's just
        // skip all but the first. Also handles the timeout callback.
        if (fired) return;

        // Child elements that also have transitions can be fired before we
        // complete. This will catch and ignore those. Unfortunately, we'll
        // have to rely on the timeout in these cases.
        if (e && e.srcElement !== el[0]) return;

        // Mark element has not being in transition
        el.data("trend", false);

        // Callback
        fired = true;
        if (handleObj.handler) handleObj.handler();
      };

      el.one(transitionEndEvents, cb);
      el.data("trend-timeout", window.setTimeout(cb, time));
    },

    remove: function (handleObj) {
      var el = $(this);
      el.off(transitionEndEvents);
      window.clearTimeout(el.data("trend-timeout"));
    }
  };

})(jQuery);
/**
 * Executes a function (fn)  if all lazySizes images are loaded and trigger an event called `containerlazyloaded`
 *
 * @param [fn] {function}
 * @return {jQuery}
 *
 * @example
 *
 *   $('.scroll-view').allLazyLoaded(function(){
 *    console.log(this)
 *  });
 * @example
 *
 *   $('.scroll-view').allLazyLoaded().on('containerlazyloaded', function(){
 *    console.log(this)
 *  });
 */
jQuery.fn.allLazyLoaded = function (fn) {
  if (this.length) {
    var loadingClass = '.' + lazySizes.cfg.loadingClass;
    var toLoadClass = '.' + lazySizes.cfg.lazyClass;
    var isComplete = function () {
      return !('complete' in this) || this.complete;
    };

    this.each(function () {
      var container = this;
      var testLoad = function () {
        if (!$(toLoadClass, container).length && !$(loadingClass, container).not(isComplete).length) {
          container.removeEventListener('load', rAFedTestLoad, true);
          if (fn) {
            fn.call(container, container);
          }
          $(container).trigger('containerlazyloaded');
        }
      };
      var rAFedTestLoad = function () {
        requestAnimationFrame(testLoad);
      };

      container.addEventListener('load', rAFedTestLoad, true);
      rAFedTestLoad();
    });
  }
  return this;
};
/*! lazysizes (bgset) - v4.0.1 */
(function (window, factory) {
  var globalInstall = function () {
    factory(window.lazySizes);
    window.removeEventListener('lazyunveilread', globalInstall, true);
  };

  factory = factory.bind(null, window, window.document);

  if (typeof module == 'object' && module.exports) {
    factory(require('lazysizes'));
  } else if (window.lazySizes) {
    globalInstall();
  } else {
    window.addEventListener('lazyunveilread', globalInstall, true);
  }
}(window, function (window, document, lazySizes) {
  'use strict';
  if (!window.addEventListener) { return; }

  var regWhite = /\s+/g;
  var regSplitSet = /\s*\|\s+|\s+\|\s*/g;
  var regSource = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/;
  var regType = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/;
  var regBgUrlEscape = /\(|\)|'/;
  var allowedBackgroundSize = { contain: 1, cover: 1 };
  var proxyWidth = function (elem) {
    var width = lazySizes.gW(elem, elem.parentNode);

    if (!elem._lazysizesWidth || width > elem._lazysizesWidth) {
      elem._lazysizesWidth = width;
    }
    return elem._lazysizesWidth;
  };
  var getBgSize = function (elem) {
    var bgSize;

    bgSize = (getComputedStyle(elem) || { getPropertyValue: function () { } }).getPropertyValue('background-size');

    if (!allowedBackgroundSize[bgSize] && allowedBackgroundSize[elem.style.backgroundSize]) {
      bgSize = elem.style.backgroundSize;
    }

    return bgSize;
  };
  var setTypeOrMedia = function (source, match) {
    if (match) {
      var typeMatch = match.match(regType);
      if (typeMatch && typeMatch[1]) {
        source.setAttribute('type', typeMatch[1]);
      } else {
        source.setAttribute('media', lazySizesConfig.customMedia[match] || match);
      }
    }
  };
  var createPicture = function (sets, elem, img) {
    var picture = document.createElement('picture');
    var sizes = elem.getAttribute(lazySizesConfig.sizesAttr);
    var ratio = elem.getAttribute('data-ratio');
    var optimumx = elem.getAttribute('data-optimumx');

    if (elem._lazybgset && elem._lazybgset.parentNode == elem) {
      elem.removeChild(elem._lazybgset);
    }

    Object.defineProperty(img, '_lazybgset', {
      value: elem,
      writable: true
    });
    Object.defineProperty(elem, '_lazybgset', {
      value: picture,
      writable: true
    });

    sets = sets.replace(regWhite, ' ').split(regSplitSet);

    picture.style.display = 'none';
    img.className = lazySizesConfig.lazyClass;

    if (sets.length == 1 && !sizes) {
      sizes = 'auto';
    }

    sets.forEach(function (set) {
      var match;
      var source = document.createElement('source');

      if (sizes && sizes != 'auto') {
        source.setAttribute('sizes', sizes);
      }

      if ((match = set.match(regSource))) {
        source.setAttribute(lazySizesConfig.srcsetAttr, match[1]);

        setTypeOrMedia(source, match[2]);
        setTypeOrMedia(source, match[3]);
      } else {
        source.setAttribute(lazySizesConfig.srcsetAttr, set);
      }

      picture.appendChild(source);
    });

    if (sizes) {
      img.setAttribute(lazySizesConfig.sizesAttr, sizes);
      elem.removeAttribute(lazySizesConfig.sizesAttr);
      elem.removeAttribute('sizes');
    }
    if (optimumx) {
      img.setAttribute('data-optimumx', optimumx);
    }
    if (ratio) {
      img.setAttribute('data-ratio', ratio);
    }

    picture.appendChild(img);

    elem.appendChild(picture);
  };

  var proxyLoad = function (e) {
    if (!e.target._lazybgset) { return; }

    var image = e.target;
    var elem = image._lazybgset;
    var bg = image.currentSrc || image.src;

    if (bg) {
      elem.style.backgroundImage = 'url(' + (regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg) + ')';
    } else if (window.navigator.userAgent.indexOf("Edge") > -1) {
      elem.style.backgroundImage = 'url(' + elem.dataset.backup + ')';
    }

    if (image._lazybgsetLoading) {
      lazySizes.fire(elem, '_lazyloaded', {}, false, true);
      delete image._lazybgsetLoading;
    }
  };

  addEventListener('lazybeforeunveil', function (e) {
    var set, image, elem;

    if (e.defaultPrevented || !(set = e.target.getAttribute('data-bgset'))) { return; }

    elem = e.target;
    image = document.createElement('img');

    image.alt = '';

    image._lazybgsetLoading = true;
    e.detail.firesLoad = true;

    createPicture(set, elem, image);

    setTimeout(function () {
      lazySizes.loader.unveil(image);

      lazySizes.rAF(function () {
        lazySizes.fire(image, '_lazyloaded', {}, true, true);
        if (image.complete) {
          proxyLoad({ target: image });
        }
      });
    });

  });

  document.addEventListener('load', proxyLoad, true);

  window.addEventListener('lazybeforesizes', function (e) {
    if (e.detail.instance != lazySizes) { return; }
    if (e.target._lazybgset && e.detail.dataAttr) {
      var elem = e.target._lazybgset;
      var bgSize = getBgSize(elem);

      if (allowedBackgroundSize[bgSize]) {
        e.target._lazysizesParentFit = bgSize;

        lazySizes.rAF(function () {
          e.target.setAttribute('data-parent-fit', bgSize);
          if (e.target._lazysizesParentFit) {
            delete e.target._lazysizesParentFit;
          }
        });
      }
    }
  }, true);

  document.documentElement.addEventListener('lazybeforesizes', function (e) {
    if (e.defaultPrevented || !e.target._lazybgset || e.detail.instance != lazySizes) { return; }
    e.detail.width = proxyWidth(e.target._lazybgset);
  });
}));

/*! lazysizes - v4.0.1 */
!function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("CustomEvent"); return e || (e = {}), e.instance = c, h.initCustomEvent(d, !f, !g, e), a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? e({ reevaluate: !0, elements: [b] }) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = 125, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && d.ricTimeout ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = a === !0) && (g = 33), b || (b = !0, d = e - (f.now() - c), 0 > d && (d = 0), a || 9 > d && m ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; d > a ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 300 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K, L, M = /^img$/i, N = /^iframe$/i, O = "onscroll" in a && !/glebot/.test(navigator.userAgent), P = 0, Q = 0, R = 0, S = -1, T = function (a) { R--, a && a.target && u(a.target, T), (!a || 0 > R || !a.target) && (R = 0) }, U = function (a, c) { var d, f = a, g = "hidden" == x(b.body, "visibility") || "hidden" != x(a, "visibility"); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)g = (x(f, "opacity") || 1) > 0, g && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, V = function () { var a, f, h, j, k, m, n, p, q, r = c.elements; if ((o = d.loadMode) && 8 > R && (a = r.length)) { f = 0, S++, null == K && ("expand" in d || (d.expand = e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370), J = d.expand, K = J * d.expFactor), K > Q && 1 > R && S > 2 && o > 2 && !b.hidden ? (Q = K, S = 0) : Q = o > 1 && S > 1 && 6 > R ? J : P; for (; a > f; f++)if (r[f] && !r[f]._lazyRace) if (O) if ((p = r[f][i]("data-expand")) && (m = 1 * p) || (m = Q), q !== m && (y = innerWidth + m * L, D = innerHeight + m, n = -1 * m, q = m), h = r[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * L && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || "hidden" != x(r[f], "visibility")) && (l && 3 > R && !p && (3 > o || 4 > S) || U(r[f], m))) { if (ba(r[f]), k = !0, R > 9) break } else !k && l && !j && 4 > R && 4 > S && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != r[f][i](d.sizesAttr))) && (j = g[0] || r[f]); else ba(r[f]); j && !k && ba(j) } }, W = B(V), X = function (a) { s(a.target, d.loadedClass), t(a.target, d.loadingClass), u(a.target, Z), v(a.target, "lazyloaded") }, Y = A(X), Z = function (a) { Y({ target: a.target }) }, $ = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, _ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, aa = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, p && (u(a, T, !0), clearTimeout(m), m = k(T, 2500), s(a, d.loadingClass), u(a, Z, !0)), l && q.call(j.getElementsByTagName("source"), _), h ? a.setAttribute("srcset", h) : g && !l && (N.test(a.nodeName) ? $(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { (!p || a.complete && a.naturalWidth > 1) && (p ? T(o) : R--, X(o)) }, !0) }), ba = function (a) { var b, c = M.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, R++, aa(a, b, f, e, c)) }, ca = function () { if (!l) { if (f.now() - p < 999) return void k(ca, 999); var a = C(function () { d.loadMode = 3, W() }); l = !0, d.loadMode = 3, W(), j("scroll", function () { 3 == d.loadMode && (d.loadMode = 2), a() }, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), L = d.hFac, j("scroll", W, !0), j("resize", W, !0), a.MutationObserver ? new MutationObserver(W).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", W, !0), e[h]("DOMAttrModified", W, !0), setInterval(W, 999)), j("hashchange", W, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, W, !0) }), /d$|^c/.test(b.readyState) ? ca() : (j("load", ca), b[h]("DOMContentLoaded", W), k(ca, 2e4)), c.elements.length ? (V(), z._lsFlush()) : W() }, checkElems: W, unveil: ba } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; g > f; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width, d && d !== a._lazysizesWidth && c(a, f, e, d))) }, f = function () { var b, c = a.length; if (c) for (b = 0; c > b; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
/*! lazysizes (parent-fit) - v4.0.1 */
!function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; if (a.addEventListener) { var d = /\s+(\d+)(w|h)\s+(\d+)(w|h)/, e = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/, f = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/, g = /^picture$/i, h = function (a) { return getComputedStyle(a, null) || {} }, i = { getParent: function (b, c) { var d = b, e = b.parentNode; return c && "prev" != c || !e || !g.test(e.nodeName || "") || (e = e.parentNode), "self" != c && (d = "prev" == c ? b.previousElementSibling : c && (e.closest || a.jQuery) ? (e.closest ? e.closest(c) : jQuery(e).closest(c)[0]) || e : e), d }, getFit: function (a) { var b, c, d = h(a), g = d.content || d.fontFamily, j = { fit: a._lazysizesParentFit || a.getAttribute("data-parent-fit") }; return !j.fit && g && (b = g.match(e)) && (j.fit = b[1]), j.fit ? (c = a._lazysizesParentContainer || a.getAttribute("data-parent-container"), !c && g && (b = g.match(f)) && (c = b[1]), j.parent = i.getParent(a, c)) : j.fit = d.objectFit, j }, getImageRatio: function (b) { var c, e, f, h, i = b.parentNode, j = i && g.test(i.nodeName || "") ? i.querySelectorAll("source, img") : [b]; for (c = 0; c < j.length; c++)if (b = j[c], e = b.getAttribute(lazySizesConfig.srcsetAttr) || b.getAttribute("srcset") || b.getAttribute("data-pfsrcset") || b.getAttribute("data-risrcset") || "", f = b._lsMedia || b.getAttribute("media"), f = lazySizesConfig.customMedia[b.getAttribute("data-media") || f] || f, e && (!f || (a.matchMedia && matchMedia(f) || {}).matches)) { h = parseFloat(b.getAttribute("data-aspectratio")), !h && e.match(d) && (h = "w" == RegExp.$2 ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1); break } return h }, calculateSize: function (a, b) { var c, d, e, f, g = this.getFit(a), h = g.fit, i = g.parent; return "width" == h || ("contain" == h || "cover" == h) && (e = this.getImageRatio(a)) ? (i ? b = i.clientWidth : i = a, f = b, "width" == h ? f = b : (d = i.clientHeight, d > 40 && (c = b / d) && ("cover" == h && e > c || "contain" == h && c > e) && (f = b * (e / c))), f) : b } }; c.parentFit = i, b.addEventListener("lazybeforesizes", function (a) { if (!a.defaultPrevented && a.detail.instance == c) { var b = a.target; a.detail.width = i.calculateSize(b, a.detail.width) } }) } });
/*! lazysizes (rias) - v4.0.1 */
!function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (f) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = { u: a.replace(n, e).replace(o, b.ratio ? Math.round(d * b.ratio) : ""), w: d }; c.push(f), c.srcset.push(f.c = f.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), j = i.rias, "widths" in j || (j.widths = [], function (a) { for (var b, c = 0; !b || 3e3 > b;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; o > m; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; d > f; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; j > i; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; return !u && (a.respimage || a.picturefill || lazySizesConfig.pf) ? void b.removeEventListener("lazybeforesizes", j) : void (("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width), e && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })))) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
// (c) Copyright 2014 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
// See http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
// Edited by Connor Munro

var Shopify = Shopify || {};

Shopify.optionsMap = {};
var soldOutVars = [];

Shopify.escapeString = function (string) {
  return string.replace(/'/g, "\\'");
};

Shopify.updateOptionsInSelector = function (selectorIndex, context, optionsMap) {

  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = jQuery("#product_form_" + context + " [data-product-swatch='0']");
      break;
    case 1:
      var key = jQuery("#product_form_" + context + " [data-product-swatch='0'] input:checked").val();
      var selector = jQuery("#product_form_" + context + " [data-product-swatch='1']");
      break;
    case 2:
      var key = jQuery("#product_form_" + context + " [data-product-swatch='0'] input:checked").val();
      key += ' / ' + jQuery("#product_form_" + context + " [data-product-swatch='1'] input:checked").val();
      var selector = jQuery("#product_form_" + context + " [data-product-swatch='2']");
  }

  var availableOptions = optionsMap[key];
  var optionsWrapper = selector.find("[data-product-swatch-value]");
  var options = selector.find("input");

  optionsWrapper.removeClass("option--active");

  if (availableOptions) {
    for (var i = 0; i < availableOptions.length; i++) {
      var option = Shopify.escapeString(availableOptions[i]);
      selector
        .find("[data-product-swatch-value='" + option + "']")
        .addClass("available");
    }
  }

  for (var i = 0; i < options.length; i++) {
    var option = options.eq(i);
    var optionWrapper = option.closest("[data-product-swatch-value]");

    if (optionWrapper) {
      if (option.is(":checked")) {
        option.closest("[data-product-swatch-value]").addClass("option--active");
      }
    }
  }

  // Reset "Available" class for next round.
  optionsWrapper.removeClass("available");

  // go up the DOM to make sure we cover ALL options in a variable group
  optionWrapper.closest('[data-product-swatch]').find('.form-swatch-item').each(function () { //data-product-swatch-value 
    if (jQuery.inArray($(this).attr('data-product-swatch-value'), availableOptions) !== -1) {
      $(this).show();
    }
    else {
      $(this).removeClass('option--active').hide();
    }
  });
};

Shopify.linkOptionSelectors = function (product, context) {

  Shopify.optionsMap[context] = {};
  // Building our mapping object.
  for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant) {
      // Gathering values for the 1st drop-down.
      Shopify.optionsMap[context]['root'] = Shopify.optionsMap[context]['root'] || [];
      Shopify.optionsMap[context]['root'].push(variant.option1);
      Shopify.optionsMap[context]['root'] = Shopify.uniq(Shopify.optionsMap[context]['root']);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[context][key] = Shopify.optionsMap[context][key] || [];
        Shopify.optionsMap[context][key].push(variant.option2);
        Shopify.optionsMap[context][key] = Shopify.uniq(Shopify.optionsMap[context][key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        Shopify.optionsMap[context][key] = Shopify.optionsMap[context][key] || [];
        Shopify.optionsMap[context][key].push(variant.option3);
        Shopify.optionsMap[context][key] = Shopify.uniq(Shopify.optionsMap[context][key]);
      }
    }
  }

  // Update options right away.
  Shopify.updateOptionsInSelector(0, context, Shopify.optionsMap[context]);
  if (product.options.length > 1) Shopify.updateOptionsInSelector(1, context, Shopify.optionsMap[context]);
  if (product.options.length === 3) Shopify.updateOptionsInSelector(2, context, Shopify.optionsMap[context]);
  // When there is an update in the first dropdown.
  jQuery("input[name='" + context + "-option-0']").change(function () {
    $(this).closest("[data-product-swatch-value]").addClass("option--active").siblings().removeClass("option--active");
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1, context, Shopify.optionsMap[context]);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, context, Shopify.optionsMap[context]);
    return true;
  });
  // When there is an update in the second dropdown.
  jQuery("input[name='" + context + "-option-1']").change(function () {
    $(this).closest("[data-product-swatch-value]").addClass("option--active").siblings().removeClass("option--active");
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, context, Shopify.optionsMap[context]);
    return true;
  });

  // When there is an update in the second dropdown.
  jQuery("input[name='" + context + "-option-2']").change(function () {
    $(this).closest("[data-product-swatch-value]").addClass("option--active").siblings().removeClass("option--active");
    return true;
  });

};
/**
 * @license
 * lodash (Custom Build) /license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash include="debounce,throttle,template"`
 */
; (function () {
  function t(t, r, n) { switch (n.length) { case 0: return t.call(r); case 1: return t.call(r, n[0]); case 2: return t.call(r, n[0], n[1]); case 3: return t.call(r, n[0], n[1], n[2]) }return t.apply(r, n) } function r(t, r) { for (var n = -1, e = t ? t.length : 0, o = Array(e); ++n < e;)o[n] = r(t[n], n, t); return o } function n(t) { return function (r) { return null == t ? X : t[r] } } function e(t, r) { for (var n = -1, e = Array(t); ++n < t;)e[n] = r(n); return e } function o(t) { return function (r) { return t(r) } } function u(t, n) {
    return r(n, function (r) { return t[r] });
  } function c(t) { return "\\" + It[t] } function i(t, r) { return null == t ? X : t[r] } function a(t, r) { return function (n) { return t(r(n)) } } function f() { } function l(t, r) { var n = pr(t), o = !n && sr(t), u = !n && !o && br(t), c = !n && !o && !u && yr(t), i = n || o || u || c, a = i ? e(t.length, String) : [], f = a.length; for (var l in t) !r && !Jt.call(t, l) || i && ("length" == l || u && ("offset" == l || "parent" == l) || c && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || x(l, f)) || a.push(l); return a } function s(t, r, n, e) { return t === X || L(t, Vt[n]) && !Jt.call(e, n) ? r : t } function p(t, r, n) {
    var e = t[r]; Jt.call(t, r) && L(e, n) && (n !== X || r in t) || b(t, r, n)
  } function b(t, r, n) { "__proto__" == r && tr ? tr(t, r, { configurable: true, enumerable: true, value: n, writable: true }) : t[r] = n } function y(t) { return D(t) && Kt.call(t) == ut } function g(t) { return !(!P(t) || $(t)) && (B(t) ? Qt : xt).test(I(t)) } function j(t) { return D(t) && N(t.length) && !!Tt[Kt.call(t)] } function v(t) { if (!w(t)) return nr(t); var r = []; for (var n in Object(t)) Jt.call(t, n) && "constructor" != n && r.push(n); return r } function _(t) {
    if (!P(t)) return E(t); var r = w(t), n = []; for (var e in t) ("constructor" != e || !r && Jt.call(t, e)) && n.push(e);
    return n
  } function m(t, r) { return fr(T(t, r, K), t + "") } function h(t) { if (typeof t == "string") return t; if (pr(t)) return r(t, h) + ""; if (M(t)) return ir ? ir.call(t) : ""; var n = t + ""; return "0" == n && 1 / t == -nt ? "-0" : n } function d(t, r, n, e) { var o = !n; n || (n = {}); for (var u = -1, c = r.length; ++u < c;) { var i = r[u], a = e ? e(n[i], t[i], i, n, t) : X; a === X && (a = t[i]), o ? b(n, i, a) : p(n, i, a) } return n } function A(t) {
    return m(function (r, n) {
      var e = -1, o = n.length, u = o > 1 ? n[o - 1] : X, c = o > 2 ? n[2] : X; for (u = t.length > 3 && typeof u == "function" ? (o--, u) : X, c && S(n[0], n[1], c) && (u = o < 3 ? X : u,
        o = 1), r = Object(r); ++e < o;) { var i = n[e]; i && t(r, i, e, u) } return r
    })
  } function O(t, r) { var n = i(t, r); return g(n) ? n : X } function x(t, r) { return r = null == r ? et : r, !!r && (typeof t == "number" || $t.test(t)) && t > -1 && t % 1 == 0 && t < r } function S(t, r, n) { if (!P(n)) return false; var e = typeof r; return !!("number" == e ? U(n) && x(r, n.length) : "string" == e && r in n) && L(n[r], t) } function $(t) { return !!zt && zt in t } function w(t) { var r = t && t.constructor; return t === (typeof r == "function" && r.prototype || Vt) } function E(t) {
    var r = []; if (null != t) for (var n in Object(t)) r.push(n);
    return r
  } function T(r, n, e) { return n = er(n === X ? r.length - 1 : n, 0), function () { for (var o = arguments, u = -1, c = er(o.length - n, 0), i = Array(c); ++u < c;)i[u] = o[n + u]; u = -1; for (var a = Array(n + 1); ++u < n;)a[u] = o[u]; return a[n] = e(i), t(r, this, a) } } function F(t) { var r = 0, n = 0; return function () { var e = ur(), o = rt - (e - n); if (n = e, o > 0) { if (++r >= tt) return arguments[0] } else r = 0; return t.apply(X, arguments) } } function I(t) { if (null != t) { try { return Ht.call(t) } catch (t) { } try { return t + "" } catch (t) { } } return "" } function R(t, r, n) {
    function e(r) {
      var n = p, e = b;
      return p = b = X, _ = r, g = t.apply(e, n)
    } function o(t) { return _ = t, j = setTimeout(i, r), m ? e(t) : g } function u(t) { var n = t - v, e = t - _, o = r - n; return h ? or(o, y - e) : o } function c(t) { var n = t - v, e = t - _; return v === X || n >= r || n < 0 || h && e >= y } function i() { var t = lr(); return c(t) ? a(t) : (j = setTimeout(i, u(t)), X) } function a(t) { return j = X, d && p ? e(t) : (p = b = X, g) } function f() { j !== X && clearTimeout(j), _ = 0, p = v = b = j = X } function l() { return j === X ? g : a(lr()) } function s() {
      var t = lr(), n = c(t); if (p = arguments, b = this, v = t, n) {
        if (j === X) return o(v); if (h) return j = setTimeout(i, r),
          e(v)
      } return j === X && (j = setTimeout(i, r)), g
    } var p, b, y, g, j, v, _ = 0, m = false, h = false, d = true; if (typeof t != "function") throw new TypeError(Z); return r = q(r) || 0, P(n) && (m = !!n.leading, h = "maxWait" in n, y = h ? er(q(n.maxWait) || 0, r) : y, d = "trailing" in n ? !!n.trailing : d), s.cancel = f, s.flush = l, s
  } function k(t, r, n) { var e = true, o = true; if (typeof t != "function") throw new TypeError(Z); return P(n) && (e = "leading" in n ? !!n.leading : e, o = "trailing" in n ? !!n.trailing : o), R(t, r, { leading: e, maxWait: r, trailing: o }) } function L(t, r) { return t === r || t !== t && r !== r } function U(t) {
    return null != t && N(t.length) && !B(t)
  } function W(t) { return !!D(t) && (Kt.call(t) == ct || typeof t.message == "string" && typeof t.name == "string") } function B(t) { var r = P(t) ? Kt.call(t) : ""; return r == it || r == at || r == ft } function N(t) { return typeof t == "number" && t > -1 && t % 1 == 0 && t <= et } function P(t) { var r = typeof t; return null != t && ("object" == r || "function" == r) } function D(t) { return null != t && typeof t == "object" } function M(t) { return typeof t == "symbol" || D(t) && Kt.call(t) == lt } function q(t) {
    if (typeof t == "number") return t; if (M(t)) return ot;
    if (P(t)) { var r = typeof t.valueOf == "function" ? t.valueOf() : t; t = P(r) ? r + "" : r } if (typeof t != "string") return 0 === t ? t : +t; t = t.replace(ht, ""); var n = Ot.test(t); return n || St.test(t) ? Rt(t.slice(2), n ? 2 : 8) : At.test(t) ? ot : +t
  } function C(t) { return null == t ? "" : h(t) } function V(t) { return U(t) ? l(t) : v(t) } function G(t) { return U(t) ? l(t, true) : _(t) } function z(t) { return t = C(t), t && gt.test(t) ? t.replace(yt, qt) : t } function H(t, r, n) {
    var e = f.templateSettings; n && S(t, r, n) && (r = X), t = C(t), r = gr({}, r, e, s); var o, i, a = gr({}, r.imports, e.imports, s), l = V(a), p = u(a, l), b = 0, y = r.interpolate || wt, g = "__p+='", j = "sourceURL" in r ? "//# sourceURL=" + r.sourceURL + "\n" : "";
    t.replace(RegExp((r.escape || wt).source + "|" + y.source + "|" + (y === _t ? dt : wt).source + "|" + (r.evaluate || wt).source + "|$", "g"), function (r, n, e, u, a, f) { return e || (e = u), g += t.slice(b, f).replace(Et, c), n && (o = true, g += "'+__e(" + n + ")+'"), a && (i = true, g += "';" + a + ";\n__p+='"), e && (g += "'+((__t=(" + e + "))==null?'':__t)+'"), b = f + r.length, r }), g += "';"; var v = r.variable; v || (g = "with(obj){" + g + "}"), g = (i ? g.replace(st, "") : g).replace(pt, "$1").replace(bt, "$1;"), g = "function(" + (v || "obj") + "){" + (v ? "" : "obj||(obj={});") + "var __t,__p=''" + (o ? ",__e=_.escape" : "") + (i ? ",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}" : ";") + g + "return __p}";
    var _ = jr(function () { return Function(l, j + "return " + g).apply(X, p) }); if (_.source = g, W(_)) throw _; return _
  } function J(t) { return function () { return t } } function K(t) { return t } function Q() { return false } var X, Y = "4.16.4", Z = "Expected a function", tt = 500, rt = 16, nt = 1 / 0, et = 9007199254740991, ot = NaN, ut = "[object Arguments]", ct = "[object Error]", it = "[object Function]", at = "[object GeneratorFunction]", ft = "[object Proxy]", lt = "[object Symbol]", st = /\b__p\+='';/g, pt = /\b(__p\+=)''\+/g, bt = /(__e\(.*?\)|\b__t\))\+'';/g, yt = /[&<>"']/g, gt = RegExp(yt.source), jt = /<%-([\s\S]+?)%>/g, vt = /<%([\s\S]+?)%>/g, _t = /<%=([\s\S]+?)%>/g, mt = /[\\^$.*+?()[\]{}|]/g, ht = /^\s+|\s+$/g, dt = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, At = /^[-+]0x[0-9a-f]+$/i, Ot = /^0b[01]+$/i, xt = /^\[object .+?Constructor\]$/, St = /^0o[0-7]+$/i, $t = /^(?:0|[1-9]\d*)$/, wt = /($^)/, Et = /['\n\r\u2028\u2029\\]/g, Tt = {};
  Tt["[object Float32Array]"] = Tt["[object Float64Array]"] = Tt["[object Int8Array]"] = Tt["[object Int16Array]"] = Tt["[object Int32Array]"] = Tt["[object Uint8Array]"] = Tt["[object Uint8ClampedArray]"] = Tt["[object Uint16Array]"] = Tt["[object Uint32Array]"] = true, Tt[ut] = Tt["[object Array]"] = Tt["[object ArrayBuffer]"] = Tt["[object Boolean]"] = Tt["[object DataView]"] = Tt["[object Date]"] = Tt[ct] = Tt[it] = Tt["[object Map]"] = Tt["[object Number]"] = Tt["[object Object]"] = Tt["[object RegExp]"] = Tt["[object Set]"] = Tt["[object String]"] = Tt["[object WeakMap]"] = false;
  var Ft = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, It = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" }, Rt = parseInt, kt = typeof global == "object" && global && global.Object === Object && global, Lt = typeof self == "object" && self && self.Object === Object && self, Ut = kt || Lt || Function("return this")(), Wt = typeof exports == "object" && exports && !exports.nodeType && exports, Bt = Wt && typeof module == "object" && module && !module.nodeType && module, Nt = Bt && Bt.exports === Wt, Pt = Nt && kt.process, Dt = function () {
    try { return Pt && Pt.binding("util") } catch (t) { }
  }(), Mt = Dt && Dt.isTypedArray, qt = n(Ft), Ct = Function.prototype, Vt = Object.prototype, Gt = Ut["__core-js_shared__"], zt = function () { var t = /[^.]+$/.exec(Gt && Gt.keys && Gt.keys.IE_PROTO || ""); return t ? "Symbol(src)_1." + t : "" }(), Ht = Ct.toString, Jt = Vt.hasOwnProperty, Kt = Vt.toString, Qt = RegExp("^" + Ht.call(Jt).replace(mt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Xt = Nt ? Ut.Buffer : X, Yt = Ut.Symbol, Zt = Vt.propertyIsEnumerable, tr = function () {
    try {
      var t = O(Object, "defineProperty"); return t({}, "", {}), t
    } catch (t) { }
  }(), rr = Xt ? Xt.isBuffer : X, nr = a(Object.keys, Object), er = Math.max, or = Math.min, ur = Date.now, cr = Yt ? Yt.prototype : X, ir = cr ? cr.toString : X; f.templateSettings = { escape: jt, evaluate: vt, interpolate: _t, variable: "", imports: { _: f } }; var ar = tr ? function (t, r) { return tr(t, "toString", { configurable: true, enumerable: false, value: J(r), writable: true }) } : K, fr = F(ar), lr = function () { return Ut.Date.now() }, sr = y(function () { return arguments }()) ? y : function (t) {
    return D(t) && Jt.call(t, "callee") && !Zt.call(t, "callee");
  }, pr = Array.isArray, br = rr || Q, yr = Mt ? o(Mt) : j, gr = A(function (t, r, n, e) { d(r, G(r), t, e) }), jr = m(function (r, n) { try { return t(r, X, n) } catch (t) { return W(t) ? t : Error(t) } }); f.assignInWith = gr, f.constant = J, f.debounce = R, f.keys = V, f.keysIn = G, f.throttle = k, f.extendWith = gr, f.attempt = jr, f.eq = L, f.escape = z, f.identity = K, f.isArguments = sr, f.isArray = pr, f.isArrayLike = U, f.isBuffer = br, f.isError = W, f.isFunction = B, f.isLength = N, f.isObject = P, f.isObjectLike = D, f.isSymbol = M, f.isTypedArray = yr, f.stubFalse = Q, f.now = lr, f.template = H, f.toNumber = q,
    f.toString = C, f.VERSION = Y, typeof define == "function" && typeof define.amd == "object" && define.amd ? (Ut._ = f, define(function () { return f })) : Bt ? ((Bt.exports = f)._ = f, Wt._ = f) : Ut._ = f
}).call(this);
/**
 * jQuery.marquee - scrolling text like old marquee element
 * @author Aamir Afridi - aamirafridi(at)gmail(dot)com / http://aamirafridi.com/jquery/jquery-marquee-plugin
 */
; (function (d) {
  d.fn.marquee = function (w) {
    return this.each(function () {
      var a = d.extend({}, d.fn.marquee.defaults, w), b = d(this), c, k, p, q, h, l = 3, x = "animation-play-state", e = !1, B = function (a, b, c) { for (var d = ["webkit", "moz", "MS", "o", ""], e = 0; e < d.length; e++)d[e] || (b = b.toLowerCase()), a.addEventListener(d[e] + b, c, !1) }, E = function (a) { var b = [], c; for (c in a) a.hasOwnProperty(c) && b.push(c + ":" + a[c]); b.push(); return "{" + b.join(",") + "}" }, g = {
        pause: function () {
          e && a.allowCss3Support ? c.css(x, "paused") : d.fn.pause && c.pause(); b.data("runningStatus",
            "paused"); b.trigger("paused")
        }, resume: function () { e && a.allowCss3Support ? c.css(x, "running") : d.fn.resume && c.resume(); b.data("runningStatus", "resumed"); b.trigger("resumed") }, toggle: function () { g["resumed" == b.data("runningStatus") ? "pause" : "resume"]() }, destroy: function () { clearTimeout(b.timer); b.css("visibility", "hidden").html(b.find(".js-marquee:first")); setTimeout(function () { b.css("visibility", "visible") }, 0) }
      }; if ("string" === typeof w) d.isFunction(g[w]) && (c || (c = b.find(".js-marquee-wrapper")), !0 === b.data("css3AnimationIsSupported") &&
        (e = !0), g[w]()); else {
        var r; d.each(a, function (c, d) { r = b.attr("data-" + c); if ("undefined" !== typeof r) { switch (r) { case "true": r = !0; break; case "false": r = !1 }a[c] = r } }); a.duration = a.speed || a.duration; q = "up" == a.direction || "down" == a.direction; a.gap = a.duplicated ? a.gap : 0; b.wrapInner('<div class="js-marquee"></div>'); var f = b.find(".js-marquee").css({ "margin-right": a.gap, "float": "left" }); a.duplicated && f.clone(!0).appendTo(b); b.wrapInner('<div style="width:100000px" class="js-marquee-wrapper"></div>'); c = b.find(".js-marquee-wrapper");
        if (q) { var m = b.height(); c.removeAttr("style"); b.height(m); b.find(".js-marquee").css({ "float": "none", "margin-bottom": a.gap, "margin-right": 0 }); a.duplicated && b.find(".js-marquee:last").css({ "margin-bottom": 0 }); var s = b.find(".js-marquee:first").height() + a.gap; a.duration *= (parseInt(s, 10) + parseInt(m, 10)) / parseInt(m, 10) } else h = b.find(".js-marquee:first").width() + a.gap, k = b.width(), a.duration *= (parseInt(h, 10) + parseInt(k, 10)) / parseInt(k, 10); a.duplicated && (a.duration /= 2); if (a.allowCss3Support) {
          var f = document.body ||
            document.createElement("div"), n = "marqueeAnimation-" + Math.floor(1E7 * Math.random()), z = ["Webkit", "Moz", "O", "ms", "Khtml"], A = "animation", t = "", u = ""; f.style.animation && (u = "@keyframes " + n + " ", e = !0); if (!1 === e) for (var y = 0; y < z.length; y++)if (void 0 !== f.style[z[y] + "AnimationName"]) { f = "-" + z[y].toLowerCase() + "-"; A = f + A; x = f + x; u = "@" + f + "keyframes " + n + " "; e = !0; break } e && (t = n + " " + a.duration / 1E3 + "s " + a.delayBeforeStart / 1E3 + "s infinite " + a.css3easing, b.data("css3AnimationIsSupported", !0))
        } var C = function () {
          c.css("margin-top",
            "up" == a.direction ? m + "px" : "-" + s + "px")
        }, D = function () { c.css("margin-left", "left" == a.direction ? k + "px" : "-" + h + "px") }; a.duplicated ? (q ? c.css("margin-top", "up" == a.direction ? m : "-" + (2 * s - a.gap) + "px") : c.css("margin-left", "left" == a.direction ? k + "px" : "-" + (2 * h - a.gap) + "px"), l = 1) : q ? C() : D(); var v = function () {
          a.duplicated && (1 === l ? (a._originalDuration = a.duration, a.duration = q ? "up" == a.direction ? a.duration + m / (s / a.duration) : 2 * a.duration : "left" == a.direction ? a.duration + k / (h / a.duration) : 2 * a.duration, t && (t = n + " " + a.duration / 1E3 +
            "s " + a.delayBeforeStart / 1E3 + "s " + a.css3easing), l++) : 2 === l && (a.duration = a._originalDuration, t && (n += "0", u = d.trim(u) + "0 ", t = n + " " + a.duration / 1E3 + "s 0s infinite " + a.css3easing), l++)); q ? a.duplicated ? (2 < l && c.css("margin-top", "up" == a.direction ? 0 : "-" + s + "px"), p = { "margin-top": "up" == a.direction ? "-" + s + "px" : 0 }) : (C(), p = { "margin-top": "up" == a.direction ? "-" + c.height() + "px" : m + "px" }) : a.duplicated ? (2 < l && c.css("margin-left", "left" == a.direction ? 0 : "-" + h + "px"), p = { "margin-left": "left" == a.direction ? "-" + h + "px" : 0 }) : (D(), p = {
              "margin-left": "left" ==
                a.direction ? "-" + h + "px" : k + "px"
            }); b.trigger("beforeStarting"); if (e) { c.css(A, t); var f = u + " { 100%  " + E(p) + "}", g = d("style"); 0 !== g.length ? g.filter(":last").append(f) : d("head").append("<style>" + f + "</style>"); B(c[0], "AnimationIteration", function () { b.trigger("finished") }); B(c[0], "AnimationEnd", function () { v(); b.trigger("finished") }) } else c.animate(p, a.duration, a.easing, function () { b.trigger("finished"); a.pauseOnCycle ? b.timer = setTimeout(v, a.delayBeforeStart) : v() }); b.data("runningStatus", "resumed")
        }; b.bind("pause",
          g.pause); b.bind("resume", g.resume); a.pauseOnHover && b.bind("mouseenter mouseleave", g.toggle); e && a.allowCss3Support ? v() : b.timer = setTimeout(v, a.delayBeforeStart)
      }
    })
  }; d.fn.marquee.defaults = { allowCss3Support: !0, css3easing: "linear", easing: "linear", delayBeforeStart: 1E3, direction: "left", duplicated: !1, duration: 5E3, gap: 20, pauseOnCycle: !1, pauseOnHover: !1 }
})(jQuery);
/*
 * Pause jQuery plugin v0.1
 *
 * Copyright 2010 by Tobia Conforto <tobia.conforto@gmail.com>
 *
 * Based on Pause-resume-animation jQuery plugin by Joe Weitzel
 *
 * This program is free software; you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by the Free
 * Software Foundation; either version 2 of the License, or(at your option)
 * any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE. See the GNU General Public License for
 * more details.
 *
 * You should have received a copy of the GNU General Public License along with
 * this program; if not, write to the Free Software Foundation, Inc., 51
 * Franklin Street, Fifth Floor, Boston, MA 02110-1301, USA.
 */
(function () { var e = jQuery, f = "jQuery.pause", d = 1, b = e.fn.animate, a = {}; function c() { return new Date().getTime() } e.fn.animate = function (k, h, j, i) { var g = e.speed(h, j, i); g.complete = g.old; return this.each(function () { if (!this[f]) { this[f] = d++ } var l = e.extend({}, g); b.apply(e(this), [k, e.extend({}, l)]); a[this[f]] = { run: true, prop: k, opt: l, start: c(), done: 0 } }) }; e.fn.pause = function () { return this.each(function () { if (!this[f]) { this[f] = d++ } var g = a[this[f]]; if (g && g.run) { g.done += c() - g.start; if (g.done > g.opt.duration) { delete a[this[f]] } else { e(this).stop(); g.run = false } } }) }; e.fn.resume = function () { return this.each(function () { if (!this[f]) { this[f] = d++ } var g = a[this[f]]; if (g && !g.run) { g.opt.duration -= g.done; g.done = 0; g.run = true; g.start = c(); b.apply(e(this), [g.prop, e.extend({}, g.opt)]) } }) } })();

/*!
 * Masonry PACKAGED v4.1.1
 * Cascading grid layout library
 * http://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

!function (t, e) { "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function (i) { return e(t, i) }) : "object" == typeof module && module.exports ? module.exports = e(t, require("jquery")) : t.jQueryBridget = e(t, t.jQuery) }(window, function (t, e) { "use strict"; function i(i, r, a) { function h(t, e, n) { var o, r = "$()." + i + '("' + e + '")'; return t.each(function (t, h) { var u = a.data(h, i); if (!u) return void s(i + " not initialized. Cannot call methods, i.e. " + r); var d = u[e]; if (!d || "_" == e.charAt(0)) return void s(r + " is not a valid method"); var l = d.apply(u, n); o = void 0 === o ? l : o }), void 0 !== o ? o : t } function u(t, e) { t.each(function (t, n) { var o = a.data(n, i); o ? (o.option(e), o._init()) : (o = new r(n, e), a.data(n, i, o)) }) } a = a || e || t.jQuery, a && (r.prototype.option || (r.prototype.option = function (t) { a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t)) }), a.fn[i] = function (t) { if ("string" == typeof t) { var e = o.call(arguments, 1); return h(this, t, e) } return u(this, t), this }, n(a)) } function n(t) { !t || t && t.bridget || (t.bridget = i) } var o = Array.prototype.slice, r = t.console, s = "undefined" == typeof r ? function () { } : function (t) { r.error(t) }; return n(e || t.jQuery), i }), function (t, e) { "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e() }("undefined" != typeof window ? window : this, function () { function t() { } var e = t.prototype; return e.on = function (t, e) { if (t && e) { var i = this._events = this._events || {}, n = i[t] = i[t] || []; return -1 == n.indexOf(e) && n.push(e), this } }, e.once = function (t, e) { if (t && e) { this.on(t, e); var i = this._onceEvents = this._onceEvents || {}, n = i[t] = i[t] || {}; return n[e] = !0, this } }, e.off = function (t, e) { var i = this._events && this._events[t]; if (i && i.length) { var n = i.indexOf(e); return -1 != n && i.splice(n, 1), this } }, e.emitEvent = function (t, e) { var i = this._events && this._events[t]; if (i && i.length) { var n = 0, o = i[n]; e = e || []; for (var r = this._onceEvents && this._onceEvents[t]; o;) { var s = r && r[o]; s && (this.off(t, o), delete r[o]), o.apply(this, e), n += s ? 0 : 1, o = i[n] } return this } }, t }), function (t, e) { "use strict"; "function" == typeof define && define.amd ? define("get-size/get-size", [], function () { return e() }) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e() }(window, function () { "use strict"; function t(t) { var e = parseFloat(t), i = -1 == t.indexOf("%") && !isNaN(e); return i && e } function e() { } function i() { for (var t = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, e = 0; u > e; e++) { var i = h[e]; t[i] = 0 } return t } function n(t) { var e = getComputedStyle(t); return e || a("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"), e } function o() { if (!d) { d = !0; var e = document.createElement("div"); e.style.width = "200px", e.style.padding = "1px 2px 3px 4px", e.style.borderStyle = "solid", e.style.borderWidth = "1px 2px 3px 4px", e.style.boxSizing = "border-box"; var i = document.body || document.documentElement; i.appendChild(e); var o = n(e); r.isBoxSizeOuter = s = 200 == t(o.width), i.removeChild(e) } } function r(e) { if (o(), "string" == typeof e && (e = document.querySelector(e)), e && "object" == typeof e && e.nodeType) { var r = n(e); if ("none" == r.display) return i(); var a = {}; a.width = e.offsetWidth, a.height = e.offsetHeight; for (var d = a.isBorderBox = "border-box" == r.boxSizing, l = 0; u > l; l++) { var c = h[l], f = r[c], m = parseFloat(f); a[c] = isNaN(m) ? 0 : m } var p = a.paddingLeft + a.paddingRight, g = a.paddingTop + a.paddingBottom, y = a.marginLeft + a.marginRight, v = a.marginTop + a.marginBottom, _ = a.borderLeftWidth + a.borderRightWidth, E = a.borderTopWidth + a.borderBottomWidth, z = d && s, b = t(r.width); b !== !1 && (a.width = b + (z ? 0 : p + _)); var x = t(r.height); return x !== !1 && (a.height = x + (z ? 0 : g + E)), a.innerWidth = a.width - (p + _), a.innerHeight = a.height - (g + E), a.outerWidth = a.width + y, a.outerHeight = a.height + v, a } } var s, a = "undefined" == typeof console ? e : function (t) { console.error(t) }, h = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"], u = h.length, d = !1; return r }), function (t, e) { "use strict"; "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e() }(window, function () { "use strict"; var t = function () { var t = Element.prototype; if (t.matches) return "matches"; if (t.matchesSelector) return "matchesSelector"; for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) { var n = e[i], o = n + "MatchesSelector"; if (t[o]) return o } }(); return function (e, i) { return e[t](i) } }), function (t, e) { "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (i) { return e(t, i) }) : "object" == typeof module && module.exports ? module.exports = e(t, require("desandro-matches-selector")) : t.fizzyUIUtils = e(t, t.matchesSelector) }(window, function (t, e) { var i = {}; i.extend = function (t, e) { for (var i in e) t[i] = e[i]; return t }, i.modulo = function (t, e) { return (t % e + e) % e }, i.makeArray = function (t) { var e = []; if (Array.isArray(t)) e = t; else if (t && "number" == typeof t.length) for (var i = 0; i < t.length; i++)e.push(t[i]); else e.push(t); return e }, i.removeFrom = function (t, e) { var i = t.indexOf(e); -1 != i && t.splice(i, 1) }, i.getParent = function (t, i) { for (; t != document.body;)if (t = t.parentNode, e(t, i)) return t }, i.getQueryElement = function (t) { return "string" == typeof t ? document.querySelector(t) : t }, i.handleEvent = function (t) { var e = "on" + t.type; this[e] && this[e](t) }, i.filterFindElements = function (t, n) { t = i.makeArray(t); var o = []; return t.forEach(function (t) { if (t instanceof HTMLElement) { if (!n) return void o.push(t); e(t, n) && o.push(t); for (var i = t.querySelectorAll(n), r = 0; r < i.length; r++)o.push(i[r]) } }), o }, i.debounceMethod = function (t, e, i) { var n = t.prototype[e], o = e + "Timeout"; t.prototype[e] = function () { var t = this[o]; t && clearTimeout(t); var e = arguments, r = this; this[o] = setTimeout(function () { n.apply(r, e), delete r[o] }, i || 100) } }, i.docReady = function (t) { var e = document.readyState; "complete" == e || "interactive" == e ? t() : document.addEventListener("DOMContentLoaded", t) }, i.toDashed = function (t) { return t.replace(/(.)([A-Z])/g, function (t, e, i) { return e + "-" + i }).toLowerCase() }; var n = t.console; return i.htmlInit = function (e, o) { i.docReady(function () { var r = i.toDashed(o), s = "data-" + r, a = document.querySelectorAll("[" + s + "]"), h = document.querySelectorAll(".js-" + r), u = i.makeArray(a).concat(i.makeArray(h)), d = s + "-options", l = t.jQuery; u.forEach(function (t) { var i, r = t.getAttribute(s) || t.getAttribute(d); try { i = r && JSON.parse(r) } catch (a) { return void (n && n.error("Error parsing " + s + " on " + t.className + ": " + a)) } var h = new e(t, i); l && l.data(t, o, h) }) }) }, i }), function (t, e) { "function" == typeof define && define.amd ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("ev-emitter"), require("get-size")) : (t.Outlayer = {}, t.Outlayer.Item = e(t.EvEmitter, t.getSize)) }(window, function (t, e) { "use strict"; function i(t) { for (var e in t) return !1; return e = null, !0 } function n(t, e) { t && (this.element = t, this.layout = e, this.position = { x: 0, y: 0 }, this._create()) } function o(t) { return t.replace(/([A-Z])/g, function (t) { return "-" + t.toLowerCase() }) } var r = document.documentElement.style, s = "string" == typeof r.transition ? "transition" : "WebkitTransition", a = "string" == typeof r.transform ? "transform" : "WebkitTransform", h = { WebkitTransition: "webkitTransitionEnd", transition: "transitionend" }[s], u = { transform: a, transition: s, transitionDuration: s + "Duration", transitionProperty: s + "Property", transitionDelay: s + "Delay" }, d = n.prototype = Object.create(t.prototype); d.constructor = n, d._create = function () { this._transn = { ingProperties: {}, clean: {}, onEnd: {} }, this.css({ position: "absolute" }) }, d.handleEvent = function (t) { var e = "on" + t.type; this[e] && this[e](t) }, d.getSize = function () { this.size = e(this.element) }, d.css = function (t) { var e = this.element.style; for (var i in t) { var n = u[i] || i; e[n] = t[i] } }, d.getPosition = function () { var t = getComputedStyle(this.element), e = this.layout._getOption("originLeft"), i = this.layout._getOption("originTop"), n = t[e ? "left" : "right"], o = t[i ? "top" : "bottom"], r = this.layout.size, s = -1 != n.indexOf("%") ? parseFloat(n) / 100 * r.width : parseInt(n, 10), a = -1 != o.indexOf("%") ? parseFloat(o) / 100 * r.height : parseInt(o, 10); s = isNaN(s) ? 0 : s, a = isNaN(a) ? 0 : a, s -= e ? r.paddingLeft : r.paddingRight, a -= i ? r.paddingTop : r.paddingBottom, this.position.x = s, this.position.y = a }, d.layoutPosition = function () { var t = this.layout.size, e = {}, i = this.layout._getOption("originLeft"), n = this.layout._getOption("originTop"), o = i ? "paddingLeft" : "paddingRight", r = i ? "left" : "right", s = i ? "right" : "left", a = this.position.x + t[o]; e[r] = this.getXValue(a), e[s] = ""; var h = n ? "paddingTop" : "paddingBottom", u = n ? "top" : "bottom", d = n ? "bottom" : "top", l = this.position.y + t[h]; e[u] = this.getYValue(l), e[d] = "", this.css(e), this.emitEvent("layout", [this]) }, d.getXValue = function (t) { var e = this.layout._getOption("horizontal"); return this.layout.options.percentPosition && !e ? t / this.layout.size.width * 100 + "%" : t + "px" }, d.getYValue = function (t) { var e = this.layout._getOption("horizontal"); return this.layout.options.percentPosition && e ? t / this.layout.size.height * 100 + "%" : t + "px" }, d._transitionTo = function (t, e) { this.getPosition(); var i = this.position.x, n = this.position.y, o = parseInt(t, 10), r = parseInt(e, 10), s = o === this.position.x && r === this.position.y; if (this.setPosition(t, e), s && !this.isTransitioning) return void this.layoutPosition(); var a = t - i, h = e - n, u = {}; u.transform = this.getTranslate(a, h), this.transition({ to: u, onTransitionEnd: { transform: this.layoutPosition }, isCleaning: !0 }) }, d.getTranslate = function (t, e) { var i = this.layout._getOption("originLeft"), n = this.layout._getOption("originTop"); return t = i ? t : -t, e = n ? e : -e, "translate3d(" + t + "px, " + e + "px, 0)" }, d.goTo = function (t, e) { this.setPosition(t, e), this.layoutPosition() }, d.moveTo = d._transitionTo, d.setPosition = function (t, e) { this.position.x = parseInt(t, 10), this.position.y = parseInt(e, 10) }, d._nonTransition = function (t) { this.css(t.to), t.isCleaning && this._removeStyles(t.to); for (var e in t.onTransitionEnd) t.onTransitionEnd[e].call(this) }, d.transition = function (t) { if (!parseFloat(this.layout.options.transitionDuration)) return void this._nonTransition(t); var e = this._transn; for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i]; for (i in t.to) e.ingProperties[i] = !0, t.isCleaning && (e.clean[i] = !0); if (t.from) { this.css(t.from); var n = this.element.offsetHeight; n = null } this.enableTransition(t.to), this.css(t.to), this.isTransitioning = !0 }; var l = "opacity," + o(a); d.enableTransition = function () { if (!this.isTransitioning) { var t = this.layout.options.transitionDuration; t = "number" == typeof t ? t + "ms" : t, this.css({ transitionProperty: l, transitionDuration: t, transitionDelay: this.staggerDelay || 0 }), this.element.addEventListener(h, this, !1) } }, d.onwebkitTransitionEnd = function (t) { this.ontransitionend(t) }, d.onotransitionend = function (t) { this.ontransitionend(t) }; var c = { "-webkit-transform": "transform" }; d.ontransitionend = function (t) { if (t.target === this.element) { var e = this._transn, n = c[t.propertyName] || t.propertyName; if (delete e.ingProperties[n], i(e.ingProperties) && this.disableTransition(), n in e.clean && (this.element.style[t.propertyName] = "", delete e.clean[n]), n in e.onEnd) { var o = e.onEnd[n]; o.call(this), delete e.onEnd[n] } this.emitEvent("transitionEnd", [this]) } }, d.disableTransition = function () { this.removeTransitionStyles(), this.element.removeEventListener(h, this, !1), this.isTransitioning = !1 }, d._removeStyles = function (t) { var e = {}; for (var i in t) e[i] = ""; this.css(e) }; var f = { transitionProperty: "", transitionDuration: "", transitionDelay: "" }; return d.removeTransitionStyles = function () { this.css(f) }, d.stagger = function (t) { t = isNaN(t) ? 0 : t, this.staggerDelay = t + "ms" }, d.removeElem = function () { this.element.parentNode.removeChild(this.element), this.css({ display: "" }), this.emitEvent("remove", [this]) }, d.remove = function () { return s && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function () { this.removeElem() }), void this.hide()) : void this.removeElem() }, d.reveal = function () { delete this.isHidden, this.css({ display: "" }); var t = this.layout.options, e = {}, i = this.getHideRevealTransitionEndProperty("visibleStyle"); e[i] = this.onRevealTransitionEnd, this.transition({ from: t.hiddenStyle, to: t.visibleStyle, isCleaning: !0, onTransitionEnd: e }) }, d.onRevealTransitionEnd = function () { this.isHidden || this.emitEvent("reveal") }, d.getHideRevealTransitionEndProperty = function (t) { var e = this.layout.options[t]; if (e.opacity) return "opacity"; for (var i in e) return i }, d.hide = function () { this.isHidden = !0, this.css({ display: "" }); var t = this.layout.options, e = {}, i = this.getHideRevealTransitionEndProperty("hiddenStyle"); e[i] = this.onHideTransitionEnd, this.transition({ from: t.visibleStyle, to: t.hiddenStyle, isCleaning: !0, onTransitionEnd: e }) }, d.onHideTransitionEnd = function () { this.isHidden && (this.css({ display: "none" }), this.emitEvent("hide")) }, d.destroy = function () { this.css({ position: "", left: "", right: "", top: "", bottom: "", transition: "", transform: "" }) }, n }), function (t, e) { "use strict"; "function" == typeof define && define.amd ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function (i, n, o, r) { return e(t, i, n, o, r) }) : "object" == typeof module && module.exports ? module.exports = e(t, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : t.Outlayer = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, t.Outlayer.Item) }(window, function (t, e, i, n, o) { "use strict"; function r(t, e) { var i = n.getQueryElement(t); if (!i) return void (h && h.error("Bad element for " + this.constructor.namespace + ": " + (i || t))); this.element = i, u && (this.$element = u(this.element)), this.options = n.extend({}, this.constructor.defaults), this.option(e); var o = ++l; this.element.outlayerGUID = o, c[o] = this, this._create(); var r = this._getOption("initLayout"); r && this.layout() } function s(t) { function e() { t.apply(this, arguments) } return e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e } function a(t) { if ("number" == typeof t) return t; var e = t.match(/(^\d*\.?\d*)(\w*)/), i = e && e[1], n = e && e[2]; if (!i.length) return 0; i = parseFloat(i); var o = m[n] || 1; return i * o } var h = t.console, u = t.jQuery, d = function () { }, l = 0, c = {}; r.namespace = "outlayer", r.Item = o, r.defaults = { containerStyle: { position: "relative" }, initLayout: !0, originLeft: !0, originTop: !0, resize: !0, resizeContainer: !0, transitionDuration: "0.4s", hiddenStyle: { opacity: 0, transform: "scale(0.001)" }, visibleStyle: { opacity: 1, transform: "scale(1)" } }; var f = r.prototype; n.extend(f, e.prototype), f.option = function (t) { n.extend(this.options, t) }, f._getOption = function (t) { var e = this.constructor.compatOptions[t]; return e && void 0 !== this.options[e] ? this.options[e] : this.options[t] }, r.compatOptions = { initLayout: "isInitLayout", horizontal: "isHorizontal", layoutInstant: "isLayoutInstant", originLeft: "isOriginLeft", originTop: "isOriginTop", resize: "isResizeBound", resizeContainer: "isResizingContainer" }, f._create = function () { this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), n.extend(this.element.style, this.options.containerStyle); var t = this._getOption("resize"); t && this.bindResize() }, f.reloadItems = function () { this.items = this._itemize(this.element.children) }, f._itemize = function (t) { for (var e = this._filterFindItemElements(t), i = this.constructor.Item, n = [], o = 0; o < e.length; o++) { var r = e[o], s = new i(r, this); n.push(s) } return n }, f._filterFindItemElements = function (t) { return n.filterFindElements(t, this.options.itemSelector) }, f.getItemElements = function () { return this.items.map(function (t) { return t.element }) }, f.layout = function () { this._resetLayout(), this._manageStamps(); var t = this._getOption("layoutInstant"), e = void 0 !== t ? t : !this._isLayoutInited; this.layoutItems(this.items, e), this._isLayoutInited = !0 }, f._init = f.layout, f._resetLayout = function () { this.getSize() }, f.getSize = function () { this.size = i(this.element) }, f._getMeasurement = function (t, e) { var n, o = this.options[t]; o ? ("string" == typeof o ? n = this.element.querySelector(o) : o instanceof HTMLElement && (n = o), this[t] = n ? i(n)[e] : o) : this[t] = 0 }, f.layoutItems = function (t, e) { t = this._getItemsForLayout(t), this._layoutItems(t, e), this._postLayout() }, f._getItemsForLayout = function (t) { return t.filter(function (t) { return !t.isIgnored }) }, f._layoutItems = function (t, e) { if (this._emitCompleteOnItems("layout", t), t && t.length) { var i = []; t.forEach(function (t) { var n = this._getItemLayoutPosition(t); n.item = t, n.isInstant = e || t.isLayoutInstant, i.push(n) }, this), this._processLayoutQueue(i) } }, f._getItemLayoutPosition = function () { return { x: 0, y: 0 } }, f._processLayoutQueue = function (t) { this.updateStagger(), t.forEach(function (t, e) { this._positionItem(t.item, t.x, t.y, t.isInstant, e) }, this) }, f.updateStagger = function () { var t = this.options.stagger; return null === t || void 0 === t ? void (this.stagger = 0) : (this.stagger = a(t), this.stagger) }, f._positionItem = function (t, e, i, n, o) { n ? t.goTo(e, i) : (t.stagger(o * this.stagger), t.moveTo(e, i)) }, f._postLayout = function () { this.resizeContainer() }, f.resizeContainer = function () { var t = this._getOption("resizeContainer"); if (t) { var e = this._getContainerSize(); e && (this._setContainerMeasure(e.width, !0), this._setContainerMeasure(e.height, !1)) } }, f._getContainerSize = d, f._setContainerMeasure = function (t, e) { if (void 0 !== t) { var i = this.size; i.isBorderBox && (t += e ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth), t = Math.max(t, 0), this.element.style[e ? "width" : "height"] = t + "px" } }, f._emitCompleteOnItems = function (t, e) { function i() { o.dispatchEvent(t + "Complete", null, [e]) } function n() { s++, s == r && i() } var o = this, r = e.length; if (!e || !r) return void i(); var s = 0; e.forEach(function (e) { e.once(t, n) }) }, f.dispatchEvent = function (t, e, i) { var n = e ? [e].concat(i) : i; if (this.emitEvent(t, n), u) if (this.$element = this.$element || u(this.element), e) { var o = u.Event(e); o.type = t, this.$element.trigger(o, i) } else this.$element.trigger(t, i) }, f.ignore = function (t) { var e = this.getItem(t); e && (e.isIgnored = !0) }, f.unignore = function (t) { var e = this.getItem(t); e && delete e.isIgnored }, f.stamp = function (t) { t = this._find(t), t && (this.stamps = this.stamps.concat(t), t.forEach(this.ignore, this)) }, f.unstamp = function (t) { t = this._find(t), t && t.forEach(function (t) { n.removeFrom(this.stamps, t), this.unignore(t) }, this) }, f._find = function (t) { return t ? ("string" == typeof t && (t = this.element.querySelectorAll(t)), t = n.makeArray(t)) : void 0 }, f._manageStamps = function () { this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this)) }, f._getBoundingRect = function () { var t = this.element.getBoundingClientRect(), e = this.size; this._boundingRect = { left: t.left + e.paddingLeft + e.borderLeftWidth, top: t.top + e.paddingTop + e.borderTopWidth, right: t.right - (e.paddingRight + e.borderRightWidth), bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth) } }, f._manageStamp = d, f._getElementOffset = function (t) { var e = t.getBoundingClientRect(), n = this._boundingRect, o = i(t), r = { left: e.left - n.left - o.marginLeft, top: e.top - n.top - o.marginTop, right: n.right - e.right - o.marginRight, bottom: n.bottom - e.bottom - o.marginBottom }; return r }, f.handleEvent = n.handleEvent, f.bindResize = function () { t.addEventListener("resize", this), this.isResizeBound = !0 }, f.unbindResize = function () { t.removeEventListener("resize", this), this.isResizeBound = !1 }, f.onresize = function () { this.resize() }, n.debounceMethod(r, "onresize", 100), f.resize = function () { this.isResizeBound && this.needsResizeLayout() && this.layout() }, f.needsResizeLayout = function () { var t = i(this.element), e = this.size && t; return e && t.innerWidth !== this.size.innerWidth }, f.addItems = function (t) { var e = this._itemize(t); return e.length && (this.items = this.items.concat(e)), e }, f.appended = function (t) { var e = this.addItems(t); e.length && (this.layoutItems(e, !0), this.reveal(e)) }, f.prepended = function (t) { var e = this._itemize(t); if (e.length) { var i = this.items.slice(0); this.items = e.concat(i), this._resetLayout(), this._manageStamps(), this.layoutItems(e, !0), this.reveal(e), this.layoutItems(i) } }, f.reveal = function (t) { if (this._emitCompleteOnItems("reveal", t), t && t.length) { var e = this.updateStagger(); t.forEach(function (t, i) { t.stagger(i * e), t.reveal() }) } }, f.hide = function (t) { if (this._emitCompleteOnItems("hide", t), t && t.length) { var e = this.updateStagger(); t.forEach(function (t, i) { t.stagger(i * e), t.hide() }) } }, f.revealItemElements = function (t) { var e = this.getItems(t); this.reveal(e) }, f.hideItemElements = function (t) { var e = this.getItems(t); this.hide(e) }, f.getItem = function (t) { for (var e = 0; e < this.items.length; e++) { var i = this.items[e]; if (i.element == t) return i } }, f.getItems = function (t) { t = n.makeArray(t); var e = []; return t.forEach(function (t) { var i = this.getItem(t); i && e.push(i) }, this), e }, f.remove = function (t) { var e = this.getItems(t); this._emitCompleteOnItems("remove", e), e && e.length && e.forEach(function (t) { t.remove(), n.removeFrom(this.items, t) }, this) }, f.destroy = function () { var t = this.element.style; t.height = "", t.position = "", t.width = "", this.items.forEach(function (t) { t.destroy() }), this.unbindResize(); var e = this.element.outlayerGUID; delete c[e], delete this.element.outlayerGUID, u && u.removeData(this.element, this.constructor.namespace) }, r.data = function (t) { t = n.getQueryElement(t); var e = t && t.outlayerGUID; return e && c[e] }, r.create = function (t, e) { var i = s(r); return i.defaults = n.extend({}, r.defaults), n.extend(i.defaults, e), i.compatOptions = n.extend({}, r.compatOptions), i.namespace = t, i.data = r.data, i.Item = s(o), n.htmlInit(i, t), u && u.bridget && u.bridget(t, i), i }; var m = { ms: 1, s: 1e3 }; return r.Item = o, r }), function (t, e) { "function" == typeof define && define.amd ? define(["outlayer/outlayer", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("outlayer"), require("get-size")) : t.Masonry = e(t.Outlayer, t.getSize) }(window, function (t, e) { var i = t.create("masonry"); return i.compatOptions.fitWidth = "isFitWidth", i.prototype._resetLayout = function () { this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), this.colYs = []; for (var t = 0; t < this.cols; t++)this.colYs.push(0); this.maxY = 0 }, i.prototype.measureColumns = function () { if (this.getContainerWidth(), !this.columnWidth) { var t = this.items[0], i = t && t.element; this.columnWidth = i && e(i).outerWidth || this.containerWidth } var n = this.columnWidth += this.gutter, o = this.containerWidth + this.gutter, r = o / n, s = n - o % n, a = s && 1 > s ? "round" : "floor"; r = Math[a](r), this.cols = Math.max(r, 1) }, i.prototype.getContainerWidth = function () { var t = this._getOption("fitWidth"), i = t ? this.element.parentNode : this.element, n = e(i); this.containerWidth = n && n.innerWidth }, i.prototype._getItemLayoutPosition = function (t) { t.getSize(); var e = t.size.outerWidth % this.columnWidth, i = e && 1 > e ? "round" : "ceil", n = Math[i](t.size.outerWidth / this.columnWidth); n = Math.min(n, this.cols); for (var o = this._getColGroup(n), r = Math.min.apply(Math, o), s = o.indexOf(r), a = { x: this.columnWidth * s, y: r }, h = r + t.size.outerHeight, u = this.cols + 1 - o.length, d = 0; u > d; d++)this.colYs[s + d] = h; return a }, i.prototype._getColGroup = function (t) { if (2 > t) return this.colYs; for (var e = [], i = this.cols + 1 - t, n = 0; i > n; n++) { var o = this.colYs.slice(n, n + t); e[n] = Math.max.apply(Math, o) } return e }, i.prototype._manageStamp = function (t) { var i = e(t), n = this._getElementOffset(t), o = this._getOption("originLeft"), r = o ? n.left : n.right, s = r + i.outerWidth, a = Math.floor(r / this.columnWidth); a = Math.max(0, a); var h = Math.floor(s / this.columnWidth); h -= s % this.columnWidth ? 0 : 1, h = Math.min(this.cols - 1, h); for (var u = this._getOption("originTop"), d = (u ? n.top : n.bottom) + i.outerHeight, l = a; h >= l; l++)this.colYs[l] = Math.max(d, this.colYs[l]) }, i.prototype._getContainerSize = function () { this.maxY = Math.max.apply(Math, this.colYs); var t = { height: this.maxY }; return this._getOption("fitWidth") && (t.width = this._getContainerFitWidth()), t }, i.prototype._getContainerFitWidth = function () { for (var t = 0, e = this.cols; --e && 0 === this.colYs[e];)t++; return (this.cols - t) * this.columnWidth - this.gutter }, i.prototype.needsResizeLayout = function () { var t = this.containerWidth; return this.getContainerWidth(), t != this.containerWidth }, i });
/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-csstransforms3d-flexbox-setclasses !*/
!function (e, n, t) { function r(e, n) { return typeof e === n } function s() { var e, n, t, s, o, i, a; for (var f in C) if (C.hasOwnProperty(f)) { if (e = [], n = C[f], n.name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length)) for (t = 0; t < n.options.aliases.length; t++)e.push(n.options.aliases[t].toLowerCase()); for (s = r(n.fn, "function") ? n.fn() : n.fn, o = 0; o < e.length; o++)i = e[o], a = i.split("."), 1 === a.length ? Modernizr[a[0]] = s : (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = s), y.push((s ? "" : "no-") + a.join("-")) } } function o(e) { var n = x.className, t = Modernizr._config.classPrefix || ""; if (S && (n = n.baseVal), Modernizr._config.enableJSClass) { var r = new RegExp("(^|\\s)" + t + "no-js(\\s|$)"); n = n.replace(r, "$1" + t + "js$2") } Modernizr._config.enableClasses && (n += " " + t + e.join(" " + t), S ? x.className.baseVal = n : x.className = n) } function i() { return "function" != typeof n.createElement ? n.createElement(arguments[0]) : S ? n.createElementNS.call(n, "http://www.w3.org/2000/svg", arguments[0]) : n.createElement.apply(n, arguments) } function a() { var e = n.body; return e || (e = i(S ? "svg" : "body"), e.fake = !0), e } function f(e, t, r, s) { var o, f, l, u, p = "modernizr", d = i("div"), c = a(); if (parseInt(r, 10)) for (; r--;)l = i("div"), l.id = s ? s[r] : p + (r + 1), d.appendChild(l); return o = i("style"), o.type = "text/css", o.id = "s" + p, (c.fake ? c : d).appendChild(o), c.appendChild(d), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(n.createTextNode(e)), d.id = p, c.fake && (c.style.background = "", c.style.overflow = "hidden", u = x.style.overflow, x.style.overflow = "hidden", x.appendChild(c)), f = t(d, e), c.fake ? (c.parentNode.removeChild(c), x.style.overflow = u, x.offsetHeight) : d.parentNode.removeChild(d), !!f } function l(e, n) { return !!~("" + e).indexOf(n) } function u(e) { return e.replace(/([a-z])-([a-z])/g, function (e, n, t) { return n + t.toUpperCase() }).replace(/^-/, "") } function p(e, n) { return function () { return e.apply(n, arguments) } } function d(e, n, t) { var s; for (var o in e) if (e[o] in n) return t === !1 ? e[o] : (s = n[e[o]], r(s, "function") ? p(s, t || n) : s); return !1 } function c(e) { return e.replace(/([A-Z])/g, function (e, n) { return "-" + n.toLowerCase() }).replace(/^ms-/, "-ms-") } function m(n, r) { var s = n.length; if ("CSS" in e && "supports" in e.CSS) { for (; s--;)if (e.CSS.supports(c(n[s]), r)) return !0; return !1 } if ("CSSSupportsRule" in e) { for (var o = []; s--;)o.push("(" + c(n[s]) + ":" + r + ")"); return o = o.join(" or "), f("@supports (" + o + ") { #modernizr { position: absolute; } }", function (e) { return "absolute" == getComputedStyle(e, null).position }) } return t } function h(e, n, s, o) { function a() { p && (delete k.style, delete k.modElem) } if (o = r(o, "undefined") ? !1 : o, !r(s, "undefined")) { var f = m(e, s); if (!r(f, "undefined")) return f } for (var p, d, c, h, v, g = ["modernizr", "tspan", "samp"]; !k.style && g.length;)p = !0, k.modElem = i(g.shift()), k.style = k.modElem.style; for (c = e.length, d = 0; c > d; d++)if (h = e[d], v = k.style[h], l(h, "-") && (h = u(h)), k.style[h] !== t) { if (o || r(s, "undefined")) return a(), "pfx" == n ? h : !0; try { k.style[h] = s } catch (y) { } if (k.style[h] != v) return a(), "pfx" == n ? h : !0 } return a(), !1 } function v(e, n, t, s, o) { var i = e.charAt(0).toUpperCase() + e.slice(1), a = (e + " " + E.join(i + " ") + i).split(" "); return r(n, "string") || r(n, "undefined") ? h(a, n, s, o) : (a = (e + " " + T.join(i + " ") + i).split(" "), d(a, n, t)) } function g(e, n, r) { return v(e, t, t, n, r) } var y = [], C = [], w = { _version: "3.3.1", _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function (e, n) { var t = this; setTimeout(function () { n(t[e]) }, 0) }, addTest: function (e, n, t) { C.push({ name: e, fn: n, options: t }) }, addAsyncTest: function (e) { C.push({ name: null, fn: e }) } }, Modernizr = function () { }; Modernizr.prototype = w, Modernizr = new Modernizr; var x = n.documentElement, S = "svg" === x.nodeName.toLowerCase(), _ = "CSS" in e && "supports" in e.CSS, b = "supportsCSS" in e; Modernizr.addTest("supports", _ || b); var P = w.testStyles = f, z = "Moz O ms Webkit", E = w._config.usePrefixes ? z.split(" ") : []; w._cssomPrefixes = E; var T = w._config.usePrefixes ? z.toLowerCase().split(" ") : []; w._domPrefixes = T; var N = { elem: i("modernizr") }; Modernizr._q.push(function () { delete N.elem }); var k = { style: N.elem.style }; Modernizr._q.unshift(function () { delete k.style }), w.testAllProps = v, w.testAllProps = g, Modernizr.addTest("flexbox", g("flexBasis", "1px", !0)), Modernizr.addTest("csstransforms3d", function () { var e = !!g("perspective", "1px", !0), n = Modernizr._config.usePrefixes; if (e && (!n || "webkitPerspective" in x.style)) { var t, r = "#modernizr{width:0;height:0}"; Modernizr.supports ? t = "@supports (perspective: 1px)" : (t = "@media (transform-3d)", n && (t += ",(-webkit-transform-3d)")), t += "{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}", P(r + t, function (n) { e = 7 === n.offsetWidth && 18 === n.offsetHeight }) } return e }), s(), o(y), delete w.addTest, delete w.addAsyncTest; for (var j = 0; j < Modernizr._q.length; j++)Modernizr._q[j](); e.Modernizr = Modernizr }(window, document);
/*! respimage - v1.4.2 - 2015-08-22
 Licensed MIT */
!function (a, b, c) { "use strict"; function d(a) { return a.trim ? a.trim() : a.replace(/^\s+|\s+$/g, "") } function e() { var b; R = !1, U = a.devicePixelRatio, S = {}, T = {}, b = (U || 1) * D.xQuant, D.uT || (D.maxX = Math.max(1.3, D.maxX), b = Math.min(b, D.maxX), v.DPR = b), V.width = Math.max(a.innerWidth || 0, B.clientWidth), V.height = Math.max(a.innerHeight || 0, B.clientHeight), V.vw = V.width / 100, V.vh = V.height / 100, V.em = v.getEmValue(), V.rem = V.em, o = D.lazyFactor / 2, o = o * b + o, q = .4 + .1 * b, l = .5 + .2 * b, m = .5 + .25 * b, p = b + 1.3, (n = V.width > V.height) || (o *= .9), I && (o *= .9), u = [V.width, V.height, b].join("-") } function f(a, b, c) { var d = b * Math.pow(a - .4, 1.9); return n || (d /= 1.3), a += d, a > c } function g(a) { var b, c = v.getSet(a), d = !1; "pending" != c && (d = u, c && (b = v.setRes(c), d = v.applySetCandidate(b, a))), a[v.ns].evaled = d } function h(a, b) { return a.res - b.res } function i(a, b, c) { var d; return !c && b && (c = a[v.ns].sets, c = c && c[c.length - 1]), d = j(b, c), d && (b = v.makeUrl(b), a[v.ns].curSrc = b, a[v.ns].curCan = d, d.res || _(d, d.set.sizes)), d } function j(a, b) { var c, d, e; if (a && b) for (e = v.parseSet(b), a = v.makeUrl(a), c = 0; c < e.length; c++)if (a == v.makeUrl(e[c].url)) { d = e[c]; break } return d } function k(a, b) { var c, d, e, f, g = a.getElementsByTagName("source"); for (c = 0, d = g.length; d > c; c++)e = g[c], e[v.ns] = !0, f = e.getAttribute("srcset"), f && b.push({ srcset: f, media: e.getAttribute("media"), type: e.getAttribute("type"), sizes: e.getAttribute("sizes") }) } var l, m, n, o, p, q, r, s, t, u, v = {}, w = function () { }, x = b.createElement("img"), y = x.getAttribute, z = x.setAttribute, A = x.removeAttribute, B = b.documentElement, C = {}, D = { xQuant: 1, lazyFactor: .4, maxX: 2 }, E = "data-pfsrc", F = E + "set", G = "webkitBackfaceVisibility" in B.style, H = navigator.userAgent, I = /rident/.test(H) || /ecko/.test(H) && H.match(/rv\:(\d+)/) && RegExp.$1 > 35, J = "currentSrc", K = /\s+\+?\d+(e\d+)?w/, L = /((?:\([^)]+\)(?:\s*and\s*|\s*or\s*|\s*not\s*)?)+)?\s*(.+)/, M = /^([\+eE\d\.]+)(w|x)$/, N = /\s*\d+h\s*/, O = a.respimgCFG, P = ("https:" == location.protocol, "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)"), Q = "font-size:100%!important;", R = !0, S = {}, T = {}, U = a.devicePixelRatio, V = { px: 1, "in": 96 }, W = b.createElement("a"), X = !1, Y = function (a, b, c, d) { a.addEventListener ? a.addEventListener(b, c, d || !1) : a.attachEvent && a.attachEvent("on" + b, c) }, Z = function (a) { var b = {}; return function (c) { return c in b || (b[c] = a(c)), b[c] } }, $ = function () { var a = /^([\d\.]+)(em|vw|px)$/, b = function () { for (var a = arguments, b = 0, c = a[0]; ++b in a;)c = c.replace(a[b], a[++b]); return c }, c = Z(function (a) { return "return " + b((a || "").toLowerCase(), /\band\b/g, "&&", /,/g, "||", /min-([a-z-\s]+):/g, "e.$1>=", /max-([a-z-\s]+):/g, "e.$1<=", /calc([^)]+)/g, "($1)", /(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)", /^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/gi, "") }); return function (b, d) { var e; if (!(b in S)) if (S[b] = !1, d && (e = b.match(a))) S[b] = e[1] * V[e[2]]; else try { S[b] = new Function("e", c(b))(V) } catch (f) { } return S[b] } }(), _ = function (a, b) { return a.w ? (a.cWidth = v.calcListLength(b || "100vw"), a.res = a.w / a.cWidth) : a.res = a.x, a }, ab = function (c) { var d, e, f, g = c || {}; if (g.elements && 1 == g.elements.nodeType && ("IMG" == g.elements.nodeName.toUpperCase() ? g.elements = [g.elements] : (g.context = g.elements, g.elements = null)), g.reparse && (g.reevaluate = !0, a.console && console.warn && console.warn("reparse was renamed to reevaluate!")), d = g.elements || v.qsa(g.context || b, g.reevaluate || g.reselect ? v.sel : v.selShort), f = d.length) { for (v.setupRun(g), X = !0, e = 0; f > e; e++)v.fillImg(d[e], g); v.teardownRun(g) } }, bb = Z(function (a) { var b = [1, "x"], c = d(a || ""); return c && (c = c.replace(N, ""), b = c.match(M) ? [1 * RegExp.$1, RegExp.$2] : !1), b }); if (J in x || (J = "src"), C["image/jpeg"] = !0, C["image/gif"] = !0, C["image/png"] = !0, C["image/svg+xml"] = b.implementation.hasFeature("http://wwwindow.w3.org/TR/SVG11/feature#Image", "1.1"), v.ns = ("ri" + (new Date).getTime()).substr(0, 9), v.supSrcset = "srcset" in x, v.supSizes = "sizes" in x, v.supPicture = !!a.HTMLPictureElement, v.supSrcset && v.supPicture && !v.supSizes && !function (a) { x.srcset = "data:,a", a.src = "data:,a", v.supSrcset = x.complete === a.complete, v.supPicture = v.supSrcset && v.supPicture }(b.createElement("img")), v.selShort = "picture>img,img[srcset]", v.sel = v.selShort, v.cfg = D, v.supSrcset && (v.sel += ",img[" + F + "]"), v.DPR = U || 1, v.u = V, v.types = C, s = v.supSrcset && !v.supSizes, v.setSize = w, v.makeUrl = Z(function (a) { return W.href = a, W.href }), v.qsa = function (a, b) { return a.querySelectorAll(b) }, v.matchesMedia = function () { return v.matchesMedia = a.matchMedia && (matchMedia("(min-width: 0.1em)") || {}).matches ? function (a) { return !a || matchMedia(a).matches } : v.mMQ, v.matchesMedia.apply(this, arguments) }, v.mMQ = function (a) { return a ? $(a) : !0 }, v.calcLength = function (a) { var b = $(a, !0) || !1; return 0 > b && (b = !1), b }, v.supportsType = function (a) { return a ? C[a] : !0 }, v.parseSize = Z(function (a) { var b = (a || "").match(L); return { media: b && b[1], length: b && b[2] } }), v.parseSet = function (a) { if (!a.cands) { var b, c, d, e, f, g, h = a.srcset; for (a.cands = []; h;)h = h.replace(/^\s+/g, ""), b = h.search(/\s/g), d = null, -1 != b ? (c = h.slice(0, b), e = c.charAt(c.length - 1), "," != e && c || (c = c.replace(/,+$/, ""), d = ""), h = h.slice(b + 1), null == d && (f = h.indexOf(","), -1 != f ? (d = h.slice(0, f), h = h.slice(f + 1)) : (d = h, h = ""))) : (c = h, h = ""), c && (d = bb(d)) && (g = { url: c.replace(/^,+/, ""), set: a }, g[d[1]] = d[0], "x" == d[1] && 1 == d[0] && (a.has1x = !0), a.cands.push(g)) } return a.cands }, v.getEmValue = function () { var a; if (!r && (a = b.body)) { var c = b.createElement("div"), d = B.style.cssText, e = a.style.cssText; c.style.cssText = P, B.style.cssText = Q, a.style.cssText = Q, a.appendChild(c), r = c.offsetWidth, a.removeChild(c), r = parseFloat(r, 10), B.style.cssText = d, a.style.cssText = e } return r || 16 }, v.calcListLength = function (a) { if (!(a in T) || D.uT) { var b, c, e, f, g, h, i = d(a).split(/\s*,\s*/), j = !1; for (g = 0, h = i.length; h > g && (b = i[g], c = v.parseSize(b), e = c.length, f = c.media, !e || !v.matchesMedia(f) || (j = v.calcLength(e)) === !1); g++); T[a] = j ? j : V.width } return T[a] }, v.setRes = function (a) { var b; if (a) { b = v.parseSet(a); for (var c = 0, d = b.length; d > c; c++)_(b[c], a.sizes) } return b }, v.setRes.res = _, v.applySetCandidate = function (a, b) { if (a.length) { var c, d, e, g, j, k, n, r, s, t, w, x, y, z = b[v.ns], A = u, B = o, C = q; if (r = z.curSrc || b[J], s = z.curCan || i(b, r, a[0].set), d = v.DPR, y = s && s.res, !n && r && (x = I && !b.complete && s && y - .2 > d, x || s && !(p > y) || (s && d > y && y > l && (m > y && (B *= .8, C += .04 * d), s.res += B * Math.pow(y - C, 2)), t = !z.pic || s && s.set == a[0].set, s && t && s.res >= d && (n = s))), !n) for (y && (s.res = s.res - (s.res - y) / 2), a.sort(h), k = a.length, n = a[k - 1], e = 0; k > e; e++)if (c = a[e], c.res >= d) { g = e - 1, n = a[g] && (j = c.res - d) && (x || r != v.makeUrl(c.url)) && f(a[g].res, j, d) ? a[g] : c; break } return y && (s.res = y), n && (w = v.makeUrl(n.url), z.curSrc = w, z.curCan = n, w != r && v.setSrc(b, n), v.setSize(b)), A } }, v.setSrc = function (a, b) { var c; a.src = b.url, G && (c = a.style.zoom, a.style.zoom = "0.999", a.style.zoom = c) }, v.getSet = function (a) { var b, c, d, e = !1, f = a[v.ns].sets; for (b = 0; b < f.length && !e; b++)if (c = f[b], c.srcset && v.matchesMedia(c.media) && (d = v.supportsType(c.type))) { "pending" == d && (c = d), e = c; break } return e }, v.parseSets = function (a, b, d) { var e, f, g, h, i = "PICTURE" == b.nodeName.toUpperCase(), l = a[v.ns]; (l.src === c || d.src) && (l.src = y.call(a, "src"), l.src ? z.call(a, E, l.src) : A.call(a, E)), (l.srcset === c || !v.supSrcset || a.srcset || d.srcset) && (e = y.call(a, "srcset"), l.srcset = e, h = !0), l.sets = [], i && (l.pic = !0, k(b, l.sets)), l.srcset ? (f = { srcset: l.srcset, sizes: y.call(a, "sizes") }, l.sets.push(f), g = (s || l.src) && K.test(l.srcset || ""), g || !l.src || j(l.src, f) || f.has1x || (f.srcset += ", " + l.src, f.cands.push({ url: l.src, x: 1, set: f }))) : l.src && l.sets.push({ srcset: l.src, sizes: null }), l.curCan = null, l.curSrc = c, l.supported = !(i || f && !v.supSrcset || g), h && v.supSrcset && !l.supported && (e ? (z.call(a, F, e), a.srcset = "") : A.call(a, F)), l.supported && !l.srcset && (!l.src && a.src || a.src != v.makeUrl(l.src)) && (null == l.src ? a.removeAttribute("src") : a.src = l.src), l.parsed = !0 }, v.fillImg = function (a, b) { var c, d, e = b.reselect || b.reevaluate; if (a[v.ns] || (a[v.ns] = {}), d = a[v.ns], e || d.evaled != u) { if (!d.parsed || b.reevaluate) { if (c = a.parentNode, !c) return; v.parseSets(a, c, b) } d.supported ? d.evaled = u : g(a) } }, v.setupRun = function (b) { (!X || R || U != a.devicePixelRatio) && (e(), b.elements || b.context || clearTimeout(t)) }, v.supPicture ? (ab = w, v.fillImg = w) : (b.createElement("picture"), function () { var c, d = a.attachEvent ? /d$|^c/ : /d$|^c|^i/, e = function () { var a = b.readyState || ""; h = setTimeout(e, "loading" == a ? 200 : 999), b.body && (c = c || d.test(a), v.fillImgs(), c && clearTimeout(h)) }, f = function () { v.fillImgs() }, g = function () { clearTimeout(t), R = !0, t = setTimeout(f, 99) }, h = setTimeout(e, b.body ? 0 : 20); Y(a, "resize", g), Y(b, "readystatechange", e) }()), v.respimage = ab, v.fillImgs = ab, v.teardownRun = w, ab._ = v, a.respimage = a.picturefill || ab, !a.picturefill) for (a.respimgCFG = { ri: v, push: function (a) { var b = a.shift(); "function" == typeof v[b] ? v[b].apply(v, a) : (D[b] = a[0], X && v.fillImgs({ reselect: !0 })) } }; O && O.length;)a.respimgCFG.push(O.shift()); a.picturefill || (a.picturefill = a.respimage, a.picturefillCFG || (a.picturefillCFG = a.respimgCFG)) }(window, document);
// ---------------------------------------------------------------------------
// Shopify generic helper methods
// ---------------------------------------------------------------------------
Shopify.arrayIncludes = function (ary, obj) {
  for (var i = 0; i < ary.length; i++) {
    if (ary[i] == obj) {
      return true;
    }
  }
  return false;
};

Shopify.uniq = function (ary) {
  var result = [];
  for (var i = 0; i < ary.length; i++) {
    if (!Shopify.arrayIncludes(result, ary[i])) { result.push(ary[i]); }
  }
  return result;
};

// ---------------------------------------------------------------------------
// Image.switchImage
// helps to switch variant images on variant selection
// ---------------------------------------------------------------------------
Shopify.Image = {

  preload: function (images, size) {
    for (var i = 0; i < images.length; i++) {
      var image = images[i];

      this.loadImage(this.getSizedImageUrl(image, size));
    }
  },

  loadImage: function (path) {
    new Image().src = path;
  },

  switchImage: function (image, element, callback) {
    if (!image || !element) {
      return;
    }

    var size = this.imageSize(element.src)
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element);
    } else {
      element.src = imageUrl;
    }
  },

  imageSize: function (src) {
    var match = src.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);

    if (match != null) {
      return match[1];
    } else {
      return null;
    }
  },

  getSizedImageUrl: function (src, size) {
    if (size == null) {
      return src;
    }

    if (size == 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    } else {
      return null;
    }
  },

  removeProtocol: function (path) {
    return path.replace(/http(s)?:/, "");
  }
};

/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.6.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
(function (factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof exports !== 'undefined') {
    module.exports = factory(require('jquery'));
  } else {
    factory(jQuery);
  }

}(function ($) {
  'use strict';
  var Slick = window.Slick || {};

  Slick = (function () {

    var instanceUid = 0;

    function Slick(element, settings) {

      var _ = this, dataSettings;

      _.defaults = {
        accessibility: true,
        adaptiveHeight: false,
        appendArrows: $(element),
        appendDots: $(element),
        arrows: true,
        asNavFor: null,
        prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"></button>',
        nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"></button>',
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: false,
        centerPadding: '50px',
        cssEase: 'ease',
        customPaging: function (slider, i) {
          return $('<button type="button" data-role="none" type="button" tabindex="0" />').text(i + 1);
        },
        dots: false,
        dotsClass: 'slick-dots',
        draggable: true,
        easing: 'linear',
        edgeFriction: 0.35,
        fade: false,
        focusOnSelect: false,
        infinite: true,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        mobileFirst: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        pauseOnDotsHover: false,
        respondTo: 'window',
        responsive: null,
        rows: 1,
        rtl: false,
        slide: '',
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: true,
        swipeToSlide: false,
        touchMove: true,
        touchThreshold: 5,
        useCSS: true,
        useTransform: true,
        variableWidth: false,
        vertical: false,
        verticalSwiping: false,
        waitForAnimate: true,
        zIndex: 1000
      };

      _.initials = {
        animating: false,
        dragging: false,
        autoPlayTimer: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        $dots: null,
        listWidth: null,
        listHeight: null,
        loadIndex: 0,
        $nextArrow: null,
        $prevArrow: null,
        slideCount: null,
        slideWidth: null,
        $slideTrack: null,
        $slides: null,
        sliding: false,
        slideOffset: 0,
        swipeLeft: null,
        $list: null,
        touchObject: {},
        transformsEnabled: false,
        unslicked: false
      };

      $.extend(_, _.initials);

      _.activeBreakpoint = null;
      _.animType = null;
      _.animProp = null;
      _.breakpoints = [];
      _.breakpointSettings = [];
      _.cssTransitions = false;
      _.focussed = false;
      _.interrupted = false;
      _.hidden = 'hidden';
      _.paused = true;
      _.positionProp = null;
      _.respondTo = null;
      _.rowCount = 1;
      _.shouldClick = true;
      _.$slider = $(element);
      _.$slidesCache = null;
      _.transformType = null;
      _.transitionType = null;
      _.visibilityChange = 'visibilitychange';
      _.windowWidth = 0;
      _.windowTimer = null;

      dataSettings = $(element).data('slick') || {};

      _.options = $.extend({}, _.defaults, settings, dataSettings);

      _.currentSlide = _.options.initialSlide;

      _.originalSettings = _.options;

      if (typeof document.mozHidden !== 'undefined') {
        _.hidden = 'mozHidden';
        _.visibilityChange = 'mozvisibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        _.hidden = 'webkitHidden';
        _.visibilityChange = 'webkitvisibilitychange';
      }

      _.autoPlay = $.proxy(_.autoPlay, _);
      _.autoPlayClear = $.proxy(_.autoPlayClear, _);
      _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
      _.changeSlide = $.proxy(_.changeSlide, _);
      _.clickHandler = $.proxy(_.clickHandler, _);
      _.selectHandler = $.proxy(_.selectHandler, _);
      _.setPosition = $.proxy(_.setPosition, _);
      _.swipeHandler = $.proxy(_.swipeHandler, _);
      _.dragHandler = $.proxy(_.dragHandler, _);
      _.keyHandler = $.proxy(_.keyHandler, _);

      _.instanceUid = instanceUid++;

      // A simple way to check for HTML strings
      // Strict HTML recognition (must start with <)
      // Extracted from jQuery v1.11 source
      _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


      _.registerBreakpoints();
      _.init(true);

    }

    return Slick;

  }());

  Slick.prototype.activateADA = function () {
    var _ = this;

    _.$slideTrack.find('.slick-active').attr({
      'aria-hidden': 'false'
    }).find('a, input, button, select').attr({
      'tabindex': '0'
    });

  };

  Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {

    var _ = this;

    if (typeof (index) === 'boolean') {
      addBefore = index;
      index = null;
    } else if (index < 0 || (index >= _.slideCount)) {
      return false;
    }

    _.unload();

    if (typeof (index) === 'number') {
      if (index === 0 && _.$slides.length === 0) {
        $(markup).appendTo(_.$slideTrack);
      } else if (addBefore) {
        $(markup).insertBefore(_.$slides.eq(index));
      } else {
        $(markup).insertAfter(_.$slides.eq(index));
      }
    } else {
      if (addBefore === true) {
        $(markup).prependTo(_.$slideTrack);
      } else {
        $(markup).appendTo(_.$slideTrack);
      }
    }

    _.$slides = _.$slideTrack.children(this.options.slide);

    _.$slideTrack.children(this.options.slide).detach();

    _.$slideTrack.append(_.$slides);

    _.$slides.each(function (index, element) {
      $(element).attr('data-slick-index', index);
    });

    _.$slidesCache = _.$slides;

    _.reinit();

  };

  Slick.prototype.animateHeight = function () {
    var _ = this;
    if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
      var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
      _.$list.animate({
        height: targetHeight
      }, _.options.speed);
    }
  };

  Slick.prototype.animateSlide = function (targetLeft, callback) {

    var animProps = {},
      _ = this;

    _.animateHeight();

    if (_.options.rtl === true && _.options.vertical === false) {
      targetLeft = -targetLeft;
    }
    if (_.transformsEnabled === false) {
      if (_.options.vertical === false) {
        _.$slideTrack.animate({
          left: targetLeft
        }, _.options.speed, _.options.easing, callback);
      } else {
        _.$slideTrack.animate({
          top: targetLeft
        }, _.options.speed, _.options.easing, callback);
      }

    } else {

      if (_.cssTransitions === false) {
        if (_.options.rtl === true) {
          _.currentLeft = -(_.currentLeft);
        }
        $({
          animStart: _.currentLeft
        }).animate({
          animStart: targetLeft
        }, {
          duration: _.options.speed,
          easing: _.options.easing,
          step: function (now) {
            now = Math.ceil(now);
            if (_.options.vertical === false) {
              animProps[_.animType] = 'translate(' +
                now + 'px, 0px)';
              _.$slideTrack.css(animProps);
            } else {
              animProps[_.animType] = 'translate(0px,' +
                now + 'px)';
              _.$slideTrack.css(animProps);
            }
          },
          complete: function () {
            if (callback) {
              callback.call();
            }
          }
        });

      } else {

        _.applyTransition();
        targetLeft = Math.ceil(targetLeft);

        if (_.options.vertical === false) {
          animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
        } else {
          animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
        }
        _.$slideTrack.css(animProps);

        if (callback) {
          setTimeout(function () {

            _.disableTransition();

            callback.call();
          }, _.options.speed);
        }

      }

    }

  };

  Slick.prototype.getNavTarget = function () {

    var _ = this,
      asNavFor = _.options.asNavFor;

    if (asNavFor && asNavFor !== null) {
      asNavFor = $(asNavFor).not(_.$slider);
    }

    return asNavFor;

  };

  Slick.prototype.asNavFor = function (index) {

    var _ = this,
      asNavFor = _.getNavTarget();

    if (asNavFor !== null && typeof asNavFor === 'object') {
      asNavFor.each(function () {
        var target = $(this).slick('getSlick');
        if (!target.unslicked) {
          target.slideHandler(index, true);
        }
      });
    }

  };

  Slick.prototype.applyTransition = function (slide) {

    var _ = this,
      transition = {};

    if (_.options.fade === false) {
      transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
    } else {
      transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
    }

    if (_.options.fade === false) {
      _.$slideTrack.css(transition);
    } else {
      _.$slides.eq(slide).css(transition);
    }

  };

  Slick.prototype.autoPlay = function () {

    var _ = this;

    _.autoPlayClear();

    if (_.slideCount > _.options.slidesToShow) {
      _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
    }

  };

  Slick.prototype.autoPlayClear = function () {

    var _ = this;

    if (_.autoPlayTimer) {
      clearInterval(_.autoPlayTimer);
    }

  };

  Slick.prototype.autoPlayIterator = function () {

    var _ = this,
      slideTo = _.currentSlide + _.options.slidesToScroll;

    if (!_.paused && !_.interrupted && !_.focussed) {

      if (_.options.infinite === false) {

        if (_.direction === 1 && (_.currentSlide + 1) === (_.slideCount - 1)) {
          _.direction = 0;
        }

        else if (_.direction === 0) {

          slideTo = _.currentSlide - _.options.slidesToScroll;

          if (_.currentSlide - 1 === 0) {
            _.direction = 1;
          }

        }

      }

      _.slideHandler(slideTo);

    }

  };

  Slick.prototype.buildArrows = function () {
    var _ = this;

    if (_.options.arrows === true) {

      _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
      _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

      if (_.slideCount > _.options.slidesToShow) {

        _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
        _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

        if (_.htmlExpr.test(_.options.prevArrow)) {
          _.$prevArrow.prependTo(_.options.appendArrows);
        }

        if (_.htmlExpr.test(_.options.nextArrow)) {
          _.$nextArrow.appendTo(_.options.appendArrows);
        }

        if (_.options.infinite !== true) {
          _.$prevArrow
            .addClass('slick-disabled')
            .attr('aria-disabled', 'true');
        }

      } else {

        _.$prevArrow.add(_.$nextArrow)

          .addClass('slick-hidden')
          .attr({
            'aria-disabled': 'true',
            'tabindex': '-1'
          });

      }

    }

  };

  Slick.prototype.buildDots = function () {

    var _ = this,
      i, dot;

    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

      _.$slider.addClass('slick-dotted');

      dot = $('<ul />').addClass(_.options.dotsClass);

      for (i = 0; i <= _.getDotCount(); i += 1) {
        dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
      }

      _.$dots = dot.appendTo(_.options.appendDots);

      _.$dots.find('li').first().addClass('slick-active').attr('aria-hidden', 'false');

    }

  };

  Slick.prototype.buildOut = function () {

    var _ = this;

    _.$slides =
      _.$slider
        .children(_.options.slide + ':not(.slick-cloned)')
        .addClass('slick-slide');

    _.slideCount = _.$slides.length;

    _.$slides.each(function (index, element) {
      $(element)
        .attr('data-slick-index', index)
        .data('originalStyling', $(element).attr('style') || '');
    });

    _.$slider.addClass('slick-slider');

    _.$slideTrack = (_.slideCount === 0) ?
      $('<div class="slick-track"/>').appendTo(_.$slider) :
      _.$slides.wrapAll('<div class="slick-track"/>').parent();

    _.$list = _.$slideTrack.wrap(
      '<div aria-live="polite" class="slick-list"/>').parent();
    _.$slideTrack.css('opacity', 0);

    if (_.options.centerMode === true || _.options.swipeToSlide === true) {
      _.options.slidesToScroll = 1;
    }

    $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

    _.setupInfinite();

    _.buildArrows();

    _.buildDots();

    _.updateDots();


    _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

    if (_.options.draggable === true) {
      _.$list.addClass('draggable');
    }

  };

  Slick.prototype.buildRows = function () {

    var _ = this, a, b, c, newSlides, numOfSlides, originalSlides, slidesPerSection;

    newSlides = document.createDocumentFragment();
    originalSlides = _.$slider.children();

    if (_.options.rows > 1) {

      slidesPerSection = _.options.slidesPerRow * _.options.rows;
      numOfSlides = Math.ceil(
        originalSlides.length / slidesPerSection
      );

      for (a = 0; a < numOfSlides; a++) {
        var slide = document.createElement('div');
        for (b = 0; b < _.options.rows; b++) {
          var row = document.createElement('div');
          for (c = 0; c < _.options.slidesPerRow; c++) {
            var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
            if (originalSlides.get(target)) {
              row.appendChild(originalSlides.get(target));
            }
          }
          slide.appendChild(row);
        }
        newSlides.appendChild(slide);
      }

      _.$slider.empty().append(newSlides);
      _.$slider.children().children().children()
        .css({
          'width': (100 / _.options.slidesPerRow) + '%',
          'display': 'inline-block'
        });

    }

  };

  Slick.prototype.checkResponsive = function (initial, forceUpdate) {

    var _ = this,
      breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
    var sliderWidth = _.$slider.width();
    var windowWidth = window.innerWidth || $(window).width();

    if (_.respondTo === 'window') {
      respondToWidth = windowWidth;
    } else if (_.respondTo === 'slider') {
      respondToWidth = sliderWidth;
    } else if (_.respondTo === 'min') {
      respondToWidth = Math.min(windowWidth, sliderWidth);
    }

    if (_.options.responsive &&
      _.options.responsive.length &&
      _.options.responsive !== null) {

      targetBreakpoint = null;

      for (breakpoint in _.breakpoints) {
        if (_.breakpoints.hasOwnProperty(breakpoint)) {
          if (_.originalSettings.mobileFirst === false) {
            if (respondToWidth < _.breakpoints[breakpoint]) {
              targetBreakpoint = _.breakpoints[breakpoint];
            }
          } else {
            if (respondToWidth > _.breakpoints[breakpoint]) {
              targetBreakpoint = _.breakpoints[breakpoint];
            }
          }
        }
      }

      if (targetBreakpoint !== null) {
        if (_.activeBreakpoint !== null) {
          if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
            _.activeBreakpoint =
              targetBreakpoint;
            if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
              _.unslick(targetBreakpoint);
            } else {
              _.options = $.extend({}, _.originalSettings,
                _.breakpointSettings[
                targetBreakpoint]);
              if (initial === true) {
                _.currentSlide = _.options.initialSlide;
              }
              _.refresh(initial);
            }
            triggerBreakpoint = targetBreakpoint;
          }
        } else {
          _.activeBreakpoint = targetBreakpoint;
          if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
            _.unslick(targetBreakpoint);
          } else {
            _.options = $.extend({}, _.originalSettings,
              _.breakpointSettings[
              targetBreakpoint]);
            if (initial === true) {
              _.currentSlide = _.options.initialSlide;
            }
            _.refresh(initial);
          }
          triggerBreakpoint = targetBreakpoint;
        }
      } else {
        if (_.activeBreakpoint !== null) {
          _.activeBreakpoint = null;
          _.options = _.originalSettings;
          if (initial === true) {
            _.currentSlide = _.options.initialSlide;
          }
          _.refresh(initial);
          triggerBreakpoint = targetBreakpoint;
        }
      }

      // only trigger breakpoints during an actual break. not on initialize.
      if (!initial && triggerBreakpoint !== false) {
        _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
      }
    }

  };

  Slick.prototype.changeSlide = function (event, dontAnimate) {

    var _ = this,
      $target = $(event.currentTarget),
      indexOffset, slideOffset, unevenOffset;

    // If target is a link, prevent default action.
    if ($target.is('a')) {
      event.preventDefault();
    }

    // If target is not the <li> element (ie: a child), find the <li>.
    if (!$target.is('li')) {
      $target = $target.closest('li');
    }

    unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
    indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

    switch (event.data.message) {

      case 'previous':
        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
        if (_.slideCount > _.options.slidesToShow) {
          _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
        }
        break;

      case 'next':
        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
        if (_.slideCount > _.options.slidesToShow) {
          _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
        }
        break;

      case 'index':
        var index = event.data.index === 0 ? 0 :
          event.data.index || $target.index() * _.options.slidesToScroll;

        _.slideHandler(_.checkNavigable(index), false, dontAnimate);
        $target.children().trigger('focus');
        break;

      default:
        return;
    }

  };

  Slick.prototype.checkNavigable = function (index) {

    var _ = this,
      navigables, prevNavigable;

    navigables = _.getNavigableIndexes();
    prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) {
      index = navigables[navigables.length - 1];
    } else {
      for (var n in navigables) {
        if (index < navigables[n]) {
          index = prevNavigable;
          break;
        }
        prevNavigable = navigables[n];
      }
    }

    return index;
  };

  Slick.prototype.cleanUpEvents = function () {

    var _ = this;

    if (_.options.dots && _.$dots !== null) {

      $('li', _.$dots)
        .off('click.slick', _.changeSlide)
        .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
        .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    }

    _.$slider.off('focus.slick blur.slick');

    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
      _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
    }

    _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
    _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
    _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
    _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

    _.$list.off('click.slick', _.clickHandler);

    $(document).off(_.visibilityChange, _.visibility);

    _.cleanUpSlideEvents();

    if (_.options.accessibility === true) {
      _.$list.off('keydown.slick', _.keyHandler);
    }

    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().off('click.slick', _.selectHandler);
    }

    $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

    $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

    $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

    $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
    $(document).off('ready.slick.slick-' + _.instanceUid, _.setPosition);

  };

  Slick.prototype.cleanUpSlideEvents = function () {

    var _ = this;

    // iOS13 hack.
    if (_.$list == null) {
      _.$list = _.$slider.find('.slick-list');
    }

    _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
    _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

  };

  Slick.prototype.cleanUpRows = function () {

    var _ = this, originalSlides;

    if (_.options.rows > 1) {
      originalSlides = _.$slides.children().children();
      originalSlides.removeAttr('style');
      _.$slider.empty().append(originalSlides);
    }

  };

  Slick.prototype.clickHandler = function (event) {

    var _ = this;

    if (_.shouldClick === false) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
    }

  };

  Slick.prototype.destroy = function (refresh) {

    var _ = this;

    _.autoPlayClear();

    _.touchObject = {};

    _.cleanUpEvents();

    $('.slick-cloned', _.$slider).detach();

    if (_.$dots) {
      _.$dots.remove();
    }

    if (_.$prevArrow && _.$prevArrow.length) {

      _.$prevArrow
        .removeClass('slick-disabled slick-arrow slick-hidden')
        .removeAttr('aria-hidden aria-disabled tabindex')
        .css('display', '');

      if (_.htmlExpr.test(_.options.prevArrow)) {
        _.$prevArrow.remove();
      }
    }

    if (_.$nextArrow && _.$nextArrow.length) {

      _.$nextArrow
        .removeClass('slick-disabled slick-arrow slick-hidden')
        .removeAttr('aria-hidden aria-disabled tabindex')
        .css('display', '');

      if (_.htmlExpr.test(_.options.nextArrow)) {
        _.$nextArrow.remove();
      }
    }


    if (_.$slides) {

      _.$slides
        .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
        .removeAttr('aria-hidden')
        .removeAttr('data-slick-index')
        .each(function () {
          $(this).attr('style', $(this).data('originalStyling'));
        });

      _.$slideTrack.children(this.options.slide).detach();

      _.$slideTrack.detach();

      _.$list.detach();

      _.$slider.append(_.$slides);
    }

    _.cleanUpRows();

    _.$slider.removeClass('slick-slider');
    _.$slider.removeClass('slick-initialized');
    _.$slider.removeClass('slick-dotted');

    _.unslicked = true;

    if (!refresh) {
      _.$slider.trigger('destroy', [_]);
    }

  };

  Slick.prototype.disableTransition = function (slide) {

    var _ = this,
      transition = {};

    transition[_.transitionType] = '';

    if (_.options.fade === false) {
      _.$slideTrack.css(transition);
    } else {
      _.$slides.eq(slide).css(transition);
    }

  };

  Slick.prototype.fadeSlide = function (slideIndex, callback) {

    var _ = this;

    if (_.cssTransitions === false) {

      _.$slides.eq(slideIndex).css({
        zIndex: _.options.zIndex
      });

      _.$slides.eq(slideIndex).animate({
        opacity: 1
      }, _.options.speed, _.options.easing, callback);

    } else {

      _.applyTransition(slideIndex);

      _.$slides.eq(slideIndex).css({
        opacity: 1,
        zIndex: _.options.zIndex
      });

      if (callback) {
        setTimeout(function () {

          _.disableTransition(slideIndex);

          callback.call();
        }, _.options.speed);
      }

    }

  };

  Slick.prototype.fadeSlideOut = function (slideIndex) {

    var _ = this;

    if (_.cssTransitions === false) {

      _.$slides.eq(slideIndex).animate({
        opacity: 0,
        zIndex: _.options.zIndex - 2
      }, _.options.speed, _.options.easing);

    } else {

      _.applyTransition(slideIndex);

      _.$slides.eq(slideIndex).css({
        opacity: 0,
        zIndex: _.options.zIndex - 2
      });

    }

  };

  Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {

    var _ = this;

    if (filter !== null) {

      _.$slidesCache = _.$slides;

      _.unload();

      _.$slideTrack.children(this.options.slide).detach();

      _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

      _.reinit();

    }

  };

  Slick.prototype.focusHandler = function () {

    var _ = this;

    _.$slider
      .off('focus.slick blur.slick')
      .on('focus.slick blur.slick',
        '*:not(.slick-arrow)', function (event) {

          event.stopImmediatePropagation();
          var $sf = $(this);

          setTimeout(function () {

            if (_.options.pauseOnFocus) {
              _.focussed = $sf.is(':focus');
              _.autoPlay();
            }

          }, 0);

        });
  };

  Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {

    var _ = this;
    return _.currentSlide;

  };

  Slick.prototype.getDotCount = function () {

    var _ = this;

    var breakPoint = 0;
    var counter = 0;
    var pagerQty = 0;

    if (_.options.infinite === true) {
      while (breakPoint < _.slideCount) {
        ++pagerQty;
        breakPoint = counter + _.options.slidesToScroll;
        counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
      }
    } else if (_.options.centerMode === true) {
      pagerQty = _.slideCount;
    } else if (!_.options.asNavFor) {
      pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
    } else {
      while (breakPoint < _.slideCount) {
        ++pagerQty;
        breakPoint = counter + _.options.slidesToScroll;
        counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
      }
    }

    return pagerQty - 1;

  };

  Slick.prototype.getLeft = function (slideIndex) {

    var _ = this,
      targetLeft,
      verticalHeight,
      verticalOffset = 0,
      targetSlide;

    _.slideOffset = 0;
    verticalHeight = _.$slides.first().outerHeight(true);

    if (_.options.infinite === true) {
      if (_.slideCount > _.options.slidesToShow) {
        _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
        verticalOffset = (verticalHeight * _.options.slidesToShow) * -1;
      }
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
          if (slideIndex > _.slideCount) {
            _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
            verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
          } else {
            _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
            verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
          }
        }
      }
    } else {
      if (slideIndex + _.options.slidesToShow > _.slideCount) {
        _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
        verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
      }
    }

    if (_.slideCount <= _.options.slidesToShow) {
      _.slideOffset = 0;
      verticalOffset = 0;
    }

    if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
      _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
    } else if (_.options.centerMode === true && _.options.infinite === true) {
      _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
    } else if (_.options.centerMode === true) {
      _.slideOffset = 0;
      _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
    }

    if (_.options.vertical === false) {
      targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
    } else {
      targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
    }

    if (_.options.variableWidth === true) {

      if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
      } else {
        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
      }

      if (_.options.rtl === true) {
        if (targetSlide[0]) {
          targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
        } else {
          targetLeft = 0;
        }
      } else {
        targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
      }

      if (_.options.centerMode === true) {
        if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
          targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
        } else {
          targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
        }

        if (_.options.rtl === true) {
          if (targetSlide[0]) {
            targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
          } else {
            targetLeft = 0;
          }
        } else {
          targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
        }

        targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
      }
    }

    return targetLeft;

  };

  Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {

    var _ = this;

    return _.options[option];

  };

  Slick.prototype.getNavigableIndexes = function () {

    var _ = this,
      breakPoint = 0,
      counter = 0,
      indexes = [],
      max;

    if (_.options.infinite === false) {
      max = _.slideCount;
    } else {
      breakPoint = _.options.slidesToScroll * -1;
      counter = _.options.slidesToScroll * -1;
      max = _.slideCount * 2;
    }

    while (breakPoint < max) {
      indexes.push(breakPoint);
      breakPoint = counter + _.options.slidesToScroll;
      counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
    }

    return indexes;

  };

  Slick.prototype.getSlick = function () {

    return this;

  };

  Slick.prototype.getSlideCount = function () {

    var _ = this,
      slidesTraversed, swipedSlide, centerOffset;

    centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

    if (_.options.swipeToSlide === true) {
      _.$slideTrack.find('.slick-slide').each(function (index, slide) {
        if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
          swipedSlide = slide;
          return false;
        }
      });

      slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

      return slidesTraversed;

    } else {
      return _.options.slidesToScroll;
    }

  };

  Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {

    var _ = this;

    _.changeSlide({
      data: {
        message: 'index',
        index: parseInt(slide)
      }
    }, dontAnimate);

  };

  Slick.prototype.init = function (creation) {

    var _ = this;

    if (!$(_.$slider).hasClass('slick-initialized')) {

      $(_.$slider).addClass('slick-initialized');

      _.buildRows();
      _.buildOut();
      _.setProps();
      _.startLoad();
      _.loadSlider();
      _.initializeEvents();
      _.updateArrows();
      _.updateDots();
      _.checkResponsive(true);
      _.focusHandler();

    }

    if (creation) {
      _.$slider.trigger('init', [_]);
    }

    if (_.options.accessibility === true) {
      _.initADA();
    }

    if (_.options.autoplay) {

      _.paused = false;
      _.autoPlay();

    }

  };

  Slick.prototype.initADA = function () {
    var _ = this;
    _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
      'aria-hidden': 'true',
      'tabindex': '-1'
    }).find('a, input, button, select').attr({
      'tabindex': '-1'
    });

    _.$slideTrack.attr('role', 'listbox');

    _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
      $(this).attr('role', 'option');

      //Evenly distribute aria-describedby tags through available dots.
      var describedBySlideId = _.options.centerMode ? i : Math.floor(i / _.options.slidesToShow);

      if (_.options.dots === true) {
        $(this).attr('aria-describedby', 'slick-slide' + _.instanceUid + describedBySlideId + '');
      }
    });

    if (_.$dots !== null) {
      _.$dots.attr('role', 'tablist').find('li').each(function (i) {
        $(this).attr({
          'role': 'presentation',
          'aria-selected': 'false',
          'aria-controls': 'navigation' + _.instanceUid + i + '',
          'id': 'slick-slide' + _.instanceUid + i + ''
        });
      })
        .first().attr('aria-selected', 'true').end()
        .find('button').attr('role', 'button').end()
        .closest('div').attr('role', 'toolbar');
    }
    _.activateADA();

  };

  Slick.prototype.initArrowEvents = function () {

    var _ = this;

    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow
        .off('click.slick')
        .on('click.slick', {
          message: 'previous'
        }, _.changeSlide);
      _.$nextArrow
        .off('click.slick')
        .on('click.slick', {
          message: 'next'
        }, _.changeSlide);
    }

  };

  Slick.prototype.initDotEvents = function () {

    var _ = this;

    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      $('li', _.$dots).on('click.slick', {
        message: 'index'
      }, _.changeSlide);
    }

    if (_.options.dots === true && _.options.pauseOnDotsHover === true) {

      $('li', _.$dots)
        .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
        .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

    }

  };

  Slick.prototype.initSlideEvents = function () {

    var _ = this;

    if (_.options.pauseOnHover) {

      // iOS13 hack.
      if (_.$list == null) {
        _.$list = _.$slider.find('.slick-list');
      }

      _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
      _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

    }

  };

  Slick.prototype.initializeEvents = function () {

    var _ = this;

    _.initArrowEvents();

    _.initDotEvents();
    _.initSlideEvents();

    _.$list.on('touchstart.slick mousedown.slick', {
      action: 'start'
    }, _.swipeHandler);
    _.$list.on('touchmove.slick mousemove.slick', {
      action: 'move'
    }, _.swipeHandler);
    _.$list.on('touchend.slick mouseup.slick', {
      action: 'end'
    }, _.swipeHandler);
    _.$list.on('touchcancel.slick mouseleave.slick', {
      action: 'end'
    }, _.swipeHandler);

    _.$list.on('click.slick', _.clickHandler);

    $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

    if (_.options.accessibility === true) {
      _.$list.on('keydown.slick', _.keyHandler);
    }

    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().on('click.slick', _.selectHandler);
    }

    $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

    $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

    $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

    $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
    $(document).on('ready.slick.slick-' + _.instanceUid, _.setPosition);

  };

  Slick.prototype.initUI = function () {

    var _ = this;

    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

      _.$prevArrow.show();
      _.$nextArrow.show();

    }

    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

      _.$dots.show();

    }

  };

  Slick.prototype.keyHandler = function (event) {

    var _ = this;
    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
    if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
      if (event.keyCode === 37 && _.options.accessibility === true) {
        _.changeSlide({
          data: {
            message: _.options.rtl === true ? 'next' : 'previous'
          }
        });
      } else if (event.keyCode === 39 && _.options.accessibility === true) {
        _.changeSlide({
          data: {
            message: _.options.rtl === true ? 'previous' : 'next'
          }
        });
      }
    }

  };

  Slick.prototype.lazyLoad = function () {

    var _ = this,
      loadRange, cloneRange, rangeStart, rangeEnd;

    function loadImages(imagesScope) {

      $('img[data-lazy]', imagesScope).each(function () {

        var image = $(this),
          imageSource = $(this).attr('data-lazy'),
          imageToLoad = document.createElement('img');

        imageToLoad.onload = function () {

          image
            .animate({ opacity: 0 }, 100, function () {
              image
                .attr('src', imageSource)
                .animate({ opacity: 1 }, 200, function () {
                  image
                    .removeAttr('data-lazy')
                    .removeClass('slick-loading');
                });
              _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
            });

        };

        imageToLoad.onerror = function () {

          image
            .removeAttr('data-lazy')
            .removeClass('slick-loading')
            .addClass('slick-lazyload-error');

          _.$slider.trigger('lazyLoadError', [_, image, imageSource]);

        };

        imageToLoad.src = imageSource;

      });

    }

    if (_.options.centerMode === true) {
      if (_.options.infinite === true) {
        rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
        rangeEnd = rangeStart + _.options.slidesToShow + 2;
      } else {
        rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
        rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
      }
    } else {
      rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
      rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
      if (_.options.fade === true) {
        if (rangeStart > 0) rangeStart--;
        if (rangeEnd <= _.slideCount) rangeEnd++;
      }
    }

    loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

    if (_.options.lazyLoad === 'anticipated') {
      var prevSlide = rangeStart - 1,
        nextSlide = rangeEnd,
        $slides = _.$slider.find('.slick-slide');

      for (var i = 0; i < _.options.slidesToScroll; i++) {
        if (prevSlide < 0) prevSlide = _.slideCount - 1;
        loadRange = loadRange.add($slides.eq(prevSlide));
        loadRange = loadRange.add($slides.eq(nextSlide));
        prevSlide--;
        nextSlide++;
      }
    }

    loadImages(loadRange);

    if (_.slideCount <= _.options.slidesToShow) {
      cloneRange = _.$slider.find('.slick-slide');
      loadImages(cloneRange);
    } else
      if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
        cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
        loadImages(cloneRange);
      } else if (_.currentSlide === 0) {
        cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
        loadImages(cloneRange);
      }

  };

  Slick.prototype.loadSlider = function () {

    var _ = this;

    _.setPosition();

    _.$slideTrack.css({
      opacity: 1
    });

    _.$slider.removeClass('slick-loading');

    _.initUI();

    if (_.options.lazyLoad === 'progressive') {
      _.progressiveLazyLoad();
    }

  };

  Slick.prototype.next = Slick.prototype.slickNext = function () {

    var _ = this;

    _.changeSlide({
      data: {
        message: 'next'
      }
    });

  };

  Slick.prototype.orientationChange = function () {

    var _ = this;

    _.checkResponsive();
    _.setPosition();

  };

  Slick.prototype.pause = Slick.prototype.slickPause = function () {

    var _ = this;

    _.autoPlayClear();
    _.paused = true;

  };

  Slick.prototype.play = Slick.prototype.slickPlay = function () {

    var _ = this;

    _.autoPlay();
    _.options.autoplay = true;
    _.paused = false;
    _.focussed = false;
    _.interrupted = false;

  };

  Slick.prototype.postSlide = function (index) {

    var _ = this;

    if (!_.unslicked) {

      _.$slider.trigger('afterChange', [_, index]);

      _.animating = false;

      _.setPosition();

      _.swipeLeft = null;

      if (_.options.autoplay) {
        _.autoPlay();
      }

      if (_.options.accessibility === true) {
        _.initADA();
      }

    }

  };

  Slick.prototype.prev = Slick.prototype.slickPrev = function () {

    var _ = this;

    _.changeSlide({
      data: {
        message: 'previous'
      }
    });

  };

  Slick.prototype.preventDefault = function (event) {

    event.preventDefault();

  };

  Slick.prototype.progressiveLazyLoad = function (tryCount) {

    tryCount = tryCount || 1;

    var _ = this,
      $imgsToLoad = $('img[data-lazy]', _.$slider),
      image,
      imageSource,
      imageToLoad;

    if ($imgsToLoad.length) {

      image = $imgsToLoad.first();
      imageSource = image.attr('data-lazy');
      imageToLoad = document.createElement('img');

      imageToLoad.onload = function () {

        image
          .attr('src', imageSource)
          .removeAttr('data-lazy')
          .removeClass('slick-loading');

        if (_.options.adaptiveHeight === true) {
          _.setPosition();
        }

        _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
        _.progressiveLazyLoad();

      };

      imageToLoad.onerror = function () {

        if (tryCount < 3) {

          /**
           * try to load the image 3 times,
           * leave a slight delay so we don't get
           * servers blocking the request.
           */
          setTimeout(function () {
            _.progressiveLazyLoad(tryCount + 1);
          }, 500);

        } else {

          image
            .removeAttr('data-lazy')
            .removeClass('slick-loading')
            .addClass('slick-lazyload-error');

          _.$slider.trigger('lazyLoadError', [_, image, imageSource]);

          _.progressiveLazyLoad();

        }

      };

      imageToLoad.src = imageSource;

    } else {

      _.$slider.trigger('allImagesLoaded', [_]);

    }

  };

  Slick.prototype.refresh = function (initializing) {

    var _ = this, currentSlide, lastVisibleIndex;

    lastVisibleIndex = _.slideCount - _.options.slidesToShow;

    // in non-infinite sliders, we don't want to go past the
    // last visible index.
    if (!_.options.infinite && (_.currentSlide > lastVisibleIndex)) {
      _.currentSlide = lastVisibleIndex;
    }

    // if less slides than to show, go to start.
    if (_.slideCount <= _.options.slidesToShow) {
      _.currentSlide = 0;

    }

    currentSlide = _.currentSlide;

    _.destroy(true);

    $.extend(_, _.initials, { currentSlide: currentSlide });

    _.init();

    if (!initializing) {

      _.changeSlide({
        data: {
          message: 'index',
          index: currentSlide
        }
      }, false);

    }

  };

  Slick.prototype.registerBreakpoints = function () {

    var _ = this, breakpoint, currentBreakpoint, l,
      responsiveSettings = _.options.responsive || null;

    if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {

      _.respondTo = _.options.respondTo || 'window';

      for (breakpoint in responsiveSettings) {

        l = _.breakpoints.length - 1;
        currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

        if (responsiveSettings.hasOwnProperty(breakpoint)) {

          // loop through the breakpoints and cut out any existing
          // ones with the same breakpoint number, we don't want dupes.
          while (l >= 0) {
            if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
              _.breakpoints.splice(l, 1);
            }
            l--;
          }

          _.breakpoints.push(currentBreakpoint);
          _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

        }

      }

      _.breakpoints.sort(function (a, b) {
        return (_.options.mobileFirst) ? a - b : b - a;
      });

    }

  };

  Slick.prototype.reinit = function () {

    var _ = this;

    // iOS13 Hack
    if (_.$slideTrack == null) {
      _.$slideTrack = _.$slider.find('.slick-track');
    }

    _.$slides =
      _.$slideTrack
        .children(_.options.slide)
        .addClass('slick-slide');

    _.slideCount = _.$slides.length;

    // iOS13 Hack
    if (_.currentSlide == null || _.currentSlide == 0) {
      _.currentSlide = _.$slider.find('.slick-active').data('slick-index');
    }

    if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
      _.currentSlide = _.currentSlide - _.options.slidesToScroll;
    }

    if (_.slideCount <= _.options.slidesToShow) {
      _.currentSlide = 0;
    }

    _.registerBreakpoints();

    _.setProps();
    _.setupInfinite();
    _.buildArrows();
    _.updateArrows();
    _.initArrowEvents();
    _.buildDots();
    _.updateDots();
    _.initDotEvents();
    _.cleanUpSlideEvents();
    _.initSlideEvents();

    _.checkResponsive(false, true);

    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().on('click.slick', _.selectHandler);
    }

    _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

    _.setPosition();
    _.focusHandler();

    _.paused = !_.options.autoplay;
    _.autoPlay();

    _.$slider.trigger('reInit', [_]);

  };

  Slick.prototype.resize = function () {

    var _ = this;

    if ($(window).width() !== _.windowWidth) {
      clearTimeout(_.windowDelay);
      _.windowDelay = window.setTimeout(function () {
        _.windowWidth = $(window).width();
        _.checkResponsive();
        if (!_.unslicked) { _.setPosition(); }
      }, 50);
    }
  };

  Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {

    var _ = this;

    if (typeof (index) === 'boolean') {
      removeBefore = index;
      index = removeBefore === true ? 0 : _.slideCount - 1;
    } else {
      index = removeBefore === true ? --index : index;
    }

    if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
      return false;
    }

    _.unload();

    if (removeAll === true) {
      _.$slideTrack.children().remove();
    } else {
      _.$slideTrack.children(this.options.slide).eq(index).remove();
    }

    _.$slides = _.$slideTrack.children(this.options.slide);

    _.$slideTrack.children(this.options.slide).detach();

    _.$slideTrack.append(_.$slides);

    _.$slidesCache = _.$slides;

    _.reinit();

  };

  Slick.prototype.setCSS = function (position) {

    var _ = this,
      positionProps = {},
      x, y;

    if (_.options.rtl === true) {
      position = -position;
    }
    x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
    y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

    positionProps[_.positionProp] = position;

    if (_.transformsEnabled === false) {
      _.$slideTrack.css(positionProps);
    } else {
      positionProps = {};
      if (_.cssTransitions === false) {
        positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
        _.$slideTrack.css(positionProps);
      } else {
        positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
        _.$slideTrack.css(positionProps);
      }
    }

  };

  Slick.prototype.setDimensions = function () {

    var _ = this;

    if (_.options.vertical === false) {
      if (_.options.centerMode === true) {
        _.$list.css({
          padding: ('0px ' + _.options.centerPadding)
        });
      }
    } else {
      _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
      if (_.options.centerMode === true) {
        _.$list.css({
          padding: (_.options.centerPadding + ' 0px')
        });
      }
    }

    _.listWidth = _.$list.width();
    _.listHeight = _.$list.height();


    if (_.options.vertical === false && _.options.variableWidth === false) {
      _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
      _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

    } else if (_.options.variableWidth === true) {
      _.$slideTrack.width(5000 * _.slideCount);
    } else {
      _.slideWidth = Math.ceil(_.listWidth);
      _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
    }

    var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
    if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

  };

  Slick.prototype.setFade = function () {

    var _ = this,
      targetLeft;

    _.$slides.each(function (index, element) {
      targetLeft = (_.slideWidth * index) * -1;
      if (_.options.rtl === true) {
        $(element).css({
          position: 'relative',
          right: targetLeft,
          top: 0,
          zIndex: _.options.zIndex - 2,
          opacity: 0
        });
      } else {
        $(element).css({
          position: 'relative',
          left: targetLeft,
          top: 0,
          zIndex: _.options.zIndex - 2,
          opacity: 0
        });
      }
    });

    _.$slides.eq(_.currentSlide).css({
      zIndex: _.options.zIndex - 1,
      opacity: 1
    });

  };

  Slick.prototype.setHeight = function () {

    var _ = this;

    if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
      var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
      _.$list.css('height', targetHeight);
    }

  };

  Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function () {

      /**
       * accepts arguments in format of:
       *
       *  - for changing a single option's value:
       *     .slick("setOption", option, value, refresh )
       *
       *  - for changing a set of responsive options:
       *     .slick("setOption", 'responsive', [{}, ...], refresh )
       *
       *  - for updating multiple values at once (not responsive)
       *     .slick("setOption", { 'option': value, ... }, refresh )
       */

      var _ = this, l, item, option, value, refresh = false, type;

      if ($.type(arguments[0]) === 'object') {

        option = arguments[0];
        refresh = arguments[1];
        type = 'multiple';

      } else if ($.type(arguments[0]) === 'string') {

        option = arguments[0];
        value = arguments[1];
        refresh = arguments[2];

        if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {

          type = 'responsive';

        } else if (typeof arguments[1] !== 'undefined') {

          type = 'single';

        }

      }

      if (type === 'single') {

        _.options[option] = value;


      } else if (type === 'multiple') {

        $.each(option, function (opt, val) {

          _.options[opt] = val;

        });


      } else if (type === 'responsive') {

        for (item in value) {

          if ($.type(_.options.responsive) !== 'array') {

            _.options.responsive = [value[item]];

          } else {

            l = _.options.responsive.length - 1;

            // loop through the responsive object and splice out duplicates.
            while (l >= 0) {

              if (_.options.responsive[l].breakpoint === value[item].breakpoint) {

                _.options.responsive.splice(l, 1);

              }

              l--;

            }

            _.options.responsive.push(value[item]);

          }

        }

      }

      if (refresh) {

        _.unload();
        _.reinit();

      }

    };

  Slick.prototype.setPosition = function () {

    var _ = this;

    _.setDimensions();

    _.setHeight();

    if (_.options.fade === false) {
      _.setCSS(_.getLeft(_.currentSlide));
    } else {
      _.setFade();
    }

    _.$slider.trigger('setPosition', [_]);

  };

  Slick.prototype.setProps = function () {

    var _ = this,
      bodyStyle = document.body.style;

    _.positionProp = _.options.vertical === true ? 'top' : 'left';

    if (_.positionProp === 'top') {
      _.$slider.addClass('slick-vertical');
    } else {
      _.$slider.removeClass('slick-vertical');
    }

    if (bodyStyle.WebkitTransition !== undefined ||
      bodyStyle.MozTransition !== undefined ||
      bodyStyle.msTransition !== undefined) {
      if (_.options.useCSS === true) {
        _.cssTransitions = true;
      }
    }

    if (_.options.fade) {
      if (typeof _.options.zIndex === 'number') {
        if (_.options.zIndex < 3) {
          _.options.zIndex = 3;
        }
      } else {
        _.options.zIndex = _.defaults.zIndex;
      }
    }

    if (bodyStyle.OTransform !== undefined) {
      _.animType = 'OTransform';
      _.transformType = '-o-transform';
      _.transitionType = 'OTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.MozTransform !== undefined) {
      _.animType = 'MozTransform';
      _.transformType = '-moz-transform';
      _.transitionType = 'MozTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.webkitTransform !== undefined) {
      _.animType = 'webkitTransform';
      _.transformType = '-webkit-transform';
      _.transitionType = 'webkitTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.msTransform !== undefined) {
      _.animType = 'msTransform';
      _.transformType = '-ms-transform';
      _.transitionType = 'msTransition';
      if (bodyStyle.msTransform === undefined) _.animType = false;
    }
    if (bodyStyle.transform !== undefined && _.animType !== false) {
      _.animType = 'transform';
      _.transformType = 'transform';
      _.transitionType = 'transition';
    }
    _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
  };


  Slick.prototype.setSlideClasses = function (index) {

    var _ = this,
      centerOffset, allSlides, indexOffset, remainder;

    allSlides = _.$slider
      .find('.slick-slide')
      .removeClass('slick-active slick-center slick-current')
      .attr('aria-hidden', 'true');

    _.$slides
      .eq(index)
      .addClass('slick-current');

    if (_.options.centerMode === true) {

      centerOffset = Math.floor(_.options.slidesToShow / 2);

      if (_.options.infinite === true) {

        if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {

          _.$slides
            .slice(index - centerOffset, index + centerOffset + 1)
            .addClass('slick-active')
            .attr('aria-hidden', 'false');

        } else {

          indexOffset = _.options.slidesToShow + index;
          allSlides
            .slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2)
            .addClass('slick-active')
            .attr('aria-hidden', 'false');

        }

        if (index === 0) {

          allSlides
            .eq(allSlides.length - 1 - _.options.slidesToShow)
            .addClass('slick-center');

        } else if (index === _.slideCount - 1) {

          allSlides
            .eq(_.options.slidesToShow)
            .addClass('slick-center');

        }

      }

      _.$slides
        .eq(index)
        .addClass('slick-center');

    } else {

      if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

        _.$slides
          .slice(index, index + _.options.slidesToShow)
          .addClass('slick-active')
          .attr('aria-hidden', 'false');

      } else if (allSlides.length <= _.options.slidesToShow) {

        allSlides
          .addClass('slick-active')
          .attr('aria-hidden', 'false');

      } else {

        remainder = _.slideCount % _.options.slidesToShow;
        indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

        if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

          allSlides
            .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
            .addClass('slick-active')
            .attr('aria-hidden', 'false');

        } else {

          allSlides
            .slice(indexOffset, indexOffset + _.options.slidesToShow)
            .addClass('slick-active')
            .attr('aria-hidden', 'false');

        }

      }

    }

    if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
      _.lazyLoad();
    }
  };

  Slick.prototype.setupInfinite = function () {

    var _ = this,
      i, slideIndex, infiniteCount;

    if (_.options.fade === true) {
      _.options.centerMode = false;
    }

    if (_.options.infinite === true && _.options.fade === false) {

      slideIndex = null;

      if (_.slideCount > _.options.slidesToShow) {

        if (_.options.centerMode === true) {
          infiniteCount = _.options.slidesToShow + 1;
        } else {
          infiniteCount = _.options.slidesToShow;
        }

        for (i = _.slideCount; i > (_.slideCount -
          infiniteCount); i -= 1) {
          slideIndex = i - 1;
          $(_.$slides[slideIndex]).clone(true).attr('id', '')
            .attr('data-slick-index', slideIndex - _.slideCount)
            .prependTo(_.$slideTrack).addClass('slick-cloned');
        }
        for (i = 0; i < infiniteCount; i += 1) {
          slideIndex = i;
          $(_.$slides[slideIndex]).clone(true).attr('id', '')
            .attr('data-slick-index', slideIndex + _.slideCount)
            .appendTo(_.$slideTrack).addClass('slick-cloned');
        }
        _.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
          $(this).attr('id', '');
        });

      }

    }

  };

  Slick.prototype.interrupt = function (toggle) {

    var _ = this;

    if (!toggle) {
      _.autoPlay();
    }
    _.interrupted = toggle;

  };

  Slick.prototype.selectHandler = function (event) {

    var _ = this;

    var targetElement =
      $(event.target).is('.slick-slide') ?
        $(event.target) :
        $(event.target).parents('.slick-slide');

    var index = parseInt(targetElement.attr('data-slick-index'));

    if (!index) index = 0;

    if (_.slideCount <= _.options.slidesToShow) {

      _.setSlideClasses(index);
      _.asNavFor(index);
      return;

    }

    _.slideHandler(index);

  };

  Slick.prototype.slideHandler = function (index, sync, dontAnimate) {

    var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
      _ = this, navTarget;

    sync = sync || false;

    if (_.animating === true && _.options.waitForAnimate === true) {
      return;
    }

    if (_.options.fade === true && _.currentSlide === index) {
      return;
    }

    if (_.slideCount <= _.options.slidesToShow) {
      return;
    }

    if (sync === false) {
      _.asNavFor(index);
    }

    targetSlide = index;
    targetLeft = _.getLeft(targetSlide);
    slideLeft = _.getLeft(_.currentSlide);

    _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

    if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
      if (_.options.fade === false) {
        targetSlide = _.currentSlide;
        if (dontAnimate !== true) {
          _.animateSlide(slideLeft, function () {
            _.postSlide(targetSlide);
          });
        } else {
          _.postSlide(targetSlide);
        }
      }
      return;
    } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
      if (_.options.fade === false) {
        targetSlide = _.currentSlide;
        if (dontAnimate !== true) {
          _.animateSlide(slideLeft, function () {
            _.postSlide(targetSlide);
          });
        } else {
          _.postSlide(targetSlide);
        }
      }
      return;
    }

    if (_.options.autoplay) {
      clearInterval(_.autoPlayTimer);
    }

    if (targetSlide < 0) {
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
      } else {
        animSlide = _.slideCount + targetSlide;
      }
    } else if (targetSlide >= _.slideCount) {
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        animSlide = 0;
      } else {
        animSlide = targetSlide - _.slideCount;
      }
    } else {
      animSlide = targetSlide;
    }

    _.animating = true;

    _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

    oldSlide = _.currentSlide;
    _.currentSlide = animSlide;

    _.setSlideClasses(_.currentSlide);

    if (_.options.asNavFor) {

      navTarget = _.getNavTarget();
      navTarget = navTarget.slick('getSlick');

      if (navTarget.slideCount <= navTarget.options.slidesToShow) {
        navTarget.setSlideClasses(_.currentSlide);
      }

    }

    _.updateDots();
    _.updateArrows();

    if (_.options.fade === true) {
      if (dontAnimate !== true) {

        _.fadeSlideOut(oldSlide);

        _.fadeSlide(animSlide, function () {
          _.postSlide(animSlide);
        });

      } else {
        _.postSlide(animSlide);
      }
      _.animateHeight();
      return;
    }

    if (dontAnimate !== true) {
      _.animateSlide(targetLeft, function () {
        _.postSlide(animSlide);
      });
    } else {
      _.postSlide(animSlide);
    }

  };

  Slick.prototype.startLoad = function () {

    var _ = this;

    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

      _.$prevArrow.hide();
      _.$nextArrow.hide();

    }

    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

      _.$dots.hide();

    }

    _.$slider.addClass('slick-loading');

  };

  Slick.prototype.swipeDirection = function () {

    var xDist, yDist, r, swipeAngle, _ = this;

    xDist = _.touchObject.startX - _.touchObject.curX;
    yDist = _.touchObject.startY - _.touchObject.curY;
    r = Math.atan2(yDist, xDist);

    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }

    if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
      return (_.options.rtl === false ? 'left' : 'right');
    }
    if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
      return (_.options.rtl === false ? 'left' : 'right');
    }
    if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
      return (_.options.rtl === false ? 'right' : 'left');
    }
    if (_.options.verticalSwiping === true) {
      if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
        return 'down';
      } else {
        return 'up';
      }
    }

    return 'vertical';

  };

  Slick.prototype.swipeEnd = function (event) {

    var _ = this,
      slideCount,
      direction;

    _.dragging = false;
    _.interrupted = false;
    _.shouldClick = (_.touchObject.swipeLength > 10) ? false : true;

    if (_.touchObject.curX === undefined) {
      return false;
    }

    if (_.touchObject.edgeHit === true) {
      _.$slider.trigger('edge', [_, _.swipeDirection()]);
    }

    if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {

      direction = _.swipeDirection();

      switch (direction) {

        case 'left':
        case 'down':

          slideCount =
            _.options.swipeToSlide ?
              _.checkNavigable(_.currentSlide + _.getSlideCount()) :
              _.currentSlide + _.getSlideCount();

          _.currentDirection = 0;

          break;

        case 'right':
        case 'up':

          slideCount =
            _.options.swipeToSlide ?
              _.checkNavigable(_.currentSlide - _.getSlideCount()) :
              _.currentSlide - _.getSlideCount();

          _.currentDirection = 1;

          break;

        default:


      }

      if (direction != 'vertical') {

        _.slideHandler(slideCount);
        _.touchObject = {};
        _.$slider.trigger('swipe', [_, direction]);

      }

    } else {

      if (_.touchObject.startX !== _.touchObject.curX) {

        _.slideHandler(_.currentSlide);
        _.touchObject = {};

      }

    }

  };

  Slick.prototype.swipeHandler = function (event) {

    var _ = this;

    if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
      return;
    } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
      return;
    }

    _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
      event.originalEvent.touches.length : 1;

    _.touchObject.minSwipe = _.listWidth / _.options
      .touchThreshold;

    if (_.options.verticalSwiping === true) {
      _.touchObject.minSwipe = _.listHeight / _.options
        .touchThreshold;
    }

    switch (event.data.action) {

      case 'start':
        _.swipeStart(event);
        break;

      case 'move':
        _.swipeMove(event);
        break;

      case 'end':
        _.swipeEnd(event);
        break;

    }

  };

  Slick.prototype.swipeMove = function (event) {

    var _ = this,
      edgeWasHit = false,
      curLeft, swipeDirection, swipeLength, positionOffset, touches;

    touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

    if (!_.dragging || touches && touches.length !== 1) {
      return false;
    }

    curLeft = _.getLeft(_.currentSlide);

    _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
    _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

    _.touchObject.swipeLength = Math.round(Math.sqrt(
      Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

    if (_.options.verticalSwiping === true) {
      _.touchObject.swipeLength = Math.round(Math.sqrt(
        Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
    }

    swipeDirection = _.swipeDirection();

    if (swipeDirection === 'vertical') {
      return;
    }

    if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
      event.preventDefault();
    }

    positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
    if (_.options.verticalSwiping === true) {
      positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
    }


    swipeLength = _.touchObject.swipeLength;

    _.touchObject.edgeHit = false;

    if (_.options.infinite === false) {
      if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
        swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
        _.touchObject.edgeHit = true;
      }
    }

    if (_.options.vertical === false) {
      _.swipeLeft = curLeft + swipeLength * positionOffset;
    } else {
      _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
    }
    if (_.options.verticalSwiping === true) {
      _.swipeLeft = curLeft + swipeLength * positionOffset;
    }

    if (_.options.fade === true || _.options.touchMove === false) {
      return false;
    }

    if (_.animating === true) {
      _.swipeLeft = null;
      return false;
    }

    _.setCSS(_.swipeLeft);

  };

  Slick.prototype.swipeStart = function (event) {

    var _ = this,
      touches;

    _.interrupted = true;

    if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
      _.touchObject = {};
      return false;
    }

    if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
      touches = event.originalEvent.touches[0];
    }

    _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
    _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

    _.dragging = true;

  };

  Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {

    var _ = this;

    if (_.$slidesCache !== null) {

      _.unload();

      _.$slideTrack.children(this.options.slide).detach();

      _.$slidesCache.appendTo(_.$slideTrack);

      _.reinit();

    }

  };

  Slick.prototype.unload = function () {

    var _ = this;

    $('.slick-cloned', _.$slider).remove();

    if (_.$dots) {
      _.$dots.remove();
    }

    if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
      _.$prevArrow.remove();
    }

    if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
      _.$nextArrow.remove();
    }

    _.$slides
      .removeClass('slick-slide slick-active slick-visible slick-current')
      .attr('aria-hidden', 'true')
      .css('width', '');

  };

  Slick.prototype.unslick = function (fromBreakpoint) {

    var _ = this;
    _.$slider.trigger('unslick', [_, fromBreakpoint]);
    _.destroy();

  };

  Slick.prototype.updateArrows = function () {
    var _ = this,
      centerOffset;

    centerOffset = Math.floor(_.options.slidesToShow / 2);

    if (_.options.arrows === true &&
      _.slideCount > _.options.slidesToShow &&
      !_.options.infinite) {

      _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

      if (_.currentSlide === 0) {

        _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

      } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

      } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

      }

    }

  };

  Slick.prototype.updateDots = function () {

    var _ = this;

    if (_.$dots !== null) {

      _.$dots
        .find('li')
        .removeClass('slick-active')
        .attr('aria-hidden', 'true');

      _.$dots
        .find('li')
        .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
        .addClass('slick-active')
        .attr('aria-hidden', 'false');

    }

  };

  Slick.prototype.visibility = function () {

    var _ = this;

    if (_.options.autoplay) {

      if (document[_.hidden]) {

        _.interrupted = true;

      } else {

        _.interrupted = false;

      }

    }

  };

  $.fn.slick = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].slick = new Slick(_[i], opt);
      else
        ret = _[i].slick[opt].apply(_[i].slick, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  };

}));

/**
 * Swiper 6.1.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://swiperjs.com
 *
 * Copyright 2014-2020 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: July 31, 2020
 */

!function (e, t) { "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = e || self).Swiper = t() }(this, (function () { "use strict"; function e(e, t) { for (var i = 0; i < t.length; i++) { var s = t[i]; s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s) } } function t() { return (t = Object.assign || function (e) { for (var t = 1; t < arguments.length; t++) { var i = arguments[t]; for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (e[s] = i[s]) } return e }).apply(this, arguments) } function i(e) { return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object } function s(e, t) { void 0 === e && (e = {}), void 0 === t && (t = {}), Object.keys(t).forEach((function (a) { void 0 === e[a] ? e[a] = t[a] : i(t[a]) && i(e[a]) && Object.keys(t[a]).length > 0 && s(e[a], t[a]) })) } var a = { body: {}, addEventListener: function () { }, removeEventListener: function () { }, activeElement: { blur: function () { }, nodeName: "" }, querySelector: function () { return null }, querySelectorAll: function () { return [] }, getElementById: function () { return null }, createEvent: function () { return { initEvent: function () { } } }, createElement: function () { return { children: [], childNodes: [], style: {}, setAttribute: function () { }, getElementsByTagName: function () { return [] } } }, createElementNS: function () { return {} }, importNode: function () { return null }, location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" } }; function r() { var e = "undefined" != typeof document ? document : {}; return s(e, a), e } var n = { document: a, navigator: { userAgent: "" }, location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" }, history: { replaceState: function () { }, pushState: function () { }, go: function () { }, back: function () { } }, CustomEvent: function () { return this }, addEventListener: function () { }, removeEventListener: function () { }, getComputedStyle: function () { return { getPropertyValue: function () { return "" } } }, Image: function () { }, Date: function () { }, screen: {}, setTimeout: function () { }, clearTimeout: function () { }, matchMedia: function () { return {} }, requestAnimationFrame: function (e) { return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0) }, cancelAnimationFrame: function (e) { "undefined" != typeof setTimeout && clearTimeout(e) } }; function l() { var e = "undefined" != typeof window ? window : {}; return s(e, n), e } function o(e) { return (o = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) { return e.__proto__ || Object.getPrototypeOf(e) })(e) } function d(e, t) { return (d = Object.setPrototypeOf || function (e, t) { return e.__proto__ = t, e })(e, t) } function h() { if ("undefined" == typeof Reflect || !Reflect.construct) return !1; if (Reflect.construct.sham) return !1; if ("function" == typeof Proxy) return !0; try { return Date.prototype.toString.call(Reflect.construct(Date, [], (function () { }))), !0 } catch (e) { return !1 } } function p(e, t, i) { return (p = h() ? Reflect.construct : function (e, t, i) { var s = [null]; s.push.apply(s, t); var a = new (Function.bind.apply(e, s)); return i && d(a, i.prototype), a }).apply(null, arguments) } function u(e) { var t = "function" == typeof Map ? new Map : void 0; return (u = function (e) { if (null === e || (i = e, -1 === Function.toString.call(i).indexOf("[native code]"))) return e; var i; if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== t) { if (t.has(e)) return t.get(e); t.set(e, s) } function s() { return p(e, arguments, o(this).constructor) } return s.prototype = Object.create(e.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), d(s, e) })(e) } var c = function (e) { var t, i; function s(t) { var i, s, a; return i = e.call.apply(e, [this].concat(t)) || this, s = function (e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e }(i), a = s.__proto__, Object.defineProperty(s, "__proto__", { get: function () { return a }, set: function (e) { a.__proto__ = e } }), i } return i = e, (t = s).prototype = Object.create(i.prototype), t.prototype.constructor = t, t.__proto__ = i, s }(u(Array)); function v(e) { void 0 === e && (e = []); var t = []; return e.forEach((function (e) { Array.isArray(e) ? t.push.apply(t, v(e)) : t.push(e) })), t } function f(e, t) { return Array.prototype.filter.call(e, t) } function m(e, t) { var i = l(), s = r(), a = []; if (!t && e instanceof c) return e; if (!e) return new c(a); if ("string" == typeof e) { var n = e.trim(); if (n.indexOf("<") >= 0 && n.indexOf(">") >= 0) { var o = "div"; 0 === n.indexOf("<li") && (o = "ul"), 0 === n.indexOf("<tr") && (o = "tbody"), 0 !== n.indexOf("<td") && 0 !== n.indexOf("<th") || (o = "tr"), 0 === n.indexOf("<tbody") && (o = "table"), 0 === n.indexOf("<option") && (o = "select"); var d = s.createElement(o); d.innerHTML = n; for (var h = 0; h < d.childNodes.length; h += 1)a.push(d.childNodes[h]) } else a = function (e, t) { if ("string" != typeof e) return [e]; for (var i = [], s = t.querySelectorAll(e), a = 0; a < s.length; a += 1)i.push(s[a]); return i }(e.trim(), t || s) } else if (e.nodeType || e === i || e === s) a.push(e); else if (Array.isArray(e)) { if (e instanceof c) return e; a = e } return new c(function (e) { for (var t = [], i = 0; i < e.length; i += 1)-1 === t.indexOf(e[i]) && t.push(e[i]); return t }(a)) } m.fn = c.prototype; var g, w, b, y = { addClass: function () { for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)t[i] = arguments[i]; var s = v(t.map((function (e) { return e.split(" ") }))); return this.forEach((function (e) { var t; (t = e.classList).add.apply(t, s) })), this }, removeClass: function () { for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)t[i] = arguments[i]; var s = v(t.map((function (e) { return e.split(" ") }))); return this.forEach((function (e) { var t; (t = e.classList).remove.apply(t, s) })), this }, hasClass: function () { for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)t[i] = arguments[i]; var s = v(t.map((function (e) { return e.split(" ") }))); return f(this, (function (e) { return s.filter((function (t) { return e.classList.contains(t) })).length > 0 })).length > 0 }, toggleClass: function () { for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)t[i] = arguments[i]; var s = v(t.map((function (e) { return e.split(" ") }))); this.forEach((function (e) { s.forEach((function (t) { e.classList.toggle(t) })) })) }, attr: function (e, t) { if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0; for (var i = 0; i < this.length; i += 1)if (2 === arguments.length) this[i].setAttribute(e, t); else for (var s in e) this[i][s] = e[s], this[i].setAttribute(s, e[s]); return this }, removeAttr: function (e) { for (var t = 0; t < this.length; t += 1)this[t].removeAttribute(e); return this }, transform: function (e) { for (var t = 0; t < this.length; t += 1)this[t].style.transform = e; return this }, transition: function (e) { for (var t = 0; t < this.length; t += 1)this[t].style.transition = "string" != typeof e ? e + "ms" : e; return this }, on: function () { for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)t[i] = arguments[i]; var s = t[0], a = t[1], r = t[2], n = t[3]; function l(e) { var t = e.target; if (t) { var i = e.target.dom7EventData || []; if (i.indexOf(e) < 0 && i.unshift(e), m(t).is(a)) r.apply(t, i); else for (var s = m(t).parents(), n = 0; n < s.length; n += 1)m(s[n]).is(a) && r.apply(s[n], i) } } function o(e) { var t = e && e.target && e.target.dom7EventData || []; t.indexOf(e) < 0 && t.unshift(e), r.apply(this, t) } "function" == typeof t[1] && (s = t[0], r = t[1], n = t[2], a = void 0), n || (n = !1); for (var d, h = s.split(" "), p = 0; p < this.length; p += 1) { var u = this[p]; if (a) for (d = 0; d < h.length; d += 1) { var c = h[d]; u.dom7LiveListeners || (u.dom7LiveListeners = {}), u.dom7LiveListeners[c] || (u.dom7LiveListeners[c] = []), u.dom7LiveListeners[c].push({ listener: r, proxyListener: l }), u.addEventListener(c, l, n) } else for (d = 0; d < h.length; d += 1) { var v = h[d]; u.dom7Listeners || (u.dom7Listeners = {}), u.dom7Listeners[v] || (u.dom7Listeners[v] = []), u.dom7Listeners[v].push({ listener: r, proxyListener: o }), u.addEventListener(v, o, n) } } return this }, off: function () { for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)t[i] = arguments[i]; var s = t[0], a = t[1], r = t[2], n = t[3]; "function" == typeof t[1] && (s = t[0], r = t[1], n = t[2], a = void 0), n || (n = !1); for (var l = s.split(" "), o = 0; o < l.length; o += 1)for (var d = l[o], h = 0; h < this.length; h += 1) { var p = this[h], u = void 0; if (!a && p.dom7Listeners ? u = p.dom7Listeners[d] : a && p.dom7LiveListeners && (u = p.dom7LiveListeners[d]), u && u.length) for (var c = u.length - 1; c >= 0; c -= 1) { var v = u[c]; r && v.listener === r || r && v.listener && v.listener.dom7proxy && v.listener.dom7proxy === r ? (p.removeEventListener(d, v.proxyListener, n), u.splice(c, 1)) : r || (p.removeEventListener(d, v.proxyListener, n), u.splice(c, 1)) } } return this }, trigger: function () { for (var e = l(), t = arguments.length, i = new Array(t), s = 0; s < t; s++)i[s] = arguments[s]; for (var a = i[0].split(" "), r = i[1], n = 0; n < a.length; n += 1)for (var o = a[n], d = 0; d < this.length; d += 1) { var h = this[d]; if (e.CustomEvent) { var p = new e.CustomEvent(o, { detail: r, bubbles: !0, cancelable: !0 }); h.dom7EventData = i.filter((function (e, t) { return t > 0 })), h.dispatchEvent(p), h.dom7EventData = [], delete h.dom7EventData } } return this }, transitionEnd: function (e) { var t = this; return e && t.on("transitionend", (function i(s) { s.target === this && (e.call(this, s), t.off("transitionend", i)) })), this }, outerWidth: function (e) { if (this.length > 0) { if (e) { var t = this.styles(); return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left")) } return this[0].offsetWidth } return null }, outerHeight: function (e) { if (this.length > 0) { if (e) { var t = this.styles(); return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom")) } return this[0].offsetHeight } return null }, styles: function () { var e = l(); return this[0] ? e.getComputedStyle(this[0], null) : {} }, offset: function () { if (this.length > 0) { var e = l(), t = r(), i = this[0], s = i.getBoundingClientRect(), a = t.body, n = i.clientTop || a.clientTop || 0, o = i.clientLeft || a.clientLeft || 0, d = i === e ? e.scrollY : i.scrollTop, h = i === e ? e.scrollX : i.scrollLeft; return { top: s.top + d - n, left: s.left + h - o } } return null }, css: function (e, t) { var i, s = l(); if (1 === arguments.length) { if ("string" != typeof e) { for (i = 0; i < this.length; i += 1)for (var a in e) this[i].style[a] = e[a]; return this } if (this[0]) return s.getComputedStyle(this[0], null).getPropertyValue(e) } if (2 === arguments.length && "string" == typeof e) { for (i = 0; i < this.length; i += 1)this[i].style[e] = t; return this } return this }, each: function (e) { return e ? (this.forEach((function (t, i) { e.apply(t, [t, i]) })), this) : this }, html: function (e) { if (void 0 === e) return this[0] ? this[0].innerHTML : null; for (var t = 0; t < this.length; t += 1)this[t].innerHTML = e; return this }, text: function (e) { if (void 0 === e) return this[0] ? this[0].textContent.trim() : null; for (var t = 0; t < this.length; t += 1)this[t].textContent = e; return this }, is: function (e) { var t, i, s = l(), a = r(), n = this[0]; if (!n || void 0 === e) return !1; if ("string" == typeof e) { if (n.matches) return n.matches(e); if (n.webkitMatchesSelector) return n.webkitMatchesSelector(e); if (n.msMatchesSelector) return n.msMatchesSelector(e); for (t = m(e), i = 0; i < t.length; i += 1)if (t[i] === n) return !0; return !1 } if (e === a) return n === a; if (e === s) return n === s; if (e.nodeType || e instanceof c) { for (t = e.nodeType ? [e] : e, i = 0; i < t.length; i += 1)if (t[i] === n) return !0; return !1 } return !1 }, index: function () { var e, t = this[0]; if (t) { for (e = 0; null !== (t = t.previousSibling);)1 === t.nodeType && (e += 1); return e } }, eq: function (e) { if (void 0 === e) return this; var t = this.length; if (e > t - 1) return m([]); if (e < 0) { var i = t + e; return m(i < 0 ? [] : [this[i]]) } return m([this[e]]) }, append: function () { for (var e, t = r(), i = 0; i < arguments.length; i += 1) { e = i < 0 || arguments.length <= i ? void 0 : arguments[i]; for (var s = 0; s < this.length; s += 1)if ("string" == typeof e) { var a = t.createElement("div"); for (a.innerHTML = e; a.firstChild;)this[s].appendChild(a.firstChild) } else if (e instanceof c) for (var n = 0; n < e.length; n += 1)this[s].appendChild(e[n]); else this[s].appendChild(e) } return this }, prepend: function (e) { var t, i, s = r(); for (t = 0; t < this.length; t += 1)if ("string" == typeof e) { var a = s.createElement("div"); for (a.innerHTML = e, i = a.childNodes.length - 1; i >= 0; i -= 1)this[t].insertBefore(a.childNodes[i], this[t].childNodes[0]) } else if (e instanceof c) for (i = 0; i < e.length; i += 1)this[t].insertBefore(e[i], this[t].childNodes[0]); else this[t].insertBefore(e, this[t].childNodes[0]); return this }, next: function (e) { return this.length > 0 ? e ? this[0].nextElementSibling && m(this[0].nextElementSibling).is(e) ? m([this[0].nextElementSibling]) : m([]) : this[0].nextElementSibling ? m([this[0].nextElementSibling]) : m([]) : m([]) }, nextAll: function (e) { var t = [], i = this[0]; if (!i) return m([]); for (; i.nextElementSibling;) { var s = i.nextElementSibling; e ? m(s).is(e) && t.push(s) : t.push(s), i = s } return m(t) }, prev: function (e) { if (this.length > 0) { var t = this[0]; return e ? t.previousElementSibling && m(t.previousElementSibling).is(e) ? m([t.previousElementSibling]) : m([]) : t.previousElementSibling ? m([t.previousElementSibling]) : m([]) } return m([]) }, prevAll: function (e) { var t = [], i = this[0]; if (!i) return m([]); for (; i.previousElementSibling;) { var s = i.previousElementSibling; e ? m(s).is(e) && t.push(s) : t.push(s), i = s } return m(t) }, parent: function (e) { for (var t = [], i = 0; i < this.length; i += 1)null !== this[i].parentNode && (e ? m(this[i].parentNode).is(e) && t.push(this[i].parentNode) : t.push(this[i].parentNode)); return m(t) }, parents: function (e) { for (var t = [], i = 0; i < this.length; i += 1)for (var s = this[i].parentNode; s;)e ? m(s).is(e) && t.push(s) : t.push(s), s = s.parentNode; return m(t) }, closest: function (e) { var t = this; return void 0 === e ? m([]) : (t.is(e) || (t = t.parents(e).eq(0)), t) }, find: function (e) { for (var t = [], i = 0; i < this.length; i += 1)for (var s = this[i].querySelectorAll(e), a = 0; a < s.length; a += 1)t.push(s[a]); return m(t) }, children: function (e) { for (var t = [], i = 0; i < this.length; i += 1)for (var s = this[i].children, a = 0; a < s.length; a += 1)e && !m(s[a]).is(e) || t.push(s[a]); return m(t) }, filter: function (e) { return m(f(this, e)) }, remove: function () { for (var e = 0; e < this.length; e += 1)this[e].parentNode && this[e].parentNode.removeChild(this[e]); return this } }; function E(e, t) { return void 0 === t && (t = 0), setTimeout(e, t) } function x() { return Date.now() } function T(e, t) { void 0 === t && (t = "x"); var i, s, a, r = l(), n = r.getComputedStyle(e, null); return r.WebKitCSSMatrix ? ((s = n.transform || n.webkitTransform).split(",").length > 6 && (s = s.split(", ").map((function (e) { return e.replace(",", ".") })).join(", ")), a = new r.WebKitCSSMatrix("none" === s ? "" : s)) : i = (a = n.MozTransform || n.OTransform || n.MsTransform || n.msTransform || n.transform || n.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","), "x" === t && (s = r.WebKitCSSMatrix ? a.m41 : 16 === i.length ? parseFloat(i[12]) : parseFloat(i[4])), "y" === t && (s = r.WebKitCSSMatrix ? a.m42 : 16 === i.length ? parseFloat(i[13]) : parseFloat(i[5])), s || 0 } function C(e) { return "object" == typeof e && null !== e && e.constructor && e.constructor === Object } function S() { for (var e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = 1; t < arguments.length; t += 1) { var i = t < 0 || arguments.length <= t ? void 0 : arguments[t]; if (null != i) for (var s = Object.keys(Object(i)), a = 0, r = s.length; a < r; a += 1) { var n = s[a], l = Object.getOwnPropertyDescriptor(i, n); void 0 !== l && l.enumerable && (C(e[n]) && C(i[n]) ? S(e[n], i[n]) : !C(e[n]) && C(i[n]) ? (e[n] = {}, S(e[n], i[n])) : e[n] = i[n]) } } return e } function M(e, t) { Object.keys(t).forEach((function (i) { C(t[i]) && Object.keys(t[i]).forEach((function (s) { "function" == typeof t[i][s] && (t[i][s] = t[i][s].bind(e)) })), e[i] = t[i] })) } function z() { return g || (g = function () { var e = l(), t = r(); return { touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch), pointerEvents: !!e.PointerEvent && "maxTouchPoints" in e.navigator && e.navigator.maxTouchPoints >= 0, observer: "MutationObserver" in e || "WebkitMutationObserver" in e, passiveListener: function () { var t = !1; try { var i = Object.defineProperty({}, "passive", { get: function () { t = !0 } }); e.addEventListener("testPassiveListener", null, i) } catch (e) { } return t }(), gestures: "ongesturestart" in e } }()), g } function P(e) { return void 0 === e && (e = {}), w || (w = function (e) { var t = (void 0 === e ? {} : e).userAgent, i = z(), s = l(), a = s.navigator.platform, r = t || s.navigator.userAgent, n = { ios: !1, android: !1 }, o = s.screen.width, d = s.screen.height, h = r.match(/(Android);?[\s\/]+([\d.]+)?/), p = r.match(/(iPad).*OS\s([\d_]+)/), u = r.match(/(iPod)(.*OS\s([\d_]+))?/), c = !p && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/), v = "Win32" === a, f = "MacIntel" === a; return !p && f && i.touch && ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768"].indexOf(o + "x" + d) >= 0 && ((p = r.match(/(Version)\/([\d.]+)/)) || (p = [0, 1, "13_0_0"]), f = !1), h && !v && (n.os = "android", n.android = !0), (p || c || u) && (n.os = "ios", n.ios = !0), n }(e)), w } function k() { return b || (b = function () { var e, t = l(); return { isEdge: !!t.navigator.userAgent.match(/Edge/g), isSafari: (e = t.navigator.userAgent.toLowerCase(), e.indexOf("safari") >= 0 && e.indexOf("chrome") < 0 && e.indexOf("android") < 0), isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent) } }()), b } Object.keys(y).forEach((function (e) { m.fn[e] = y[e] })); var $ = { name: "resize", create: function () { var e = this; S(e, { resize: { resizeHandler: function () { e && !e.destroyed && e.initialized && (e.emit("beforeResize"), e.emit("resize")) }, orientationChangeHandler: function () { e && !e.destroyed && e.initialized && e.emit("orientationchange") } } }) }, on: { init: function (e) { var t = l(); t.addEventListener("resize", e.resize.resizeHandler), t.addEventListener("orientationchange", e.resize.orientationChangeHandler) }, destroy: function (e) { var t = l(); t.removeEventListener("resize", e.resize.resizeHandler), t.removeEventListener("orientationchange", e.resize.orientationChangeHandler) } } }, L = { attach: function (e, t) { void 0 === t && (t = {}); var i = l(), s = this, a = new (i.MutationObserver || i.WebkitMutationObserver)((function (e) { if (1 !== e.length) { var t = function () { s.emit("observerUpdate", e[0]) }; i.requestAnimationFrame ? i.requestAnimationFrame(t) : i.setTimeout(t, 0) } else s.emit("observerUpdate", e[0]) })); a.observe(e, { attributes: void 0 === t.attributes || t.attributes, childList: void 0 === t.childList || t.childList, characterData: void 0 === t.characterData || t.characterData }), s.observer.observers.push(a) }, init: function () { if (this.support.observer && this.params.observer) { if (this.params.observeParents) for (var e = this.$el.parents(), t = 0; t < e.length; t += 1)this.observer.attach(e[t]); this.observer.attach(this.$el[0], { childList: this.params.observeSlideChildren }), this.observer.attach(this.$wrapperEl[0], { attributes: !1 }) } }, destroy: function () { this.observer.observers.forEach((function (e) { e.disconnect() })), this.observer.observers = [] } }, I = { name: "observer", params: { observer: !1, observeParents: !1, observeSlideChildren: !1 }, create: function () { M(this, { observer: t(t({}, L), {}, { observers: [] }) }) }, on: { init: function (e) { e.observer.init() }, destroy: function (e) { e.observer.destroy() } } }; function O(e) { var t = r(), i = l(), s = this.touchEventsData, a = this.params, n = this.touches; if (!this.animating || !a.preventInteractionOnTransition) { var o = e; o.originalEvent && (o = o.originalEvent); var d = m(o.target); if (("wrapper" !== a.touchEventsTarget || d.closest(this.wrapperEl).length) && (s.isTouchEvent = "touchstart" === o.type, (s.isTouchEvent || !("which" in o) || 3 !== o.which) && !(!s.isTouchEvent && "button" in o && o.button > 0 || s.isTouched && s.isMoved))) if (a.noSwiping && d.closest(a.noSwipingSelector ? a.noSwipingSelector : "." + a.noSwipingClass)[0]) this.allowClick = !0; else if (!a.swipeHandler || d.closest(a.swipeHandler)[0]) { n.currentX = "touchstart" === o.type ? o.targetTouches[0].pageX : o.pageX, n.currentY = "touchstart" === o.type ? o.targetTouches[0].pageY : o.pageY; var h = n.currentX, p = n.currentY, u = a.edgeSwipeDetection || a.iOSEdgeSwipeDetection, c = a.edgeSwipeThreshold || a.iOSEdgeSwipeThreshold; if (!u || !(h <= c || h >= i.screen.width - c)) { if (S(s, { isTouched: !0, isMoved: !1, allowTouchCallbacks: !0, isScrolling: void 0, startMoving: void 0 }), n.startX = h, n.startY = p, s.touchStartTime = x(), this.allowClick = !0, this.updateSize(), this.swipeDirection = void 0, a.threshold > 0 && (s.allowThresholdMove = !1), "touchstart" !== o.type) { var v = !0; d.is(s.formElements) && (v = !1), t.activeElement && m(t.activeElement).is(s.formElements) && t.activeElement !== d[0] && t.activeElement.blur(); var f = v && this.allowTouchMove && a.touchStartPreventDefault; (a.touchStartForcePreventDefault || f) && o.preventDefault() } this.emit("touchStart", o) } } } } function A(e) { var t = r(), i = this.touchEventsData, s = this.params, a = this.touches, n = this.rtlTranslate, l = e; if (l.originalEvent && (l = l.originalEvent), i.isTouched) { if (!i.isTouchEvent || "touchmove" === l.type) { var o = "touchmove" === l.type && l.targetTouches && (l.targetTouches[0] || l.changedTouches[0]), d = "touchmove" === l.type ? o.pageX : l.pageX, h = "touchmove" === l.type ? o.pageY : l.pageY; if (l.preventedByNestedSwiper) return a.startX = d, void (a.startY = h); if (!this.allowTouchMove) return this.allowClick = !1, void (i.isTouched && (S(a, { startX: d, startY: h, currentX: d, currentY: h }), i.touchStartTime = x())); if (i.isTouchEvent && s.touchReleaseOnEdges && !s.loop) if (this.isVertical()) { if (h < a.startY && this.translate <= this.maxTranslate() || h > a.startY && this.translate >= this.minTranslate()) return i.isTouched = !1, void (i.isMoved = !1) } else if (d < a.startX && this.translate <= this.maxTranslate() || d > a.startX && this.translate >= this.minTranslate()) return; if (i.isTouchEvent && t.activeElement && l.target === t.activeElement && m(l.target).is(i.formElements)) return i.isMoved = !0, void (this.allowClick = !1); if (i.allowTouchCallbacks && this.emit("touchMove", l), !(l.targetTouches && l.targetTouches.length > 1)) { a.currentX = d, a.currentY = h; var p = a.currentX - a.startX, u = a.currentY - a.startY; if (!(this.params.threshold && Math.sqrt(Math.pow(p, 2) + Math.pow(u, 2)) < this.params.threshold)) { var c; if (void 0 === i.isScrolling) this.isHorizontal() && a.currentY === a.startY || this.isVertical() && a.currentX === a.startX ? i.isScrolling = !1 : p * p + u * u >= 25 && (c = 180 * Math.atan2(Math.abs(u), Math.abs(p)) / Math.PI, i.isScrolling = this.isHorizontal() ? c > s.touchAngle : 90 - c > s.touchAngle); if (i.isScrolling && this.emit("touchMoveOpposite", l), void 0 === i.startMoving && (a.currentX === a.startX && a.currentY === a.startY || (i.startMoving = !0)), i.isScrolling) i.isTouched = !1; else if (i.startMoving) { this.allowClick = !1, !s.cssMode && l.cancelable && l.preventDefault(), s.touchMoveStopPropagation && !s.nested && l.stopPropagation(), i.isMoved || (s.loop && this.loopFix(), i.startTranslate = this.getTranslate(), this.setTransition(0), this.animating && this.$wrapperEl.trigger("webkitTransitionEnd transitionend"), i.allowMomentumBounce = !1, !s.grabCursor || !0 !== this.allowSlideNext && !0 !== this.allowSlidePrev || this.setGrabCursor(!0), this.emit("sliderFirstMove", l)), this.emit("sliderMove", l), i.isMoved = !0; var v = this.isHorizontal() ? p : u; a.diff = v, v *= s.touchRatio, n && (v = -v), this.swipeDirection = v > 0 ? "prev" : "next", i.currentTranslate = v + i.startTranslate; var f = !0, g = s.resistanceRatio; if (s.touchReleaseOnEdges && (g = 0), v > 0 && i.currentTranslate > this.minTranslate() ? (f = !1, s.resistance && (i.currentTranslate = this.minTranslate() - 1 + Math.pow(-this.minTranslate() + i.startTranslate + v, g))) : v < 0 && i.currentTranslate < this.maxTranslate() && (f = !1, s.resistance && (i.currentTranslate = this.maxTranslate() + 1 - Math.pow(this.maxTranslate() - i.startTranslate - v, g))), f && (l.preventedByNestedSwiper = !0), !this.allowSlideNext && "next" === this.swipeDirection && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate), !this.allowSlidePrev && "prev" === this.swipeDirection && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate), s.threshold > 0) { if (!(Math.abs(v) > s.threshold || i.allowThresholdMove)) return void (i.currentTranslate = i.startTranslate); if (!i.allowThresholdMove) return i.allowThresholdMove = !0, a.startX = a.currentX, a.startY = a.currentY, i.currentTranslate = i.startTranslate, void (a.diff = this.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY) } s.followFinger && !s.cssMode && ((s.freeMode || s.watchSlidesProgress || s.watchSlidesVisibility) && (this.updateActiveIndex(), this.updateSlidesClasses()), s.freeMode && (0 === i.velocities.length && i.velocities.push({ position: a[this.isHorizontal() ? "startX" : "startY"], time: i.touchStartTime }), i.velocities.push({ position: a[this.isHorizontal() ? "currentX" : "currentY"], time: x() })), this.updateProgress(i.currentTranslate), this.setTranslate(i.currentTranslate)) } } } } } else i.startMoving && i.isScrolling && this.emit("touchMoveOpposite", l) } function D(e) { var t = this, i = t.touchEventsData, s = t.params, a = t.touches, r = t.rtlTranslate, n = t.$wrapperEl, l = t.slidesGrid, o = t.snapGrid, d = e; if (d.originalEvent && (d = d.originalEvent), i.allowTouchCallbacks && t.emit("touchEnd", d), i.allowTouchCallbacks = !1, !i.isTouched) return i.isMoved && s.grabCursor && t.setGrabCursor(!1), i.isMoved = !1, void (i.startMoving = !1); s.grabCursor && i.isMoved && i.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1); var h, p = x(), u = p - i.touchStartTime; if (t.allowClick && (t.updateClickedSlide(d), t.emit("tap click", d), u < 300 && p - i.lastClickTime < 300 && t.emit("doubleTap doubleClick", d)), i.lastClickTime = x(), E((function () { t.destroyed || (t.allowClick = !0) })), !i.isTouched || !i.isMoved || !t.swipeDirection || 0 === a.diff || i.currentTranslate === i.startTranslate) return i.isTouched = !1, i.isMoved = !1, void (i.startMoving = !1); if (i.isTouched = !1, i.isMoved = !1, i.startMoving = !1, h = s.followFinger ? r ? t.translate : -t.translate : -i.currentTranslate, !s.cssMode) if (s.freeMode) { if (h < -t.minTranslate()) return void t.slideTo(t.activeIndex); if (h > -t.maxTranslate()) return void (t.slides.length < o.length ? t.slideTo(o.length - 1) : t.slideTo(t.slides.length - 1)); if (s.freeModeMomentum) { if (i.velocities.length > 1) { var c = i.velocities.pop(), v = i.velocities.pop(), f = c.position - v.position, m = c.time - v.time; t.velocity = f / m, t.velocity /= 2, Math.abs(t.velocity) < s.freeModeMinimumVelocity && (t.velocity = 0), (m > 150 || x() - c.time > 300) && (t.velocity = 0) } else t.velocity = 0; t.velocity *= s.freeModeMomentumVelocityRatio, i.velocities.length = 0; var g = 1e3 * s.freeModeMomentumRatio, w = t.velocity * g, b = t.translate + w; r && (b = -b); var y, T, C = !1, S = 20 * Math.abs(t.velocity) * s.freeModeMomentumBounceRatio; if (b < t.maxTranslate()) s.freeModeMomentumBounce ? (b + t.maxTranslate() < -S && (b = t.maxTranslate() - S), y = t.maxTranslate(), C = !0, i.allowMomentumBounce = !0) : b = t.maxTranslate(), s.loop && s.centeredSlides && (T = !0); else if (b > t.minTranslate()) s.freeModeMomentumBounce ? (b - t.minTranslate() > S && (b = t.minTranslate() + S), y = t.minTranslate(), C = !0, i.allowMomentumBounce = !0) : b = t.minTranslate(), s.loop && s.centeredSlides && (T = !0); else if (s.freeModeSticky) { for (var M, z = 0; z < o.length; z += 1)if (o[z] > -b) { M = z; break } b = -(b = Math.abs(o[M] - b) < Math.abs(o[M - 1] - b) || "next" === t.swipeDirection ? o[M] : o[M - 1]) } if (T && t.once("transitionEnd", (function () { t.loopFix() })), 0 !== t.velocity) { if (g = r ? Math.abs((-b - t.translate) / t.velocity) : Math.abs((b - t.translate) / t.velocity), s.freeModeSticky) { var P = Math.abs((r ? -b : b) - t.translate), k = t.slidesSizesGrid[t.activeIndex]; g = P < k ? s.speed : P < 2 * k ? 1.5 * s.speed : 2.5 * s.speed } } else if (s.freeModeSticky) return void t.slideToClosest(); s.freeModeMomentumBounce && C ? (t.updateProgress(y), t.setTransition(g), t.setTranslate(b), t.transitionStart(!0, t.swipeDirection), t.animating = !0, n.transitionEnd((function () { t && !t.destroyed && i.allowMomentumBounce && (t.emit("momentumBounce"), t.setTransition(s.speed), setTimeout((function () { t.setTranslate(y), n.transitionEnd((function () { t && !t.destroyed && t.transitionEnd() })) }), 0)) }))) : t.velocity ? (t.updateProgress(b), t.setTransition(g), t.setTranslate(b), t.transitionStart(!0, t.swipeDirection), t.animating || (t.animating = !0, n.transitionEnd((function () { t && !t.destroyed && t.transitionEnd() })))) : t.updateProgress(b), t.updateActiveIndex(), t.updateSlidesClasses() } else if (s.freeModeSticky) return void t.slideToClosest(); (!s.freeModeMomentum || u >= s.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses()) } else { for (var $ = 0, L = t.slidesSizesGrid[0], I = 0; I < l.length; I += I < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup) { var O = I < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup; void 0 !== l[I + O] ? h >= l[I] && h < l[I + O] && ($ = I, L = l[I + O] - l[I]) : h >= l[I] && ($ = I, L = l[l.length - 1] - l[l.length - 2]) } var A = (h - l[$]) / L, D = $ < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup; if (u > s.longSwipesMs) { if (!s.longSwipes) return void t.slideTo(t.activeIndex); "next" === t.swipeDirection && (A >= s.longSwipesRatio ? t.slideTo($ + D) : t.slideTo($)), "prev" === t.swipeDirection && (A > 1 - s.longSwipesRatio ? t.slideTo($ + D) : t.slideTo($)) } else { if (!s.shortSwipes) return void t.slideTo(t.activeIndex); t.navigation && (d.target === t.navigation.nextEl || d.target === t.navigation.prevEl) ? d.target === t.navigation.nextEl ? t.slideTo($ + D) : t.slideTo($) : ("next" === t.swipeDirection && t.slideTo($ + D), "prev" === t.swipeDirection && t.slideTo($)) } } } function G() { var e = this.params, t = this.el; if (!t || 0 !== t.offsetWidth) { e.breakpoints && this.setBreakpoint(); var i = this.allowSlideNext, s = this.allowSlidePrev, a = this.snapGrid; this.allowSlideNext = !0, this.allowSlidePrev = !0, this.updateSize(), this.updateSlides(), this.updateSlidesClasses(), ("auto" === e.slidesPerView || e.slidesPerView > 1) && this.isEnd && !this.isBeginning && !this.params.centeredSlides ? this.slideTo(this.slides.length - 1, 0, !1, !0) : this.slideTo(this.activeIndex, 0, !1, !0), this.autoplay && this.autoplay.running && this.autoplay.paused && this.autoplay.run(), this.allowSlidePrev = s, this.allowSlideNext = i, this.params.watchOverflow && a !== this.snapGrid && this.checkOverflow() } } function N(e) { this.allowClick || (this.params.preventClicks && e.preventDefault(), this.params.preventClicksPropagation && this.animating && (e.stopPropagation(), e.stopImmediatePropagation())) } function B() { var e = this.wrapperEl, t = this.rtlTranslate; this.previousTranslate = this.translate, this.isHorizontal() ? this.translate = t ? e.scrollWidth - e.offsetWidth - e.scrollLeft : -e.scrollLeft : this.translate = -e.scrollTop, -0 === this.translate && (this.translate = 0), this.updateActiveIndex(), this.updateSlidesClasses(); var i = this.maxTranslate() - this.minTranslate(); (0 === i ? 0 : (this.translate - this.minTranslate()) / i) !== this.progress && this.updateProgress(t ? -this.translate : this.translate), this.emit("setTranslate", this.translate, !1) } var H = !1; function X() { } var Y = { init: !0, direction: "horizontal", touchEventsTarget: "container", initialSlide: 0, speed: 300, cssMode: !1, updateOnWindowResize: !0, width: null, height: null, preventInteractionOnTransition: !1, userAgent: null, url: null, edgeSwipeDetection: !1, edgeSwipeThreshold: 20, freeMode: !1, freeModeMomentum: !0, freeModeMomentumRatio: 1, freeModeMomentumBounce: !0, freeModeMomentumBounceRatio: 1, freeModeMomentumVelocityRatio: 1, freeModeSticky: !1, freeModeMinimumVelocity: .02, autoHeight: !1, setWrapperSize: !1, virtualTranslate: !1, effect: "slide", breakpoints: void 0, spaceBetween: 0, slidesPerView: 1, slidesPerColumn: 1, slidesPerColumnFill: "column", slidesPerGroup: 1, slidesPerGroupSkip: 0, centeredSlides: !1, centeredSlidesBounds: !1, slidesOffsetBefore: 0, slidesOffsetAfter: 0, normalizeSlideIndex: !0, centerInsufficientSlides: !1, watchOverflow: !1, roundLengths: !1, touchRatio: 1, touchAngle: 45, simulateTouch: !0, shortSwipes: !0, longSwipes: !0, longSwipesRatio: .5, longSwipesMs: 300, followFinger: !0, allowTouchMove: !0, threshold: 0, touchMoveStopPropagation: !1, touchStartPreventDefault: !0, touchStartForcePreventDefault: !1, touchReleaseOnEdges: !1, uniqueNavElements: !0, resistance: !0, resistanceRatio: .85, watchSlidesProgress: !1, watchSlidesVisibility: !1, grabCursor: !1, preventClicks: !0, preventClicksPropagation: !0, slideToClickedSlide: !1, preloadImages: !0, updateOnImagesReady: !0, loop: !1, loopAdditionalSlides: 0, loopedSlides: null, loopFillGroupWithBlank: !1, loopPreventsSlide: !0, allowSlidePrev: !0, allowSlideNext: !0, swipeHandler: null, noSwiping: !0, noSwipingClass: "swiper-no-swiping", noSwipingSelector: null, passiveListeners: !0, containerModifierClass: "swiper-container-", slideClass: "swiper-slide", slideBlankClass: "swiper-slide-invisible-blank", slideActiveClass: "swiper-slide-active", slideDuplicateActiveClass: "swiper-slide-duplicate-active", slideVisibleClass: "swiper-slide-visible", slideDuplicateClass: "swiper-slide-duplicate", slideNextClass: "swiper-slide-next", slideDuplicateNextClass: "swiper-slide-duplicate-next", slidePrevClass: "swiper-slide-prev", slideDuplicatePrevClass: "swiper-slide-duplicate-prev", wrapperClass: "swiper-wrapper", runCallbacksOnInit: !0, _emitClasses: !1 }, V = { modular: { useParams: function (e) { var t = this; t.modules && Object.keys(t.modules).forEach((function (i) { var s = t.modules[i]; s.params && S(e, s.params) })) }, useModules: function (e) { void 0 === e && (e = {}); var t = this; t.modules && Object.keys(t.modules).forEach((function (i) { var s = t.modules[i], a = e[i] || {}; s.on && t.on && Object.keys(s.on).forEach((function (e) { t.on(e, s.on[e]) })), s.create && s.create.bind(t)(a) })) } }, eventsEmitter: { on: function (e, t, i) { var s = this; if ("function" != typeof t) return s; var a = i ? "unshift" : "push"; return e.split(" ").forEach((function (e) { s.eventsListeners[e] || (s.eventsListeners[e] = []), s.eventsListeners[e][a](t) })), s }, once: function (e, t, i) { var s = this; if ("function" != typeof t) return s; function a() { s.off(e, a), a.__emitterProxy && delete a.__emitterProxy; for (var i = arguments.length, r = new Array(i), n = 0; n < i; n++)r[n] = arguments[n]; t.apply(s, r) } return a.__emitterProxy = t, s.on(e, a, i) }, onAny: function (e, t) { if ("function" != typeof e) return this; var i = t ? "unshift" : "push"; return this.eventsAnyListeners.indexOf(e) < 0 && this.eventsAnyListeners[i](e), this }, offAny: function (e) { if (!this.eventsAnyListeners) return this; var t = this.eventsAnyListeners.indexOf(e); return t >= 0 && this.eventsAnyListeners.splice(t, 1), this }, off: function (e, t) { var i = this; return i.eventsListeners ? (e.split(" ").forEach((function (e) { void 0 === t ? i.eventsListeners[e] = [] : i.eventsListeners[e] && i.eventsListeners[e].forEach((function (s, a) { (s === t || s.__emitterProxy && s.__emitterProxy === t) && i.eventsListeners[e].splice(a, 1) })) })), i) : i }, emit: function () { var e, t, i, s = this; if (!s.eventsListeners) return s; for (var a = arguments.length, r = new Array(a), n = 0; n < a; n++)r[n] = arguments[n]; "string" == typeof r[0] || Array.isArray(r[0]) ? (e = r[0], t = r.slice(1, r.length), i = s) : (e = r[0].events, t = r[0].data, i = r[0].context || s), t.unshift(i); var l = Array.isArray(e) ? e : e.split(" "); return l.forEach((function (e) { if (s.eventsListeners && s.eventsListeners[e]) { var a = []; s.eventsListeners[e].forEach((function (e) { a.push(e) })), a.forEach((function (e) { e.apply(i, t) })) } })), s } }, update: { updateSize: function () { var e, t, i = this.$el; e = void 0 !== this.params.width && null !== this.params.width ? this.params.width : i[0].clientWidth, t = void 0 !== this.params.height && null !== this.params.width ? this.params.height : i[0].clientHeight, 0 === e && this.isHorizontal() || 0 === t && this.isVertical() || (e = e - parseInt(i.css("padding-left") || 0, 10) - parseInt(i.css("padding-right") || 0, 10), t = t - parseInt(i.css("padding-top") || 0, 10) - parseInt(i.css("padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(t) && (t = 0), S(this, { width: e, height: t, size: this.isHorizontal() ? e : t })) }, updateSlides: function () { var e = l(), t = this.params, i = this.$wrapperEl, s = this.size, a = this.rtlTranslate, r = this.wrongRTL, n = this.virtual && t.virtual.enabled, o = n ? this.virtual.slides.length : this.slides.length, d = i.children("." + this.params.slideClass), h = n ? this.virtual.slides.length : d.length, p = [], u = [], c = []; function v(e, i) { return !t.cssMode || i !== d.length - 1 } var f = t.slidesOffsetBefore; "function" == typeof f && (f = t.slidesOffsetBefore.call(this)); var m = t.slidesOffsetAfter; "function" == typeof m && (m = t.slidesOffsetAfter.call(this)); var g = this.snapGrid.length, w = this.snapGrid.length, b = t.spaceBetween, y = -f, E = 0, x = 0; if (void 0 !== s) { var T, C; "string" == typeof b && b.indexOf("%") >= 0 && (b = parseFloat(b.replace("%", "")) / 100 * s), this.virtualSize = -b, a ? d.css({ marginLeft: "", marginTop: "" }) : d.css({ marginRight: "", marginBottom: "" }), t.slidesPerColumn > 1 && (T = Math.floor(h / t.slidesPerColumn) === h / this.params.slidesPerColumn ? h : Math.ceil(h / t.slidesPerColumn) * t.slidesPerColumn, "auto" !== t.slidesPerView && "row" === t.slidesPerColumnFill && (T = Math.max(T, t.slidesPerView * t.slidesPerColumn))); for (var M, z = t.slidesPerColumn, P = T / z, k = Math.floor(h / t.slidesPerColumn), $ = 0; $ < h; $ += 1) { C = 0; var L = d.eq($); if (t.slidesPerColumn > 1) { var I = void 0, O = void 0, A = void 0; if ("row" === t.slidesPerColumnFill && t.slidesPerGroup > 1) { var D = Math.floor($ / (t.slidesPerGroup * t.slidesPerColumn)), G = $ - t.slidesPerColumn * t.slidesPerGroup * D, N = 0 === D ? t.slidesPerGroup : Math.min(Math.ceil((h - D * z * t.slidesPerGroup) / z), t.slidesPerGroup); I = (O = G - (A = Math.floor(G / N)) * N + D * t.slidesPerGroup) + A * T / z, L.css({ "-webkit-box-ordinal-group": I, "-moz-box-ordinal-group": I, "-ms-flex-order": I, "-webkit-order": I, order: I }) } else "column" === t.slidesPerColumnFill ? (A = $ - (O = Math.floor($ / z)) * z, (O > k || O === k && A === z - 1) && (A += 1) >= z && (A = 0, O += 1)) : O = $ - (A = Math.floor($ / P)) * P; L.css("margin-" + (this.isHorizontal() ? "top" : "left"), 0 !== A && t.spaceBetween && t.spaceBetween + "px") } if ("none" !== L.css("display")) { if ("auto" === t.slidesPerView) { var B = e.getComputedStyle(L[0], null), H = L[0].style.transform, X = L[0].style.webkitTransform; if (H && (L[0].style.transform = "none"), X && (L[0].style.webkitTransform = "none"), t.roundLengths) C = this.isHorizontal() ? L.outerWidth(!0) : L.outerHeight(!0); else if (this.isHorizontal()) { var Y = parseFloat(B.getPropertyValue("width") || 0), V = parseFloat(B.getPropertyValue("padding-left") || 0), F = parseFloat(B.getPropertyValue("padding-right") || 0), W = parseFloat(B.getPropertyValue("margin-left") || 0), R = parseFloat(B.getPropertyValue("margin-right") || 0), q = B.getPropertyValue("box-sizing"); C = q && "border-box" === q ? Y + W + R : Y + V + F + W + R } else { var j = parseFloat(B.getPropertyValue("height") || 0), _ = parseFloat(B.getPropertyValue("padding-top") || 0), U = parseFloat(B.getPropertyValue("padding-bottom") || 0), K = parseFloat(B.getPropertyValue("margin-top") || 0), Z = parseFloat(B.getPropertyValue("margin-bottom") || 0), J = B.getPropertyValue("box-sizing"); C = J && "border-box" === J ? j + K + Z : j + _ + U + K + Z } H && (L[0].style.transform = H), X && (L[0].style.webkitTransform = X), t.roundLengths && (C = Math.floor(C)) } else C = (s - (t.slidesPerView - 1) * b) / t.slidesPerView, t.roundLengths && (C = Math.floor(C)), d[$] && (this.isHorizontal() ? d[$].style.width = C + "px" : d[$].style.height = C + "px"); d[$] && (d[$].swiperSlideSize = C), c.push(C), t.centeredSlides ? (y = y + C / 2 + E / 2 + b, 0 === E && 0 !== $ && (y = y - s / 2 - b), 0 === $ && (y = y - s / 2 - b), Math.abs(y) < .001 && (y = 0), t.roundLengths && (y = Math.floor(y)), x % t.slidesPerGroup == 0 && p.push(y), u.push(y)) : (t.roundLengths && (y = Math.floor(y)), (x - Math.min(this.params.slidesPerGroupSkip, x)) % this.params.slidesPerGroup == 0 && p.push(y), u.push(y), y = y + C + b), this.virtualSize += C + b, E = C, x += 1 } } if (this.virtualSize = Math.max(this.virtualSize, s) + m, a && r && ("slide" === t.effect || "coverflow" === t.effect) && i.css({ width: this.virtualSize + t.spaceBetween + "px" }), t.setWrapperSize && (this.isHorizontal() ? i.css({ width: this.virtualSize + t.spaceBetween + "px" }) : i.css({ height: this.virtualSize + t.spaceBetween + "px" })), t.slidesPerColumn > 1 && (this.virtualSize = (C + t.spaceBetween) * T, this.virtualSize = Math.ceil(this.virtualSize / t.slidesPerColumn) - t.spaceBetween, this.isHorizontal() ? i.css({ width: this.virtualSize + t.spaceBetween + "px" }) : i.css({ height: this.virtualSize + t.spaceBetween + "px" }), t.centeredSlides)) { M = []; for (var Q = 0; Q < p.length; Q += 1) { var ee = p[Q]; t.roundLengths && (ee = Math.floor(ee)), p[Q] < this.virtualSize + p[0] && M.push(ee) } p = M } if (!t.centeredSlides) { M = []; for (var te = 0; te < p.length; te += 1) { var ie = p[te]; t.roundLengths && (ie = Math.floor(ie)), p[te] <= this.virtualSize - s && M.push(ie) } p = M, Math.floor(this.virtualSize - s) - Math.floor(p[p.length - 1]) > 1 && p.push(this.virtualSize - s) } if (0 === p.length && (p = [0]), 0 !== t.spaceBetween && (this.isHorizontal() ? a ? d.filter(v).css({ marginLeft: b + "px" }) : d.filter(v).css({ marginRight: b + "px" }) : d.filter(v).css({ marginBottom: b + "px" })), t.centeredSlides && t.centeredSlidesBounds) { var se = 0; c.forEach((function (e) { se += e + (t.spaceBetween ? t.spaceBetween : 0) })); var ae = (se -= t.spaceBetween) - s; p = p.map((function (e) { return e < 0 ? -f : e > ae ? ae + m : e })) } if (t.centerInsufficientSlides) { var re = 0; if (c.forEach((function (e) { re += e + (t.spaceBetween ? t.spaceBetween : 0) })), (re -= t.spaceBetween) < s) { var ne = (s - re) / 2; p.forEach((function (e, t) { p[t] = e - ne })), u.forEach((function (e, t) { u[t] = e + ne })) } } S(this, { slides: d, snapGrid: p, slidesGrid: u, slidesSizesGrid: c }), h !== o && this.emit("slidesLengthChange"), p.length !== g && (this.params.watchOverflow && this.checkOverflow(), this.emit("snapGridLengthChange")), u.length !== w && this.emit("slidesGridLengthChange"), (t.watchSlidesProgress || t.watchSlidesVisibility) && this.updateSlidesOffset() } }, updateAutoHeight: function (e) { var t, i = [], s = 0; if ("number" == typeof e ? this.setTransition(e) : !0 === e && this.setTransition(this.params.speed), "auto" !== this.params.slidesPerView && this.params.slidesPerView > 1) if (this.params.centeredSlides) this.visibleSlides.each((function (e) { i.push(e) })); else for (t = 0; t < Math.ceil(this.params.slidesPerView); t += 1) { var a = this.activeIndex + t; if (a > this.slides.length) break; i.push(this.slides.eq(a)[0]) } else i.push(this.slides.eq(this.activeIndex)[0]); for (t = 0; t < i.length; t += 1)if (void 0 !== i[t]) { var r = i[t].offsetHeight; s = r > s ? r : s } s && this.$wrapperEl.css("height", s + "px") }, updateSlidesOffset: function () { for (var e = this.slides, t = 0; t < e.length; t += 1)e[t].swiperSlideOffset = this.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop }, updateSlidesProgress: function (e) { void 0 === e && (e = this && this.translate || 0); var t = this.params, i = this.slides, s = this.rtlTranslate; if (0 !== i.length) { void 0 === i[0].swiperSlideOffset && this.updateSlidesOffset(); var a = -e; s && (a = e), i.removeClass(t.slideVisibleClass), this.visibleSlidesIndexes = [], this.visibleSlides = []; for (var r = 0; r < i.length; r += 1) { var n = i[r], l = (a + (t.centeredSlides ? this.minTranslate() : 0) - n.swiperSlideOffset) / (n.swiperSlideSize + t.spaceBetween); if (t.watchSlidesVisibility || t.centeredSlides && t.autoHeight) { var o = -(a - n.swiperSlideOffset), d = o + this.slidesSizesGrid[r]; (o >= 0 && o < this.size - 1 || d > 1 && d <= this.size || o <= 0 && d >= this.size) && (this.visibleSlides.push(n), this.visibleSlidesIndexes.push(r), i.eq(r).addClass(t.slideVisibleClass)) } n.progress = s ? -l : l } this.visibleSlides = m(this.visibleSlides) } }, updateProgress: function (e) { if (void 0 === e) { var t = this.rtlTranslate ? -1 : 1; e = this && this.translate && this.translate * t || 0 } var i = this.params, s = this.maxTranslate() - this.minTranslate(), a = this.progress, r = this.isBeginning, n = this.isEnd, l = r, o = n; 0 === s ? (a = 0, r = !0, n = !0) : (r = (a = (e - this.minTranslate()) / s) <= 0, n = a >= 1), S(this, { progress: a, isBeginning: r, isEnd: n }), (i.watchSlidesProgress || i.watchSlidesVisibility || i.centeredSlides && i.autoHeight) && this.updateSlidesProgress(e), r && !l && this.emit("reachBeginning toEdge"), n && !o && this.emit("reachEnd toEdge"), (l && !r || o && !n) && this.emit("fromEdge"), this.emit("progress", a) }, updateSlidesClasses: function () { var e, t = this.slides, i = this.params, s = this.$wrapperEl, a = this.activeIndex, r = this.realIndex, n = this.virtual && i.virtual.enabled; t.removeClass(i.slideActiveClass + " " + i.slideNextClass + " " + i.slidePrevClass + " " + i.slideDuplicateActiveClass + " " + i.slideDuplicateNextClass + " " + i.slideDuplicatePrevClass), (e = n ? this.$wrapperEl.find("." + i.slideClass + '[data-swiper-slide-index="' + a + '"]') : t.eq(a)).addClass(i.slideActiveClass), i.loop && (e.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + r + '"]').addClass(i.slideDuplicateActiveClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + r + '"]').addClass(i.slideDuplicateActiveClass)); var l = e.nextAll("." + i.slideClass).eq(0).addClass(i.slideNextClass); i.loop && 0 === l.length && (l = t.eq(0)).addClass(i.slideNextClass); var o = e.prevAll("." + i.slideClass).eq(0).addClass(i.slidePrevClass); i.loop && 0 === o.length && (o = t.eq(-1)).addClass(i.slidePrevClass), i.loop && (l.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass), o.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + o.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + o.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass)), this.emitSlidesClasses() }, updateActiveIndex: function (e) { var t, i = this.rtlTranslate ? this.translate : -this.translate, s = this.slidesGrid, a = this.snapGrid, r = this.params, n = this.activeIndex, l = this.realIndex, o = this.snapIndex, d = e; if (void 0 === d) { for (var h = 0; h < s.length; h += 1)void 0 !== s[h + 1] ? i >= s[h] && i < s[h + 1] - (s[h + 1] - s[h]) / 2 ? d = h : i >= s[h] && i < s[h + 1] && (d = h + 1) : i >= s[h] && (d = h); r.normalizeSlideIndex && (d < 0 || void 0 === d) && (d = 0) } if (a.indexOf(i) >= 0) t = a.indexOf(i); else { var p = Math.min(r.slidesPerGroupSkip, d); t = p + Math.floor((d - p) / r.slidesPerGroup) } if (t >= a.length && (t = a.length - 1), d !== n) { var u = parseInt(this.slides.eq(d).attr("data-swiper-slide-index") || d, 10); S(this, { snapIndex: t, realIndex: u, previousIndex: n, activeIndex: d }), this.emit("activeIndexChange"), this.emit("snapIndexChange"), l !== u && this.emit("realIndexChange"), (this.initialized || this.params.runCallbacksOnInit) && this.emit("slideChange") } else t !== o && (this.snapIndex = t, this.emit("snapIndexChange")) }, updateClickedSlide: function (e) { var t = this.params, i = m(e.target).closest("." + t.slideClass)[0], s = !1; if (i) for (var a = 0; a < this.slides.length; a += 1)this.slides[a] === i && (s = !0); if (!i || !s) return this.clickedSlide = void 0, void (this.clickedIndex = void 0); this.clickedSlide = i, this.virtual && this.params.virtual.enabled ? this.clickedIndex = parseInt(m(i).attr("data-swiper-slide-index"), 10) : this.clickedIndex = m(i).index(), t.slideToClickedSlide && void 0 !== this.clickedIndex && this.clickedIndex !== this.activeIndex && this.slideToClickedSlide() } }, translate: { getTranslate: function (e) { void 0 === e && (e = this.isHorizontal() ? "x" : "y"); var t = this.params, i = this.rtlTranslate, s = this.translate, a = this.$wrapperEl; if (t.virtualTranslate) return i ? -s : s; if (t.cssMode) return s; var r = T(a[0], e); return i && (r = -r), r || 0 }, setTranslate: function (e, t) { var i = this.rtlTranslate, s = this.params, a = this.$wrapperEl, r = this.wrapperEl, n = this.progress, l = 0, o = 0; this.isHorizontal() ? l = i ? -e : e : o = e, s.roundLengths && (l = Math.floor(l), o = Math.floor(o)), s.cssMode ? r[this.isHorizontal() ? "scrollLeft" : "scrollTop"] = this.isHorizontal() ? -l : -o : s.virtualTranslate || a.transform("translate3d(" + l + "px, " + o + "px, 0px)"), this.previousTranslate = this.translate, this.translate = this.isHorizontal() ? l : o; var d = this.maxTranslate() - this.minTranslate(); (0 === d ? 0 : (e - this.minTranslate()) / d) !== n && this.updateProgress(e), this.emit("setTranslate", this.translate, t) }, minTranslate: function () { return -this.snapGrid[0] }, maxTranslate: function () { return -this.snapGrid[this.snapGrid.length - 1] }, translateTo: function (e, t, i, s, a) { void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0), void 0 === s && (s = !0); var r = this, n = r.params, l = r.wrapperEl; if (r.animating && n.preventInteractionOnTransition) return !1; var o, d = r.minTranslate(), h = r.maxTranslate(); if (o = s && e > d ? d : s && e < h ? h : e, r.updateProgress(o), n.cssMode) { var p, u = r.isHorizontal(); if (0 === t) l[u ? "scrollLeft" : "scrollTop"] = -o; else if (l.scrollTo) l.scrollTo(((p = {})[u ? "left" : "top"] = -o, p.behavior = "smooth", p)); else l[u ? "scrollLeft" : "scrollTop"] = -o; return !0 } return 0 === t ? (r.setTransition(0), r.setTranslate(o), i && (r.emit("beforeTransitionStart", t, a), r.emit("transitionEnd"))) : (r.setTransition(t), r.setTranslate(o), i && (r.emit("beforeTransitionStart", t, a), r.emit("transitionStart")), r.animating || (r.animating = !0, r.onTranslateToWrapperTransitionEnd || (r.onTranslateToWrapperTransitionEnd = function (e) { r && !r.destroyed && e.target === this && (r.$wrapperEl[0].removeEventListener("transitionend", r.onTranslateToWrapperTransitionEnd), r.$wrapperEl[0].removeEventListener("webkitTransitionEnd", r.onTranslateToWrapperTransitionEnd), r.onTranslateToWrapperTransitionEnd = null, delete r.onTranslateToWrapperTransitionEnd, i && r.emit("transitionEnd")) }), r.$wrapperEl[0].addEventListener("transitionend", r.onTranslateToWrapperTransitionEnd), r.$wrapperEl[0].addEventListener("webkitTransitionEnd", r.onTranslateToWrapperTransitionEnd))), !0 } }, transition: { setTransition: function (e, t) { this.params.cssMode || this.$wrapperEl.transition(e), this.emit("setTransition", e, t) }, transitionStart: function (e, t) { void 0 === e && (e = !0); var i = this.activeIndex, s = this.params, a = this.previousIndex; if (!s.cssMode) { s.autoHeight && this.updateAutoHeight(); var r = t; if (r || (r = i > a ? "next" : i < a ? "prev" : "reset"), this.emit("transitionStart"), e && i !== a) { if ("reset" === r) return void this.emit("slideResetTransitionStart"); this.emit("slideChangeTransitionStart"), "next" === r ? this.emit("slideNextTransitionStart") : this.emit("slidePrevTransitionStart") } } }, transitionEnd: function (e, t) { void 0 === e && (e = !0); var i = this.activeIndex, s = this.previousIndex, a = this.params; if (this.animating = !1, !a.cssMode) { this.setTransition(0); var r = t; if (r || (r = i > s ? "next" : i < s ? "prev" : "reset"), this.emit("transitionEnd"), e && i !== s) { if ("reset" === r) return void this.emit("slideResetTransitionEnd"); this.emit("slideChangeTransitionEnd"), "next" === r ? this.emit("slideNextTransitionEnd") : this.emit("slidePrevTransitionEnd") } } } }, slide: { slideTo: function (e, t, i, s) { void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0); var a = this, r = e; r < 0 && (r = 0); var n = a.params, l = a.snapGrid, o = a.slidesGrid, d = a.previousIndex, h = a.activeIndex, p = a.rtlTranslate, u = a.wrapperEl; if (a.animating && n.preventInteractionOnTransition) return !1; var c = Math.min(a.params.slidesPerGroupSkip, r), v = c + Math.floor((r - c) / a.params.slidesPerGroup); v >= l.length && (v = l.length - 1), (h || n.initialSlide || 0) === (d || 0) && i && a.emit("beforeSlideChangeStart"); var f, m = -l[v]; if (a.updateProgress(m), n.normalizeSlideIndex) for (var g = 0; g < o.length; g += 1)-Math.floor(100 * m) >= Math.floor(100 * o[g]) && (r = g); if (a.initialized && r !== h) { if (!a.allowSlideNext && m < a.translate && m < a.minTranslate()) return !1; if (!a.allowSlidePrev && m > a.translate && m > a.maxTranslate() && (h || 0) !== r) return !1 } if (f = r > h ? "next" : r < h ? "prev" : "reset", p && -m === a.translate || !p && m === a.translate) return a.updateActiveIndex(r), n.autoHeight && a.updateAutoHeight(), a.updateSlidesClasses(), "slide" !== n.effect && a.setTranslate(m), "reset" !== f && (a.transitionStart(i, f), a.transitionEnd(i, f)), !1; if (n.cssMode) { var w, b = a.isHorizontal(), y = -m; if (p && (y = u.scrollWidth - u.offsetWidth - y), 0 === t) u[b ? "scrollLeft" : "scrollTop"] = y; else if (u.scrollTo) u.scrollTo(((w = {})[b ? "left" : "top"] = y, w.behavior = "smooth", w)); else u[b ? "scrollLeft" : "scrollTop"] = y; return !0 } return 0 === t ? (a.setTransition(0), a.setTranslate(m), a.updateActiveIndex(r), a.updateSlidesClasses(), a.emit("beforeTransitionStart", t, s), a.transitionStart(i, f), a.transitionEnd(i, f)) : (a.setTransition(t), a.setTranslate(m), a.updateActiveIndex(r), a.updateSlidesClasses(), a.emit("beforeTransitionStart", t, s), a.transitionStart(i, f), a.animating || (a.animating = !0, a.onSlideToWrapperTransitionEnd || (a.onSlideToWrapperTransitionEnd = function (e) { a && !a.destroyed && e.target === this && (a.$wrapperEl[0].removeEventListener("transitionend", a.onSlideToWrapperTransitionEnd), a.$wrapperEl[0].removeEventListener("webkitTransitionEnd", a.onSlideToWrapperTransitionEnd), a.onSlideToWrapperTransitionEnd = null, delete a.onSlideToWrapperTransitionEnd, a.transitionEnd(i, f)) }), a.$wrapperEl[0].addEventListener("transitionend", a.onSlideToWrapperTransitionEnd), a.$wrapperEl[0].addEventListener("webkitTransitionEnd", a.onSlideToWrapperTransitionEnd))), !0 }, slideToLoop: function (e, t, i, s) { void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0); var a = e; return this.params.loop && (a += this.loopedSlides), this.slideTo(a, t, i, s) }, slideNext: function (e, t, i) { void 0 === e && (e = this.params.speed), void 0 === t && (t = !0); var s = this.params, a = this.animating, r = this.activeIndex < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup; if (s.loop) { if (a && s.loopPreventsSlide) return !1; this.loopFix(), this._clientLeft = this.$wrapperEl[0].clientLeft } return this.slideTo(this.activeIndex + r, e, t, i) }, slidePrev: function (e, t, i) { void 0 === e && (e = this.params.speed), void 0 === t && (t = !0); var s = this.params, a = this.animating, r = this.snapGrid, n = this.slidesGrid, l = this.rtlTranslate; if (s.loop) { if (a && s.loopPreventsSlide) return !1; this.loopFix(), this._clientLeft = this.$wrapperEl[0].clientLeft } function o(e) { return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e) } var d, h = o(l ? this.translate : -this.translate), p = r.map((function (e) { return o(e) })), u = (r[p.indexOf(h)], r[p.indexOf(h) - 1]); return void 0 === u && s.cssMode && r.forEach((function (e) { !u && h >= e && (u = e) })), void 0 !== u && (d = n.indexOf(u)) < 0 && (d = this.activeIndex - 1), this.slideTo(d, e, t, i) }, slideReset: function (e, t, i) { return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, i) }, slideToClosest: function (e, t, i, s) { void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === s && (s = .5); var a = this.activeIndex, r = Math.min(this.params.slidesPerGroupSkip, a), n = r + Math.floor((a - r) / this.params.slidesPerGroup), l = this.rtlTranslate ? this.translate : -this.translate; if (l >= this.snapGrid[n]) { var o = this.snapGrid[n]; l - o > (this.snapGrid[n + 1] - o) * s && (a += this.params.slidesPerGroup) } else { var d = this.snapGrid[n - 1]; l - d <= (this.snapGrid[n] - d) * s && (a -= this.params.slidesPerGroup) } return a = Math.max(a, 0), a = Math.min(a, this.slidesGrid.length - 1), this.slideTo(a, e, t, i) }, slideToClickedSlide: function () { var e, t = this, i = t.params, s = t.$wrapperEl, a = "auto" === i.slidesPerView ? t.slidesPerViewDynamic() : i.slidesPerView, r = t.clickedIndex; if (i.loop) { if (t.animating) return; e = parseInt(m(t.clickedSlide).attr("data-swiper-slide-index"), 10), i.centeredSlides ? r < t.loopedSlides - a / 2 || r > t.slides.length - t.loopedSlides + a / 2 ? (t.loopFix(), r = s.children("." + i.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + i.slideDuplicateClass + ")").eq(0).index(), E((function () { t.slideTo(r) }))) : t.slideTo(r) : r > t.slides.length - a ? (t.loopFix(), r = s.children("." + i.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + i.slideDuplicateClass + ")").eq(0).index(), E((function () { t.slideTo(r) }))) : t.slideTo(r) } else t.slideTo(r) } }, loop: { loopCreate: function () { var e = this, t = r(), i = e.params, s = e.$wrapperEl; s.children("." + i.slideClass + "." + i.slideDuplicateClass).remove(); var a = s.children("." + i.slideClass); if (i.loopFillGroupWithBlank) { var n = i.slidesPerGroup - a.length % i.slidesPerGroup; if (n !== i.slidesPerGroup) { for (var l = 0; l < n; l += 1) { var o = m(t.createElement("div")).addClass(i.slideClass + " " + i.slideBlankClass); s.append(o) } a = s.children("." + i.slideClass) } } "auto" !== i.slidesPerView || i.loopedSlides || (i.loopedSlides = a.length), e.loopedSlides = Math.ceil(parseFloat(i.loopedSlides || i.slidesPerView, 10)), e.loopedSlides += i.loopAdditionalSlides, e.loopedSlides > a.length && (e.loopedSlides = a.length); var d = [], h = []; a.each((function (t, i) { var s = m(t); i < e.loopedSlides && h.push(t), i < a.length && i >= a.length - e.loopedSlides && d.push(t), s.attr("data-swiper-slide-index", i) })); for (var p = 0; p < h.length; p += 1)s.append(m(h[p].cloneNode(!0)).addClass(i.slideDuplicateClass)); for (var u = d.length - 1; u >= 0; u -= 1)s.prepend(m(d[u].cloneNode(!0)).addClass(i.slideDuplicateClass)) }, loopFix: function () { this.emit("beforeLoopFix"); var e, t = this.activeIndex, i = this.slides, s = this.loopedSlides, a = this.allowSlidePrev, r = this.allowSlideNext, n = this.snapGrid, l = this.rtlTranslate; this.allowSlidePrev = !0, this.allowSlideNext = !0; var o = -n[t] - this.getTranslate(); if (t < s) e = i.length - 3 * s + t, e += s, this.slideTo(e, 0, !1, !0) && 0 !== o && this.setTranslate((l ? -this.translate : this.translate) - o); else if (t >= i.length - s) { e = -i.length + t + s, e += s, this.slideTo(e, 0, !1, !0) && 0 !== o && this.setTranslate((l ? -this.translate : this.translate) - o) } this.allowSlidePrev = a, this.allowSlideNext = r, this.emit("loopFix") }, loopDestroy: function () { var e = this.$wrapperEl, t = this.params, i = this.slides; e.children("." + t.slideClass + "." + t.slideDuplicateClass + ",." + t.slideClass + "." + t.slideBlankClass).remove(), i.removeAttr("data-swiper-slide-index") } }, grabCursor: { setGrabCursor: function (e) { if (!(this.support.touch || !this.params.simulateTouch || this.params.watchOverflow && this.isLocked || this.params.cssMode)) { var t = this.el; t.style.cursor = "move", t.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab", t.style.cursor = e ? "-moz-grabbin" : "-moz-grab", t.style.cursor = e ? "grabbing" : "grab" } }, unsetGrabCursor: function () { this.support.touch || this.params.watchOverflow && this.isLocked || this.params.cssMode || (this.el.style.cursor = "") } }, manipulation: { appendSlide: function (e) { var t = this.$wrapperEl, i = this.params; if (i.loop && this.loopDestroy(), "object" == typeof e && "length" in e) for (var s = 0; s < e.length; s += 1)e[s] && t.append(e[s]); else t.append(e); i.loop && this.loopCreate(), i.observer && this.support.observer || this.update() }, prependSlide: function (e) { var t = this.params, i = this.$wrapperEl, s = this.activeIndex; t.loop && this.loopDestroy(); var a = s + 1; if ("object" == typeof e && "length" in e) { for (var r = 0; r < e.length; r += 1)e[r] && i.prepend(e[r]); a = s + e.length } else i.prepend(e); t.loop && this.loopCreate(), t.observer && this.support.observer || this.update(), this.slideTo(a, 0, !1) }, addSlide: function (e, t) { var i = this.$wrapperEl, s = this.params, a = this.activeIndex; s.loop && (a -= this.loopedSlides, this.loopDestroy(), this.slides = i.children("." + s.slideClass)); var r = this.slides.length; if (e <= 0) this.prependSlide(t); else if (e >= r) this.appendSlide(t); else { for (var n = a > e ? a + 1 : a, l = [], o = r - 1; o >= e; o -= 1) { var d = this.slides.eq(o); d.remove(), l.unshift(d) } if ("object" == typeof t && "length" in t) { for (var h = 0; h < t.length; h += 1)t[h] && i.append(t[h]); n = a > e ? a + t.length : a } else i.append(t); for (var p = 0; p < l.length; p += 1)i.append(l[p]); s.loop && this.loopCreate(), s.observer && this.support.observer || this.update(), s.loop ? this.slideTo(n + this.loopedSlides, 0, !1) : this.slideTo(n, 0, !1) } }, removeSlide: function (e) { var t = this.params, i = this.$wrapperEl, s = this.activeIndex; t.loop && (s -= this.loopedSlides, this.loopDestroy(), this.slides = i.children("." + t.slideClass)); var a, r = s; if ("object" == typeof e && "length" in e) { for (var n = 0; n < e.length; n += 1)a = e[n], this.slides[a] && this.slides.eq(a).remove(), a < r && (r -= 1); r = Math.max(r, 0) } else a = e, this.slides[a] && this.slides.eq(a).remove(), a < r && (r -= 1), r = Math.max(r, 0); t.loop && this.loopCreate(), t.observer && this.support.observer || this.update(), t.loop ? this.slideTo(r + this.loopedSlides, 0, !1) : this.slideTo(r, 0, !1) }, removeAllSlides: function () { for (var e = [], t = 0; t < this.slides.length; t += 1)e.push(t); this.removeSlide(e) } }, events: { attachEvents: function () { var e = r(), t = this.params, i = this.touchEvents, s = this.el, a = this.wrapperEl, n = this.device, l = this.support; this.onTouchStart = O.bind(this), this.onTouchMove = A.bind(this), this.onTouchEnd = D.bind(this), t.cssMode && (this.onScroll = B.bind(this)), this.onClick = N.bind(this); var o = !!t.nested; if (!l.touch && l.pointerEvents) s.addEventListener(i.start, this.onTouchStart, !1), e.addEventListener(i.move, this.onTouchMove, o), e.addEventListener(i.end, this.onTouchEnd, !1); else { if (l.touch) { var d = !("touchstart" !== i.start || !l.passiveListener || !t.passiveListeners) && { passive: !0, capture: !1 }; s.addEventListener(i.start, this.onTouchStart, d), s.addEventListener(i.move, this.onTouchMove, l.passiveListener ? { passive: !1, capture: o } : o), s.addEventListener(i.end, this.onTouchEnd, d), i.cancel && s.addEventListener(i.cancel, this.onTouchEnd, d), H || (e.addEventListener("touchstart", X), H = !0) } (t.simulateTouch && !n.ios && !n.android || t.simulateTouch && !l.touch && n.ios) && (s.addEventListener("mousedown", this.onTouchStart, !1), e.addEventListener("mousemove", this.onTouchMove, o), e.addEventListener("mouseup", this.onTouchEnd, !1)) } (t.preventClicks || t.preventClicksPropagation) && s.addEventListener("click", this.onClick, !0), t.cssMode && a.addEventListener("scroll", this.onScroll), t.updateOnWindowResize ? this.on(n.ios || n.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", G, !0) : this.on("observerUpdate", G, !0) }, detachEvents: function () { var e = r(), t = this.params, i = this.touchEvents, s = this.el, a = this.wrapperEl, n = this.device, l = this.support, o = !!t.nested; if (!l.touch && l.pointerEvents) s.removeEventListener(i.start, this.onTouchStart, !1), e.removeEventListener(i.move, this.onTouchMove, o), e.removeEventListener(i.end, this.onTouchEnd, !1); else { if (l.touch) { var d = !("onTouchStart" !== i.start || !l.passiveListener || !t.passiveListeners) && { passive: !0, capture: !1 }; s.removeEventListener(i.start, this.onTouchStart, d), s.removeEventListener(i.move, this.onTouchMove, o), s.removeEventListener(i.end, this.onTouchEnd, d), i.cancel && s.removeEventListener(i.cancel, this.onTouchEnd, d) } (t.simulateTouch && !n.ios && !n.android || t.simulateTouch && !l.touch && n.ios) && (s.removeEventListener("mousedown", this.onTouchStart, !1), e.removeEventListener("mousemove", this.onTouchMove, o), e.removeEventListener("mouseup", this.onTouchEnd, !1)) } (t.preventClicks || t.preventClicksPropagation) && s.removeEventListener("click", this.onClick, !0), t.cssMode && a.removeEventListener("scroll", this.onScroll), this.off(n.ios || n.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", G) } }, breakpoints: { setBreakpoint: function () { var e = this.activeIndex, t = this.initialized, i = this.loopedSlides, s = void 0 === i ? 0 : i, a = this.params, r = this.$el, n = a.breakpoints; if (n && (!n || 0 !== Object.keys(n).length)) { var l = this.getBreakpoint(n); if (l && this.currentBreakpoint !== l) { var o = l in n ? n[l] : void 0; o && ["slidesPerView", "spaceBetween", "slidesPerGroup", "slidesPerGroupSkip", "slidesPerColumn"].forEach((function (e) { var t = o[e]; void 0 !== t && (o[e] = "slidesPerView" !== e || "AUTO" !== t && "auto" !== t ? "slidesPerView" === e ? parseFloat(t) : parseInt(t, 10) : "auto") })); var d = o || this.originalParams, h = a.slidesPerColumn > 1, p = d.slidesPerColumn > 1; h && !p ? (r.removeClass(a.containerModifierClass + "multirow " + a.containerModifierClass + "multirow-column"), this.emitContainerClasses()) : !h && p && (r.addClass(a.containerModifierClass + "multirow"), "column" === d.slidesPerColumnFill && r.addClass(a.containerModifierClass + "multirow-column"), this.emitContainerClasses()); var u = d.direction && d.direction !== a.direction, c = a.loop && (d.slidesPerView !== a.slidesPerView || u); u && t && this.changeDirection(), S(this.params, d), S(this, { allowTouchMove: this.params.allowTouchMove, allowSlideNext: this.params.allowSlideNext, allowSlidePrev: this.params.allowSlidePrev }), this.currentBreakpoint = l, c && t && (this.loopDestroy(), this.loopCreate(), this.updateSlides(), this.slideTo(e - s + this.loopedSlides, 0, !1)), this.emit("breakpoint", d) } } }, getBreakpoint: function (e) { var t = l(); if (e) { var i = !1, s = Object.keys(e).map((function (e) { if ("string" == typeof e && 0 === e.indexOf("@")) { var i = parseFloat(e.substr(1)); return { value: t.innerHeight * i, point: e } } return { value: e, point: e } })); s.sort((function (e, t) { return parseInt(e.value, 10) - parseInt(t.value, 10) })); for (var a = 0; a < s.length; a += 1) { var r = s[a], n = r.point; r.value <= t.innerWidth && (i = n) } return i || "max" } } }, checkOverflow: { checkOverflow: function () { var e = this.params, t = this.isLocked, i = this.slides.length > 0 && e.slidesOffsetBefore + e.spaceBetween * (this.slides.length - 1) + this.slides[0].offsetWidth * this.slides.length; e.slidesOffsetBefore && e.slidesOffsetAfter && i ? this.isLocked = i <= this.size : this.isLocked = 1 === this.snapGrid.length, this.allowSlideNext = !this.isLocked, this.allowSlidePrev = !this.isLocked, t !== this.isLocked && this.emit(this.isLocked ? "lock" : "unlock"), t && t !== this.isLocked && (this.isEnd = !1, this.navigation && this.navigation.update()) } }, classes: { addClasses: function () { var e = this.classNames, t = this.params, i = this.rtl, s = this.$el, a = this.device, r = []; r.push("initialized"), r.push(t.direction), t.freeMode && r.push("free-mode"), t.autoHeight && r.push("autoheight"), i && r.push("rtl"), t.slidesPerColumn > 1 && (r.push("multirow"), "column" === t.slidesPerColumnFill && r.push("multirow-column")), a.android && r.push("android"), a.ios && r.push("ios"), t.cssMode && r.push("css-mode"), r.forEach((function (i) { e.push(t.containerModifierClass + i) })), s.addClass(e.join(" ")), this.emitContainerClasses() }, removeClasses: function () { var e = this.$el, t = this.classNames; e.removeClass(t.join(" ")), this.emitContainerClasses() } }, images: { loadImage: function (e, t, i, s, a, r) { var n, o = l(); function d() { r && r() } m(e).parent("picture")[0] || e.complete && a ? d() : t ? ((n = new o.Image).onload = d, n.onerror = d, s && (n.sizes = s), i && (n.srcset = i), t && (n.src = t)) : d() }, preloadImages: function () { var e = this; function t() { null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady"))) } e.imagesToLoad = e.$el.find("img"); for (var i = 0; i < e.imagesToLoad.length; i += 1) { var s = e.imagesToLoad[i]; e.loadImage(s, s.currentSrc || s.getAttribute("src"), s.srcset || s.getAttribute("srcset"), s.sizes || s.getAttribute("sizes"), !0, t) } } } }, F = {}, W = function () { function t() { for (var e, i, s = arguments.length, a = new Array(s), r = 0; r < s; r++)a[r] = arguments[r]; 1 === a.length && a[0].constructor && a[0].constructor === Object ? i = a[0] : (e = a[0], i = a[1]), i || (i = {}), i = S({}, i), e && !i.el && (i.el = e); var n = this; n.support = z(), n.device = P({ userAgent: i.userAgent }), n.browser = k(), n.eventsListeners = {}, n.eventsAnyListeners = [], Object.keys(V).forEach((function (e) { Object.keys(V[e]).forEach((function (i) { t.prototype[i] || (t.prototype[i] = V[e][i]) })) })), void 0 === n.modules && (n.modules = {}), Object.keys(n.modules).forEach((function (e) { var t = n.modules[e]; if (t.params) { var s = Object.keys(t.params)[0], a = t.params[s]; if ("object" != typeof a || null === a) return; if (!(s in i) || !("enabled" in a)) return; !0 === i[s] && (i[s] = { enabled: !0 }), "object" != typeof i[s] || "enabled" in i[s] || (i[s].enabled = !0), i[s] || (i[s] = { enabled: !1 }) } })); var l = S({}, Y); n.useParams(l), n.params = S({}, l, F, i), n.originalParams = S({}, n.params), n.passedParams = S({}, i), n.params && n.params.on && Object.keys(n.params.on).forEach((function (e) { n.on(e, n.params.on[e]) })), n.$ = m; var o = m(n.params.el); if (e = o[0]) { if (o.length > 1) { var d = []; return o.each((function (e) { var s = S({}, i, { el: e }); d.push(new t(s)) })), d } var h, p, u; return e.swiper = n, e && e.shadowRoot && e.shadowRoot.querySelector ? (h = m(e.shadowRoot.querySelector("." + n.params.wrapperClass))).children = function (e) { return o.children(e) } : h = o.children("." + n.params.wrapperClass), S(n, { $el: o, el: e, $wrapperEl: h, wrapperEl: h[0], classNames: [], slides: m(), slidesGrid: [], snapGrid: [], slidesSizesGrid: [], isHorizontal: function () { return "horizontal" === n.params.direction }, isVertical: function () { return "vertical" === n.params.direction }, rtl: "rtl" === e.dir.toLowerCase() || "rtl" === o.css("direction"), rtlTranslate: "horizontal" === n.params.direction && ("rtl" === e.dir.toLowerCase() || "rtl" === o.css("direction")), wrongRTL: "-webkit-box" === h.css("display"), activeIndex: 0, realIndex: 0, isBeginning: !0, isEnd: !1, translate: 0, previousTranslate: 0, progress: 0, velocity: 0, animating: !1, allowSlideNext: n.params.allowSlideNext, allowSlidePrev: n.params.allowSlidePrev, touchEvents: (p = ["touchstart", "touchmove", "touchend", "touchcancel"], u = ["mousedown", "mousemove", "mouseup"], n.support.pointerEvents && (u = ["pointerdown", "pointermove", "pointerup"]), n.touchEventsTouch = { start: p[0], move: p[1], end: p[2], cancel: p[3] }, n.touchEventsDesktop = { start: u[0], move: u[1], end: u[2] }, n.support.touch || !n.params.simulateTouch ? n.touchEventsTouch : n.touchEventsDesktop), touchEventsData: { isTouched: void 0, isMoved: void 0, allowTouchCallbacks: void 0, touchStartTime: void 0, isScrolling: void 0, currentTranslate: void 0, startTranslate: void 0, allowThresholdMove: void 0, formElements: "input, select, option, textarea, button, video, label", lastClickTime: x(), clickTimeout: void 0, velocities: [], allowMomentumBounce: void 0, isTouchEvent: void 0, startMoving: void 0 }, allowClick: !0, allowTouchMove: n.params.allowTouchMove, touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 }, imagesToLoad: [], imagesLoaded: 0 }), n.useModules(), n.emit("_swiper"), n.params.init && n.init(), n } } var i, s, a, r = t.prototype; return r.emitContainerClasses = function () { var e = this; if (e.params._emitClasses && e.el) { var t = e.el.className.split(" ").filter((function (t) { return 0 === t.indexOf("swiper-container") || 0 === t.indexOf(e.params.containerModifierClass) })); e.emit("_containerClasses", t.join(" ")) } }, r.emitSlidesClasses = function () { var e = this; e.params._emitClasses && e.el && e.slides.each((function (t) { var i = t.className.split(" ").filter((function (t) { return 0 === t.indexOf("swiper-slide") || 0 === t.indexOf(e.params.slideClass) })); e.emit("_slideClass", t, i.join(" ")) })) }, r.slidesPerViewDynamic = function () { var e = this.params, t = this.slides, i = this.slidesGrid, s = this.size, a = this.activeIndex, r = 1; if (e.centeredSlides) { for (var n, l = t[a].swiperSlideSize, o = a + 1; o < t.length; o += 1)t[o] && !n && (r += 1, (l += t[o].swiperSlideSize) > s && (n = !0)); for (var d = a - 1; d >= 0; d -= 1)t[d] && !n && (r += 1, (l += t[d].swiperSlideSize) > s && (n = !0)) } else for (var h = a + 1; h < t.length; h += 1)i[h] - i[a] < s && (r += 1); return r }, r.update = function () { var e = this; if (e && !e.destroyed) { var t = e.snapGrid, i = e.params; i.breakpoints && e.setBreakpoint(), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.params.freeMode ? (s(), e.params.autoHeight && e.updateAutoHeight()) : (("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0)) || s(), i.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update") } function s() { var t = e.rtlTranslate ? -1 * e.translate : e.translate, i = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate()); e.setTranslate(i), e.updateActiveIndex(), e.updateSlidesClasses() } }, r.changeDirection = function (e, t) { void 0 === t && (t = !0); var i = this.params.direction; return e || (e = "horizontal" === i ? "vertical" : "horizontal"), e === i || "horizontal" !== e && "vertical" !== e || (this.$el.removeClass("" + this.params.containerModifierClass + i).addClass("" + this.params.containerModifierClass + e), this.emitContainerClasses(), this.params.direction = e, this.slides.each((function (t) { "vertical" === e ? t.style.width = "" : t.style.height = "" })), this.emit("changeDirection"), t && this.update()), this }, r.init = function () { this.initialized || (this.emit("beforeInit"), this.params.breakpoints && this.setBreakpoint(), this.addClasses(), this.params.loop && this.loopCreate(), this.updateSize(), this.updateSlides(), this.params.watchOverflow && this.checkOverflow(), this.params.grabCursor && this.setGrabCursor(), this.params.preloadImages && this.preloadImages(), this.params.loop ? this.slideTo(this.params.initialSlide + this.loopedSlides, 0, this.params.runCallbacksOnInit) : this.slideTo(this.params.initialSlide, 0, this.params.runCallbacksOnInit), this.attachEvents(), this.initialized = !0, this.emit("init")) }, r.destroy = function (e, t) { void 0 === e && (e = !0), void 0 === t && (t = !0); var i, s = this, a = s.params, r = s.$el, n = s.$wrapperEl, l = s.slides; return void 0 === s.params || s.destroyed || (s.emit("beforeDestroy"), s.initialized = !1, s.detachEvents(), a.loop && s.loopDestroy(), t && (s.removeClasses(), r.removeAttr("style"), n.removeAttr("style"), l && l.length && l.removeClass([a.slideVisibleClass, a.slideActiveClass, a.slideNextClass, a.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")), s.emit("destroy"), Object.keys(s.eventsListeners).forEach((function (e) { s.off(e) })), !1 !== e && (s.$el[0].swiper = null, i = s, Object.keys(i).forEach((function (e) { try { i[e] = null } catch (e) { } try { delete i[e] } catch (e) { } }))), s.destroyed = !0), null }, t.extendDefaults = function (e) { S(F, e) }, t.installModule = function (e) { t.prototype.modules || (t.prototype.modules = {}); var i = e.name || Object.keys(t.prototype.modules).length + "_" + x(); t.prototype.modules[i] = e }, t.use = function (e) { return Array.isArray(e) ? (e.forEach((function (e) { return t.installModule(e) })), t) : (t.installModule(e), t) }, i = t, a = [{ key: "extendedDefaults", get: function () { return F } }, { key: "defaults", get: function () { return Y } }], (s = null) && e(i.prototype, s), a && e(i, a), t }(); W.use([$, I]); var R = { update: function (e) { var t = this, i = t.params, s = i.slidesPerView, a = i.slidesPerGroup, r = i.centeredSlides, n = t.params.virtual, l = n.addSlidesBefore, o = n.addSlidesAfter, d = t.virtual, h = d.from, p = d.to, u = d.slides, c = d.slidesGrid, v = d.renderSlide, f = d.offset; t.updateActiveIndex(); var m, g, w, b = t.activeIndex || 0; m = t.rtlTranslate ? "right" : t.isHorizontal() ? "left" : "top", r ? (g = Math.floor(s / 2) + a + o, w = Math.floor(s / 2) + a + l) : (g = s + (a - 1) + o, w = a + l); var y = Math.max((b || 0) - w, 0), E = Math.min((b || 0) + g, u.length - 1), x = (t.slidesGrid[y] || 0) - (t.slidesGrid[0] || 0); function T() { t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.lazy && t.params.lazy.enabled && t.lazy.load() } if (S(t.virtual, { from: y, to: E, offset: x, slidesGrid: t.slidesGrid }), h === y && p === E && !e) return t.slidesGrid !== c && x !== f && t.slides.css(m, x + "px"), void t.updateProgress(); if (t.params.virtual.renderExternal) return t.params.virtual.renderExternal.call(t, { offset: x, from: y, to: E, slides: function () { for (var e = [], t = y; t <= E; t += 1)e.push(u[t]); return e }() }), void (t.params.virtual.renderExternalUpdate && T()); var C = [], M = []; if (e) t.$wrapperEl.find("." + t.params.slideClass).remove(); else for (var z = h; z <= p; z += 1)(z < y || z > E) && t.$wrapperEl.find("." + t.params.slideClass + '[data-swiper-slide-index="' + z + '"]').remove(); for (var P = 0; P < u.length; P += 1)P >= y && P <= E && (void 0 === p || e ? M.push(P) : (P > p && M.push(P), P < h && C.push(P))); M.forEach((function (e) { t.$wrapperEl.append(v(u[e], e)) })), C.sort((function (e, t) { return t - e })).forEach((function (e) { t.$wrapperEl.prepend(v(u[e], e)) })), t.$wrapperEl.children(".swiper-slide").css(m, x + "px"), T() }, renderSlide: function (e, t) { var i = this.params.virtual; if (i.cache && this.virtual.cache[t]) return this.virtual.cache[t]; var s = i.renderSlide ? m(i.renderSlide.call(this, e, t)) : m('<div class="' + this.params.slideClass + '" data-swiper-slide-index="' + t + '">' + e + "</div>"); return s.attr("data-swiper-slide-index") || s.attr("data-swiper-slide-index", t), i.cache && (this.virtual.cache[t] = s), s }, appendSlide: function (e) { if ("object" == typeof e && "length" in e) for (var t = 0; t < e.length; t += 1)e[t] && this.virtual.slides.push(e[t]); else this.virtual.slides.push(e); this.virtual.update(!0) }, prependSlide: function (e) { var t = this.activeIndex, i = t + 1, s = 1; if (Array.isArray(e)) { for (var a = 0; a < e.length; a += 1)e[a] && this.virtual.slides.unshift(e[a]); i = t + e.length, s = e.length } else this.virtual.slides.unshift(e); if (this.params.virtual.cache) { var r = this.virtual.cache, n = {}; Object.keys(r).forEach((function (e) { var t = r[e], i = t.attr("data-swiper-slide-index"); i && t.attr("data-swiper-slide-index", parseInt(i, 10) + 1), n[parseInt(e, 10) + s] = t })), this.virtual.cache = n } this.virtual.update(!0), this.slideTo(i, 0) }, removeSlide: function (e) { if (null != e) { var t = this.activeIndex; if (Array.isArray(e)) for (var i = e.length - 1; i >= 0; i -= 1)this.virtual.slides.splice(e[i], 1), this.params.virtual.cache && delete this.virtual.cache[e[i]], e[i] < t && (t -= 1), t = Math.max(t, 0); else this.virtual.slides.splice(e, 1), this.params.virtual.cache && delete this.virtual.cache[e], e < t && (t -= 1), t = Math.max(t, 0); this.virtual.update(!0), this.slideTo(t, 0) } }, removeAllSlides: function () { this.virtual.slides = [], this.params.virtual.cache && (this.virtual.cache = {}), this.virtual.update(!0), this.slideTo(0, 0) } }, q = { name: "virtual", params: { virtual: { enabled: !1, slides: [], cache: !0, renderSlide: null, renderExternal: null, renderExternalUpdate: !0, addSlidesBefore: 0, addSlidesAfter: 0 } }, create: function () { M(this, { virtual: t(t({}, R), {}, { slides: this.params.virtual.slides, cache: {} }) }) }, on: { beforeInit: function (e) { if (e.params.virtual.enabled) { e.classNames.push(e.params.containerModifierClass + "virtual"); var t = { watchSlidesProgress: !0 }; S(e.params, t), S(e.originalParams, t), e.params.initialSlide || e.virtual.update() } }, setTranslate: function (e) { e.params.virtual.enabled && e.virtual.update() } } }, j = { handle: function (e) { var t = l(), i = r(), s = this.rtlTranslate, a = e; a.originalEvent && (a = a.originalEvent); var n = a.keyCode || a.charCode, o = this.params.keyboard.pageUpDown, d = o && 33 === n, h = o && 34 === n, p = 37 === n, u = 39 === n, c = 38 === n, v = 40 === n; if (!this.allowSlideNext && (this.isHorizontal() && u || this.isVertical() && v || h)) return !1; if (!this.allowSlidePrev && (this.isHorizontal() && p || this.isVertical() && c || d)) return !1; if (!(a.shiftKey || a.altKey || a.ctrlKey || a.metaKey || i.activeElement && i.activeElement.nodeName && ("input" === i.activeElement.nodeName.toLowerCase() || "textarea" === i.activeElement.nodeName.toLowerCase()))) { if (this.params.keyboard.onlyInViewport && (d || h || p || u || c || v)) { var f = !1; if (this.$el.parents("." + this.params.slideClass).length > 0 && 0 === this.$el.parents("." + this.params.slideActiveClass).length) return; var m = t.innerWidth, g = t.innerHeight, w = this.$el.offset(); s && (w.left -= this.$el[0].scrollLeft); for (var b = [[w.left, w.top], [w.left + this.width, w.top], [w.left, w.top + this.height], [w.left + this.width, w.top + this.height]], y = 0; y < b.length; y += 1) { var E = b[y]; E[0] >= 0 && E[0] <= m && E[1] >= 0 && E[1] <= g && (f = !0) } if (!f) return } this.isHorizontal() ? ((d || h || p || u) && (a.preventDefault ? a.preventDefault() : a.returnValue = !1), ((h || u) && !s || (d || p) && s) && this.slideNext(), ((d || p) && !s || (h || u) && s) && this.slidePrev()) : ((d || h || c || v) && (a.preventDefault ? a.preventDefault() : a.returnValue = !1), (h || v) && this.slideNext(), (d || c) && this.slidePrev()), this.emit("keyPress", n) } }, enable: function () { var e = r(); this.keyboard.enabled || (m(e).on("keydown", this.keyboard.handle), this.keyboard.enabled = !0) }, disable: function () { var e = r(); this.keyboard.enabled && (m(e).off("keydown", this.keyboard.handle), this.keyboard.enabled = !1) } }, _ = { name: "keyboard", params: { keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } }, create: function () { M(this, { keyboard: t({ enabled: !1 }, j) }) }, on: { init: function (e) { e.params.keyboard.enabled && e.keyboard.enable() }, destroy: function (e) { e.keyboard.enabled && e.keyboard.disable() } } }; var U = { lastScrollTime: x(), lastEventBeforeSnap: void 0, recentWheelEvents: [], event: function () { return l().navigator.userAgent.indexOf("firefox") > -1 ? "DOMMouseScroll" : function () { var e = r(), t = "onwheel" in e; if (!t) { var i = e.createElement("div"); i.setAttribute("onwheel", "return;"), t = "function" == typeof i.onwheel } return !t && e.implementation && e.implementation.hasFeature && !0 !== e.implementation.hasFeature("", "") && (t = e.implementation.hasFeature("Events.wheel", "3.0")), t }() ? "wheel" : "mousewheel" }, normalize: function (e) { var t = 0, i = 0, s = 0, a = 0; return "detail" in e && (i = e.detail), "wheelDelta" in e && (i = -e.wheelDelta / 120), "wheelDeltaY" in e && (i = -e.wheelDeltaY / 120), "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120), "axis" in e && e.axis === e.HORIZONTAL_AXIS && (t = i, i = 0), s = 10 * t, a = 10 * i, "deltaY" in e && (a = e.deltaY), "deltaX" in e && (s = e.deltaX), e.shiftKey && !s && (s = a, a = 0), (s || a) && e.deltaMode && (1 === e.deltaMode ? (s *= 40, a *= 40) : (s *= 800, a *= 800)), s && !t && (t = s < 1 ? -1 : 1), a && !i && (i = a < 1 ? -1 : 1), { spinX: t, spinY: i, pixelX: s, pixelY: a } }, handleMouseEnter: function () { this.mouseEntered = !0 }, handleMouseLeave: function () { this.mouseEntered = !1 }, handle: function (e) { var t = e, i = this, s = i.params.mousewheel; i.params.cssMode && t.preventDefault(); var a = i.$el; if ("container" !== i.params.mousewheel.eventsTarget && (a = m(i.params.mousewheel.eventsTarget)), !i.mouseEntered && !a[0].contains(t.target) && !s.releaseOnEdges) return !0; t.originalEvent && (t = t.originalEvent); var r = 0, n = i.rtlTranslate ? -1 : 1, l = U.normalize(t); if (s.forceToAxis) if (i.isHorizontal()) { if (!(Math.abs(l.pixelX) > Math.abs(l.pixelY))) return !0; r = -l.pixelX * n } else { if (!(Math.abs(l.pixelY) > Math.abs(l.pixelX))) return !0; r = -l.pixelY } else r = Math.abs(l.pixelX) > Math.abs(l.pixelY) ? -l.pixelX * n : -l.pixelY; if (0 === r) return !0; if (s.invert && (r = -r), i.params.freeMode) { var o = { time: x(), delta: Math.abs(r), direction: Math.sign(r) }, d = i.mousewheel.lastEventBeforeSnap, h = d && o.time < d.time + 500 && o.delta <= d.delta && o.direction === d.direction; if (!h) { i.mousewheel.lastEventBeforeSnap = void 0, i.params.loop && i.loopFix(); var p = i.getTranslate() + r * s.sensitivity, u = i.isBeginning, c = i.isEnd; if (p >= i.minTranslate() && (p = i.minTranslate()), p <= i.maxTranslate() && (p = i.maxTranslate()), i.setTransition(0), i.setTranslate(p), i.updateProgress(), i.updateActiveIndex(), i.updateSlidesClasses(), (!u && i.isBeginning || !c && i.isEnd) && i.updateSlidesClasses(), i.params.freeModeSticky) { clearTimeout(i.mousewheel.timeout), i.mousewheel.timeout = void 0; var v = i.mousewheel.recentWheelEvents; v.length >= 15 && v.shift(); var f = v.length ? v[v.length - 1] : void 0, g = v[0]; if (v.push(o), f && (o.delta > f.delta || o.direction !== f.direction)) v.splice(0); else if (v.length >= 15 && o.time - g.time < 500 && g.delta - o.delta >= 1 && o.delta <= 6) { var w = r > 0 ? .8 : .2; i.mousewheel.lastEventBeforeSnap = o, v.splice(0), i.mousewheel.timeout = E((function () { i.slideToClosest(i.params.speed, !0, void 0, w) }), 0) } i.mousewheel.timeout || (i.mousewheel.timeout = E((function () { i.mousewheel.lastEventBeforeSnap = o, v.splice(0), i.slideToClosest(i.params.speed, !0, void 0, .5) }), 500)) } if (h || i.emit("scroll", t), i.params.autoplay && i.params.autoplayDisableOnInteraction && i.autoplay.stop(), p === i.minTranslate() || p === i.maxTranslate()) return !0 } } else { var b = { time: x(), delta: Math.abs(r), direction: Math.sign(r), raw: e }, y = i.mousewheel.recentWheelEvents; y.length >= 2 && y.shift(); var T = y.length ? y[y.length - 1] : void 0; if (y.push(b), T ? (b.direction !== T.direction || b.delta > T.delta || b.time > T.time + 150) && i.mousewheel.animateSlider(b) : i.mousewheel.animateSlider(b), i.mousewheel.releaseScroll(b)) return !0 } return t.preventDefault ? t.preventDefault() : t.returnValue = !1, !1 }, animateSlider: function (e) { var t = l(); return !(this.params.mousewheel.thresholdDelta && e.delta < this.params.mousewheel.thresholdDelta) && (!(this.params.mousewheel.thresholdTime && x() - this.mousewheel.lastScrollTime < this.params.mousewheel.thresholdTime) && (e.delta >= 6 && x() - this.mousewheel.lastScrollTime < 60 || (e.direction < 0 ? this.isEnd && !this.params.loop || this.animating || (this.slideNext(), this.emit("scroll", e.raw)) : this.isBeginning && !this.params.loop || this.animating || (this.slidePrev(), this.emit("scroll", e.raw)), this.mousewheel.lastScrollTime = (new t.Date).getTime(), !1))) }, releaseScroll: function (e) { var t = this.params.mousewheel; if (e.direction < 0) { if (this.isEnd && !this.params.loop && t.releaseOnEdges) return !0 } else if (this.isBeginning && !this.params.loop && t.releaseOnEdges) return !0; return !1 }, enable: function () { var e = U.event(); if (this.params.cssMode) return this.wrapperEl.removeEventListener(e, this.mousewheel.handle), !0; if (!e) return !1; if (this.mousewheel.enabled) return !1; var t = this.$el; return "container" !== this.params.mousewheel.eventsTarget && (t = m(this.params.mousewheel.eventsTarget)), t.on("mouseenter", this.mousewheel.handleMouseEnter), t.on("mouseleave", this.mousewheel.handleMouseLeave), t.on(e, this.mousewheel.handle), this.mousewheel.enabled = !0, !0 }, disable: function () { var e = U.event(); if (this.params.cssMode) return this.wrapperEl.addEventListener(e, this.mousewheel.handle), !0; if (!e) return !1; if (!this.mousewheel.enabled) return !1; var t = this.$el; return "container" !== this.params.mousewheel.eventsTarget && (t = m(this.params.mousewheel.eventsTarget)), t.off(e, this.mousewheel.handle), this.mousewheel.enabled = !1, !0 } }, K = { update: function () { var e = this.params.navigation; if (!this.params.loop) { var t = this.navigation, i = t.$nextEl, s = t.$prevEl; s && s.length > 0 && (this.isBeginning ? s.addClass(e.disabledClass) : s.removeClass(e.disabledClass), s[this.params.watchOverflow && this.isLocked ? "addClass" : "removeClass"](e.lockClass)), i && i.length > 0 && (this.isEnd ? i.addClass(e.disabledClass) : i.removeClass(e.disabledClass), i[this.params.watchOverflow && this.isLocked ? "addClass" : "removeClass"](e.lockClass)) } }, onPrevClick: function (e) { e.preventDefault(), this.isBeginning && !this.params.loop || this.slidePrev() }, onNextClick: function (e) { e.preventDefault(), this.isEnd && !this.params.loop || this.slideNext() }, init: function () { var e, t, i = this.params.navigation; (i.nextEl || i.prevEl) && (i.nextEl && (e = m(i.nextEl), this.params.uniqueNavElements && "string" == typeof i.nextEl && e.length > 1 && 1 === this.$el.find(i.nextEl).length && (e = this.$el.find(i.nextEl))), i.prevEl && (t = m(i.prevEl), this.params.uniqueNavElements && "string" == typeof i.prevEl && t.length > 1 && 1 === this.$el.find(i.prevEl).length && (t = this.$el.find(i.prevEl))), e && e.length > 0 && e.on("click", this.navigation.onNextClick), t && t.length > 0 && t.on("click", this.navigation.onPrevClick), S(this.navigation, { $nextEl: e, nextEl: e && e[0], $prevEl: t, prevEl: t && t[0] })) }, destroy: function () { var e = this.navigation, t = e.$nextEl, i = e.$prevEl; t && t.length && (t.off("click", this.navigation.onNextClick), t.removeClass(this.params.navigation.disabledClass)), i && i.length && (i.off("click", this.navigation.onPrevClick), i.removeClass(this.params.navigation.disabledClass)) } }, Z = { update: function () { var e = this.rtl, t = this.params.pagination; if (t.el && this.pagination.el && this.pagination.$el && 0 !== this.pagination.$el.length) { var i, s = this.virtual && this.params.virtual.enabled ? this.virtual.slides.length : this.slides.length, a = this.pagination.$el, r = this.params.loop ? Math.ceil((s - 2 * this.loopedSlides) / this.params.slidesPerGroup) : this.snapGrid.length; if (this.params.loop ? ((i = Math.ceil((this.activeIndex - this.loopedSlides) / this.params.slidesPerGroup)) > s - 1 - 2 * this.loopedSlides && (i -= s - 2 * this.loopedSlides), i > r - 1 && (i -= r), i < 0 && "bullets" !== this.params.paginationType && (i = r + i)) : i = void 0 !== this.snapIndex ? this.snapIndex : this.activeIndex || 0, "bullets" === t.type && this.pagination.bullets && this.pagination.bullets.length > 0) { var n, l, o, d = this.pagination.bullets; if (t.dynamicBullets && (this.pagination.bulletSize = d.eq(0)[this.isHorizontal() ? "outerWidth" : "outerHeight"](!0), a.css(this.isHorizontal() ? "width" : "height", this.pagination.bulletSize * (t.dynamicMainBullets + 4) + "px"), t.dynamicMainBullets > 1 && void 0 !== this.previousIndex && (this.pagination.dynamicBulletIndex += i - this.previousIndex, this.pagination.dynamicBulletIndex > t.dynamicMainBullets - 1 ? this.pagination.dynamicBulletIndex = t.dynamicMainBullets - 1 : this.pagination.dynamicBulletIndex < 0 && (this.pagination.dynamicBulletIndex = 0)), n = i - this.pagination.dynamicBulletIndex, o = ((l = n + (Math.min(d.length, t.dynamicMainBullets) - 1)) + n) / 2), d.removeClass(t.bulletActiveClass + " " + t.bulletActiveClass + "-next " + t.bulletActiveClass + "-next-next " + t.bulletActiveClass + "-prev " + t.bulletActiveClass + "-prev-prev " + t.bulletActiveClass + "-main"), a.length > 1) d.each((function (e) { var s = m(e), a = s.index(); a === i && s.addClass(t.bulletActiveClass), t.dynamicBullets && (a >= n && a <= l && s.addClass(t.bulletActiveClass + "-main"), a === n && s.prev().addClass(t.bulletActiveClass + "-prev").prev().addClass(t.bulletActiveClass + "-prev-prev"), a === l && s.next().addClass(t.bulletActiveClass + "-next").next().addClass(t.bulletActiveClass + "-next-next")) })); else { var h = d.eq(i), p = h.index(); if (h.addClass(t.bulletActiveClass), t.dynamicBullets) { for (var u = d.eq(n), c = d.eq(l), v = n; v <= l; v += 1)d.eq(v).addClass(t.bulletActiveClass + "-main"); if (this.params.loop) if (p >= d.length - t.dynamicMainBullets) { for (var f = t.dynamicMainBullets; f >= 0; f -= 1)d.eq(d.length - f).addClass(t.bulletActiveClass + "-main"); d.eq(d.length - t.dynamicMainBullets - 1).addClass(t.bulletActiveClass + "-prev") } else u.prev().addClass(t.bulletActiveClass + "-prev").prev().addClass(t.bulletActiveClass + "-prev-prev"), c.next().addClass(t.bulletActiveClass + "-next").next().addClass(t.bulletActiveClass + "-next-next"); else u.prev().addClass(t.bulletActiveClass + "-prev").prev().addClass(t.bulletActiveClass + "-prev-prev"), c.next().addClass(t.bulletActiveClass + "-next").next().addClass(t.bulletActiveClass + "-next-next") } } if (t.dynamicBullets) { var g = Math.min(d.length, t.dynamicMainBullets + 4), w = (this.pagination.bulletSize * g - this.pagination.bulletSize) / 2 - o * this.pagination.bulletSize, b = e ? "right" : "left"; d.css(this.isHorizontal() ? b : "top", w + "px") } } if ("fraction" === t.type && (a.find("." + t.currentClass).text(t.formatFractionCurrent(i + 1)), a.find("." + t.totalClass).text(t.formatFractionTotal(r))), "progressbar" === t.type) { var y; y = t.progressbarOpposite ? this.isHorizontal() ? "vertical" : "horizontal" : this.isHorizontal() ? "horizontal" : "vertical"; var E = (i + 1) / r, x = 1, T = 1; "horizontal" === y ? x = E : T = E, a.find("." + t.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + x + ") scaleY(" + T + ")").transition(this.params.speed) } "custom" === t.type && t.renderCustom ? (a.html(t.renderCustom(this, i + 1, r)), this.emit("paginationRender", a[0])) : this.emit("paginationUpdate", a[0]), a[this.params.watchOverflow && this.isLocked ? "addClass" : "removeClass"](t.lockClass) } }, render: function () { var e = this.params.pagination; if (e.el && this.pagination.el && this.pagination.$el && 0 !== this.pagination.$el.length) { var t = this.virtual && this.params.virtual.enabled ? this.virtual.slides.length : this.slides.length, i = this.pagination.$el, s = ""; if ("bullets" === e.type) { for (var a = this.params.loop ? Math.ceil((t - 2 * this.loopedSlides) / this.params.slidesPerGroup) : this.snapGrid.length, r = 0; r < a; r += 1)e.renderBullet ? s += e.renderBullet.call(this, r, e.bulletClass) : s += "<" + e.bulletElement + ' class="' + e.bulletClass + '"></' + e.bulletElement + ">"; i.html(s), this.pagination.bullets = i.find("." + e.bulletClass) } "fraction" === e.type && (s = e.renderFraction ? e.renderFraction.call(this, e.currentClass, e.totalClass) : '<span class="' + e.currentClass + '"></span> / <span class="' + e.totalClass + '"></span>', i.html(s)), "progressbar" === e.type && (s = e.renderProgressbar ? e.renderProgressbar.call(this, e.progressbarFillClass) : '<span class="' + e.progressbarFillClass + '"></span>', i.html(s)), "custom" !== e.type && this.emit("paginationRender", this.pagination.$el[0]) } }, init: function () { var e = this, t = e.params.pagination; if (t.el) { var i = m(t.el); 0 !== i.length && (e.params.uniqueNavElements && "string" == typeof t.el && i.length > 1 && (i = e.$el.find(t.el)), "bullets" === t.type && t.clickable && i.addClass(t.clickableClass), i.addClass(t.modifierClass + t.type), "bullets" === t.type && t.dynamicBullets && (i.addClass("" + t.modifierClass + t.type + "-dynamic"), e.pagination.dynamicBulletIndex = 0, t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)), "progressbar" === t.type && t.progressbarOpposite && i.addClass(t.progressbarOppositeClass), t.clickable && i.on("click", "." + t.bulletClass, (function (t) { t.preventDefault(); var i = m(this).index() * e.params.slidesPerGroup; e.params.loop && (i += e.loopedSlides), e.slideTo(i) })), S(e.pagination, { $el: i, el: i[0] })) } }, destroy: function () { var e = this.params.pagination; if (e.el && this.pagination.el && this.pagination.$el && 0 !== this.pagination.$el.length) { var t = this.pagination.$el; t.removeClass(e.hiddenClass), t.removeClass(e.modifierClass + e.type), this.pagination.bullets && this.pagination.bullets.removeClass(e.bulletActiveClass), e.clickable && t.off("click", "." + e.bulletClass) } } }, J = { setTranslate: function () { if (this.params.scrollbar.el && this.scrollbar.el) { var e = this.scrollbar, t = this.rtlTranslate, i = this.progress, s = e.dragSize, a = e.trackSize, r = e.$dragEl, n = e.$el, l = this.params.scrollbar, o = s, d = (a - s) * i; t ? (d = -d) > 0 ? (o = s - d, d = 0) : -d + s > a && (o = a + d) : d < 0 ? (o = s + d, d = 0) : d + s > a && (o = a - d), this.isHorizontal() ? (r.transform("translate3d(" + d + "px, 0, 0)"), r[0].style.width = o + "px") : (r.transform("translate3d(0px, " + d + "px, 0)"), r[0].style.height = o + "px"), l.hide && (clearTimeout(this.scrollbar.timeout), n[0].style.opacity = 1, this.scrollbar.timeout = setTimeout((function () { n[0].style.opacity = 0, n.transition(400) }), 1e3)) } }, setTransition: function (e) { this.params.scrollbar.el && this.scrollbar.el && this.scrollbar.$dragEl.transition(e) }, updateSize: function () { if (this.params.scrollbar.el && this.scrollbar.el) { var e = this.scrollbar, t = e.$dragEl, i = e.$el; t[0].style.width = "", t[0].style.height = ""; var s, a = this.isHorizontal() ? i[0].offsetWidth : i[0].offsetHeight, r = this.size / this.virtualSize, n = r * (a / this.size); s = "auto" === this.params.scrollbar.dragSize ? a * r : parseInt(this.params.scrollbar.dragSize, 10), this.isHorizontal() ? t[0].style.width = s + "px" : t[0].style.height = s + "px", i[0].style.display = r >= 1 ? "none" : "", this.params.scrollbar.hide && (i[0].style.opacity = 0), S(e, { trackSize: a, divider: r, moveDivider: n, dragSize: s }), e.$el[this.params.watchOverflow && this.isLocked ? "addClass" : "removeClass"](this.params.scrollbar.lockClass) } }, getPointerPosition: function (e) { return this.isHorizontal() ? "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].clientX : e.clientX : "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].clientY : e.clientY }, setDragPosition: function (e) { var t, i = this.scrollbar, s = this.rtlTranslate, a = i.$el, r = i.dragSize, n = i.trackSize, l = i.dragStartPos; t = (i.getPointerPosition(e) - a.offset()[this.isHorizontal() ? "left" : "top"] - (null !== l ? l : r / 2)) / (n - r), t = Math.max(Math.min(t, 1), 0), s && (t = 1 - t); var o = this.minTranslate() + (this.maxTranslate() - this.minTranslate()) * t; this.updateProgress(o), this.setTranslate(o), this.updateActiveIndex(), this.updateSlidesClasses() }, onDragStart: function (e) { var t = this.params.scrollbar, i = this.scrollbar, s = this.$wrapperEl, a = i.$el, r = i.$dragEl; this.scrollbar.isTouched = !0, this.scrollbar.dragStartPos = e.target === r[0] || e.target === r ? i.getPointerPosition(e) - e.target.getBoundingClientRect()[this.isHorizontal() ? "left" : "top"] : null, e.preventDefault(), e.stopPropagation(), s.transition(100), r.transition(100), i.setDragPosition(e), clearTimeout(this.scrollbar.dragTimeout), a.transition(0), t.hide && a.css("opacity", 1), this.params.cssMode && this.$wrapperEl.css("scroll-snap-type", "none"), this.emit("scrollbarDragStart", e) }, onDragMove: function (e) { var t = this.scrollbar, i = this.$wrapperEl, s = t.$el, a = t.$dragEl; this.scrollbar.isTouched && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, t.setDragPosition(e), i.transition(0), s.transition(0), a.transition(0), this.emit("scrollbarDragMove", e)) }, onDragEnd: function (e) { var t = this.params.scrollbar, i = this.scrollbar, s = this.$wrapperEl, a = i.$el; this.scrollbar.isTouched && (this.scrollbar.isTouched = !1, this.params.cssMode && (this.$wrapperEl.css("scroll-snap-type", ""), s.transition("")), t.hide && (clearTimeout(this.scrollbar.dragTimeout), this.scrollbar.dragTimeout = E((function () { a.css("opacity", 0), a.transition(400) }), 1e3)), this.emit("scrollbarDragEnd", e), t.snapOnRelease && this.slideToClosest()) }, enableDraggable: function () { if (this.params.scrollbar.el) { var e = r(), t = this.scrollbar, i = this.touchEventsTouch, s = this.touchEventsDesktop, a = this.params, n = this.support, l = t.$el[0], o = !(!n.passiveListener || !a.passiveListeners) && { passive: !1, capture: !1 }, d = !(!n.passiveListener || !a.passiveListeners) && { passive: !0, capture: !1 }; n.touch ? (l.addEventListener(i.start, this.scrollbar.onDragStart, o), l.addEventListener(i.move, this.scrollbar.onDragMove, o), l.addEventListener(i.end, this.scrollbar.onDragEnd, d)) : (l.addEventListener(s.start, this.scrollbar.onDragStart, o), e.addEventListener(s.move, this.scrollbar.onDragMove, o), e.addEventListener(s.end, this.scrollbar.onDragEnd, d)) } }, disableDraggable: function () { if (this.params.scrollbar.el) { var e = r(), t = this.scrollbar, i = this.touchEventsTouch, s = this.touchEventsDesktop, a = this.params, n = this.support, l = t.$el[0], o = !(!n.passiveListener || !a.passiveListeners) && { passive: !1, capture: !1 }, d = !(!n.passiveListener || !a.passiveListeners) && { passive: !0, capture: !1 }; n.touch ? (l.removeEventListener(i.start, this.scrollbar.onDragStart, o), l.removeEventListener(i.move, this.scrollbar.onDragMove, o), l.removeEventListener(i.end, this.scrollbar.onDragEnd, d)) : (l.removeEventListener(s.start, this.scrollbar.onDragStart, o), e.removeEventListener(s.move, this.scrollbar.onDragMove, o), e.removeEventListener(s.end, this.scrollbar.onDragEnd, d)) } }, init: function () { if (this.params.scrollbar.el) { var e = this.scrollbar, t = this.$el, i = this.params.scrollbar, s = m(i.el); this.params.uniqueNavElements && "string" == typeof i.el && s.length > 1 && 1 === t.find(i.el).length && (s = t.find(i.el)); var a = s.find("." + this.params.scrollbar.dragClass); 0 === a.length && (a = m('<div class="' + this.params.scrollbar.dragClass + '"></div>'), s.append(a)), S(e, { $el: s, el: s[0], $dragEl: a, dragEl: a[0] }), i.draggable && e.enableDraggable() } }, destroy: function () { this.scrollbar.disableDraggable() } }, Q = { setTransform: function (e, t) { var i = this.rtl, s = m(e), a = i ? -1 : 1, r = s.attr("data-swiper-parallax") || "0", n = s.attr("data-swiper-parallax-x"), l = s.attr("data-swiper-parallax-y"), o = s.attr("data-swiper-parallax-scale"), d = s.attr("data-swiper-parallax-opacity"); if (n || l ? (n = n || "0", l = l || "0") : this.isHorizontal() ? (n = r, l = "0") : (l = r, n = "0"), n = n.indexOf("%") >= 0 ? parseInt(n, 10) * t * a + "%" : n * t * a + "px", l = l.indexOf("%") >= 0 ? parseInt(l, 10) * t + "%" : l * t + "px", null != d) { var h = d - (d - 1) * (1 - Math.abs(t)); s[0].style.opacity = h } if (null == o) s.transform("translate3d(" + n + ", " + l + ", 0px)"); else { var p = o - (o - 1) * (1 - Math.abs(t)); s.transform("translate3d(" + n + ", " + l + ", 0px) scale(" + p + ")") } }, setTranslate: function () { var e = this, t = e.$el, i = e.slides, s = e.progress, a = e.snapGrid; t.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function (t) { e.parallax.setTransform(t, s) })), i.each((function (t, i) { var r = t.progress; e.params.slidesPerGroup > 1 && "auto" !== e.params.slidesPerView && (r += Math.ceil(i / 2) - s * (a.length - 1)), r = Math.min(Math.max(r, -1), 1), m(t).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function (t) { e.parallax.setTransform(t, r) })) })) }, setTransition: function (e) { void 0 === e && (e = this.params.speed); this.$el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function (t) { var i = m(t), s = parseInt(i.attr("data-swiper-parallax-duration"), 10) || e; 0 === e && (s = 0), i.transition(s) })) } }, ee = { getDistanceBetweenTouches: function (e) { if (e.targetTouches.length < 2) return 1; var t = e.targetTouches[0].pageX, i = e.targetTouches[0].pageY, s = e.targetTouches[1].pageX, a = e.targetTouches[1].pageY; return Math.sqrt(Math.pow(s - t, 2) + Math.pow(a - i, 2)) }, onGestureStart: function (e) { var t = this.support, i = this.params.zoom, s = this.zoom, a = s.gesture; if (s.fakeGestureTouched = !1, s.fakeGestureMoved = !1, !t.gestures) { if ("touchstart" !== e.type || "touchstart" === e.type && e.targetTouches.length < 2) return; s.fakeGestureTouched = !0, a.scaleStart = ee.getDistanceBetweenTouches(e) } a.$slideEl && a.$slideEl.length || (a.$slideEl = m(e.target).closest("." + this.params.slideClass), 0 === a.$slideEl.length && (a.$slideEl = this.slides.eq(this.activeIndex)), a.$imageEl = a.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"), a.$imageWrapEl = a.$imageEl.parent("." + i.containerClass), a.maxRatio = a.$imageWrapEl.attr("data-swiper-zoom") || i.maxRatio, 0 !== a.$imageWrapEl.length) ? (a.$imageEl && a.$imageEl.transition(0), this.zoom.isScaling = !0) : a.$imageEl = void 0 }, onGestureChange: function (e) { var t = this.support, i = this.params.zoom, s = this.zoom, a = s.gesture; if (!t.gestures) { if ("touchmove" !== e.type || "touchmove" === e.type && e.targetTouches.length < 2) return; s.fakeGestureMoved = !0, a.scaleMove = ee.getDistanceBetweenTouches(e) } a.$imageEl && 0 !== a.$imageEl.length ? (t.gestures ? s.scale = e.scale * s.currentScale : s.scale = a.scaleMove / a.scaleStart * s.currentScale, s.scale > a.maxRatio && (s.scale = a.maxRatio - 1 + Math.pow(s.scale - a.maxRatio + 1, .5)), s.scale < i.minRatio && (s.scale = i.minRatio + 1 - Math.pow(i.minRatio - s.scale + 1, .5)), a.$imageEl.transform("translate3d(0,0,0) scale(" + s.scale + ")")) : "gesturechange" === e.type && s.onGestureStart(e) }, onGestureEnd: function (e) { var t = this.device, i = this.support, s = this.params.zoom, a = this.zoom, r = a.gesture; if (!i.gestures) { if (!a.fakeGestureTouched || !a.fakeGestureMoved) return; if ("touchend" !== e.type || "touchend" === e.type && e.changedTouches.length < 2 && !t.android) return; a.fakeGestureTouched = !1, a.fakeGestureMoved = !1 } r.$imageEl && 0 !== r.$imageEl.length && (a.scale = Math.max(Math.min(a.scale, r.maxRatio), s.minRatio), r.$imageEl.transition(this.params.speed).transform("translate3d(0,0,0) scale(" + a.scale + ")"), a.currentScale = a.scale, a.isScaling = !1, 1 === a.scale && (r.$slideEl = void 0)) }, onTouchStart: function (e) { var t = this.device, i = this.zoom, s = i.gesture, a = i.image; s.$imageEl && 0 !== s.$imageEl.length && (a.isTouched || (t.android && e.cancelable && e.preventDefault(), a.isTouched = !0, a.touchesStart.x = "touchstart" === e.type ? e.targetTouches[0].pageX : e.pageX, a.touchesStart.y = "touchstart" === e.type ? e.targetTouches[0].pageY : e.pageY)) }, onTouchMove: function (e) { var t = this.zoom, i = t.gesture, s = t.image, a = t.velocity; if (i.$imageEl && 0 !== i.$imageEl.length && (this.allowClick = !1, s.isTouched && i.$slideEl)) { s.isMoved || (s.width = i.$imageEl[0].offsetWidth, s.height = i.$imageEl[0].offsetHeight, s.startX = T(i.$imageWrapEl[0], "x") || 0, s.startY = T(i.$imageWrapEl[0], "y") || 0, i.slideWidth = i.$slideEl[0].offsetWidth, i.slideHeight = i.$slideEl[0].offsetHeight, i.$imageWrapEl.transition(0), this.rtl && (s.startX = -s.startX, s.startY = -s.startY)); var r = s.width * t.scale, n = s.height * t.scale; if (!(r < i.slideWidth && n < i.slideHeight)) { if (s.minX = Math.min(i.slideWidth / 2 - r / 2, 0), s.maxX = -s.minX, s.minY = Math.min(i.slideHeight / 2 - n / 2, 0), s.maxY = -s.minY, s.touchesCurrent.x = "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX, s.touchesCurrent.y = "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY, !s.isMoved && !t.isScaling) { if (this.isHorizontal() && (Math.floor(s.minX) === Math.floor(s.startX) && s.touchesCurrent.x < s.touchesStart.x || Math.floor(s.maxX) === Math.floor(s.startX) && s.touchesCurrent.x > s.touchesStart.x)) return void (s.isTouched = !1); if (!this.isHorizontal() && (Math.floor(s.minY) === Math.floor(s.startY) && s.touchesCurrent.y < s.touchesStart.y || Math.floor(s.maxY) === Math.floor(s.startY) && s.touchesCurrent.y > s.touchesStart.y)) return void (s.isTouched = !1) } e.cancelable && e.preventDefault(), e.stopPropagation(), s.isMoved = !0, s.currentX = s.touchesCurrent.x - s.touchesStart.x + s.startX, s.currentY = s.touchesCurrent.y - s.touchesStart.y + s.startY, s.currentX < s.minX && (s.currentX = s.minX + 1 - Math.pow(s.minX - s.currentX + 1, .8)), s.currentX > s.maxX && (s.currentX = s.maxX - 1 + Math.pow(s.currentX - s.maxX + 1, .8)), s.currentY < s.minY && (s.currentY = s.minY + 1 - Math.pow(s.minY - s.currentY + 1, .8)), s.currentY > s.maxY && (s.currentY = s.maxY - 1 + Math.pow(s.currentY - s.maxY + 1, .8)), a.prevPositionX || (a.prevPositionX = s.touchesCurrent.x), a.prevPositionY || (a.prevPositionY = s.touchesCurrent.y), a.prevTime || (a.prevTime = Date.now()), a.x = (s.touchesCurrent.x - a.prevPositionX) / (Date.now() - a.prevTime) / 2, a.y = (s.touchesCurrent.y - a.prevPositionY) / (Date.now() - a.prevTime) / 2, Math.abs(s.touchesCurrent.x - a.prevPositionX) < 2 && (a.x = 0), Math.abs(s.touchesCurrent.y - a.prevPositionY) < 2 && (a.y = 0), a.prevPositionX = s.touchesCurrent.x, a.prevPositionY = s.touchesCurrent.y, a.prevTime = Date.now(), i.$imageWrapEl.transform("translate3d(" + s.currentX + "px, " + s.currentY + "px,0)") } } }, onTouchEnd: function () { var e = this.zoom, t = e.gesture, i = e.image, s = e.velocity; if (t.$imageEl && 0 !== t.$imageEl.length) { if (!i.isTouched || !i.isMoved) return i.isTouched = !1, void (i.isMoved = !1); i.isTouched = !1, i.isMoved = !1; var a = 300, r = 300, n = s.x * a, l = i.currentX + n, o = s.y * r, d = i.currentY + o; 0 !== s.x && (a = Math.abs((l - i.currentX) / s.x)), 0 !== s.y && (r = Math.abs((d - i.currentY) / s.y)); var h = Math.max(a, r); i.currentX = l, i.currentY = d; var p = i.width * e.scale, u = i.height * e.scale; i.minX = Math.min(t.slideWidth / 2 - p / 2, 0), i.maxX = -i.minX, i.minY = Math.min(t.slideHeight / 2 - u / 2, 0), i.maxY = -i.minY, i.currentX = Math.max(Math.min(i.currentX, i.maxX), i.minX), i.currentY = Math.max(Math.min(i.currentY, i.maxY), i.minY), t.$imageWrapEl.transition(h).transform("translate3d(" + i.currentX + "px, " + i.currentY + "px,0)") } }, onTransitionEnd: function () { var e = this.zoom, t = e.gesture; t.$slideEl && this.previousIndex !== this.activeIndex && (t.$imageEl && t.$imageEl.transform("translate3d(0,0,0) scale(1)"), t.$imageWrapEl && t.$imageWrapEl.transform("translate3d(0,0,0)"), e.scale = 1, e.currentScale = 1, t.$slideEl = void 0, t.$imageEl = void 0, t.$imageWrapEl = void 0) }, toggle: function (e) { var t = this.zoom; t.scale && 1 !== t.scale ? t.out() : t.in(e) }, in: function (e) { var t, i, s, a, r, n, l, o, d, h, p, u, c, v, f, m, g = this.zoom, w = this.params.zoom, b = g.gesture, y = g.image; (b.$slideEl || (this.params.virtual && this.params.virtual.enabled && this.virtual ? b.$slideEl = this.$wrapperEl.children("." + this.params.slideActiveClass) : b.$slideEl = this.slides.eq(this.activeIndex), b.$imageEl = b.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"), b.$imageWrapEl = b.$imageEl.parent("." + w.containerClass)), b.$imageEl && 0 !== b.$imageEl.length) && (b.$slideEl.addClass("" + w.zoomedSlideClass), void 0 === y.touchesStart.x && e ? (t = "touchend" === e.type ? e.changedTouches[0].pageX : e.pageX, i = "touchend" === e.type ? e.changedTouches[0].pageY : e.pageY) : (t = y.touchesStart.x, i = y.touchesStart.y), g.scale = b.$imageWrapEl.attr("data-swiper-zoom") || w.maxRatio, g.currentScale = b.$imageWrapEl.attr("data-swiper-zoom") || w.maxRatio, e ? (f = b.$slideEl[0].offsetWidth, m = b.$slideEl[0].offsetHeight, s = b.$slideEl.offset().left + f / 2 - t, a = b.$slideEl.offset().top + m / 2 - i, l = b.$imageEl[0].offsetWidth, o = b.$imageEl[0].offsetHeight, d = l * g.scale, h = o * g.scale, c = -(p = Math.min(f / 2 - d / 2, 0)), v = -(u = Math.min(m / 2 - h / 2, 0)), (r = s * g.scale) < p && (r = p), r > c && (r = c), (n = a * g.scale) < u && (n = u), n > v && (n = v)) : (r = 0, n = 0), b.$imageWrapEl.transition(300).transform("translate3d(" + r + "px, " + n + "px,0)"), b.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + g.scale + ")")) }, out: function () { var e = this.zoom, t = this.params.zoom, i = e.gesture; i.$slideEl || (this.params.virtual && this.params.virtual.enabled && this.virtual ? i.$slideEl = this.$wrapperEl.children("." + this.params.slideActiveClass) : i.$slideEl = this.slides.eq(this.activeIndex), i.$imageEl = i.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"), i.$imageWrapEl = i.$imageEl.parent("." + t.containerClass)), i.$imageEl && 0 !== i.$imageEl.length && (e.scale = 1, e.currentScale = 1, i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"), i.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"), i.$slideEl.removeClass("" + t.zoomedSlideClass), i.$slideEl = void 0) }, toggleGestures: function (e) { var t = this.zoom, i = t.slideSelector, s = t.passiveListener; this.$wrapperEl[e]("gesturestart", i, t.onGestureStart, s), this.$wrapperEl[e]("gesturechange", i, t.onGestureChange, s), this.$wrapperEl[e]("gestureend", i, t.onGestureEnd, s) }, enableGestures: function () { this.zoom.gesturesEnabled || (this.zoom.gesturesEnabled = !0, this.zoom.toggleGestures("on")) }, disableGestures: function () { this.zoom.gesturesEnabled && (this.zoom.gesturesEnabled = !1, this.zoom.toggleGestures("off")) }, enable: function () { var e = this.support, t = this.zoom; if (!t.enabled) { t.enabled = !0; var i = !("touchstart" !== this.touchEvents.start || !e.passiveListener || !this.params.passiveListeners) && { passive: !0, capture: !1 }, s = !e.passiveListener || { passive: !1, capture: !0 }, a = "." + this.params.slideClass; this.zoom.passiveListener = i, this.zoom.slideSelector = a, e.gestures ? (this.$wrapperEl.on(this.touchEvents.start, this.zoom.enableGestures, i), this.$wrapperEl.on(this.touchEvents.end, this.zoom.disableGestures, i)) : "touchstart" === this.touchEvents.start && (this.$wrapperEl.on(this.touchEvents.start, a, t.onGestureStart, i), this.$wrapperEl.on(this.touchEvents.move, a, t.onGestureChange, s), this.$wrapperEl.on(this.touchEvents.end, a, t.onGestureEnd, i), this.touchEvents.cancel && this.$wrapperEl.on(this.touchEvents.cancel, a, t.onGestureEnd, i)), this.$wrapperEl.on(this.touchEvents.move, "." + this.params.zoom.containerClass, t.onTouchMove, s) } }, disable: function () { var e = this.zoom; if (e.enabled) { var t = this.support; this.zoom.enabled = !1; var i = !("touchstart" !== this.touchEvents.start || !t.passiveListener || !this.params.passiveListeners) && { passive: !0, capture: !1 }, s = !t.passiveListener || { passive: !1, capture: !0 }, a = "." + this.params.slideClass; t.gestures ? (this.$wrapperEl.off(this.touchEvents.start, this.zoom.enableGestures, i), this.$wrapperEl.off(this.touchEvents.end, this.zoom.disableGestures, i)) : "touchstart" === this.touchEvents.start && (this.$wrapperEl.off(this.touchEvents.start, a, e.onGestureStart, i), this.$wrapperEl.off(this.touchEvents.move, a, e.onGestureChange, s), this.$wrapperEl.off(this.touchEvents.end, a, e.onGestureEnd, i), this.touchEvents.cancel && this.$wrapperEl.off(this.touchEvents.cancel, a, e.onGestureEnd, i)), this.$wrapperEl.off(this.touchEvents.move, "." + this.params.zoom.containerClass, e.onTouchMove, s) } } }, te = { loadInSlide: function (e, t) { void 0 === t && (t = !0); var i = this, s = i.params.lazy; if (void 0 !== e && 0 !== i.slides.length) { var a = i.virtual && i.params.virtual.enabled ? i.$wrapperEl.children("." + i.params.slideClass + '[data-swiper-slide-index="' + e + '"]') : i.slides.eq(e), r = a.find("." + s.elementClass + ":not(." + s.loadedClass + "):not(." + s.loadingClass + ")"); !a.hasClass(s.elementClass) || a.hasClass(s.loadedClass) || a.hasClass(s.loadingClass) || r.push(a[0]), 0 !== r.length && r.each((function (e) { var r = m(e); r.addClass(s.loadingClass); var n = r.attr("data-background"), l = r.attr("data-src"), o = r.attr("data-srcset"), d = r.attr("data-sizes"), h = r.parent("picture"); i.loadImage(r[0], l || n, o, d, !1, (function () { if (null != i && i && (!i || i.params) && !i.destroyed) { if (n ? (r.css("background-image", 'url("' + n + '")'), r.removeAttr("data-background")) : (o && (r.attr("srcset", o), r.removeAttr("data-srcset")), d && (r.attr("sizes", d), r.removeAttr("data-sizes")), h.length && h.children("source").each((function (e) { var t = m(e); t.attr("data-srcset") && (t.attr("srcset", t.attr("data-srcset")), t.removeAttr("data-srcset")) })), l && (r.attr("src", l), r.removeAttr("data-src"))), r.addClass(s.loadedClass).removeClass(s.loadingClass), a.find("." + s.preloaderClass).remove(), i.params.loop && t) { var e = a.attr("data-swiper-slide-index"); if (a.hasClass(i.params.slideDuplicateClass)) { var p = i.$wrapperEl.children('[data-swiper-slide-index="' + e + '"]:not(.' + i.params.slideDuplicateClass + ")"); i.lazy.loadInSlide(p.index(), !1) } else { var u = i.$wrapperEl.children("." + i.params.slideDuplicateClass + '[data-swiper-slide-index="' + e + '"]'); i.lazy.loadInSlide(u.index(), !1) } } i.emit("lazyImageReady", a[0], r[0]), i.params.autoHeight && i.updateAutoHeight() } })), i.emit("lazyImageLoad", a[0], r[0]) })) } }, load: function () { var e = this, t = e.$wrapperEl, i = e.params, s = e.slides, a = e.activeIndex, r = e.virtual && i.virtual.enabled, n = i.lazy, l = i.slidesPerView; function o(e) { if (r) { if (t.children("." + i.slideClass + '[data-swiper-slide-index="' + e + '"]').length) return !0 } else if (s[e]) return !0; return !1 } function d(e) { return r ? m(e).attr("data-swiper-slide-index") : m(e).index() } if ("auto" === l && (l = 0), e.lazy.initialImageLoaded || (e.lazy.initialImageLoaded = !0), e.params.watchSlidesVisibility) t.children("." + i.slideVisibleClass).each((function (t) { var i = r ? m(t).attr("data-swiper-slide-index") : m(t).index(); e.lazy.loadInSlide(i) })); else if (l > 1) for (var h = a; h < a + l; h += 1)o(h) && e.lazy.loadInSlide(h); else e.lazy.loadInSlide(a); if (n.loadPrevNext) if (l > 1 || n.loadPrevNextAmount && n.loadPrevNextAmount > 1) { for (var p = n.loadPrevNextAmount, u = l, c = Math.min(a + u + Math.max(p, u), s.length), v = Math.max(a - Math.max(u, p), 0), f = a + l; f < c; f += 1)o(f) && e.lazy.loadInSlide(f); for (var g = v; g < a; g += 1)o(g) && e.lazy.loadInSlide(g) } else { var w = t.children("." + i.slideNextClass); w.length > 0 && e.lazy.loadInSlide(d(w)); var b = t.children("." + i.slidePrevClass); b.length > 0 && e.lazy.loadInSlide(d(b)) } } }, ie = { LinearSpline: function (e, t) { var i, s, a, r, n, l = function (e, t) { for (s = -1, i = e.length; i - s > 1;)e[a = i + s >> 1] <= t ? s = a : i = a; return i }; return this.x = e, this.y = t, this.lastIndex = e.length - 1, this.interpolate = function (e) { return e ? (n = l(this.x, e), r = n - 1, (e - this.x[r]) * (this.y[n] - this.y[r]) / (this.x[n] - this.x[r]) + this.y[r]) : 0 }, this }, getInterpolateFunction: function (e) { this.controller.spline || (this.controller.spline = this.params.loop ? new ie.LinearSpline(this.slidesGrid, e.slidesGrid) : new ie.LinearSpline(this.snapGrid, e.snapGrid)) }, setTranslate: function (e, t) { var i, s, a = this, r = a.controller.control, n = a.constructor; function l(e) { var t = a.rtlTranslate ? -a.translate : a.translate; "slide" === a.params.controller.by && (a.controller.getInterpolateFunction(e), s = -a.controller.spline.interpolate(-t)), s && "container" !== a.params.controller.by || (i = (e.maxTranslate() - e.minTranslate()) / (a.maxTranslate() - a.minTranslate()), s = (t - a.minTranslate()) * i + e.minTranslate()), a.params.controller.inverse && (s = e.maxTranslate() - s), e.updateProgress(s), e.setTranslate(s, a), e.updateActiveIndex(), e.updateSlidesClasses() } if (Array.isArray(r)) for (var o = 0; o < r.length; o += 1)r[o] !== t && r[o] instanceof n && l(r[o]); else r instanceof n && t !== r && l(r) }, setTransition: function (e, t) { var i, s = this, a = s.constructor, r = s.controller.control; function n(t) { t.setTransition(e, s), 0 !== e && (t.transitionStart(), t.params.autoHeight && E((function () { t.updateAutoHeight() })), t.$wrapperEl.transitionEnd((function () { r && (t.params.loop && "slide" === s.params.controller.by && t.loopFix(), t.transitionEnd()) }))) } if (Array.isArray(r)) for (i = 0; i < r.length; i += 1)r[i] !== t && r[i] instanceof a && n(r[i]); else r instanceof a && t !== r && n(r) } }, se = { makeElFocusable: function (e) { return e.attr("tabIndex", "0"), e }, makeElNotFocusable: function (e) { return e.attr("tabIndex", "-1"), e }, addElRole: function (e, t) { return e.attr("role", t), e }, addElLabel: function (e, t) { return e.attr("aria-label", t), e }, disableEl: function (e) { return e.attr("aria-disabled", !0), e }, enableEl: function (e) { return e.attr("aria-disabled", !1), e }, onEnterKey: function (e) { var t = this.params.a11y; if (13 === e.keyCode) { var i = m(e.target); this.navigation && this.navigation.$nextEl && i.is(this.navigation.$nextEl) && (this.isEnd && !this.params.loop || this.slideNext(), this.isEnd ? this.a11y.notify(t.lastSlideMessage) : this.a11y.notify(t.nextSlideMessage)), this.navigation && this.navigation.$prevEl && i.is(this.navigation.$prevEl) && (this.isBeginning && !this.params.loop || this.slidePrev(), this.isBeginning ? this.a11y.notify(t.firstSlideMessage) : this.a11y.notify(t.prevSlideMessage)), this.pagination && i.is("." + this.params.pagination.bulletClass) && i[0].click() } }, notify: function (e) { var t = this.a11y.liveRegion; 0 !== t.length && (t.html(""), t.html(e)) }, updateNavigation: function () { if (!this.params.loop && this.navigation) { var e = this.navigation, t = e.$nextEl, i = e.$prevEl; i && i.length > 0 && (this.isBeginning ? (this.a11y.disableEl(i), this.a11y.makeElNotFocusable(i)) : (this.a11y.enableEl(i), this.a11y.makeElFocusable(i))), t && t.length > 0 && (this.isEnd ? (this.a11y.disableEl(t), this.a11y.makeElNotFocusable(t)) : (this.a11y.enableEl(t), this.a11y.makeElFocusable(t))) } }, updatePagination: function () { var e = this, t = e.params.a11y; e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length && e.pagination.bullets.each((function (i) { var s = m(i); e.a11y.makeElFocusable(s), e.a11y.addElRole(s, "button"), e.a11y.addElLabel(s, t.paginationBulletMessage.replace(/\{\{index\}\}/, s.index() + 1)) })) }, init: function () { this.$el.append(this.a11y.liveRegion); var e, t, i = this.params.a11y; this.navigation && this.navigation.$nextEl && (e = this.navigation.$nextEl), this.navigation && this.navigation.$prevEl && (t = this.navigation.$prevEl), e && (this.a11y.makeElFocusable(e), this.a11y.addElRole(e, "button"), this.a11y.addElLabel(e, i.nextSlideMessage), e.on("keydown", this.a11y.onEnterKey)), t && (this.a11y.makeElFocusable(t), this.a11y.addElRole(t, "button"), this.a11y.addElLabel(t, i.prevSlideMessage), t.on("keydown", this.a11y.onEnterKey)), this.pagination && this.params.pagination.clickable && this.pagination.bullets && this.pagination.bullets.length && this.pagination.$el.on("keydown", "." + this.params.pagination.bulletClass, this.a11y.onEnterKey) }, destroy: function () { var e, t; this.a11y.liveRegion && this.a11y.liveRegion.length > 0 && this.a11y.liveRegion.remove(), this.navigation && this.navigation.$nextEl && (e = this.navigation.$nextEl), this.navigation && this.navigation.$prevEl && (t = this.navigation.$prevEl), e && e.off("keydown", this.a11y.onEnterKey), t && t.off("keydown", this.a11y.onEnterKey), this.pagination && this.params.pagination.clickable && this.pagination.bullets && this.pagination.bullets.length && this.pagination.$el.off("keydown", "." + this.params.pagination.bulletClass, this.a11y.onEnterKey) } }, ae = { init: function () { var e = l(); if (this.params.history) { if (!e.history || !e.history.pushState) return this.params.history.enabled = !1, void (this.params.hashNavigation.enabled = !0); var t = this.history; t.initialized = !0, t.paths = ae.getPathValues(this.params.url), (t.paths.key || t.paths.value) && (t.scrollToSlide(0, t.paths.value, this.params.runCallbacksOnInit), this.params.history.replaceState || e.addEventListener("popstate", this.history.setHistoryPopState)) } }, destroy: function () { var e = l(); this.params.history.replaceState || e.removeEventListener("popstate", this.history.setHistoryPopState) }, setHistoryPopState: function () { this.history.paths = ae.getPathValues(this.params.url), this.history.scrollToSlide(this.params.speed, this.history.paths.value, !1) }, getPathValues: function (e) { var t = l(), i = (e ? new URL(e) : t.location).pathname.slice(1).split("/").filter((function (e) { return "" !== e })), s = i.length; return { key: i[s - 2], value: i[s - 1] } }, setHistory: function (e, t) { var i = l(); if (this.history.initialized && this.params.history.enabled) { var s; s = this.params.url ? new URL(this.params.url) : i.location; var a = this.slides.eq(t), r = ae.slugify(a.attr("data-history")); s.pathname.includes(e) || (r = e + "/" + r); var n = i.history.state; n && n.value === r || (this.params.history.replaceState ? i.history.replaceState({ value: r }, null, r) : i.history.pushState({ value: r }, null, r)) } }, slugify: function (e) { return e.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "") }, scrollToSlide: function (e, t, i) { if (t) for (var s = 0, a = this.slides.length; s < a; s += 1) { var r = this.slides.eq(s); if (ae.slugify(r.attr("data-history")) === t && !r.hasClass(this.params.slideDuplicateClass)) { var n = r.index(); this.slideTo(n, e, i) } } else this.slideTo(0, e, i) } }, re = { onHashCange: function () { var e = r(); this.emit("hashChange"); var t = e.location.hash.replace("#", ""); if (t !== this.slides.eq(this.activeIndex).attr("data-hash")) { var i = this.$wrapperEl.children("." + this.params.slideClass + '[data-hash="' + t + '"]').index(); if (void 0 === i) return; this.slideTo(i) } }, setHash: function () { var e = l(), t = r(); if (this.hashNavigation.initialized && this.params.hashNavigation.enabled) if (this.params.hashNavigation.replaceState && e.history && e.history.replaceState) e.history.replaceState(null, null, "#" + this.slides.eq(this.activeIndex).attr("data-hash") || ""), this.emit("hashSet"); else { var i = this.slides.eq(this.activeIndex), s = i.attr("data-hash") || i.attr("data-history"); t.location.hash = s || "", this.emit("hashSet") } }, init: function () { var e = r(), t = l(); if (!(!this.params.hashNavigation.enabled || this.params.history && this.params.history.enabled)) { this.hashNavigation.initialized = !0; var i = e.location.hash.replace("#", ""); if (i) for (var s = 0, a = this.slides.length; s < a; s += 1) { var n = this.slides.eq(s); if ((n.attr("data-hash") || n.attr("data-history")) === i && !n.hasClass(this.params.slideDuplicateClass)) { var o = n.index(); this.slideTo(o, 0, this.params.runCallbacksOnInit, !0) } } this.params.hashNavigation.watchState && m(t).on("hashchange", this.hashNavigation.onHashCange) } }, destroy: function () { var e = l(); this.params.hashNavigation.watchState && m(e).off("hashchange", this.hashNavigation.onHashCange) } }, ne = { run: function () { var e = this, t = e.slides.eq(e.activeIndex), i = e.params.autoplay.delay; t.attr("data-swiper-autoplay") && (i = t.attr("data-swiper-autoplay") || e.params.autoplay.delay), clearTimeout(e.autoplay.timeout), e.autoplay.timeout = E((function () { e.params.autoplay.reverseDirection ? e.params.loop ? (e.loopFix(), e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay")) : e.isBeginning ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (e.slideTo(e.slides.length - 1, e.params.speed, !0, !0), e.emit("autoplay")) : (e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay")) : e.params.loop ? (e.loopFix(), e.slideNext(e.params.speed, !0, !0), e.emit("autoplay")) : e.isEnd ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (e.slideTo(0, e.params.speed, !0, !0), e.emit("autoplay")) : (e.slideNext(e.params.speed, !0, !0), e.emit("autoplay")), e.params.cssMode && e.autoplay.running && e.autoplay.run() }), i) }, start: function () { return void 0 === this.autoplay.timeout && (!this.autoplay.running && (this.autoplay.running = !0, this.emit("autoplayStart"), this.autoplay.run(), !0)) }, stop: function () { return !!this.autoplay.running && (void 0 !== this.autoplay.timeout && (this.autoplay.timeout && (clearTimeout(this.autoplay.timeout), this.autoplay.timeout = void 0), this.autoplay.running = !1, this.emit("autoplayStop"), !0)) }, pause: function (e) { this.autoplay.running && (this.autoplay.paused || (this.autoplay.timeout && clearTimeout(this.autoplay.timeout), this.autoplay.paused = !0, 0 !== e && this.params.autoplay.waitForTransition ? (this.$wrapperEl[0].addEventListener("transitionend", this.autoplay.onTransitionEnd), this.$wrapperEl[0].addEventListener("webkitTransitionEnd", this.autoplay.onTransitionEnd)) : (this.autoplay.paused = !1, this.autoplay.run()))) }, onVisibilityChange: function () { var e = r(); "hidden" === e.visibilityState && this.autoplay.running && this.autoplay.pause(), "visible" === e.visibilityState && this.autoplay.paused && (this.autoplay.run(), this.autoplay.paused = !1) }, onTransitionEnd: function (e) { this && !this.destroyed && this.$wrapperEl && e.target === this.$wrapperEl[0] && (this.$wrapperEl[0].removeEventListener("transitionend", this.autoplay.onTransitionEnd), this.$wrapperEl[0].removeEventListener("webkitTransitionEnd", this.autoplay.onTransitionEnd), this.autoplay.paused = !1, this.autoplay.running ? this.autoplay.run() : this.autoplay.stop()) } }, le = { setTranslate: function () { for (var e = this.slides, t = 0; t < e.length; t += 1) { var i = this.slides.eq(t), s = -i[0].swiperSlideOffset; this.params.virtualTranslate || (s -= this.translate); var a = 0; this.isHorizontal() || (a = s, s = 0); var r = this.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(i[0].progress), 0) : 1 + Math.min(Math.max(i[0].progress, -1), 0); i.css({ opacity: r }).transform("translate3d(" + s + "px, " + a + "px, 0px)") } }, setTransition: function (e) { var t = this, i = t.slides, s = t.$wrapperEl; if (i.transition(e), t.params.virtualTranslate && 0 !== e) { var a = !1; i.transitionEnd((function () { if (!a && t && !t.destroyed) { a = !0, t.animating = !1; for (var e = ["webkitTransitionEnd", "transitionend"], i = 0; i < e.length; i += 1)s.trigger(e[i]) } })) } } }, oe = { setTranslate: function () { var e, t = this.$el, i = this.$wrapperEl, s = this.slides, a = this.width, r = this.height, n = this.rtlTranslate, l = this.size, o = this.browser, d = this.params.cubeEffect, h = this.isHorizontal(), p = this.virtual && this.params.virtual.enabled, u = 0; d.shadow && (h ? (0 === (e = i.find(".swiper-cube-shadow")).length && (e = m('<div class="swiper-cube-shadow"></div>'), i.append(e)), e.css({ height: a + "px" })) : 0 === (e = t.find(".swiper-cube-shadow")).length && (e = m('<div class="swiper-cube-shadow"></div>'), t.append(e))); for (var c = 0; c < s.length; c += 1) { var v = s.eq(c), f = c; p && (f = parseInt(v.attr("data-swiper-slide-index"), 10)); var g = 90 * f, w = Math.floor(g / 360); n && (g = -g, w = Math.floor(-g / 360)); var b = Math.max(Math.min(v[0].progress, 1), -1), y = 0, E = 0, x = 0; f % 4 == 0 ? (y = 4 * -w * l, x = 0) : (f - 1) % 4 == 0 ? (y = 0, x = 4 * -w * l) : (f - 2) % 4 == 0 ? (y = l + 4 * w * l, x = l) : (f - 3) % 4 == 0 && (y = -l, x = 3 * l + 4 * l * w), n && (y = -y), h || (E = y, y = 0); var T = "rotateX(" + (h ? 0 : -g) + "deg) rotateY(" + (h ? g : 0) + "deg) translate3d(" + y + "px, " + E + "px, " + x + "px)"; if (b <= 1 && b > -1 && (u = 90 * f + 90 * b, n && (u = 90 * -f - 90 * b)), v.transform(T), d.slideShadows) { var C = h ? v.find(".swiper-slide-shadow-left") : v.find(".swiper-slide-shadow-top"), S = h ? v.find(".swiper-slide-shadow-right") : v.find(".swiper-slide-shadow-bottom"); 0 === C.length && (C = m('<div class="swiper-slide-shadow-' + (h ? "left" : "top") + '"></div>'), v.append(C)), 0 === S.length && (S = m('<div class="swiper-slide-shadow-' + (h ? "right" : "bottom") + '"></div>'), v.append(S)), C.length && (C[0].style.opacity = Math.max(-b, 0)), S.length && (S[0].style.opacity = Math.max(b, 0)) } } if (i.css({ "-webkit-transform-origin": "50% 50% -" + l / 2 + "px", "-moz-transform-origin": "50% 50% -" + l / 2 + "px", "-ms-transform-origin": "50% 50% -" + l / 2 + "px", "transform-origin": "50% 50% -" + l / 2 + "px" }), d.shadow) if (h) e.transform("translate3d(0px, " + (a / 2 + d.shadowOffset) + "px, " + -a / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + d.shadowScale + ")"); else { var M = Math.abs(u) - 90 * Math.floor(Math.abs(u) / 90), z = 1.5 - (Math.sin(2 * M * Math.PI / 360) / 2 + Math.cos(2 * M * Math.PI / 360) / 2), P = d.shadowScale, k = d.shadowScale / z, $ = d.shadowOffset; e.transform("scale3d(" + P + ", 1, " + k + ") translate3d(0px, " + (r / 2 + $) + "px, " + -r / 2 / k + "px) rotateX(-90deg)") } var L = o.isSafari || o.isWebView ? -l / 2 : 0; i.transform("translate3d(0px,0," + L + "px) rotateX(" + (this.isHorizontal() ? 0 : u) + "deg) rotateY(" + (this.isHorizontal() ? -u : 0) + "deg)") }, setTransition: function (e) { var t = this.$el; this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), this.params.cubeEffect.shadow && !this.isHorizontal() && t.find(".swiper-cube-shadow").transition(e) } }, de = { setTranslate: function () { for (var e = this.slides, t = this.rtlTranslate, i = 0; i < e.length; i += 1) { var s = e.eq(i), a = s[0].progress; this.params.flipEffect.limitRotation && (a = Math.max(Math.min(s[0].progress, 1), -1)); var r = -180 * a, n = 0, l = -s[0].swiperSlideOffset, o = 0; if (this.isHorizontal() ? t && (r = -r) : (o = l, l = 0, n = -r, r = 0), s[0].style.zIndex = -Math.abs(Math.round(a)) + e.length, this.params.flipEffect.slideShadows) { var d = this.isHorizontal() ? s.find(".swiper-slide-shadow-left") : s.find(".swiper-slide-shadow-top"), h = this.isHorizontal() ? s.find(".swiper-slide-shadow-right") : s.find(".swiper-slide-shadow-bottom"); 0 === d.length && (d = m('<div class="swiper-slide-shadow-' + (this.isHorizontal() ? "left" : "top") + '"></div>'), s.append(d)), 0 === h.length && (h = m('<div class="swiper-slide-shadow-' + (this.isHorizontal() ? "right" : "bottom") + '"></div>'), s.append(h)), d.length && (d[0].style.opacity = Math.max(-a, 0)), h.length && (h[0].style.opacity = Math.max(a, 0)) } s.transform("translate3d(" + l + "px, " + o + "px, 0px) rotateX(" + n + "deg) rotateY(" + r + "deg)") } }, setTransition: function (e) { var t = this, i = t.slides, s = t.activeIndex, a = t.$wrapperEl; if (i.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), t.params.virtualTranslate && 0 !== e) { var r = !1; i.eq(s).transitionEnd((function () { if (!r && t && !t.destroyed) { r = !0, t.animating = !1; for (var e = ["webkitTransitionEnd", "transitionend"], i = 0; i < e.length; i += 1)a.trigger(e[i]) } })) } } }, he = { setTranslate: function () { for (var e = this.width, t = this.height, i = this.slides, s = this.slidesSizesGrid, a = this.params.coverflowEffect, r = this.isHorizontal(), n = this.translate, l = r ? e / 2 - n : t / 2 - n, o = r ? a.rotate : -a.rotate, d = a.depth, h = 0, p = i.length; h < p; h += 1) { var u = i.eq(h), c = s[h], v = (l - u[0].swiperSlideOffset - c / 2) / c * a.modifier, f = r ? o * v : 0, g = r ? 0 : o * v, w = -d * Math.abs(v), b = a.stretch; "string" == typeof b && -1 !== b.indexOf("%") && (b = parseFloat(a.stretch) / 100 * c); var y = r ? 0 : b * v, E = r ? b * v : 0, x = 1 - (1 - a.scale) * Math.abs(v); Math.abs(E) < .001 && (E = 0), Math.abs(y) < .001 && (y = 0), Math.abs(w) < .001 && (w = 0), Math.abs(f) < .001 && (f = 0), Math.abs(g) < .001 && (g = 0), Math.abs(x) < .001 && (x = 0); var T = "translate3d(" + E + "px," + y + "px," + w + "px)  rotateX(" + g + "deg) rotateY(" + f + "deg) scale(" + x + ")"; if (u.transform(T), u[0].style.zIndex = 1 - Math.abs(Math.round(v)), a.slideShadows) { var C = r ? u.find(".swiper-slide-shadow-left") : u.find(".swiper-slide-shadow-top"), S = r ? u.find(".swiper-slide-shadow-right") : u.find(".swiper-slide-shadow-bottom"); 0 === C.length && (C = m('<div class="swiper-slide-shadow-' + (r ? "left" : "top") + '"></div>'), u.append(C)), 0 === S.length && (S = m('<div class="swiper-slide-shadow-' + (r ? "right" : "bottom") + '"></div>'), u.append(S)), C.length && (C[0].style.opacity = v > 0 ? v : 0), S.length && (S[0].style.opacity = -v > 0 ? -v : 0) } } }, setTransition: function (e) { this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e) } }, pe = { init: function () { var e = this.params.thumbs; if (this.thumbs.initialized) return !1; this.thumbs.initialized = !0; var t = this.constructor; return e.swiper instanceof t ? (this.thumbs.swiper = e.swiper, S(this.thumbs.swiper.originalParams, { watchSlidesProgress: !0, slideToClickedSlide: !1 }), S(this.thumbs.swiper.params, { watchSlidesProgress: !0, slideToClickedSlide: !1 })) : C(e.swiper) && (this.thumbs.swiper = new t(S({}, e.swiper, { watchSlidesVisibility: !0, watchSlidesProgress: !0, slideToClickedSlide: !1 })), this.thumbs.swiperCreated = !0), this.thumbs.swiper.$el.addClass(this.params.thumbs.thumbsContainerClass), this.thumbs.swiper.on("tap", this.thumbs.onThumbClick), !0 }, onThumbClick: function () { var e = this.thumbs.swiper; if (e) { var t = e.clickedIndex, i = e.clickedSlide; if (!(i && m(i).hasClass(this.params.thumbs.slideThumbActiveClass) || null == t)) { var s; if (s = e.params.loop ? parseInt(m(e.clickedSlide).attr("data-swiper-slide-index"), 10) : t, this.params.loop) { var a = this.activeIndex; this.slides.eq(a).hasClass(this.params.slideDuplicateClass) && (this.loopFix(), this._clientLeft = this.$wrapperEl[0].clientLeft, a = this.activeIndex); var r = this.slides.eq(a).prevAll('[data-swiper-slide-index="' + s + '"]').eq(0).index(), n = this.slides.eq(a).nextAll('[data-swiper-slide-index="' + s + '"]').eq(0).index(); s = void 0 === r ? n : void 0 === n ? r : n - a < a - r ? n : r } this.slideTo(s) } } }, update: function (e) { var t = this.thumbs.swiper; if (t) { var i = "auto" === t.params.slidesPerView ? t.slidesPerViewDynamic() : t.params.slidesPerView, s = this.params.thumbs.autoScrollOffset, a = s && !t.params.loop; if (this.realIndex !== t.realIndex || a) { var r, n, l = t.activeIndex; if (t.params.loop) { t.slides.eq(l).hasClass(t.params.slideDuplicateClass) && (t.loopFix(), t._clientLeft = t.$wrapperEl[0].clientLeft, l = t.activeIndex); var o = t.slides.eq(l).prevAll('[data-swiper-slide-index="' + this.realIndex + '"]').eq(0).index(), d = t.slides.eq(l).nextAll('[data-swiper-slide-index="' + this.realIndex + '"]').eq(0).index(); r = void 0 === o ? d : void 0 === d ? o : d - l == l - o ? l : d - l < l - o ? d : o, n = this.activeIndex > this.previousIndex ? "next" : "prev" } else n = (r = this.realIndex) > this.previousIndex ? "next" : "prev"; a && (r += "next" === n ? s : -1 * s), t.visibleSlidesIndexes && t.visibleSlidesIndexes.indexOf(r) < 0 && (t.params.centeredSlides ? r = r > l ? r - Math.floor(i / 2) + 1 : r + Math.floor(i / 2) - 1 : r > l && (r = r - i + 1), t.slideTo(r, e ? 0 : void 0)) } var h = 1, p = this.params.thumbs.slideThumbActiveClass; if (this.params.slidesPerView > 1 && !this.params.centeredSlides && (h = this.params.slidesPerView), this.params.thumbs.multipleActiveThumbs || (h = 1), h = Math.floor(h), t.slides.removeClass(p), t.params.loop || t.params.virtual && t.params.virtual.enabled) for (var u = 0; u < h; u += 1)t.$wrapperEl.children('[data-swiper-slide-index="' + (this.realIndex + u) + '"]').addClass(p); else for (var c = 0; c < h; c += 1)t.slides.eq(this.realIndex + c).addClass(p) } } }, ue = [q, _, { name: "mousewheel", params: { mousewheel: { enabled: !1, releaseOnEdges: !1, invert: !1, forceToAxis: !1, sensitivity: 1, eventsTarget: "container", thresholdDelta: null, thresholdTime: null } }, create: function () { M(this, { mousewheel: { enabled: !1, lastScrollTime: x(), lastEventBeforeSnap: void 0, recentWheelEvents: [], enable: U.enable, disable: U.disable, handle: U.handle, handleMouseEnter: U.handleMouseEnter, handleMouseLeave: U.handleMouseLeave, animateSlider: U.animateSlider, releaseScroll: U.releaseScroll } }) }, on: { init: function (e) { !e.params.mousewheel.enabled && e.params.cssMode && e.mousewheel.disable(), e.params.mousewheel.enabled && e.mousewheel.enable() }, destroy: function (e) { e.params.cssMode && e.mousewheel.enable(), e.mousewheel.enabled && e.mousewheel.disable() } } }, { name: "navigation", params: { navigation: { nextEl: null, prevEl: null, hideOnClick: !1, disabledClass: "swiper-button-disabled", hiddenClass: "swiper-button-hidden", lockClass: "swiper-button-lock" } }, create: function () { M(this, { navigation: t({}, K) }) }, on: { init: function (e) { e.navigation.init(), e.navigation.update() }, toEdge: function (e) { e.navigation.update() }, fromEdge: function (e) { e.navigation.update() }, destroy: function (e) { e.navigation.destroy() }, click: function (e, t) { var i, s = e.navigation, a = s.$nextEl, r = s.$prevEl; !e.params.navigation.hideOnClick || m(t.target).is(r) || m(t.target).is(a) || (a ? i = a.hasClass(e.params.navigation.hiddenClass) : r && (i = r.hasClass(e.params.navigation.hiddenClass)), !0 === i ? e.emit("navigationShow") : e.emit("navigationHide"), a && a.toggleClass(e.params.navigation.hiddenClass), r && r.toggleClass(e.params.navigation.hiddenClass)) } } }, { name: "pagination", params: { pagination: { el: null, bulletElement: "span", clickable: !1, hideOnClick: !1, renderBullet: null, renderProgressbar: null, renderFraction: null, renderCustom: null, progressbarOpposite: !1, type: "bullets", dynamicBullets: !1, dynamicMainBullets: 1, formatFractionCurrent: function (e) { return e }, formatFractionTotal: function (e) { return e }, bulletClass: "swiper-pagination-bullet", bulletActiveClass: "swiper-pagination-bullet-active", modifierClass: "swiper-pagination-", currentClass: "swiper-pagination-current", totalClass: "swiper-pagination-total", hiddenClass: "swiper-pagination-hidden", progressbarFillClass: "swiper-pagination-progressbar-fill", progressbarOppositeClass: "swiper-pagination-progressbar-opposite", clickableClass: "swiper-pagination-clickable", lockClass: "swiper-pagination-lock" } }, create: function () { M(this, { pagination: t({ dynamicBulletIndex: 0 }, Z) }) }, on: { init: function (e) { e.pagination.init(), e.pagination.render(), e.pagination.update() }, activeIndexChange: function (e) { (e.params.loop || void 0 === e.snapIndex) && e.pagination.update() }, snapIndexChange: function (e) { e.params.loop || e.pagination.update() }, slidesLengthChange: function (e) { e.params.loop && (e.pagination.render(), e.pagination.update()) }, snapGridLengthChange: function (e) { e.params.loop || (e.pagination.render(), e.pagination.update()) }, destroy: function (e) { e.pagination.destroy() }, click: function (e, t) { e.params.pagination.el && e.params.pagination.hideOnClick && e.pagination.$el.length > 0 && !m(t.target).hasClass(e.params.pagination.bulletClass) && (!0 === e.pagination.$el.hasClass(e.params.pagination.hiddenClass) ? e.emit("paginationShow") : e.emit("paginationHide"), e.pagination.$el.toggleClass(e.params.pagination.hiddenClass)) } } }, { name: "scrollbar", params: { scrollbar: { el: null, dragSize: "auto", hide: !1, draggable: !1, snapOnRelease: !0, lockClass: "swiper-scrollbar-lock", dragClass: "swiper-scrollbar-drag" } }, create: function () { M(this, { scrollbar: t({ isTouched: !1, timeout: null, dragTimeout: null }, J) }) }, on: { init: function (e) { e.scrollbar.init(), e.scrollbar.updateSize(), e.scrollbar.setTranslate() }, update: function (e) { e.scrollbar.updateSize() }, resize: function (e) { e.scrollbar.updateSize() }, observerUpdate: function (e) { e.scrollbar.updateSize() }, setTranslate: function (e) { e.scrollbar.setTranslate() }, setTransition: function (e, t) { e.scrollbar.setTransition(t) }, destroy: function (e) { e.scrollbar.destroy() } } }, { name: "parallax", params: { parallax: { enabled: !1 } }, create: function () { M(this, { parallax: t({}, Q) }) }, on: { beforeInit: function (e) { e.params.parallax.enabled && (e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0) }, init: function (e) { e.params.parallax.enabled && e.parallax.setTranslate() }, setTranslate: function (e) { e.params.parallax.enabled && e.parallax.setTranslate() }, setTransition: function (e, t) { e.params.parallax.enabled && e.parallax.setTransition(t) } } }, { name: "zoom", params: { zoom: { enabled: !1, maxRatio: 3, minRatio: 1, toggle: !0, containerClass: "swiper-zoom-container", zoomedSlideClass: "swiper-slide-zoomed" } }, create: function () { var e = this; M(e, { zoom: t({ enabled: !1, scale: 1, currentScale: 1, isScaling: !1, gesture: { $slideEl: void 0, slideWidth: void 0, slideHeight: void 0, $imageEl: void 0, $imageWrapEl: void 0, maxRatio: 3 }, image: { isTouched: void 0, isMoved: void 0, currentX: void 0, currentY: void 0, minX: void 0, minY: void 0, maxX: void 0, maxY: void 0, width: void 0, height: void 0, startX: void 0, startY: void 0, touchesStart: {}, touchesCurrent: {} }, velocity: { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 } }, ee) }); var i = 1; Object.defineProperty(e.zoom, "scale", { get: function () { return i }, set: function (t) { if (i !== t) { var s = e.zoom.gesture.$imageEl ? e.zoom.gesture.$imageEl[0] : void 0, a = e.zoom.gesture.$slideEl ? e.zoom.gesture.$slideEl[0] : void 0; e.emit("zoomChange", t, s, a) } i = t } }) }, on: { init: function (e) { e.params.zoom.enabled && e.zoom.enable() }, destroy: function (e) { e.zoom.disable() }, touchStart: function (e, t) { e.zoom.enabled && e.zoom.onTouchStart(t) }, touchEnd: function (e, t) { e.zoom.enabled && e.zoom.onTouchEnd(t) }, doubleTap: function (e, t) { e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && e.zoom.toggle(t) }, transitionEnd: function (e) { e.zoom.enabled && e.params.zoom.enabled && e.zoom.onTransitionEnd() }, slideChange: function (e) { e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && e.zoom.onTransitionEnd() } } }, { name: "lazy", params: { lazy: { enabled: !1, loadPrevNext: !1, loadPrevNextAmount: 1, loadOnTransitionStart: !1, elementClass: "swiper-lazy", loadingClass: "swiper-lazy-loading", loadedClass: "swiper-lazy-loaded", preloaderClass: "swiper-lazy-preloader" } }, create: function () { M(this, { lazy: t({ initialImageLoaded: !1 }, te) }) }, on: { beforeInit: function (e) { e.params.lazy.enabled && e.params.preloadImages && (e.params.preloadImages = !1) }, init: function (e) { e.params.lazy.enabled && !e.params.loop && 0 === e.params.initialSlide && e.lazy.load() }, scroll: function (e) { e.params.freeMode && !e.params.freeModeSticky && e.lazy.load() }, resize: function (e) { e.params.lazy.enabled && e.lazy.load() }, scrollbarDragMove: function (e) { e.params.lazy.enabled && e.lazy.load() }, transitionStart: function (e) { e.params.lazy.enabled && (e.params.lazy.loadOnTransitionStart || !e.params.lazy.loadOnTransitionStart && !e.lazy.initialImageLoaded) && e.lazy.load() }, transitionEnd: function (e) { e.params.lazy.enabled && !e.params.lazy.loadOnTransitionStart && e.lazy.load() }, slideChange: function (e) { e.params.lazy.enabled && e.params.cssMode && e.lazy.load() } } }, { name: "controller", params: { controller: { control: void 0, inverse: !1, by: "slide" } }, create: function () { M(this, { controller: t({ control: this.params.controller.control }, ie) }) }, on: { update: function (e) { e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline) }, resize: function (e) { e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline) }, observerUpdate: function (e) { e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline) }, setTranslate: function (e, t, i) { e.controller.control && e.controller.setTranslate(t, i) }, setTransition: function (e, t, i) { e.controller.control && e.controller.setTransition(t, i) } } }, { name: "a11y", params: { a11y: { enabled: !0, notificationClass: "swiper-notification", prevSlideMessage: "Previous slide", nextSlideMessage: "Next slide", firstSlideMessage: "This is the first slide", lastSlideMessage: "This is the last slide", paginationBulletMessage: "Go to slide {{index}}" } }, create: function () { M(this, { a11y: t(t({}, se), {}, { liveRegion: m('<span class="' + this.params.a11y.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>') }) }) }, on: { init: function (e) { e.params.a11y.enabled && (e.a11y.init(), e.a11y.updateNavigation()) }, toEdge: function (e) { e.params.a11y.enabled && e.a11y.updateNavigation() }, fromEdge: function (e) { e.params.a11y.enabled && e.a11y.updateNavigation() }, paginationUpdate: function (e) { e.params.a11y.enabled && e.a11y.updatePagination() }, destroy: function (e) { e.params.a11y.enabled && e.a11y.destroy() } } }, { name: "history", params: { history: { enabled: !1, replaceState: !1, key: "slides" } }, create: function () { M(this, { history: t({}, ae) }) }, on: { init: function (e) { e.params.history.enabled && e.history.init() }, destroy: function (e) { e.params.history.enabled && e.history.destroy() }, transitionEnd: function (e) { e.history.initialized && e.history.setHistory(e.params.history.key, e.activeIndex) }, slideChange: function (e) { e.history.initialized && e.params.cssMode && e.history.setHistory(e.params.history.key, e.activeIndex) } } }, { name: "hash-navigation", params: { hashNavigation: { enabled: !1, replaceState: !1, watchState: !1 } }, create: function () { M(this, { hashNavigation: t({ initialized: !1 }, re) }) }, on: { init: function (e) { e.params.hashNavigation.enabled && e.hashNavigation.init() }, destroy: function (e) { e.params.hashNavigation.enabled && e.hashNavigation.destroy() }, transitionEnd: function (e) { e.hashNavigation.initialized && e.hashNavigation.setHash() }, slideChange: function (e) { e.hashNavigation.initialized && e.params.cssMode && e.hashNavigation.setHash() } } }, { name: "autoplay", params: { autoplay: { enabled: !1, delay: 3e3, waitForTransition: !0, disableOnInteraction: !0, stopOnLastSlide: !1, reverseDirection: !1 } }, create: function () { M(this, { autoplay: t(t({}, ne), {}, { running: !1, paused: !1 }) }) }, on: { init: function (e) { e.params.autoplay.enabled && (e.autoplay.start(), r().addEventListener("visibilitychange", e.autoplay.onVisibilityChange)) }, beforeTransitionStart: function (e, t, i) { e.autoplay.running && (i || !e.params.autoplay.disableOnInteraction ? e.autoplay.pause(t) : e.autoplay.stop()) }, sliderFirstMove: function (e) { e.autoplay.running && (e.params.autoplay.disableOnInteraction ? e.autoplay.stop() : e.autoplay.pause()) }, touchEnd: function (e) { e.params.cssMode && e.autoplay.paused && !e.params.autoplay.disableOnInteraction && e.autoplay.run() }, destroy: function (e) { e.autoplay.running && e.autoplay.stop(), r().removeEventListener("visibilitychange", e.autoplay.onVisibilityChange) } } }, { name: "effect-fade", params: { fadeEffect: { crossFade: !1 } }, create: function () { M(this, { fadeEffect: t({}, le) }) }, on: { beforeInit: function (e) { if ("fade" === e.params.effect) { e.classNames.push(e.params.containerModifierClass + "fade"); var t = { slidesPerView: 1, slidesPerColumn: 1, slidesPerGroup: 1, watchSlidesProgress: !0, spaceBetween: 0, virtualTranslate: !0 }; S(e.params, t), S(e.originalParams, t) } }, setTranslate: function (e) { "fade" === e.params.effect && e.fadeEffect.setTranslate() }, setTransition: function (e, t) { "fade" === e.params.effect && e.fadeEffect.setTransition(t) } } }, { name: "effect-cube", params: { cubeEffect: { slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: .94 } }, create: function () { M(this, { cubeEffect: t({}, oe) }) }, on: { beforeInit: function (e) { if ("cube" === e.params.effect) { e.classNames.push(e.params.containerModifierClass + "cube"), e.classNames.push(e.params.containerModifierClass + "3d"); var t = { slidesPerView: 1, slidesPerColumn: 1, slidesPerGroup: 1, watchSlidesProgress: !0, resistanceRatio: 0, spaceBetween: 0, centeredSlides: !1, virtualTranslate: !0 }; S(e.params, t), S(e.originalParams, t) } }, setTranslate: function (e) { "cube" === e.params.effect && e.cubeEffect.setTranslate() }, setTransition: function (e, t) { "cube" === e.params.effect && e.cubeEffect.setTransition(t) } } }, { name: "effect-flip", params: { flipEffect: { slideShadows: !0, limitRotation: !0 } }, create: function () { M(this, { flipEffect: t({}, de) }) }, on: { beforeInit: function (e) { if ("flip" === e.params.effect) { e.classNames.push(e.params.containerModifierClass + "flip"), e.classNames.push(e.params.containerModifierClass + "3d"); var t = { slidesPerView: 1, slidesPerColumn: 1, slidesPerGroup: 1, watchSlidesProgress: !0, spaceBetween: 0, virtualTranslate: !0 }; S(e.params, t), S(e.originalParams, t) } }, setTranslate: function (e) { "flip" === e.params.effect && e.flipEffect.setTranslate() }, setTransition: function (e, t) { "flip" === e.params.effect && e.flipEffect.setTransition(t) } } }, { name: "effect-coverflow", params: { coverflowEffect: { rotate: 50, stretch: 0, depth: 100, scale: 1, modifier: 1, slideShadows: !0 } }, create: function () { M(this, { coverflowEffect: t({}, he) }) }, on: { beforeInit: function (e) { "coverflow" === e.params.effect && (e.classNames.push(e.params.containerModifierClass + "coverflow"), e.classNames.push(e.params.containerModifierClass + "3d"), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0) }, setTranslate: function (e) { "coverflow" === e.params.effect && e.coverflowEffect.setTranslate() }, setTransition: function (e, t) { "coverflow" === e.params.effect && e.coverflowEffect.setTransition(t) } } }, { name: "thumbs", params: { thumbs: { swiper: null, multipleActiveThumbs: !0, autoScrollOffset: 0, slideThumbActiveClass: "swiper-slide-thumb-active", thumbsContainerClass: "swiper-container-thumbs" } }, create: function () { M(this, { thumbs: t({ swiper: null, initialized: !1 }, pe) }) }, on: { beforeInit: function (e) { var t = e.params.thumbs; t && t.swiper && (e.thumbs.init(), e.thumbs.update(!0)) }, slideChange: function (e) { e.thumbs.swiper && e.thumbs.update() }, update: function (e) { e.thumbs.swiper && e.thumbs.update() }, resize: function (e) { e.thumbs.swiper && e.thumbs.update() }, observerUpdate: function (e) { e.thumbs.swiper && e.thumbs.update() }, setTransition: function (e, t) { var i = e.thumbs.swiper; i && i.setTransition(t) }, beforeDestroy: function (e) { var t = e.thumbs.swiper; t && e.thumbs.swiperCreated && t && t.destroy() } } }]; return W.use(ue), W }));
//# sourceMappingURL=swiper-bundle.min.js.map
/*!
 * Vue.js v2.6.11
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
!function (e, t) { "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = e || self).Vue = t() }(this, function () { "use strict"; var e = Object.freeze({}); function t(e) { return null == e } function n(e) { return null != e } function r(e) { return !0 === e } function i(e) { return "string" == typeof e || "number" == typeof e || "symbol" == typeof e || "boolean" == typeof e } function o(e) { return null !== e && "object" == typeof e } var a = Object.prototype.toString; function s(e) { return "[object Object]" === a.call(e) } function c(e) { var t = parseFloat(String(e)); return t >= 0 && Math.floor(t) === t && isFinite(e) } function u(e) { return n(e) && "function" == typeof e.then && "function" == typeof e.catch } function l(e) { return null == e ? "" : Array.isArray(e) || s(e) && e.toString === a ? JSON.stringify(e, null, 2) : String(e) } function f(e) { var t = parseFloat(e); return isNaN(t) ? e : t } function p(e, t) { for (var n = Object.create(null), r = e.split(","), i = 0; i < r.length; i++)n[r[i]] = !0; return t ? function (e) { return n[e.toLowerCase()] } : function (e) { return n[e] } } var d = p("slot,component", !0), v = p("key,ref,slot,slot-scope,is"); function h(e, t) { if (e.length) { var n = e.indexOf(t); if (n > -1) return e.splice(n, 1) } } var m = Object.prototype.hasOwnProperty; function y(e, t) { return m.call(e, t) } function g(e) { var t = Object.create(null); return function (n) { return t[n] || (t[n] = e(n)) } } var _ = /-(\w)/g, b = g(function (e) { return e.replace(_, function (e, t) { return t ? t.toUpperCase() : "" }) }), $ = g(function (e) { return e.charAt(0).toUpperCase() + e.slice(1) }), w = /\B([A-Z])/g, C = g(function (e) { return e.replace(w, "-$1").toLowerCase() }); var x = Function.prototype.bind ? function (e, t) { return e.bind(t) } : function (e, t) { function n(n) { var r = arguments.length; return r ? r > 1 ? e.apply(t, arguments) : e.call(t, n) : e.call(t) } return n._length = e.length, n }; function k(e, t) { t = t || 0; for (var n = e.length - t, r = new Array(n); n--;)r[n] = e[n + t]; return r } function A(e, t) { for (var n in t) e[n] = t[n]; return e } function O(e) { for (var t = {}, n = 0; n < e.length; n++)e[n] && A(t, e[n]); return t } function S(e, t, n) { } var T = function (e, t, n) { return !1 }, E = function (e) { return e }; function N(e, t) { if (e === t) return !0; var n = o(e), r = o(t); if (!n || !r) return !n && !r && String(e) === String(t); try { var i = Array.isArray(e), a = Array.isArray(t); if (i && a) return e.length === t.length && e.every(function (e, n) { return N(e, t[n]) }); if (e instanceof Date && t instanceof Date) return e.getTime() === t.getTime(); if (i || a) return !1; var s = Object.keys(e), c = Object.keys(t); return s.length === c.length && s.every(function (n) { return N(e[n], t[n]) }) } catch (e) { return !1 } } function j(e, t) { for (var n = 0; n < e.length; n++)if (N(e[n], t)) return n; return -1 } function D(e) { var t = !1; return function () { t || (t = !0, e.apply(this, arguments)) } } var L = "data-server-rendered", M = ["component", "directive", "filter"], I = ["beforeCreate", "created", "beforeMount", "mounted", "beforeUpdate", "updated", "beforeDestroy", "destroyed", "activated", "deactivated", "errorCaptured", "serverPrefetch"], F = { optionMergeStrategies: Object.create(null), silent: !1, productionTip: !1, devtools: !1, performance: !1, errorHandler: null, warnHandler: null, ignoredElements: [], keyCodes: Object.create(null), isReservedTag: T, isReservedAttr: T, isUnknownElement: T, getTagNamespace: S, parsePlatformTagName: E, mustUseProp: T, async: !0, _lifecycleHooks: I }, P = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/; function R(e, t, n, r) { Object.defineProperty(e, t, { value: n, enumerable: !!r, writable: !0, configurable: !0 }) } var H = new RegExp("[^" + P.source + ".$_\\d]"); var B, U = "__proto__" in {}, z = "undefined" != typeof window, V = "undefined" != typeof WXEnvironment && !!WXEnvironment.platform, K = V && WXEnvironment.platform.toLowerCase(), J = z && window.navigator.userAgent.toLowerCase(), q = J && /msie|trident/.test(J), W = J && J.indexOf("msie 9.0") > 0, Z = J && J.indexOf("edge/") > 0, G = (J && J.indexOf("android"), J && /iphone|ipad|ipod|ios/.test(J) || "ios" === K), X = (J && /chrome\/\d+/.test(J), J && /phantomjs/.test(J), J && J.match(/firefox\/(\d+)/)), Y = {}.watch, Q = !1; if (z) try { var ee = {}; Object.defineProperty(ee, "passive", { get: function () { Q = !0 } }), window.addEventListener("test-passive", null, ee) } catch (e) { } var te = function () { return void 0 === B && (B = !z && !V && "undefined" != typeof global && (global.process && "server" === global.process.env.VUE_ENV)), B }, ne = z && window.__VUE_DEVTOOLS_GLOBAL_HOOK__; function re(e) { return "function" == typeof e && /native code/.test(e.toString()) } var ie, oe = "undefined" != typeof Symbol && re(Symbol) && "undefined" != typeof Reflect && re(Reflect.ownKeys); ie = "undefined" != typeof Set && re(Set) ? Set : function () { function e() { this.set = Object.create(null) } return e.prototype.has = function (e) { return !0 === this.set[e] }, e.prototype.add = function (e) { this.set[e] = !0 }, e.prototype.clear = function () { this.set = Object.create(null) }, e }(); var ae = S, se = 0, ce = function () { this.id = se++, this.subs = [] }; ce.prototype.addSub = function (e) { this.subs.push(e) }, ce.prototype.removeSub = function (e) { h(this.subs, e) }, ce.prototype.depend = function () { ce.target && ce.target.addDep(this) }, ce.prototype.notify = function () { for (var e = this.subs.slice(), t = 0, n = e.length; t < n; t++)e[t].update() }, ce.target = null; var ue = []; function le(e) { ue.push(e), ce.target = e } function fe() { ue.pop(), ce.target = ue[ue.length - 1] } var pe = function (e, t, n, r, i, o, a, s) { this.tag = e, this.data = t, this.children = n, this.text = r, this.elm = i, this.ns = void 0, this.context = o, this.fnContext = void 0, this.fnOptions = void 0, this.fnScopeId = void 0, this.key = t && t.key, this.componentOptions = a, this.componentInstance = void 0, this.parent = void 0, this.raw = !1, this.isStatic = !1, this.isRootInsert = !0, this.isComment = !1, this.isCloned = !1, this.isOnce = !1, this.asyncFactory = s, this.asyncMeta = void 0, this.isAsyncPlaceholder = !1 }, de = { child: { configurable: !0 } }; de.child.get = function () { return this.componentInstance }, Object.defineProperties(pe.prototype, de); var ve = function (e) { void 0 === e && (e = ""); var t = new pe; return t.text = e, t.isComment = !0, t }; function he(e) { return new pe(void 0, void 0, void 0, String(e)) } function me(e) { var t = new pe(e.tag, e.data, e.children && e.children.slice(), e.text, e.elm, e.context, e.componentOptions, e.asyncFactory); return t.ns = e.ns, t.isStatic = e.isStatic, t.key = e.key, t.isComment = e.isComment, t.fnContext = e.fnContext, t.fnOptions = e.fnOptions, t.fnScopeId = e.fnScopeId, t.asyncMeta = e.asyncMeta, t.isCloned = !0, t } var ye = Array.prototype, ge = Object.create(ye);["push", "pop", "shift", "unshift", "splice", "sort", "reverse"].forEach(function (e) { var t = ye[e]; R(ge, e, function () { for (var n = [], r = arguments.length; r--;)n[r] = arguments[r]; var i, o = t.apply(this, n), a = this.__ob__; switch (e) { case "push": case "unshift": i = n; break; case "splice": i = n.slice(2) }return i && a.observeArray(i), a.dep.notify(), o }) }); var _e = Object.getOwnPropertyNames(ge), be = !0; function $e(e) { be = e } var we = function (e) { var t; this.value = e, this.dep = new ce, this.vmCount = 0, R(e, "__ob__", this), Array.isArray(e) ? (U ? (t = ge, e.__proto__ = t) : function (e, t, n) { for (var r = 0, i = n.length; r < i; r++) { var o = n[r]; R(e, o, t[o]) } }(e, ge, _e), this.observeArray(e)) : this.walk(e) }; function Ce(e, t) { var n; if (o(e) && !(e instanceof pe)) return y(e, "__ob__") && e.__ob__ instanceof we ? n = e.__ob__ : be && !te() && (Array.isArray(e) || s(e)) && Object.isExtensible(e) && !e._isVue && (n = new we(e)), t && n && n.vmCount++, n } function xe(e, t, n, r, i) { var o = new ce, a = Object.getOwnPropertyDescriptor(e, t); if (!a || !1 !== a.configurable) { var s = a && a.get, c = a && a.set; s && !c || 2 !== arguments.length || (n = e[t]); var u = !i && Ce(n); Object.defineProperty(e, t, { enumerable: !0, configurable: !0, get: function () { var t = s ? s.call(e) : n; return ce.target && (o.depend(), u && (u.dep.depend(), Array.isArray(t) && function e(t) { for (var n = void 0, r = 0, i = t.length; r < i; r++)(n = t[r]) && n.__ob__ && n.__ob__.dep.depend(), Array.isArray(n) && e(n) }(t))), t }, set: function (t) { var r = s ? s.call(e) : n; t === r || t != t && r != r || s && !c || (c ? c.call(e, t) : n = t, u = !i && Ce(t), o.notify()) } }) } } function ke(e, t, n) { if (Array.isArray(e) && c(t)) return e.length = Math.max(e.length, t), e.splice(t, 1, n), n; if (t in e && !(t in Object.prototype)) return e[t] = n, n; var r = e.__ob__; return e._isVue || r && r.vmCount ? n : r ? (xe(r.value, t, n), r.dep.notify(), n) : (e[t] = n, n) } function Ae(e, t) { if (Array.isArray(e) && c(t)) e.splice(t, 1); else { var n = e.__ob__; e._isVue || n && n.vmCount || y(e, t) && (delete e[t], n && n.dep.notify()) } } we.prototype.walk = function (e) { for (var t = Object.keys(e), n = 0; n < t.length; n++)xe(e, t[n]) }, we.prototype.observeArray = function (e) { for (var t = 0, n = e.length; t < n; t++)Ce(e[t]) }; var Oe = F.optionMergeStrategies; function Se(e, t) { if (!t) return e; for (var n, r, i, o = oe ? Reflect.ownKeys(t) : Object.keys(t), a = 0; a < o.length; a++)"__ob__" !== (n = o[a]) && (r = e[n], i = t[n], y(e, n) ? r !== i && s(r) && s(i) && Se(r, i) : ke(e, n, i)); return e } function Te(e, t, n) { return n ? function () { var r = "function" == typeof t ? t.call(n, n) : t, i = "function" == typeof e ? e.call(n, n) : e; return r ? Se(r, i) : i } : t ? e ? function () { return Se("function" == typeof t ? t.call(this, this) : t, "function" == typeof e ? e.call(this, this) : e) } : t : e } function Ee(e, t) { var n = t ? e ? e.concat(t) : Array.isArray(t) ? t : [t] : e; return n ? function (e) { for (var t = [], n = 0; n < e.length; n++)-1 === t.indexOf(e[n]) && t.push(e[n]); return t }(n) : n } function Ne(e, t, n, r) { var i = Object.create(e || null); return t ? A(i, t) : i } Oe.data = function (e, t, n) { return n ? Te(e, t, n) : t && "function" != typeof t ? e : Te(e, t) }, I.forEach(function (e) { Oe[e] = Ee }), M.forEach(function (e) { Oe[e + "s"] = Ne }), Oe.watch = function (e, t, n, r) { if (e === Y && (e = void 0), t === Y && (t = void 0), !t) return Object.create(e || null); if (!e) return t; var i = {}; for (var o in A(i, e), t) { var a = i[o], s = t[o]; a && !Array.isArray(a) && (a = [a]), i[o] = a ? a.concat(s) : Array.isArray(s) ? s : [s] } return i }, Oe.props = Oe.methods = Oe.inject = Oe.computed = function (e, t, n, r) { if (!e) return t; var i = Object.create(null); return A(i, e), t && A(i, t), i }, Oe.provide = Te; var je = function (e, t) { return void 0 === t ? e : t }; function De(e, t, n) { if ("function" == typeof t && (t = t.options), function (e, t) { var n = e.props; if (n) { var r, i, o = {}; if (Array.isArray(n)) for (r = n.length; r--;)"string" == typeof (i = n[r]) && (o[b(i)] = { type: null }); else if (s(n)) for (var a in n) i = n[a], o[b(a)] = s(i) ? i : { type: i }; e.props = o } }(t), function (e, t) { var n = e.inject; if (n) { var r = e.inject = {}; if (Array.isArray(n)) for (var i = 0; i < n.length; i++)r[n[i]] = { from: n[i] }; else if (s(n)) for (var o in n) { var a = n[o]; r[o] = s(a) ? A({ from: o }, a) : { from: a } } } }(t), function (e) { var t = e.directives; if (t) for (var n in t) { var r = t[n]; "function" == typeof r && (t[n] = { bind: r, update: r }) } }(t), !t._base && (t.extends && (e = De(e, t.extends, n)), t.mixins)) for (var r = 0, i = t.mixins.length; r < i; r++)e = De(e, t.mixins[r], n); var o, a = {}; for (o in e) c(o); for (o in t) y(e, o) || c(o); function c(r) { var i = Oe[r] || je; a[r] = i(e[r], t[r], n, r) } return a } function Le(e, t, n, r) { if ("string" == typeof n) { var i = e[t]; if (y(i, n)) return i[n]; var o = b(n); if (y(i, o)) return i[o]; var a = $(o); return y(i, a) ? i[a] : i[n] || i[o] || i[a] } } function Me(e, t, n, r) { var i = t[e], o = !y(n, e), a = n[e], s = Pe(Boolean, i.type); if (s > -1) if (o && !y(i, "default")) a = !1; else if ("" === a || a === C(e)) { var c = Pe(String, i.type); (c < 0 || s < c) && (a = !0) } if (void 0 === a) { a = function (e, t, n) { if (!y(t, "default")) return; var r = t.default; if (e && e.$options.propsData && void 0 === e.$options.propsData[n] && void 0 !== e._props[n]) return e._props[n]; return "function" == typeof r && "Function" !== Ie(t.type) ? r.call(e) : r }(r, i, e); var u = be; $e(!0), Ce(a), $e(u) } return a } function Ie(e) { var t = e && e.toString().match(/^\s*function (\w+)/); return t ? t[1] : "" } function Fe(e, t) { return Ie(e) === Ie(t) } function Pe(e, t) { if (!Array.isArray(t)) return Fe(t, e) ? 0 : -1; for (var n = 0, r = t.length; n < r; n++)if (Fe(t[n], e)) return n; return -1 } function Re(e, t, n) { le(); try { if (t) for (var r = t; r = r.$parent;) { var i = r.$options.errorCaptured; if (i) for (var o = 0; o < i.length; o++)try { if (!1 === i[o].call(r, e, t, n)) return } catch (e) { Be(e, r, "errorCaptured hook") } } Be(e, t, n) } finally { fe() } } function He(e, t, n, r, i) { var o; try { (o = n ? e.apply(t, n) : e.call(t)) && !o._isVue && u(o) && !o._handled && (o.catch(function (e) { return Re(e, r, i + " (Promise/async)") }), o._handled = !0) } catch (e) { Re(e, r, i) } return o } function Be(e, t, n) { if (F.errorHandler) try { return F.errorHandler.call(null, e, t, n) } catch (t) { t !== e && Ue(t, null, "config.errorHandler") } Ue(e, t, n) } function Ue(e, t, n) { if (!z && !V || "undefined" == typeof console) throw e; console.error(e) } var ze, Ve = !1, Ke = [], Je = !1; function qe() { Je = !1; var e = Ke.slice(0); Ke.length = 0; for (var t = 0; t < e.length; t++)e[t]() } if ("undefined" != typeof Promise && re(Promise)) { var We = Promise.resolve(); ze = function () { We.then(qe), G && setTimeout(S) }, Ve = !0 } else if (q || "undefined" == typeof MutationObserver || !re(MutationObserver) && "[object MutationObserverConstructor]" !== MutationObserver.toString()) ze = "undefined" != typeof setImmediate && re(setImmediate) ? function () { setImmediate(qe) } : function () { setTimeout(qe, 0) }; else { var Ze = 1, Ge = new MutationObserver(qe), Xe = document.createTextNode(String(Ze)); Ge.observe(Xe, { characterData: !0 }), ze = function () { Ze = (Ze + 1) % 2, Xe.data = String(Ze) }, Ve = !0 } function Ye(e, t) { var n; if (Ke.push(function () { if (e) try { e.call(t) } catch (e) { Re(e, t, "nextTick") } else n && n(t) }), Je || (Je = !0, ze()), !e && "undefined" != typeof Promise) return new Promise(function (e) { n = e }) } var Qe = new ie; function et(e) { !function e(t, n) { var r, i; var a = Array.isArray(t); if (!a && !o(t) || Object.isFrozen(t) || t instanceof pe) return; if (t.__ob__) { var s = t.__ob__.dep.id; if (n.has(s)) return; n.add(s) } if (a) for (r = t.length; r--;)e(t[r], n); else for (i = Object.keys(t), r = i.length; r--;)e(t[i[r]], n) }(e, Qe), Qe.clear() } var tt = g(function (e) { var t = "&" === e.charAt(0), n = "~" === (e = t ? e.slice(1) : e).charAt(0), r = "!" === (e = n ? e.slice(1) : e).charAt(0); return { name: e = r ? e.slice(1) : e, once: n, capture: r, passive: t } }); function nt(e, t) { function n() { var e = arguments, r = n.fns; if (!Array.isArray(r)) return He(r, null, arguments, t, "v-on handler"); for (var i = r.slice(), o = 0; o < i.length; o++)He(i[o], null, e, t, "v-on handler") } return n.fns = e, n } function rt(e, n, i, o, a, s) { var c, u, l, f; for (c in e) u = e[c], l = n[c], f = tt(c), t(u) || (t(l) ? (t(u.fns) && (u = e[c] = nt(u, s)), r(f.once) && (u = e[c] = a(f.name, u, f.capture)), i(f.name, u, f.capture, f.passive, f.params)) : u !== l && (l.fns = u, e[c] = l)); for (c in n) t(e[c]) && o((f = tt(c)).name, n[c], f.capture) } function it(e, i, o) { var a; e instanceof pe && (e = e.data.hook || (e.data.hook = {})); var s = e[i]; function c() { o.apply(this, arguments), h(a.fns, c) } t(s) ? a = nt([c]) : n(s.fns) && r(s.merged) ? (a = s).fns.push(c) : a = nt([s, c]), a.merged = !0, e[i] = a } function ot(e, t, r, i, o) { if (n(t)) { if (y(t, r)) return e[r] = t[r], o || delete t[r], !0; if (y(t, i)) return e[r] = t[i], o || delete t[i], !0 } return !1 } function at(e) { return i(e) ? [he(e)] : Array.isArray(e) ? function e(o, a) { var s = []; var c, u, l, f; for (c = 0; c < o.length; c++)t(u = o[c]) || "boolean" == typeof u || (l = s.length - 1, f = s[l], Array.isArray(u) ? u.length > 0 && (st((u = e(u, (a || "") + "_" + c))[0]) && st(f) && (s[l] = he(f.text + u[0].text), u.shift()), s.push.apply(s, u)) : i(u) ? st(f) ? s[l] = he(f.text + u) : "" !== u && s.push(he(u)) : st(u) && st(f) ? s[l] = he(f.text + u.text) : (r(o._isVList) && n(u.tag) && t(u.key) && n(a) && (u.key = "__vlist" + a + "_" + c + "__"), s.push(u))); return s }(e) : void 0 } function st(e) { return n(e) && n(e.text) && !1 === e.isComment } function ct(e, t) { if (e) { for (var n = Object.create(null), r = oe ? Reflect.ownKeys(e) : Object.keys(e), i = 0; i < r.length; i++) { var o = r[i]; if ("__ob__" !== o) { for (var a = e[o].from, s = t; s;) { if (s._provided && y(s._provided, a)) { n[o] = s._provided[a]; break } s = s.$parent } if (!s && "default" in e[o]) { var c = e[o].default; n[o] = "function" == typeof c ? c.call(t) : c } } } return n } } function ut(e, t) { if (!e || !e.length) return {}; for (var n = {}, r = 0, i = e.length; r < i; r++) { var o = e[r], a = o.data; if (a && a.attrs && a.attrs.slot && delete a.attrs.slot, o.context !== t && o.fnContext !== t || !a || null == a.slot) (n.default || (n.default = [])).push(o); else { var s = a.slot, c = n[s] || (n[s] = []); "template" === o.tag ? c.push.apply(c, o.children || []) : c.push(o) } } for (var u in n) n[u].every(lt) && delete n[u]; return n } function lt(e) { return e.isComment && !e.asyncFactory || " " === e.text } function ft(t, n, r) { var i, o = Object.keys(n).length > 0, a = t ? !!t.$stable : !o, s = t && t.$key; if (t) { if (t._normalized) return t._normalized; if (a && r && r !== e && s === r.$key && !o && !r.$hasNormal) return r; for (var c in i = {}, t) t[c] && "$" !== c[0] && (i[c] = pt(n, c, t[c])) } else i = {}; for (var u in n) u in i || (i[u] = dt(n, u)); return t && Object.isExtensible(t) && (t._normalized = i), R(i, "$stable", a), R(i, "$key", s), R(i, "$hasNormal", o), i } function pt(e, t, n) { var r = function () { var e = arguments.length ? n.apply(null, arguments) : n({}); return (e = e && "object" == typeof e && !Array.isArray(e) ? [e] : at(e)) && (0 === e.length || 1 === e.length && e[0].isComment) ? void 0 : e }; return n.proxy && Object.defineProperty(e, t, { get: r, enumerable: !0, configurable: !0 }), r } function dt(e, t) { return function () { return e[t] } } function vt(e, t) { var r, i, a, s, c; if (Array.isArray(e) || "string" == typeof e) for (r = new Array(e.length), i = 0, a = e.length; i < a; i++)r[i] = t(e[i], i); else if ("number" == typeof e) for (r = new Array(e), i = 0; i < e; i++)r[i] = t(i + 1, i); else if (o(e)) if (oe && e[Symbol.iterator]) { r = []; for (var u = e[Symbol.iterator](), l = u.next(); !l.done;)r.push(t(l.value, r.length)), l = u.next() } else for (s = Object.keys(e), r = new Array(s.length), i = 0, a = s.length; i < a; i++)c = s[i], r[i] = t(e[c], c, i); return n(r) || (r = []), r._isVList = !0, r } function ht(e, t, n, r) { var i, o = this.$scopedSlots[e]; o ? (n = n || {}, r && (n = A(A({}, r), n)), i = o(n) || t) : i = this.$slots[e] || t; var a = n && n.slot; return a ? this.$createElement("template", { slot: a }, i) : i } function mt(e) { return Le(this.$options, "filters", e) || E } function yt(e, t) { return Array.isArray(e) ? -1 === e.indexOf(t) : e !== t } function gt(e, t, n, r, i) { var o = F.keyCodes[t] || n; return i && r && !F.keyCodes[t] ? yt(i, r) : o ? yt(o, e) : r ? C(r) !== t : void 0 } function _t(e, t, n, r, i) { if (n) if (o(n)) { var a; Array.isArray(n) && (n = O(n)); var s = function (o) { if ("class" === o || "style" === o || v(o)) a = e; else { var s = e.attrs && e.attrs.type; a = r || F.mustUseProp(t, s, o) ? e.domProps || (e.domProps = {}) : e.attrs || (e.attrs = {}) } var c = b(o), u = C(o); c in a || u in a || (a[o] = n[o], i && ((e.on || (e.on = {}))["update:" + o] = function (e) { n[o] = e })) }; for (var c in n) s(c) } else; return e } function bt(e, t) { var n = this._staticTrees || (this._staticTrees = []), r = n[e]; return r && !t ? r : (wt(r = n[e] = this.$options.staticRenderFns[e].call(this._renderProxy, null, this), "__static__" + e, !1), r) } function $t(e, t, n) { return wt(e, "__once__" + t + (n ? "_" + n : ""), !0), e } function wt(e, t, n) { if (Array.isArray(e)) for (var r = 0; r < e.length; r++)e[r] && "string" != typeof e[r] && Ct(e[r], t + "_" + r, n); else Ct(e, t, n) } function Ct(e, t, n) { e.isStatic = !0, e.key = t, e.isOnce = n } function xt(e, t) { if (t) if (s(t)) { var n = e.on = e.on ? A({}, e.on) : {}; for (var r in t) { var i = n[r], o = t[r]; n[r] = i ? [].concat(i, o) : o } } else; return e } function kt(e, t, n, r) { t = t || { $stable: !n }; for (var i = 0; i < e.length; i++) { var o = e[i]; Array.isArray(o) ? kt(o, t, n) : o && (o.proxy && (o.fn.proxy = !0), t[o.key] = o.fn) } return r && (t.$key = r), t } function At(e, t) { for (var n = 0; n < t.length; n += 2) { var r = t[n]; "string" == typeof r && r && (e[t[n]] = t[n + 1]) } return e } function Ot(e, t) { return "string" == typeof e ? t + e : e } function St(e) { e._o = $t, e._n = f, e._s = l, e._l = vt, e._t = ht, e._q = N, e._i = j, e._m = bt, e._f = mt, e._k = gt, e._b = _t, e._v = he, e._e = ve, e._u = kt, e._g = xt, e._d = At, e._p = Ot } function Tt(t, n, i, o, a) { var s, c = this, u = a.options; y(o, "_uid") ? (s = Object.create(o))._original = o : (s = o, o = o._original); var l = r(u._compiled), f = !l; this.data = t, this.props = n, this.children = i, this.parent = o, this.listeners = t.on || e, this.injections = ct(u.inject, o), this.slots = function () { return c.$slots || ft(t.scopedSlots, c.$slots = ut(i, o)), c.$slots }, Object.defineProperty(this, "scopedSlots", { enumerable: !0, get: function () { return ft(t.scopedSlots, this.slots()) } }), l && (this.$options = u, this.$slots = this.slots(), this.$scopedSlots = ft(t.scopedSlots, this.$slots)), u._scopeId ? this._c = function (e, t, n, r) { var i = Pt(s, e, t, n, r, f); return i && !Array.isArray(i) && (i.fnScopeId = u._scopeId, i.fnContext = o), i } : this._c = function (e, t, n, r) { return Pt(s, e, t, n, r, f) } } function Et(e, t, n, r, i) { var o = me(e); return o.fnContext = n, o.fnOptions = r, t.slot && ((o.data || (o.data = {})).slot = t.slot), o } function Nt(e, t) { for (var n in t) e[b(n)] = t[n] } St(Tt.prototype); var jt = { init: function (e, t) { if (e.componentInstance && !e.componentInstance._isDestroyed && e.data.keepAlive) { var r = e; jt.prepatch(r, r) } else { (e.componentInstance = function (e, t) { var r = { _isComponent: !0, _parentVnode: e, parent: t }, i = e.data.inlineTemplate; n(i) && (r.render = i.render, r.staticRenderFns = i.staticRenderFns); return new e.componentOptions.Ctor(r) }(e, Wt)).$mount(t ? e.elm : void 0, t) } }, prepatch: function (t, n) { var r = n.componentOptions; !function (t, n, r, i, o) { var a = i.data.scopedSlots, s = t.$scopedSlots, c = !!(a && !a.$stable || s !== e && !s.$stable || a && t.$scopedSlots.$key !== a.$key), u = !!(o || t.$options._renderChildren || c); t.$options._parentVnode = i, t.$vnode = i, t._vnode && (t._vnode.parent = i); if (t.$options._renderChildren = o, t.$attrs = i.data.attrs || e, t.$listeners = r || e, n && t.$options.props) { $e(!1); for (var l = t._props, f = t.$options._propKeys || [], p = 0; p < f.length; p++) { var d = f[p], v = t.$options.props; l[d] = Me(d, v, n, t) } $e(!0), t.$options.propsData = n } r = r || e; var h = t.$options._parentListeners; t.$options._parentListeners = r, qt(t, r, h), u && (t.$slots = ut(o, i.context), t.$forceUpdate()) }(n.componentInstance = t.componentInstance, r.propsData, r.listeners, n, r.children) }, insert: function (e) { var t, n = e.context, r = e.componentInstance; r._isMounted || (r._isMounted = !0, Yt(r, "mounted")), e.data.keepAlive && (n._isMounted ? ((t = r)._inactive = !1, en.push(t)) : Xt(r, !0)) }, destroy: function (e) { var t = e.componentInstance; t._isDestroyed || (e.data.keepAlive ? function e(t, n) { if (n && (t._directInactive = !0, Gt(t))) return; if (!t._inactive) { t._inactive = !0; for (var r = 0; r < t.$children.length; r++)e(t.$children[r]); Yt(t, "deactivated") } }(t, !0) : t.$destroy()) } }, Dt = Object.keys(jt); function Lt(i, a, s, c, l) { if (!t(i)) { var f = s.$options._base; if (o(i) && (i = f.extend(i)), "function" == typeof i) { var p; if (t(i.cid) && void 0 === (i = function (e, i) { if (r(e.error) && n(e.errorComp)) return e.errorComp; if (n(e.resolved)) return e.resolved; var a = Ht; a && n(e.owners) && -1 === e.owners.indexOf(a) && e.owners.push(a); if (r(e.loading) && n(e.loadingComp)) return e.loadingComp; if (a && !n(e.owners)) { var s = e.owners = [a], c = !0, l = null, f = null; a.$on("hook:destroyed", function () { return h(s, a) }); var p = function (e) { for (var t = 0, n = s.length; t < n; t++)s[t].$forceUpdate(); e && (s.length = 0, null !== l && (clearTimeout(l), l = null), null !== f && (clearTimeout(f), f = null)) }, d = D(function (t) { e.resolved = Bt(t, i), c ? s.length = 0 : p(!0) }), v = D(function (t) { n(e.errorComp) && (e.error = !0, p(!0)) }), m = e(d, v); return o(m) && (u(m) ? t(e.resolved) && m.then(d, v) : u(m.component) && (m.component.then(d, v), n(m.error) && (e.errorComp = Bt(m.error, i)), n(m.loading) && (e.loadingComp = Bt(m.loading, i), 0 === m.delay ? e.loading = !0 : l = setTimeout(function () { l = null, t(e.resolved) && t(e.error) && (e.loading = !0, p(!1)) }, m.delay || 200)), n(m.timeout) && (f = setTimeout(function () { f = null, t(e.resolved) && v(null) }, m.timeout)))), c = !1, e.loading ? e.loadingComp : e.resolved } }(p = i, f))) return function (e, t, n, r, i) { var o = ve(); return o.asyncFactory = e, o.asyncMeta = { data: t, context: n, children: r, tag: i }, o }(p, a, s, c, l); a = a || {}, $n(i), n(a.model) && function (e, t) { var r = e.model && e.model.prop || "value", i = e.model && e.model.event || "input"; (t.attrs || (t.attrs = {}))[r] = t.model.value; var o = t.on || (t.on = {}), a = o[i], s = t.model.callback; n(a) ? (Array.isArray(a) ? -1 === a.indexOf(s) : a !== s) && (o[i] = [s].concat(a)) : o[i] = s }(i.options, a); var d = function (e, r, i) { var o = r.options.props; if (!t(o)) { var a = {}, s = e.attrs, c = e.props; if (n(s) || n(c)) for (var u in o) { var l = C(u); ot(a, c, u, l, !0) || ot(a, s, u, l, !1) } return a } }(a, i); if (r(i.options.functional)) return function (t, r, i, o, a) { var s = t.options, c = {}, u = s.props; if (n(u)) for (var l in u) c[l] = Me(l, u, r || e); else n(i.attrs) && Nt(c, i.attrs), n(i.props) && Nt(c, i.props); var f = new Tt(i, c, a, o, t), p = s.render.call(null, f._c, f); if (p instanceof pe) return Et(p, i, f.parent, s); if (Array.isArray(p)) { for (var d = at(p) || [], v = new Array(d.length), h = 0; h < d.length; h++)v[h] = Et(d[h], i, f.parent, s); return v } }(i, d, a, s, c); var v = a.on; if (a.on = a.nativeOn, r(i.options.abstract)) { var m = a.slot; a = {}, m && (a.slot = m) } !function (e) { for (var t = e.hook || (e.hook = {}), n = 0; n < Dt.length; n++) { var r = Dt[n], i = t[r], o = jt[r]; i === o || i && i._merged || (t[r] = i ? Mt(o, i) : o) } }(a); var y = i.options.name || l; return new pe("vue-component-" + i.cid + (y ? "-" + y : ""), a, void 0, void 0, void 0, s, { Ctor: i, propsData: d, listeners: v, tag: l, children: c }, p) } } } function Mt(e, t) { var n = function (n, r) { e(n, r), t(n, r) }; return n._merged = !0, n } var It = 1, Ft = 2; function Pt(e, a, s, c, u, l) { return (Array.isArray(s) || i(s)) && (u = c, c = s, s = void 0), r(l) && (u = Ft), function (e, i, a, s, c) { if (n(a) && n(a.__ob__)) return ve(); n(a) && n(a.is) && (i = a.is); if (!i) return ve(); Array.isArray(s) && "function" == typeof s[0] && ((a = a || {}).scopedSlots = { default: s[0] }, s.length = 0); c === Ft ? s = at(s) : c === It && (s = function (e) { for (var t = 0; t < e.length; t++)if (Array.isArray(e[t])) return Array.prototype.concat.apply([], e); return e }(s)); var u, l; if ("string" == typeof i) { var f; l = e.$vnode && e.$vnode.ns || F.getTagNamespace(i), u = F.isReservedTag(i) ? new pe(F.parsePlatformTagName(i), a, s, void 0, void 0, e) : a && a.pre || !n(f = Le(e.$options, "components", i)) ? new pe(i, a, s, void 0, void 0, e) : Lt(f, a, e, s, i) } else u = Lt(i, a, e, s); return Array.isArray(u) ? u : n(u) ? (n(l) && function e(i, o, a) { i.ns = o; "foreignObject" === i.tag && (o = void 0, a = !0); if (n(i.children)) for (var s = 0, c = i.children.length; s < c; s++) { var u = i.children[s]; n(u.tag) && (t(u.ns) || r(a) && "svg" !== u.tag) && e(u, o, a) } }(u, l), n(a) && function (e) { o(e.style) && et(e.style); o(e.class) && et(e.class) }(a), u) : ve() }(e, a, s, c, u) } var Rt, Ht = null; function Bt(e, t) { return (e.__esModule || oe && "Module" === e[Symbol.toStringTag]) && (e = e.default), o(e) ? t.extend(e) : e } function Ut(e) { return e.isComment && e.asyncFactory } function zt(e) { if (Array.isArray(e)) for (var t = 0; t < e.length; t++) { var r = e[t]; if (n(r) && (n(r.componentOptions) || Ut(r))) return r } } function Vt(e, t) { Rt.$on(e, t) } function Kt(e, t) { Rt.$off(e, t) } function Jt(e, t) { var n = Rt; return function r() { null !== t.apply(null, arguments) && n.$off(e, r) } } function qt(e, t, n) { Rt = e, rt(t, n || {}, Vt, Kt, Jt, e), Rt = void 0 } var Wt = null; function Zt(e) { var t = Wt; return Wt = e, function () { Wt = t } } function Gt(e) { for (; e && (e = e.$parent);)if (e._inactive) return !0; return !1 } function Xt(e, t) { if (t) { if (e._directInactive = !1, Gt(e)) return } else if (e._directInactive) return; if (e._inactive || null === e._inactive) { e._inactive = !1; for (var n = 0; n < e.$children.length; n++)Xt(e.$children[n]); Yt(e, "activated") } } function Yt(e, t) { le(); var n = e.$options[t], r = t + " hook"; if (n) for (var i = 0, o = n.length; i < o; i++)He(n[i], e, null, e, r); e._hasHookEvent && e.$emit("hook:" + t), fe() } var Qt = [], en = [], tn = {}, nn = !1, rn = !1, on = 0; var an = 0, sn = Date.now; if (z && !q) { var cn = window.performance; cn && "function" == typeof cn.now && sn() > document.createEvent("Event").timeStamp && (sn = function () { return cn.now() }) } function un() { var e, t; for (an = sn(), rn = !0, Qt.sort(function (e, t) { return e.id - t.id }), on = 0; on < Qt.length; on++)(e = Qt[on]).before && e.before(), t = e.id, tn[t] = null, e.run(); var n = en.slice(), r = Qt.slice(); on = Qt.length = en.length = 0, tn = {}, nn = rn = !1, function (e) { for (var t = 0; t < e.length; t++)e[t]._inactive = !0, Xt(e[t], !0) }(n), function (e) { var t = e.length; for (; t--;) { var n = e[t], r = n.vm; r._watcher === n && r._isMounted && !r._isDestroyed && Yt(r, "updated") } }(r), ne && F.devtools && ne.emit("flush") } var ln = 0, fn = function (e, t, n, r, i) { this.vm = e, i && (e._watcher = this), e._watchers.push(this), r ? (this.deep = !!r.deep, this.user = !!r.user, this.lazy = !!r.lazy, this.sync = !!r.sync, this.before = r.before) : this.deep = this.user = this.lazy = this.sync = !1, this.cb = n, this.id = ++ln, this.active = !0, this.dirty = this.lazy, this.deps = [], this.newDeps = [], this.depIds = new ie, this.newDepIds = new ie, this.expression = "", "function" == typeof t ? this.getter = t : (this.getter = function (e) { if (!H.test(e)) { var t = e.split("."); return function (e) { for (var n = 0; n < t.length; n++) { if (!e) return; e = e[t[n]] } return e } } }(t), this.getter || (this.getter = S)), this.value = this.lazy ? void 0 : this.get() }; fn.prototype.get = function () { var e; le(this); var t = this.vm; try { e = this.getter.call(t, t) } catch (e) { if (!this.user) throw e; Re(e, t, 'getter for watcher "' + this.expression + '"') } finally { this.deep && et(e), fe(), this.cleanupDeps() } return e }, fn.prototype.addDep = function (e) { var t = e.id; this.newDepIds.has(t) || (this.newDepIds.add(t), this.newDeps.push(e), this.depIds.has(t) || e.addSub(this)) }, fn.prototype.cleanupDeps = function () { for (var e = this.deps.length; e--;) { var t = this.deps[e]; this.newDepIds.has(t.id) || t.removeSub(this) } var n = this.depIds; this.depIds = this.newDepIds, this.newDepIds = n, this.newDepIds.clear(), n = this.deps, this.deps = this.newDeps, this.newDeps = n, this.newDeps.length = 0 }, fn.prototype.update = function () { this.lazy ? this.dirty = !0 : this.sync ? this.run() : function (e) { var t = e.id; if (null == tn[t]) { if (tn[t] = !0, rn) { for (var n = Qt.length - 1; n > on && Qt[n].id > e.id;)n--; Qt.splice(n + 1, 0, e) } else Qt.push(e); nn || (nn = !0, Ye(un)) } }(this) }, fn.prototype.run = function () { if (this.active) { var e = this.get(); if (e !== this.value || o(e) || this.deep) { var t = this.value; if (this.value = e, this.user) try { this.cb.call(this.vm, e, t) } catch (e) { Re(e, this.vm, 'callback for watcher "' + this.expression + '"') } else this.cb.call(this.vm, e, t) } } }, fn.prototype.evaluate = function () { this.value = this.get(), this.dirty = !1 }, fn.prototype.depend = function () { for (var e = this.deps.length; e--;)this.deps[e].depend() }, fn.prototype.teardown = function () { if (this.active) { this.vm._isBeingDestroyed || h(this.vm._watchers, this); for (var e = this.deps.length; e--;)this.deps[e].removeSub(this); this.active = !1 } }; var pn = { enumerable: !0, configurable: !0, get: S, set: S }; function dn(e, t, n) { pn.get = function () { return this[t][n] }, pn.set = function (e) { this[t][n] = e }, Object.defineProperty(e, n, pn) } function vn(e) { e._watchers = []; var t = e.$options; t.props && function (e, t) { var n = e.$options.propsData || {}, r = e._props = {}, i = e.$options._propKeys = []; e.$parent && $e(!1); var o = function (o) { i.push(o); var a = Me(o, t, n, e); xe(r, o, a), o in e || dn(e, "_props", o) }; for (var a in t) o(a); $e(!0) }(e, t.props), t.methods && function (e, t) { e.$options.props; for (var n in t) e[n] = "function" != typeof t[n] ? S : x(t[n], e) }(e, t.methods), t.data ? function (e) { var t = e.$options.data; s(t = e._data = "function" == typeof t ? function (e, t) { le(); try { return e.call(t, t) } catch (e) { return Re(e, t, "data()"), {} } finally { fe() } }(t, e) : t || {}) || (t = {}); var n = Object.keys(t), r = e.$options.props, i = (e.$options.methods, n.length); for (; i--;) { var o = n[i]; r && y(r, o) || (a = void 0, 36 !== (a = (o + "").charCodeAt(0)) && 95 !== a && dn(e, "_data", o)) } var a; Ce(t, !0) }(e) : Ce(e._data = {}, !0), t.computed && function (e, t) { var n = e._computedWatchers = Object.create(null), r = te(); for (var i in t) { var o = t[i], a = "function" == typeof o ? o : o.get; r || (n[i] = new fn(e, a || S, S, hn)), i in e || mn(e, i, o) } }(e, t.computed), t.watch && t.watch !== Y && function (e, t) { for (var n in t) { var r = t[n]; if (Array.isArray(r)) for (var i = 0; i < r.length; i++)_n(e, n, r[i]); else _n(e, n, r) } }(e, t.watch) } var hn = { lazy: !0 }; function mn(e, t, n) { var r = !te(); "function" == typeof n ? (pn.get = r ? yn(t) : gn(n), pn.set = S) : (pn.get = n.get ? r && !1 !== n.cache ? yn(t) : gn(n.get) : S, pn.set = n.set || S), Object.defineProperty(e, t, pn) } function yn(e) { return function () { var t = this._computedWatchers && this._computedWatchers[e]; if (t) return t.dirty && t.evaluate(), ce.target && t.depend(), t.value } } function gn(e) { return function () { return e.call(this, this) } } function _n(e, t, n, r) { return s(n) && (r = n, n = n.handler), "string" == typeof n && (n = e[n]), e.$watch(t, n, r) } var bn = 0; function $n(e) { var t = e.options; if (e.super) { var n = $n(e.super); if (n !== e.superOptions) { e.superOptions = n; var r = function (e) { var t, n = e.options, r = e.sealedOptions; for (var i in n) n[i] !== r[i] && (t || (t = {}), t[i] = n[i]); return t }(e); r && A(e.extendOptions, r), (t = e.options = De(n, e.extendOptions)).name && (t.components[t.name] = e) } } return t } function wn(e) { this._init(e) } function Cn(e) { e.cid = 0; var t = 1; e.extend = function (e) { e = e || {}; var n = this, r = n.cid, i = e._Ctor || (e._Ctor = {}); if (i[r]) return i[r]; var o = e.name || n.options.name, a = function (e) { this._init(e) }; return (a.prototype = Object.create(n.prototype)).constructor = a, a.cid = t++, a.options = De(n.options, e), a.super = n, a.options.props && function (e) { var t = e.options.props; for (var n in t) dn(e.prototype, "_props", n) }(a), a.options.computed && function (e) { var t = e.options.computed; for (var n in t) mn(e.prototype, n, t[n]) }(a), a.extend = n.extend, a.mixin = n.mixin, a.use = n.use, M.forEach(function (e) { a[e] = n[e] }), o && (a.options.components[o] = a), a.superOptions = n.options, a.extendOptions = e, a.sealedOptions = A({}, a.options), i[r] = a, a } } function xn(e) { return e && (e.Ctor.options.name || e.tag) } function kn(e, t) { return Array.isArray(e) ? e.indexOf(t) > -1 : "string" == typeof e ? e.split(",").indexOf(t) > -1 : (n = e, "[object RegExp]" === a.call(n) && e.test(t)); var n } function An(e, t) { var n = e.cache, r = e.keys, i = e._vnode; for (var o in n) { var a = n[o]; if (a) { var s = xn(a.componentOptions); s && !t(s) && On(n, o, r, i) } } } function On(e, t, n, r) { var i = e[t]; !i || r && i.tag === r.tag || i.componentInstance.$destroy(), e[t] = null, h(n, t) } !function (t) { t.prototype._init = function (t) { var n = this; n._uid = bn++, n._isVue = !0, t && t._isComponent ? function (e, t) { var n = e.$options = Object.create(e.constructor.options), r = t._parentVnode; n.parent = t.parent, n._parentVnode = r; var i = r.componentOptions; n.propsData = i.propsData, n._parentListeners = i.listeners, n._renderChildren = i.children, n._componentTag = i.tag, t.render && (n.render = t.render, n.staticRenderFns = t.staticRenderFns) }(n, t) : n.$options = De($n(n.constructor), t || {}, n), n._renderProxy = n, n._self = n, function (e) { var t = e.$options, n = t.parent; if (n && !t.abstract) { for (; n.$options.abstract && n.$parent;)n = n.$parent; n.$children.push(e) } e.$parent = n, e.$root = n ? n.$root : e, e.$children = [], e.$refs = {}, e._watcher = null, e._inactive = null, e._directInactive = !1, e._isMounted = !1, e._isDestroyed = !1, e._isBeingDestroyed = !1 }(n), function (e) { e._events = Object.create(null), e._hasHookEvent = !1; var t = e.$options._parentListeners; t && qt(e, t) }(n), function (t) { t._vnode = null, t._staticTrees = null; var n = t.$options, r = t.$vnode = n._parentVnode, i = r && r.context; t.$slots = ut(n._renderChildren, i), t.$scopedSlots = e, t._c = function (e, n, r, i) { return Pt(t, e, n, r, i, !1) }, t.$createElement = function (e, n, r, i) { return Pt(t, e, n, r, i, !0) }; var o = r && r.data; xe(t, "$attrs", o && o.attrs || e, null, !0), xe(t, "$listeners", n._parentListeners || e, null, !0) }(n), Yt(n, "beforeCreate"), function (e) { var t = ct(e.$options.inject, e); t && ($e(!1), Object.keys(t).forEach(function (n) { xe(e, n, t[n]) }), $e(!0)) }(n), vn(n), function (e) { var t = e.$options.provide; t && (e._provided = "function" == typeof t ? t.call(e) : t) }(n), Yt(n, "created"), n.$options.el && n.$mount(n.$options.el) } }(wn), function (e) { var t = { get: function () { return this._data } }, n = { get: function () { return this._props } }; Object.defineProperty(e.prototype, "$data", t), Object.defineProperty(e.prototype, "$props", n), e.prototype.$set = ke, e.prototype.$delete = Ae, e.prototype.$watch = function (e, t, n) { if (s(t)) return _n(this, e, t, n); (n = n || {}).user = !0; var r = new fn(this, e, t, n); if (n.immediate) try { t.call(this, r.value) } catch (e) { Re(e, this, 'callback for immediate watcher "' + r.expression + '"') } return function () { r.teardown() } } }(wn), function (e) { var t = /^hook:/; e.prototype.$on = function (e, n) { var r = this; if (Array.isArray(e)) for (var i = 0, o = e.length; i < o; i++)r.$on(e[i], n); else (r._events[e] || (r._events[e] = [])).push(n), t.test(e) && (r._hasHookEvent = !0); return r }, e.prototype.$once = function (e, t) { var n = this; function r() { n.$off(e, r), t.apply(n, arguments) } return r.fn = t, n.$on(e, r), n }, e.prototype.$off = function (e, t) { var n = this; if (!arguments.length) return n._events = Object.create(null), n; if (Array.isArray(e)) { for (var r = 0, i = e.length; r < i; r++)n.$off(e[r], t); return n } var o, a = n._events[e]; if (!a) return n; if (!t) return n._events[e] = null, n; for (var s = a.length; s--;)if ((o = a[s]) === t || o.fn === t) { a.splice(s, 1); break } return n }, e.prototype.$emit = function (e) { var t = this._events[e]; if (t) { t = t.length > 1 ? k(t) : t; for (var n = k(arguments, 1), r = 'event handler for "' + e + '"', i = 0, o = t.length; i < o; i++)He(t[i], this, n, this, r) } return this } }(wn), function (e) { e.prototype._update = function (e, t) { var n = this, r = n.$el, i = n._vnode, o = Zt(n); n._vnode = e, n.$el = i ? n.__patch__(i, e) : n.__patch__(n.$el, e, t, !1), o(), r && (r.__vue__ = null), n.$el && (n.$el.__vue__ = n), n.$vnode && n.$parent && n.$vnode === n.$parent._vnode && (n.$parent.$el = n.$el) }, e.prototype.$forceUpdate = function () { this._watcher && this._watcher.update() }, e.prototype.$destroy = function () { var e = this; if (!e._isBeingDestroyed) { Yt(e, "beforeDestroy"), e._isBeingDestroyed = !0; var t = e.$parent; !t || t._isBeingDestroyed || e.$options.abstract || h(t.$children, e), e._watcher && e._watcher.teardown(); for (var n = e._watchers.length; n--;)e._watchers[n].teardown(); e._data.__ob__ && e._data.__ob__.vmCount--, e._isDestroyed = !0, e.__patch__(e._vnode, null), Yt(e, "destroyed"), e.$off(), e.$el && (e.$el.__vue__ = null), e.$vnode && (e.$vnode.parent = null) } } }(wn), function (e) { St(e.prototype), e.prototype.$nextTick = function (e) { return Ye(e, this) }, e.prototype._render = function () { var e, t = this, n = t.$options, r = n.render, i = n._parentVnode; i && (t.$scopedSlots = ft(i.data.scopedSlots, t.$slots, t.$scopedSlots)), t.$vnode = i; try { Ht = t, e = r.call(t._renderProxy, t.$createElement) } catch (n) { Re(n, t, "render"), e = t._vnode } finally { Ht = null } return Array.isArray(e) && 1 === e.length && (e = e[0]), e instanceof pe || (e = ve()), e.parent = i, e } }(wn); var Sn = [String, RegExp, Array], Tn = { KeepAlive: { name: "keep-alive", abstract: !0, props: { include: Sn, exclude: Sn, max: [String, Number] }, created: function () { this.cache = Object.create(null), this.keys = [] }, destroyed: function () { for (var e in this.cache) On(this.cache, e, this.keys) }, mounted: function () { var e = this; this.$watch("include", function (t) { An(e, function (e) { return kn(t, e) }) }), this.$watch("exclude", function (t) { An(e, function (e) { return !kn(t, e) }) }) }, render: function () { var e = this.$slots.default, t = zt(e), n = t && t.componentOptions; if (n) { var r = xn(n), i = this.include, o = this.exclude; if (i && (!r || !kn(i, r)) || o && r && kn(o, r)) return t; var a = this.cache, s = this.keys, c = null == t.key ? n.Ctor.cid + (n.tag ? "::" + n.tag : "") : t.key; a[c] ? (t.componentInstance = a[c].componentInstance, h(s, c), s.push(c)) : (a[c] = t, s.push(c), this.max && s.length > parseInt(this.max) && On(a, s[0], s, this._vnode)), t.data.keepAlive = !0 } return t || e && e[0] } } }; !function (e) { var t = { get: function () { return F } }; Object.defineProperty(e, "config", t), e.util = { warn: ae, extend: A, mergeOptions: De, defineReactive: xe }, e.set = ke, e.delete = Ae, e.nextTick = Ye, e.observable = function (e) { return Ce(e), e }, e.options = Object.create(null), M.forEach(function (t) { e.options[t + "s"] = Object.create(null) }), e.options._base = e, A(e.options.components, Tn), function (e) { e.use = function (e) { var t = this._installedPlugins || (this._installedPlugins = []); if (t.indexOf(e) > -1) return this; var n = k(arguments, 1); return n.unshift(this), "function" == typeof e.install ? e.install.apply(e, n) : "function" == typeof e && e.apply(null, n), t.push(e), this } }(e), function (e) { e.mixin = function (e) { return this.options = De(this.options, e), this } }(e), Cn(e), function (e) { M.forEach(function (t) { e[t] = function (e, n) { return n ? ("component" === t && s(n) && (n.name = n.name || e, n = this.options._base.extend(n)), "directive" === t && "function" == typeof n && (n = { bind: n, update: n }), this.options[t + "s"][e] = n, n) : this.options[t + "s"][e] } }) }(e) }(wn), Object.defineProperty(wn.prototype, "$isServer", { get: te }), Object.defineProperty(wn.prototype, "$ssrContext", { get: function () { return this.$vnode && this.$vnode.ssrContext } }), Object.defineProperty(wn, "FunctionalRenderContext", { value: Tt }), wn.version = "2.6.11"; var En = p("style,class"), Nn = p("input,textarea,option,select,progress"), jn = function (e, t, n) { return "value" === n && Nn(e) && "button" !== t || "selected" === n && "option" === e || "checked" === n && "input" === e || "muted" === n && "video" === e }, Dn = p("contenteditable,draggable,spellcheck"), Ln = p("events,caret,typing,plaintext-only"), Mn = function (e, t) { return Hn(t) || "false" === t ? "false" : "contenteditable" === e && Ln(t) ? t : "true" }, In = p("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"), Fn = "http://www.w3.org/1999/xlink", Pn = function (e) { return ":" === e.charAt(5) && "xlink" === e.slice(0, 5) }, Rn = function (e) { return Pn(e) ? e.slice(6, e.length) : "" }, Hn = function (e) { return null == e || !1 === e }; function Bn(e) { for (var t = e.data, r = e, i = e; n(i.componentInstance);)(i = i.componentInstance._vnode) && i.data && (t = Un(i.data, t)); for (; n(r = r.parent);)r && r.data && (t = Un(t, r.data)); return function (e, t) { if (n(e) || n(t)) return zn(e, Vn(t)); return "" }(t.staticClass, t.class) } function Un(e, t) { return { staticClass: zn(e.staticClass, t.staticClass), class: n(e.class) ? [e.class, t.class] : t.class } } function zn(e, t) { return e ? t ? e + " " + t : e : t || "" } function Vn(e) { return Array.isArray(e) ? function (e) { for (var t, r = "", i = 0, o = e.length; i < o; i++)n(t = Vn(e[i])) && "" !== t && (r && (r += " "), r += t); return r }(e) : o(e) ? function (e) { var t = ""; for (var n in e) e[n] && (t && (t += " "), t += n); return t }(e) : "string" == typeof e ? e : "" } var Kn = { svg: "http://www.w3.org/2000/svg", math: "http://www.w3.org/1998/Math/MathML" }, Jn = p("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"), qn = p("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view", !0), Wn = function (e) { return Jn(e) || qn(e) }; function Zn(e) { return qn(e) ? "svg" : "math" === e ? "math" : void 0 } var Gn = Object.create(null); var Xn = p("text,number,password,search,email,tel,url"); function Yn(e) { if ("string" == typeof e) { var t = document.querySelector(e); return t || document.createElement("div") } return e } var Qn = Object.freeze({ createElement: function (e, t) { var n = document.createElement(e); return "select" !== e ? n : (t.data && t.data.attrs && void 0 !== t.data.attrs.multiple && n.setAttribute("multiple", "multiple"), n) }, createElementNS: function (e, t) { return document.createElementNS(Kn[e], t) }, createTextNode: function (e) { return document.createTextNode(e) }, createComment: function (e) { return document.createComment(e) }, insertBefore: function (e, t, n) { e.insertBefore(t, n) }, removeChild: function (e, t) { e.removeChild(t) }, appendChild: function (e, t) { e.appendChild(t) }, parentNode: function (e) { return e.parentNode }, nextSibling: function (e) { return e.nextSibling }, tagName: function (e) { return e.tagName }, setTextContent: function (e, t) { e.textContent = t }, setStyleScope: function (e, t) { e.setAttribute(t, "") } }), er = { create: function (e, t) { tr(t) }, update: function (e, t) { e.data.ref !== t.data.ref && (tr(e, !0), tr(t)) }, destroy: function (e) { tr(e, !0) } }; function tr(e, t) { var r = e.data.ref; if (n(r)) { var i = e.context, o = e.componentInstance || e.elm, a = i.$refs; t ? Array.isArray(a[r]) ? h(a[r], o) : a[r] === o && (a[r] = void 0) : e.data.refInFor ? Array.isArray(a[r]) ? a[r].indexOf(o) < 0 && a[r].push(o) : a[r] = [o] : a[r] = o } } var nr = new pe("", {}, []), rr = ["create", "activate", "update", "remove", "destroy"]; function ir(e, i) { return e.key === i.key && (e.tag === i.tag && e.isComment === i.isComment && n(e.data) === n(i.data) && function (e, t) { if ("input" !== e.tag) return !0; var r, i = n(r = e.data) && n(r = r.attrs) && r.type, o = n(r = t.data) && n(r = r.attrs) && r.type; return i === o || Xn(i) && Xn(o) }(e, i) || r(e.isAsyncPlaceholder) && e.asyncFactory === i.asyncFactory && t(i.asyncFactory.error)) } function or(e, t, r) { var i, o, a = {}; for (i = t; i <= r; ++i)n(o = e[i].key) && (a[o] = i); return a } var ar = { create: sr, update: sr, destroy: function (e) { sr(e, nr) } }; function sr(e, t) { (e.data.directives || t.data.directives) && function (e, t) { var n, r, i, o = e === nr, a = t === nr, s = ur(e.data.directives, e.context), c = ur(t.data.directives, t.context), u = [], l = []; for (n in c) r = s[n], i = c[n], r ? (i.oldValue = r.value, i.oldArg = r.arg, fr(i, "update", t, e), i.def && i.def.componentUpdated && l.push(i)) : (fr(i, "bind", t, e), i.def && i.def.inserted && u.push(i)); if (u.length) { var f = function () { for (var n = 0; n < u.length; n++)fr(u[n], "inserted", t, e) }; o ? it(t, "insert", f) : f() } l.length && it(t, "postpatch", function () { for (var n = 0; n < l.length; n++)fr(l[n], "componentUpdated", t, e) }); if (!o) for (n in s) c[n] || fr(s[n], "unbind", e, e, a) }(e, t) } var cr = Object.create(null); function ur(e, t) { var n, r, i = Object.create(null); if (!e) return i; for (n = 0; n < e.length; n++)(r = e[n]).modifiers || (r.modifiers = cr), i[lr(r)] = r, r.def = Le(t.$options, "directives", r.name); return i } function lr(e) { return e.rawName || e.name + "." + Object.keys(e.modifiers || {}).join(".") } function fr(e, t, n, r, i) { var o = e.def && e.def[t]; if (o) try { o(n.elm, e, n, r, i) } catch (r) { Re(r, n.context, "directive " + e.name + " " + t + " hook") } } var pr = [er, ar]; function dr(e, r) { var i = r.componentOptions; if (!(n(i) && !1 === i.Ctor.options.inheritAttrs || t(e.data.attrs) && t(r.data.attrs))) { var o, a, s = r.elm, c = e.data.attrs || {}, u = r.data.attrs || {}; for (o in n(u.__ob__) && (u = r.data.attrs = A({}, u)), u) a = u[o], c[o] !== a && vr(s, o, a); for (o in (q || Z) && u.value !== c.value && vr(s, "value", u.value), c) t(u[o]) && (Pn(o) ? s.removeAttributeNS(Fn, Rn(o)) : Dn(o) || s.removeAttribute(o)) } } function vr(e, t, n) { e.tagName.indexOf("-") > -1 ? hr(e, t, n) : In(t) ? Hn(n) ? e.removeAttribute(t) : (n = "allowfullscreen" === t && "EMBED" === e.tagName ? "true" : t, e.setAttribute(t, n)) : Dn(t) ? e.setAttribute(t, Mn(t, n)) : Pn(t) ? Hn(n) ? e.removeAttributeNS(Fn, Rn(t)) : e.setAttributeNS(Fn, t, n) : hr(e, t, n) } function hr(e, t, n) { if (Hn(n)) e.removeAttribute(t); else { if (q && !W && "TEXTAREA" === e.tagName && "placeholder" === t && "" !== n && !e.__ieph) { var r = function (t) { t.stopImmediatePropagation(), e.removeEventListener("input", r) }; e.addEventListener("input", r), e.__ieph = !0 } e.setAttribute(t, n) } } var mr = { create: dr, update: dr }; function yr(e, r) { var i = r.elm, o = r.data, a = e.data; if (!(t(o.staticClass) && t(o.class) && (t(a) || t(a.staticClass) && t(a.class)))) { var s = Bn(r), c = i._transitionClasses; n(c) && (s = zn(s, Vn(c))), s !== i._prevClass && (i.setAttribute("class", s), i._prevClass = s) } } var gr, _r, br, $r, wr, Cr, xr = { create: yr, update: yr }, kr = /[\w).+\-_$\]]/; function Ar(e) { var t, n, r, i, o, a = !1, s = !1, c = !1, u = !1, l = 0, f = 0, p = 0, d = 0; for (r = 0; r < e.length; r++)if (n = t, t = e.charCodeAt(r), a) 39 === t && 92 !== n && (a = !1); else if (s) 34 === t && 92 !== n && (s = !1); else if (c) 96 === t && 92 !== n && (c = !1); else if (u) 47 === t && 92 !== n && (u = !1); else if (124 !== t || 124 === e.charCodeAt(r + 1) || 124 === e.charCodeAt(r - 1) || l || f || p) { switch (t) { case 34: s = !0; break; case 39: a = !0; break; case 96: c = !0; break; case 40: p++; break; case 41: p--; break; case 91: f++; break; case 93: f--; break; case 123: l++; break; case 125: l-- }if (47 === t) { for (var v = r - 1, h = void 0; v >= 0 && " " === (h = e.charAt(v)); v--); h && kr.test(h) || (u = !0) } } else void 0 === i ? (d = r + 1, i = e.slice(0, r).trim()) : m(); function m() { (o || (o = [])).push(e.slice(d, r).trim()), d = r + 1 } if (void 0 === i ? i = e.slice(0, r).trim() : 0 !== d && m(), o) for (r = 0; r < o.length; r++)i = Or(i, o[r]); return i } function Or(e, t) { var n = t.indexOf("("); if (n < 0) return '_f("' + t + '")(' + e + ")"; var r = t.slice(0, n), i = t.slice(n + 1); return '_f("' + r + '")(' + e + (")" !== i ? "," + i : i) } function Sr(e, t) { console.error("[Vue compiler]: " + e) } function Tr(e, t) { return e ? e.map(function (e) { return e[t] }).filter(function (e) { return e }) : [] } function Er(e, t, n, r, i) { (e.props || (e.props = [])).push(Rr({ name: t, value: n, dynamic: i }, r)), e.plain = !1 } function Nr(e, t, n, r, i) { (i ? e.dynamicAttrs || (e.dynamicAttrs = []) : e.attrs || (e.attrs = [])).push(Rr({ name: t, value: n, dynamic: i }, r)), e.plain = !1 } function jr(e, t, n, r) { e.attrsMap[t] = n, e.attrsList.push(Rr({ name: t, value: n }, r)) } function Dr(e, t, n, r, i, o, a, s) { (e.directives || (e.directives = [])).push(Rr({ name: t, rawName: n, value: r, arg: i, isDynamicArg: o, modifiers: a }, s)), e.plain = !1 } function Lr(e, t, n) { return n ? "_p(" + t + ',"' + e + '")' : e + t } function Mr(t, n, r, i, o, a, s, c) { var u; (i = i || e).right ? c ? n = "(" + n + ")==='click'?'contextmenu':(" + n + ")" : "click" === n && (n = "contextmenu", delete i.right) : i.middle && (c ? n = "(" + n + ")==='click'?'mouseup':(" + n + ")" : "click" === n && (n = "mouseup")), i.capture && (delete i.capture, n = Lr("!", n, c)), i.once && (delete i.once, n = Lr("~", n, c)), i.passive && (delete i.passive, n = Lr("&", n, c)), i.native ? (delete i.native, u = t.nativeEvents || (t.nativeEvents = {})) : u = t.events || (t.events = {}); var l = Rr({ value: r.trim(), dynamic: c }, s); i !== e && (l.modifiers = i); var f = u[n]; Array.isArray(f) ? o ? f.unshift(l) : f.push(l) : u[n] = f ? o ? [l, f] : [f, l] : l, t.plain = !1 } function Ir(e, t, n) { var r = Fr(e, ":" + t) || Fr(e, "v-bind:" + t); if (null != r) return Ar(r); if (!1 !== n) { var i = Fr(e, t); if (null != i) return JSON.stringify(i) } } function Fr(e, t, n) { var r; if (null != (r = e.attrsMap[t])) for (var i = e.attrsList, o = 0, a = i.length; o < a; o++)if (i[o].name === t) { i.splice(o, 1); break } return n && delete e.attrsMap[t], r } function Pr(e, t) { for (var n = e.attrsList, r = 0, i = n.length; r < i; r++) { var o = n[r]; if (t.test(o.name)) return n.splice(r, 1), o } } function Rr(e, t) { return t && (null != t.start && (e.start = t.start), null != t.end && (e.end = t.end)), e } function Hr(e, t, n) { var r = n || {}, i = r.number, o = "$$v"; r.trim && (o = "(typeof $$v === 'string'? $$v.trim(): $$v)"), i && (o = "_n(" + o + ")"); var a = Br(t, o); e.model = { value: "(" + t + ")", expression: JSON.stringify(t), callback: "function ($$v) {" + a + "}" } } function Br(e, t) { var n = function (e) { if (e = e.trim(), gr = e.length, e.indexOf("[") < 0 || e.lastIndexOf("]") < gr - 1) return ($r = e.lastIndexOf(".")) > -1 ? { exp: e.slice(0, $r), key: '"' + e.slice($r + 1) + '"' } : { exp: e, key: null }; _r = e, $r = wr = Cr = 0; for (; !zr();)Vr(br = Ur()) ? Jr(br) : 91 === br && Kr(br); return { exp: e.slice(0, wr), key: e.slice(wr + 1, Cr) } }(e); return null === n.key ? e + "=" + t : "$set(" + n.exp + ", " + n.key + ", " + t + ")" } function Ur() { return _r.charCodeAt(++$r) } function zr() { return $r >= gr } function Vr(e) { return 34 === e || 39 === e } function Kr(e) { var t = 1; for (wr = $r; !zr();)if (Vr(e = Ur())) Jr(e); else if (91 === e && t++, 93 === e && t--, 0 === t) { Cr = $r; break } } function Jr(e) { for (var t = e; !zr() && (e = Ur()) !== t;); } var qr, Wr = "__r", Zr = "__c"; function Gr(e, t, n) { var r = qr; return function i() { null !== t.apply(null, arguments) && Qr(e, i, n, r) } } var Xr = Ve && !(X && Number(X[1]) <= 53); function Yr(e, t, n, r) { if (Xr) { var i = an, o = t; t = o._wrapper = function (e) { if (e.target === e.currentTarget || e.timeStamp >= i || e.timeStamp <= 0 || e.target.ownerDocument !== document) return o.apply(this, arguments) } } qr.addEventListener(e, t, Q ? { capture: n, passive: r } : n) } function Qr(e, t, n, r) { (r || qr).removeEventListener(e, t._wrapper || t, n) } function ei(e, r) { if (!t(e.data.on) || !t(r.data.on)) { var i = r.data.on || {}, o = e.data.on || {}; qr = r.elm, function (e) { if (n(e[Wr])) { var t = q ? "change" : "input"; e[t] = [].concat(e[Wr], e[t] || []), delete e[Wr] } n(e[Zr]) && (e.change = [].concat(e[Zr], e.change || []), delete e[Zr]) }(i), rt(i, o, Yr, Qr, Gr, r.context), qr = void 0 } } var ti, ni = { create: ei, update: ei }; function ri(e, r) { if (!t(e.data.domProps) || !t(r.data.domProps)) { var i, o, a = r.elm, s = e.data.domProps || {}, c = r.data.domProps || {}; for (i in n(c.__ob__) && (c = r.data.domProps = A({}, c)), s) i in c || (a[i] = ""); for (i in c) { if (o = c[i], "textContent" === i || "innerHTML" === i) { if (r.children && (r.children.length = 0), o === s[i]) continue; 1 === a.childNodes.length && a.removeChild(a.childNodes[0]) } if ("value" === i && "PROGRESS" !== a.tagName) { a._value = o; var u = t(o) ? "" : String(o); ii(a, u) && (a.value = u) } else if ("innerHTML" === i && qn(a.tagName) && t(a.innerHTML)) { (ti = ti || document.createElement("div")).innerHTML = "<svg>" + o + "</svg>"; for (var l = ti.firstChild; a.firstChild;)a.removeChild(a.firstChild); for (; l.firstChild;)a.appendChild(l.firstChild) } else if (o !== s[i]) try { a[i] = o } catch (e) { } } } } function ii(e, t) { return !e.composing && ("OPTION" === e.tagName || function (e, t) { var n = !0; try { n = document.activeElement !== e } catch (e) { } return n && e.value !== t }(e, t) || function (e, t) { var r = e.value, i = e._vModifiers; if (n(i)) { if (i.number) return f(r) !== f(t); if (i.trim) return r.trim() !== t.trim() } return r !== t }(e, t)) } var oi = { create: ri, update: ri }, ai = g(function (e) { var t = {}, n = /:(.+)/; return e.split(/;(?![^(]*\))/g).forEach(function (e) { if (e) { var r = e.split(n); r.length > 1 && (t[r[0].trim()] = r[1].trim()) } }), t }); function si(e) { var t = ci(e.style); return e.staticStyle ? A(e.staticStyle, t) : t } function ci(e) { return Array.isArray(e) ? O(e) : "string" == typeof e ? ai(e) : e } var ui, li = /^--/, fi = /\s*!important$/, pi = function (e, t, n) { if (li.test(t)) e.style.setProperty(t, n); else if (fi.test(n)) e.style.setProperty(C(t), n.replace(fi, ""), "important"); else { var r = vi(t); if (Array.isArray(n)) for (var i = 0, o = n.length; i < o; i++)e.style[r] = n[i]; else e.style[r] = n } }, di = ["Webkit", "Moz", "ms"], vi = g(function (e) { if (ui = ui || document.createElement("div").style, "filter" !== (e = b(e)) && e in ui) return e; for (var t = e.charAt(0).toUpperCase() + e.slice(1), n = 0; n < di.length; n++) { var r = di[n] + t; if (r in ui) return r } }); function hi(e, r) { var i = r.data, o = e.data; if (!(t(i.staticStyle) && t(i.style) && t(o.staticStyle) && t(o.style))) { var a, s, c = r.elm, u = o.staticStyle, l = o.normalizedStyle || o.style || {}, f = u || l, p = ci(r.data.style) || {}; r.data.normalizedStyle = n(p.__ob__) ? A({}, p) : p; var d = function (e, t) { var n, r = {}; if (t) for (var i = e; i.componentInstance;)(i = i.componentInstance._vnode) && i.data && (n = si(i.data)) && A(r, n); (n = si(e.data)) && A(r, n); for (var o = e; o = o.parent;)o.data && (n = si(o.data)) && A(r, n); return r }(r, !0); for (s in f) t(d[s]) && pi(c, s, ""); for (s in d) (a = d[s]) !== f[s] && pi(c, s, null == a ? "" : a) } } var mi = { create: hi, update: hi }, yi = /\s+/; function gi(e, t) { if (t && (t = t.trim())) if (e.classList) t.indexOf(" ") > -1 ? t.split(yi).forEach(function (t) { return e.classList.add(t) }) : e.classList.add(t); else { var n = " " + (e.getAttribute("class") || "") + " "; n.indexOf(" " + t + " ") < 0 && e.setAttribute("class", (n + t).trim()) } } function _i(e, t) { if (t && (t = t.trim())) if (e.classList) t.indexOf(" ") > -1 ? t.split(yi).forEach(function (t) { return e.classList.remove(t) }) : e.classList.remove(t), e.classList.length || e.removeAttribute("class"); else { for (var n = " " + (e.getAttribute("class") || "") + " ", r = " " + t + " "; n.indexOf(r) >= 0;)n = n.replace(r, " "); (n = n.trim()) ? e.setAttribute("class", n) : e.removeAttribute("class") } } function bi(e) { if (e) { if ("object" == typeof e) { var t = {}; return !1 !== e.css && A(t, $i(e.name || "v")), A(t, e), t } return "string" == typeof e ? $i(e) : void 0 } } var $i = g(function (e) { return { enterClass: e + "-enter", enterToClass: e + "-enter-to", enterActiveClass: e + "-enter-active", leaveClass: e + "-leave", leaveToClass: e + "-leave-to", leaveActiveClass: e + "-leave-active" } }), wi = z && !W, Ci = "transition", xi = "animation", ki = "transition", Ai = "transitionend", Oi = "animation", Si = "animationend"; wi && (void 0 === window.ontransitionend && void 0 !== window.onwebkittransitionend && (ki = "WebkitTransition", Ai = "webkitTransitionEnd"), void 0 === window.onanimationend && void 0 !== window.onwebkitanimationend && (Oi = "WebkitAnimation", Si = "webkitAnimationEnd")); var Ti = z ? window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout : function (e) { return e() }; function Ei(e) { Ti(function () { Ti(e) }) } function Ni(e, t) { var n = e._transitionClasses || (e._transitionClasses = []); n.indexOf(t) < 0 && (n.push(t), gi(e, t)) } function ji(e, t) { e._transitionClasses && h(e._transitionClasses, t), _i(e, t) } function Di(e, t, n) { var r = Mi(e, t), i = r.type, o = r.timeout, a = r.propCount; if (!i) return n(); var s = i === Ci ? Ai : Si, c = 0, u = function () { e.removeEventListener(s, l), n() }, l = function (t) { t.target === e && ++c >= a && u() }; setTimeout(function () { c < a && u() }, o + 1), e.addEventListener(s, l) } var Li = /\b(transform|all)(,|$)/; function Mi(e, t) { var n, r = window.getComputedStyle(e), i = (r[ki + "Delay"] || "").split(", "), o = (r[ki + "Duration"] || "").split(", "), a = Ii(i, o), s = (r[Oi + "Delay"] || "").split(", "), c = (r[Oi + "Duration"] || "").split(", "), u = Ii(s, c), l = 0, f = 0; return t === Ci ? a > 0 && (n = Ci, l = a, f = o.length) : t === xi ? u > 0 && (n = xi, l = u, f = c.length) : f = (n = (l = Math.max(a, u)) > 0 ? a > u ? Ci : xi : null) ? n === Ci ? o.length : c.length : 0, { type: n, timeout: l, propCount: f, hasTransform: n === Ci && Li.test(r[ki + "Property"]) } } function Ii(e, t) { for (; e.length < t.length;)e = e.concat(e); return Math.max.apply(null, t.map(function (t, n) { return Fi(t) + Fi(e[n]) })) } function Fi(e) { return 1e3 * Number(e.slice(0, -1).replace(",", ".")) } function Pi(e, r) { var i = e.elm; n(i._leaveCb) && (i._leaveCb.cancelled = !0, i._leaveCb()); var a = bi(e.data.transition); if (!t(a) && !n(i._enterCb) && 1 === i.nodeType) { for (var s = a.css, c = a.type, u = a.enterClass, l = a.enterToClass, p = a.enterActiveClass, d = a.appearClass, v = a.appearToClass, h = a.appearActiveClass, m = a.beforeEnter, y = a.enter, g = a.afterEnter, _ = a.enterCancelled, b = a.beforeAppear, $ = a.appear, w = a.afterAppear, C = a.appearCancelled, x = a.duration, k = Wt, A = Wt.$vnode; A && A.parent;)k = A.context, A = A.parent; var O = !k._isMounted || !e.isRootInsert; if (!O || $ || "" === $) { var S = O && d ? d : u, T = O && h ? h : p, E = O && v ? v : l, N = O && b || m, j = O && "function" == typeof $ ? $ : y, L = O && w || g, M = O && C || _, I = f(o(x) ? x.enter : x), F = !1 !== s && !W, P = Bi(j), R = i._enterCb = D(function () { F && (ji(i, E), ji(i, T)), R.cancelled ? (F && ji(i, S), M && M(i)) : L && L(i), i._enterCb = null }); e.data.show || it(e, "insert", function () { var t = i.parentNode, n = t && t._pending && t._pending[e.key]; n && n.tag === e.tag && n.elm._leaveCb && n.elm._leaveCb(), j && j(i, R) }), N && N(i), F && (Ni(i, S), Ni(i, T), Ei(function () { ji(i, S), R.cancelled || (Ni(i, E), P || (Hi(I) ? setTimeout(R, I) : Di(i, c, R))) })), e.data.show && (r && r(), j && j(i, R)), F || P || R() } } } function Ri(e, r) { var i = e.elm; n(i._enterCb) && (i._enterCb.cancelled = !0, i._enterCb()); var a = bi(e.data.transition); if (t(a) || 1 !== i.nodeType) return r(); if (!n(i._leaveCb)) { var s = a.css, c = a.type, u = a.leaveClass, l = a.leaveToClass, p = a.leaveActiveClass, d = a.beforeLeave, v = a.leave, h = a.afterLeave, m = a.leaveCancelled, y = a.delayLeave, g = a.duration, _ = !1 !== s && !W, b = Bi(v), $ = f(o(g) ? g.leave : g), w = i._leaveCb = D(function () { i.parentNode && i.parentNode._pending && (i.parentNode._pending[e.key] = null), _ && (ji(i, l), ji(i, p)), w.cancelled ? (_ && ji(i, u), m && m(i)) : (r(), h && h(i)), i._leaveCb = null }); y ? y(C) : C() } function C() { w.cancelled || (!e.data.show && i.parentNode && ((i.parentNode._pending || (i.parentNode._pending = {}))[e.key] = e), d && d(i), _ && (Ni(i, u), Ni(i, p), Ei(function () { ji(i, u), w.cancelled || (Ni(i, l), b || (Hi($) ? setTimeout(w, $) : Di(i, c, w))) })), v && v(i, w), _ || b || w()) } } function Hi(e) { return "number" == typeof e && !isNaN(e) } function Bi(e) { if (t(e)) return !1; var r = e.fns; return n(r) ? Bi(Array.isArray(r) ? r[0] : r) : (e._length || e.length) > 1 } function Ui(e, t) { !0 !== t.data.show && Pi(t) } var zi = function (e) { var o, a, s = {}, c = e.modules, u = e.nodeOps; for (o = 0; o < rr.length; ++o)for (s[rr[o]] = [], a = 0; a < c.length; ++a)n(c[a][rr[o]]) && s[rr[o]].push(c[a][rr[o]]); function l(e) { var t = u.parentNode(e); n(t) && u.removeChild(t, e) } function f(e, t, i, o, a, c, l) { if (n(e.elm) && n(c) && (e = c[l] = me(e)), e.isRootInsert = !a, !function (e, t, i, o) { var a = e.data; if (n(a)) { var c = n(e.componentInstance) && a.keepAlive; if (n(a = a.hook) && n(a = a.init) && a(e, !1), n(e.componentInstance)) return d(e, t), v(i, e.elm, o), r(c) && function (e, t, r, i) { for (var o, a = e; a.componentInstance;)if (a = a.componentInstance._vnode, n(o = a.data) && n(o = o.transition)) { for (o = 0; o < s.activate.length; ++o)s.activate[o](nr, a); t.push(a); break } v(r, e.elm, i) }(e, t, i, o), !0 } }(e, t, i, o)) { var f = e.data, p = e.children, m = e.tag; n(m) ? (e.elm = e.ns ? u.createElementNS(e.ns, m) : u.createElement(m, e), g(e), h(e, p, t), n(f) && y(e, t), v(i, e.elm, o)) : r(e.isComment) ? (e.elm = u.createComment(e.text), v(i, e.elm, o)) : (e.elm = u.createTextNode(e.text), v(i, e.elm, o)) } } function d(e, t) { n(e.data.pendingInsert) && (t.push.apply(t, e.data.pendingInsert), e.data.pendingInsert = null), e.elm = e.componentInstance.$el, m(e) ? (y(e, t), g(e)) : (tr(e), t.push(e)) } function v(e, t, r) { n(e) && (n(r) ? u.parentNode(r) === e && u.insertBefore(e, t, r) : u.appendChild(e, t)) } function h(e, t, n) { if (Array.isArray(t)) for (var r = 0; r < t.length; ++r)f(t[r], n, e.elm, null, !0, t, r); else i(e.text) && u.appendChild(e.elm, u.createTextNode(String(e.text))) } function m(e) { for (; e.componentInstance;)e = e.componentInstance._vnode; return n(e.tag) } function y(e, t) { for (var r = 0; r < s.create.length; ++r)s.create[r](nr, e); n(o = e.data.hook) && (n(o.create) && o.create(nr, e), n(o.insert) && t.push(e)) } function g(e) { var t; if (n(t = e.fnScopeId)) u.setStyleScope(e.elm, t); else for (var r = e; r;)n(t = r.context) && n(t = t.$options._scopeId) && u.setStyleScope(e.elm, t), r = r.parent; n(t = Wt) && t !== e.context && t !== e.fnContext && n(t = t.$options._scopeId) && u.setStyleScope(e.elm, t) } function _(e, t, n, r, i, o) { for (; r <= i; ++r)f(n[r], o, e, t, !1, n, r) } function b(e) { var t, r, i = e.data; if (n(i)) for (n(t = i.hook) && n(t = t.destroy) && t(e), t = 0; t < s.destroy.length; ++t)s.destroy[t](e); if (n(t = e.children)) for (r = 0; r < e.children.length; ++r)b(e.children[r]) } function $(e, t, r) { for (; t <= r; ++t) { var i = e[t]; n(i) && (n(i.tag) ? (w(i), b(i)) : l(i.elm)) } } function w(e, t) { if (n(t) || n(e.data)) { var r, i = s.remove.length + 1; for (n(t) ? t.listeners += i : t = function (e, t) { function n() { 0 == --n.listeners && l(e) } return n.listeners = t, n }(e.elm, i), n(r = e.componentInstance) && n(r = r._vnode) && n(r.data) && w(r, t), r = 0; r < s.remove.length; ++r)s.remove[r](e, t); n(r = e.data.hook) && n(r = r.remove) ? r(e, t) : t() } else l(e.elm) } function C(e, t, r, i) { for (var o = r; o < i; o++) { var a = t[o]; if (n(a) && ir(e, a)) return o } } function x(e, i, o, a, c, l) { if (e !== i) { n(i.elm) && n(a) && (i = a[c] = me(i)); var p = i.elm = e.elm; if (r(e.isAsyncPlaceholder)) n(i.asyncFactory.resolved) ? O(e.elm, i, o) : i.isAsyncPlaceholder = !0; else if (r(i.isStatic) && r(e.isStatic) && i.key === e.key && (r(i.isCloned) || r(i.isOnce))) i.componentInstance = e.componentInstance; else { var d, v = i.data; n(v) && n(d = v.hook) && n(d = d.prepatch) && d(e, i); var h = e.children, y = i.children; if (n(v) && m(i)) { for (d = 0; d < s.update.length; ++d)s.update[d](e, i); n(d = v.hook) && n(d = d.update) && d(e, i) } t(i.text) ? n(h) && n(y) ? h !== y && function (e, r, i, o, a) { for (var s, c, l, p = 0, d = 0, v = r.length - 1, h = r[0], m = r[v], y = i.length - 1, g = i[0], b = i[y], w = !a; p <= v && d <= y;)t(h) ? h = r[++p] : t(m) ? m = r[--v] : ir(h, g) ? (x(h, g, o, i, d), h = r[++p], g = i[++d]) : ir(m, b) ? (x(m, b, o, i, y), m = r[--v], b = i[--y]) : ir(h, b) ? (x(h, b, o, i, y), w && u.insertBefore(e, h.elm, u.nextSibling(m.elm)), h = r[++p], b = i[--y]) : ir(m, g) ? (x(m, g, o, i, d), w && u.insertBefore(e, m.elm, h.elm), m = r[--v], g = i[++d]) : (t(s) && (s = or(r, p, v)), t(c = n(g.key) ? s[g.key] : C(g, r, p, v)) ? f(g, o, e, h.elm, !1, i, d) : ir(l = r[c], g) ? (x(l, g, o, i, d), r[c] = void 0, w && u.insertBefore(e, l.elm, h.elm)) : f(g, o, e, h.elm, !1, i, d), g = i[++d]); p > v ? _(e, t(i[y + 1]) ? null : i[y + 1].elm, i, d, y, o) : d > y && $(r, p, v) }(p, h, y, o, l) : n(y) ? (n(e.text) && u.setTextContent(p, ""), _(p, null, y, 0, y.length - 1, o)) : n(h) ? $(h, 0, h.length - 1) : n(e.text) && u.setTextContent(p, "") : e.text !== i.text && u.setTextContent(p, i.text), n(v) && n(d = v.hook) && n(d = d.postpatch) && d(e, i) } } } function k(e, t, i) { if (r(i) && n(e.parent)) e.parent.data.pendingInsert = t; else for (var o = 0; o < t.length; ++o)t[o].data.hook.insert(t[o]) } var A = p("attrs,class,staticClass,staticStyle,key"); function O(e, t, i, o) { var a, s = t.tag, c = t.data, u = t.children; if (o = o || c && c.pre, t.elm = e, r(t.isComment) && n(t.asyncFactory)) return t.isAsyncPlaceholder = !0, !0; if (n(c) && (n(a = c.hook) && n(a = a.init) && a(t, !0), n(a = t.componentInstance))) return d(t, i), !0; if (n(s)) { if (n(u)) if (e.hasChildNodes()) if (n(a = c) && n(a = a.domProps) && n(a = a.innerHTML)) { if (a !== e.innerHTML) return !1 } else { for (var l = !0, f = e.firstChild, p = 0; p < u.length; p++) { if (!f || !O(f, u[p], i, o)) { l = !1; break } f = f.nextSibling } if (!l || f) return !1 } else h(t, u, i); if (n(c)) { var v = !1; for (var m in c) if (!A(m)) { v = !0, y(t, i); break } !v && c.class && et(c.class) } } else e.data !== t.text && (e.data = t.text); return !0 } return function (e, i, o, a) { if (!t(i)) { var c, l = !1, p = []; if (t(e)) l = !0, f(i, p); else { var d = n(e.nodeType); if (!d && ir(e, i)) x(e, i, p, null, null, a); else { if (d) { if (1 === e.nodeType && e.hasAttribute(L) && (e.removeAttribute(L), o = !0), r(o) && O(e, i, p)) return k(i, p, !0), e; c = e, e = new pe(u.tagName(c).toLowerCase(), {}, [], void 0, c) } var v = e.elm, h = u.parentNode(v); if (f(i, p, v._leaveCb ? null : h, u.nextSibling(v)), n(i.parent)) for (var y = i.parent, g = m(i); y;) { for (var _ = 0; _ < s.destroy.length; ++_)s.destroy[_](y); if (y.elm = i.elm, g) { for (var w = 0; w < s.create.length; ++w)s.create[w](nr, y); var C = y.data.hook.insert; if (C.merged) for (var A = 1; A < C.fns.length; A++)C.fns[A]() } else tr(y); y = y.parent } n(h) ? $([e], 0, 0) : n(e.tag) && b(e) } } return k(i, p, l), i.elm } n(e) && b(e) } }({ nodeOps: Qn, modules: [mr, xr, ni, oi, mi, z ? { create: Ui, activate: Ui, remove: function (e, t) { !0 !== e.data.show ? Ri(e, t) : t() } } : {}].concat(pr) }); W && document.addEventListener("selectionchange", function () { var e = document.activeElement; e && e.vmodel && Xi(e, "input") }); var Vi = { inserted: function (e, t, n, r) { "select" === n.tag ? (r.elm && !r.elm._vOptions ? it(n, "postpatch", function () { Vi.componentUpdated(e, t, n) }) : Ki(e, t, n.context), e._vOptions = [].map.call(e.options, Wi)) : ("textarea" === n.tag || Xn(e.type)) && (e._vModifiers = t.modifiers, t.modifiers.lazy || (e.addEventListener("compositionstart", Zi), e.addEventListener("compositionend", Gi), e.addEventListener("change", Gi), W && (e.vmodel = !0))) }, componentUpdated: function (e, t, n) { if ("select" === n.tag) { Ki(e, t, n.context); var r = e._vOptions, i = e._vOptions = [].map.call(e.options, Wi); if (i.some(function (e, t) { return !N(e, r[t]) })) (e.multiple ? t.value.some(function (e) { return qi(e, i) }) : t.value !== t.oldValue && qi(t.value, i)) && Xi(e, "change") } } }; function Ki(e, t, n) { Ji(e, t, n), (q || Z) && setTimeout(function () { Ji(e, t, n) }, 0) } function Ji(e, t, n) { var r = t.value, i = e.multiple; if (!i || Array.isArray(r)) { for (var o, a, s = 0, c = e.options.length; s < c; s++)if (a = e.options[s], i) o = j(r, Wi(a)) > -1, a.selected !== o && (a.selected = o); else if (N(Wi(a), r)) return void (e.selectedIndex !== s && (e.selectedIndex = s)); i || (e.selectedIndex = -1) } } function qi(e, t) { return t.every(function (t) { return !N(t, e) }) } function Wi(e) { return "_value" in e ? e._value : e.value } function Zi(e) { e.target.composing = !0 } function Gi(e) { e.target.composing && (e.target.composing = !1, Xi(e.target, "input")) } function Xi(e, t) { var n = document.createEvent("HTMLEvents"); n.initEvent(t, !0, !0), e.dispatchEvent(n) } function Yi(e) { return !e.componentInstance || e.data && e.data.transition ? e : Yi(e.componentInstance._vnode) } var Qi = { model: Vi, show: { bind: function (e, t, n) { var r = t.value, i = (n = Yi(n)).data && n.data.transition, o = e.__vOriginalDisplay = "none" === e.style.display ? "" : e.style.display; r && i ? (n.data.show = !0, Pi(n, function () { e.style.display = o })) : e.style.display = r ? o : "none" }, update: function (e, t, n) { var r = t.value; !r != !t.oldValue && ((n = Yi(n)).data && n.data.transition ? (n.data.show = !0, r ? Pi(n, function () { e.style.display = e.__vOriginalDisplay }) : Ri(n, function () { e.style.display = "none" })) : e.style.display = r ? e.__vOriginalDisplay : "none") }, unbind: function (e, t, n, r, i) { i || (e.style.display = e.__vOriginalDisplay) } } }, eo = { name: String, appear: Boolean, css: Boolean, mode: String, type: String, enterClass: String, leaveClass: String, enterToClass: String, leaveToClass: String, enterActiveClass: String, leaveActiveClass: String, appearClass: String, appearActiveClass: String, appearToClass: String, duration: [Number, String, Object] }; function to(e) { var t = e && e.componentOptions; return t && t.Ctor.options.abstract ? to(zt(t.children)) : e } function no(e) { var t = {}, n = e.$options; for (var r in n.propsData) t[r] = e[r]; var i = n._parentListeners; for (var o in i) t[b(o)] = i[o]; return t } function ro(e, t) { if (/\d-keep-alive$/.test(t.tag)) return e("keep-alive", { props: t.componentOptions.propsData }) } var io = function (e) { return e.tag || Ut(e) }, oo = function (e) { return "show" === e.name }, ao = { name: "transition", props: eo, abstract: !0, render: function (e) { var t = this, n = this.$slots.default; if (n && (n = n.filter(io)).length) { var r = this.mode, o = n[0]; if (function (e) { for (; e = e.parent;)if (e.data.transition) return !0 }(this.$vnode)) return o; var a = to(o); if (!a) return o; if (this._leaving) return ro(e, o); var s = "__transition-" + this._uid + "-"; a.key = null == a.key ? a.isComment ? s + "comment" : s + a.tag : i(a.key) ? 0 === String(a.key).indexOf(s) ? a.key : s + a.key : a.key; var c = (a.data || (a.data = {})).transition = no(this), u = this._vnode, l = to(u); if (a.data.directives && a.data.directives.some(oo) && (a.data.show = !0), l && l.data && !function (e, t) { return t.key === e.key && t.tag === e.tag }(a, l) && !Ut(l) && (!l.componentInstance || !l.componentInstance._vnode.isComment)) { var f = l.data.transition = A({}, c); if ("out-in" === r) return this._leaving = !0, it(f, "afterLeave", function () { t._leaving = !1, t.$forceUpdate() }), ro(e, o); if ("in-out" === r) { if (Ut(a)) return u; var p, d = function () { p() }; it(c, "afterEnter", d), it(c, "enterCancelled", d), it(f, "delayLeave", function (e) { p = e }) } } return o } } }, so = A({ tag: String, moveClass: String }, eo); function co(e) { e.elm._moveCb && e.elm._moveCb(), e.elm._enterCb && e.elm._enterCb() } function uo(e) { e.data.newPos = e.elm.getBoundingClientRect() } function lo(e) { var t = e.data.pos, n = e.data.newPos, r = t.left - n.left, i = t.top - n.top; if (r || i) { e.data.moved = !0; var o = e.elm.style; o.transform = o.WebkitTransform = "translate(" + r + "px," + i + "px)", o.transitionDuration = "0s" } } delete so.mode; var fo = { Transition: ao, TransitionGroup: { props: so, beforeMount: function () { var e = this, t = this._update; this._update = function (n, r) { var i = Zt(e); e.__patch__(e._vnode, e.kept, !1, !0), e._vnode = e.kept, i(), t.call(e, n, r) } }, render: function (e) { for (var t = this.tag || this.$vnode.data.tag || "span", n = Object.create(null), r = this.prevChildren = this.children, i = this.$slots.default || [], o = this.children = [], a = no(this), s = 0; s < i.length; s++) { var c = i[s]; c.tag && null != c.key && 0 !== String(c.key).indexOf("__vlist") && (o.push(c), n[c.key] = c, (c.data || (c.data = {})).transition = a) } if (r) { for (var u = [], l = [], f = 0; f < r.length; f++) { var p = r[f]; p.data.transition = a, p.data.pos = p.elm.getBoundingClientRect(), n[p.key] ? u.push(p) : l.push(p) } this.kept = e(t, null, u), this.removed = l } return e(t, null, o) }, updated: function () { var e = this.prevChildren, t = this.moveClass || (this.name || "v") + "-move"; e.length && this.hasMove(e[0].elm, t) && (e.forEach(co), e.forEach(uo), e.forEach(lo), this._reflow = document.body.offsetHeight, e.forEach(function (e) { if (e.data.moved) { var n = e.elm, r = n.style; Ni(n, t), r.transform = r.WebkitTransform = r.transitionDuration = "", n.addEventListener(Ai, n._moveCb = function e(r) { r && r.target !== n || r && !/transform$/.test(r.propertyName) || (n.removeEventListener(Ai, e), n._moveCb = null, ji(n, t)) }) } })) }, methods: { hasMove: function (e, t) { if (!wi) return !1; if (this._hasMove) return this._hasMove; var n = e.cloneNode(); e._transitionClasses && e._transitionClasses.forEach(function (e) { _i(n, e) }), gi(n, t), n.style.display = "none", this.$el.appendChild(n); var r = Mi(n); return this.$el.removeChild(n), this._hasMove = r.hasTransform } } } }; wn.config.mustUseProp = jn, wn.config.isReservedTag = Wn, wn.config.isReservedAttr = En, wn.config.getTagNamespace = Zn, wn.config.isUnknownElement = function (e) { if (!z) return !0; if (Wn(e)) return !1; if (e = e.toLowerCase(), null != Gn[e]) return Gn[e]; var t = document.createElement(e); return e.indexOf("-") > -1 ? Gn[e] = t.constructor === window.HTMLUnknownElement || t.constructor === window.HTMLElement : Gn[e] = /HTMLUnknownElement/.test(t.toString()) }, A(wn.options.directives, Qi), A(wn.options.components, fo), wn.prototype.__patch__ = z ? zi : S, wn.prototype.$mount = function (e, t) { return function (e, t, n) { var r; return e.$el = t, e.$options.render || (e.$options.render = ve), Yt(e, "beforeMount"), r = function () { e._update(e._render(), n) }, new fn(e, r, S, { before: function () { e._isMounted && !e._isDestroyed && Yt(e, "beforeUpdate") } }, !0), n = !1, null == e.$vnode && (e._isMounted = !0, Yt(e, "mounted")), e }(this, e = e && z ? Yn(e) : void 0, t) }, z && setTimeout(function () { F.devtools && ne && ne.emit("init", wn) }, 0); var po = /\{\{((?:.|\r?\n)+?)\}\}/g, vo = /[-.*+?^${}()|[\]\/\\]/g, ho = g(function (e) { var t = e[0].replace(vo, "\\$&"), n = e[1].replace(vo, "\\$&"); return new RegExp(t + "((?:.|\\n)+?)" + n, "g") }); var mo = { staticKeys: ["staticClass"], transformNode: function (e, t) { t.warn; var n = Fr(e, "class"); n && (e.staticClass = JSON.stringify(n)); var r = Ir(e, "class", !1); r && (e.classBinding = r) }, genData: function (e) { var t = ""; return e.staticClass && (t += "staticClass:" + e.staticClass + ","), e.classBinding && (t += "class:" + e.classBinding + ","), t } }; var yo, go = { staticKeys: ["staticStyle"], transformNode: function (e, t) { t.warn; var n = Fr(e, "style"); n && (e.staticStyle = JSON.stringify(ai(n))); var r = Ir(e, "style", !1); r && (e.styleBinding = r) }, genData: function (e) { var t = ""; return e.staticStyle && (t += "staticStyle:" + e.staticStyle + ","), e.styleBinding && (t += "style:(" + e.styleBinding + "),"), t } }, _o = function (e) { return (yo = yo || document.createElement("div")).innerHTML = e, yo.textContent }, bo = p("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"), $o = p("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"), wo = p("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"), Co = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/, xo = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/, ko = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + P.source + "]*", Ao = "((?:" + ko + "\\:)?" + ko + ")", Oo = new RegExp("^<" + Ao), So = /^\s*(\/?)>/, To = new RegExp("^<\\/" + Ao + "[^>]*>"), Eo = /^<!DOCTYPE [^>]+>/i, No = /^<!\--/, jo = /^<!\[/, Do = p("script,style,textarea", !0), Lo = {}, Mo = { "&lt;": "<", "&gt;": ">", "&quot;": '"', "&amp;": "&", "&#10;": "\n", "&#9;": "\t", "&#39;": "'" }, Io = /&(?:lt|gt|quot|amp|#39);/g, Fo = /&(?:lt|gt|quot|amp|#39|#10|#9);/g, Po = p("pre,textarea", !0), Ro = function (e, t) { return e && Po(e) && "\n" === t[0] }; function Ho(e, t) { var n = t ? Fo : Io; return e.replace(n, function (e) { return Mo[e] }) } var Bo, Uo, zo, Vo, Ko, Jo, qo, Wo, Zo = /^@|^v-on:/, Go = /^v-|^@|^:|^#/, Xo = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/, Yo = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/, Qo = /^\(|\)$/g, ea = /^\[.*\]$/, ta = /:(.*)$/, na = /^:|^\.|^v-bind:/, ra = /\.[^.\]]+(?=[^\]]*$)/g, ia = /^v-slot(:|$)|^#/, oa = /[\r\n]/, aa = /\s+/g, sa = g(_o), ca = "_empty_"; function ua(e, t, n) { return { type: 1, tag: e, attrsList: t, attrsMap: ma(t), rawAttrsMap: {}, parent: n, children: [] } } function la(e, t) { Bo = t.warn || Sr, Jo = t.isPreTag || T, qo = t.mustUseProp || T, Wo = t.getTagNamespace || T; t.isReservedTag; zo = Tr(t.modules, "transformNode"), Vo = Tr(t.modules, "preTransformNode"), Ko = Tr(t.modules, "postTransformNode"), Uo = t.delimiters; var n, r, i = [], o = !1 !== t.preserveWhitespace, a = t.whitespace, s = !1, c = !1; function u(e) { if (l(e), s || e.processed || (e = fa(e, t)), i.length || e === n || n.if && (e.elseif || e.else) && da(n, { exp: e.elseif, block: e }), r && !e.forbidden) if (e.elseif || e.else) a = e, (u = function (e) { var t = e.length; for (; t--;) { if (1 === e[t].type) return e[t]; e.pop() } }(r.children)) && u.if && da(u, { exp: a.elseif, block: a }); else { if (e.slotScope) { var o = e.slotTarget || '"default"'; (r.scopedSlots || (r.scopedSlots = {}))[o] = e } r.children.push(e), e.parent = r } var a, u; e.children = e.children.filter(function (e) { return !e.slotScope }), l(e), e.pre && (s = !1), Jo(e.tag) && (c = !1); for (var f = 0; f < Ko.length; f++)Ko[f](e, t) } function l(e) { if (!c) for (var t; (t = e.children[e.children.length - 1]) && 3 === t.type && " " === t.text;)e.children.pop() } return function (e, t) { for (var n, r, i = [], o = t.expectHTML, a = t.isUnaryTag || T, s = t.canBeLeftOpenTag || T, c = 0; e;) { if (n = e, r && Do(r)) { var u = 0, l = r.toLowerCase(), f = Lo[l] || (Lo[l] = new RegExp("([\\s\\S]*?)(</" + l + "[^>]*>)", "i")), p = e.replace(f, function (e, n, r) { return u = r.length, Do(l) || "noscript" === l || (n = n.replace(/<!\--([\s\S]*?)-->/g, "$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g, "$1")), Ro(l, n) && (n = n.slice(1)), t.chars && t.chars(n), "" }); c += e.length - p.length, e = p, A(l, c - u, c) } else { var d = e.indexOf("<"); if (0 === d) { if (No.test(e)) { var v = e.indexOf("--\x3e"); if (v >= 0) { t.shouldKeepComment && t.comment(e.substring(4, v), c, c + v + 3), C(v + 3); continue } } if (jo.test(e)) { var h = e.indexOf("]>"); if (h >= 0) { C(h + 2); continue } } var m = e.match(Eo); if (m) { C(m[0].length); continue } var y = e.match(To); if (y) { var g = c; C(y[0].length), A(y[1], g, c); continue } var _ = x(); if (_) { k(_), Ro(_.tagName, e) && C(1); continue } } var b = void 0, $ = void 0, w = void 0; if (d >= 0) { for ($ = e.slice(d); !(To.test($) || Oo.test($) || No.test($) || jo.test($) || (w = $.indexOf("<", 1)) < 0);)d += w, $ = e.slice(d); b = e.substring(0, d) } d < 0 && (b = e), b && C(b.length), t.chars && b && t.chars(b, c - b.length, c) } if (e === n) { t.chars && t.chars(e); break } } function C(t) { c += t, e = e.substring(t) } function x() { var t = e.match(Oo); if (t) { var n, r, i = { tagName: t[1], attrs: [], start: c }; for (C(t[0].length); !(n = e.match(So)) && (r = e.match(xo) || e.match(Co));)r.start = c, C(r[0].length), r.end = c, i.attrs.push(r); if (n) return i.unarySlash = n[1], C(n[0].length), i.end = c, i } } function k(e) { var n = e.tagName, c = e.unarySlash; o && ("p" === r && wo(n) && A(r), s(n) && r === n && A(n)); for (var u = a(n) || !!c, l = e.attrs.length, f = new Array(l), p = 0; p < l; p++) { var d = e.attrs[p], v = d[3] || d[4] || d[5] || "", h = "a" === n && "href" === d[1] ? t.shouldDecodeNewlinesForHref : t.shouldDecodeNewlines; f[p] = { name: d[1], value: Ho(v, h) } } u || (i.push({ tag: n, lowerCasedTag: n.toLowerCase(), attrs: f, start: e.start, end: e.end }), r = n), t.start && t.start(n, f, u, e.start, e.end) } function A(e, n, o) { var a, s; if (null == n && (n = c), null == o && (o = c), e) for (s = e.toLowerCase(), a = i.length - 1; a >= 0 && i[a].lowerCasedTag !== s; a--); else a = 0; if (a >= 0) { for (var u = i.length - 1; u >= a; u--)t.end && t.end(i[u].tag, n, o); i.length = a, r = a && i[a - 1].tag } else "br" === s ? t.start && t.start(e, [], !0, n, o) : "p" === s && (t.start && t.start(e, [], !1, n, o), t.end && t.end(e, n, o)) } A() }(e, { warn: Bo, expectHTML: t.expectHTML, isUnaryTag: t.isUnaryTag, canBeLeftOpenTag: t.canBeLeftOpenTag, shouldDecodeNewlines: t.shouldDecodeNewlines, shouldDecodeNewlinesForHref: t.shouldDecodeNewlinesForHref, shouldKeepComment: t.comments, outputSourceRange: t.outputSourceRange, start: function (e, o, a, l, f) { var p = r && r.ns || Wo(e); q && "svg" === p && (o = function (e) { for (var t = [], n = 0; n < e.length; n++) { var r = e[n]; ya.test(r.name) || (r.name = r.name.replace(ga, ""), t.push(r)) } return t }(o)); var d, v = ua(e, o, r); p && (v.ns = p), "style" !== (d = v).tag && ("script" !== d.tag || d.attrsMap.type && "text/javascript" !== d.attrsMap.type) || te() || (v.forbidden = !0); for (var h = 0; h < Vo.length; h++)v = Vo[h](v, t) || v; s || (!function (e) { null != Fr(e, "v-pre") && (e.pre = !0) }(v), v.pre && (s = !0)), Jo(v.tag) && (c = !0), s ? function (e) { var t = e.attrsList, n = t.length; if (n) for (var r = e.attrs = new Array(n), i = 0; i < n; i++)r[i] = { name: t[i].name, value: JSON.stringify(t[i].value) }, null != t[i].start && (r[i].start = t[i].start, r[i].end = t[i].end); else e.pre || (e.plain = !0) }(v) : v.processed || (pa(v), function (e) { var t = Fr(e, "v-if"); if (t) e.if = t, da(e, { exp: t, block: e }); else { null != Fr(e, "v-else") && (e.else = !0); var n = Fr(e, "v-else-if"); n && (e.elseif = n) } }(v), function (e) { null != Fr(e, "v-once") && (e.once = !0) }(v)), n || (n = v), a ? u(v) : (r = v, i.push(v)) }, end: function (e, t, n) { var o = i[i.length - 1]; i.length -= 1, r = i[i.length - 1], u(o) }, chars: function (e, t, n) { if (r && (!q || "textarea" !== r.tag || r.attrsMap.placeholder !== e)) { var i, u, l, f = r.children; if (e = c || e.trim() ? "script" === (i = r).tag || "style" === i.tag ? e : sa(e) : f.length ? a ? "condense" === a && oa.test(e) ? "" : " " : o ? " " : "" : "") c || "condense" !== a || (e = e.replace(aa, " ")), !s && " " !== e && (u = function (e, t) { var n = t ? ho(t) : po; if (n.test(e)) { for (var r, i, o, a = [], s = [], c = n.lastIndex = 0; r = n.exec(e);) { (i = r.index) > c && (s.push(o = e.slice(c, i)), a.push(JSON.stringify(o))); var u = Ar(r[1].trim()); a.push("_s(" + u + ")"), s.push({ "@binding": u }), c = i + r[0].length } return c < e.length && (s.push(o = e.slice(c)), a.push(JSON.stringify(o))), { expression: a.join("+"), tokens: s } } }(e, Uo)) ? l = { type: 2, expression: u.expression, tokens: u.tokens, text: e } : " " === e && f.length && " " === f[f.length - 1].text || (l = { type: 3, text: e }), l && f.push(l) } }, comment: function (e, t, n) { if (r) { var i = { type: 3, text: e, isComment: !0 }; r.children.push(i) } } }), n } function fa(e, t) { var n, r; (r = Ir(n = e, "key")) && (n.key = r), e.plain = !e.key && !e.scopedSlots && !e.attrsList.length, function (e) { var t = Ir(e, "ref"); t && (e.ref = t, e.refInFor = function (e) { var t = e; for (; t;) { if (void 0 !== t.for) return !0; t = t.parent } return !1 }(e)) }(e), function (e) { var t; "template" === e.tag ? (t = Fr(e, "scope"), e.slotScope = t || Fr(e, "slot-scope")) : (t = Fr(e, "slot-scope")) && (e.slotScope = t); var n = Ir(e, "slot"); n && (e.slotTarget = '""' === n ? '"default"' : n, e.slotTargetDynamic = !(!e.attrsMap[":slot"] && !e.attrsMap["v-bind:slot"]), "template" === e.tag || e.slotScope || Nr(e, "slot", n, function (e, t) { return e.rawAttrsMap[":" + t] || e.rawAttrsMap["v-bind:" + t] || e.rawAttrsMap[t] }(e, "slot"))); if ("template" === e.tag) { var r = Pr(e, ia); if (r) { var i = va(r), o = i.name, a = i.dynamic; e.slotTarget = o, e.slotTargetDynamic = a, e.slotScope = r.value || ca } } else { var s = Pr(e, ia); if (s) { var c = e.scopedSlots || (e.scopedSlots = {}), u = va(s), l = u.name, f = u.dynamic, p = c[l] = ua("template", [], e); p.slotTarget = l, p.slotTargetDynamic = f, p.children = e.children.filter(function (e) { if (!e.slotScope) return e.parent = p, !0 }), p.slotScope = s.value || ca, e.children = [], e.plain = !1 } } }(e), function (e) { "slot" === e.tag && (e.slotName = Ir(e, "name")) }(e), function (e) { var t; (t = Ir(e, "is")) && (e.component = t); null != Fr(e, "inline-template") && (e.inlineTemplate = !0) }(e); for (var i = 0; i < zo.length; i++)e = zo[i](e, t) || e; return function (e) { var t, n, r, i, o, a, s, c, u = e.attrsList; for (t = 0, n = u.length; t < n; t++)if (r = i = u[t].name, o = u[t].value, Go.test(r)) if (e.hasBindings = !0, (a = ha(r.replace(Go, ""))) && (r = r.replace(ra, "")), na.test(r)) r = r.replace(na, ""), o = Ar(o), (c = ea.test(r)) && (r = r.slice(1, -1)), a && (a.prop && !c && "innerHtml" === (r = b(r)) && (r = "innerHTML"), a.camel && !c && (r = b(r)), a.sync && (s = Br(o, "$event"), c ? Mr(e, '"update:"+(' + r + ")", s, null, !1, 0, u[t], !0) : (Mr(e, "update:" + b(r), s, null, !1, 0, u[t]), C(r) !== b(r) && Mr(e, "update:" + C(r), s, null, !1, 0, u[t])))), a && a.prop || !e.component && qo(e.tag, e.attrsMap.type, r) ? Er(e, r, o, u[t], c) : Nr(e, r, o, u[t], c); else if (Zo.test(r)) r = r.replace(Zo, ""), (c = ea.test(r)) && (r = r.slice(1, -1)), Mr(e, r, o, a, !1, 0, u[t], c); else { var l = (r = r.replace(Go, "")).match(ta), f = l && l[1]; c = !1, f && (r = r.slice(0, -(f.length + 1)), ea.test(f) && (f = f.slice(1, -1), c = !0)), Dr(e, r, i, o, f, c, a, u[t]) } else Nr(e, r, JSON.stringify(o), u[t]), !e.component && "muted" === r && qo(e.tag, e.attrsMap.type, r) && Er(e, r, "true", u[t]) }(e), e } function pa(e) { var t; if (t = Fr(e, "v-for")) { var n = function (e) { var t = e.match(Xo); if (!t) return; var n = {}; n.for = t[2].trim(); var r = t[1].trim().replace(Qo, ""), i = r.match(Yo); i ? (n.alias = r.replace(Yo, "").trim(), n.iterator1 = i[1].trim(), i[2] && (n.iterator2 = i[2].trim())) : n.alias = r; return n }(t); n && A(e, n) } } function da(e, t) { e.ifConditions || (e.ifConditions = []), e.ifConditions.push(t) } function va(e) { var t = e.name.replace(ia, ""); return t || "#" !== e.name[0] && (t = "default"), ea.test(t) ? { name: t.slice(1, -1), dynamic: !0 } : { name: '"' + t + '"', dynamic: !1 } } function ha(e) { var t = e.match(ra); if (t) { var n = {}; return t.forEach(function (e) { n[e.slice(1)] = !0 }), n } } function ma(e) { for (var t = {}, n = 0, r = e.length; n < r; n++)t[e[n].name] = e[n].value; return t } var ya = /^xmlns:NS\d+/, ga = /^NS\d+:/; function _a(e) { return ua(e.tag, e.attrsList.slice(), e.parent) } var ba = [mo, go, { preTransformNode: function (e, t) { if ("input" === e.tag) { var n, r = e.attrsMap; if (!r["v-model"]) return; if ((r[":type"] || r["v-bind:type"]) && (n = Ir(e, "type")), r.type || n || !r["v-bind"] || (n = "(" + r["v-bind"] + ").type"), n) { var i = Fr(e, "v-if", !0), o = i ? "&&(" + i + ")" : "", a = null != Fr(e, "v-else", !0), s = Fr(e, "v-else-if", !0), c = _a(e); pa(c), jr(c, "type", "checkbox"), fa(c, t), c.processed = !0, c.if = "(" + n + ")==='checkbox'" + o, da(c, { exp: c.if, block: c }); var u = _a(e); Fr(u, "v-for", !0), jr(u, "type", "radio"), fa(u, t), da(c, { exp: "(" + n + ")==='radio'" + o, block: u }); var l = _a(e); return Fr(l, "v-for", !0), jr(l, ":type", n), fa(l, t), da(c, { exp: i, block: l }), a ? c.else = !0 : s && (c.elseif = s), c } } } }]; var $a, wa, Ca = { expectHTML: !0, modules: ba, directives: { model: function (e, t, n) { var r = t.value, i = t.modifiers, o = e.tag, a = e.attrsMap.type; if (e.component) return Hr(e, r, i), !1; if ("select" === o) !function (e, t, n) { var r = 'var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return ' + (n && n.number ? "_n(val)" : "val") + "});"; r = r + " " + Br(t, "$event.target.multiple ? $$selectedVal : $$selectedVal[0]"), Mr(e, "change", r, null, !0) }(e, r, i); else if ("input" === o && "checkbox" === a) !function (e, t, n) { var r = n && n.number, i = Ir(e, "value") || "null", o = Ir(e, "true-value") || "true", a = Ir(e, "false-value") || "false"; Er(e, "checked", "Array.isArray(" + t + ")?_i(" + t + "," + i + ")>-1" + ("true" === o ? ":(" + t + ")" : ":_q(" + t + "," + o + ")")), Mr(e, "change", "var $$a=" + t + ",$$el=$event.target,$$c=$$el.checked?(" + o + "):(" + a + ");if(Array.isArray($$a)){var $$v=" + (r ? "_n(" + i + ")" : i) + ",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&(" + Br(t, "$$a.concat([$$v])") + ")}else{$$i>-1&&(" + Br(t, "$$a.slice(0,$$i).concat($$a.slice($$i+1))") + ")}}else{" + Br(t, "$$c") + "}", null, !0) }(e, r, i); else if ("input" === o && "radio" === a) !function (e, t, n) { var r = n && n.number, i = Ir(e, "value") || "null"; Er(e, "checked", "_q(" + t + "," + (i = r ? "_n(" + i + ")" : i) + ")"), Mr(e, "change", Br(t, i), null, !0) }(e, r, i); else if ("input" === o || "textarea" === o) !function (e, t, n) { var r = e.attrsMap.type, i = n || {}, o = i.lazy, a = i.number, s = i.trim, c = !o && "range" !== r, u = o ? "change" : "range" === r ? Wr : "input", l = "$event.target.value"; s && (l = "$event.target.value.trim()"), a && (l = "_n(" + l + ")"); var f = Br(t, l); c && (f = "if($event.target.composing)return;" + f), Er(e, "value", "(" + t + ")"), Mr(e, u, f, null, !0), (s || a) && Mr(e, "blur", "$forceUpdate()") }(e, r, i); else if (!F.isReservedTag(o)) return Hr(e, r, i), !1; return !0 }, text: function (e, t) { t.value && Er(e, "textContent", "_s(" + t.value + ")", t) }, html: function (e, t) { t.value && Er(e, "innerHTML", "_s(" + t.value + ")", t) } }, isPreTag: function (e) { return "pre" === e }, isUnaryTag: bo, mustUseProp: jn, canBeLeftOpenTag: $o, isReservedTag: Wn, getTagNamespace: Zn, staticKeys: function (e) { return e.reduce(function (e, t) { return e.concat(t.staticKeys || []) }, []).join(",") }(ba) }, xa = g(function (e) { return p("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap" + (e ? "," + e : "")) }); function ka(e, t) { e && ($a = xa(t.staticKeys || ""), wa = t.isReservedTag || T, function e(t) { t.static = function (e) { if (2 === e.type) return !1; if (3 === e.type) return !0; return !(!e.pre && (e.hasBindings || e.if || e.for || d(e.tag) || !wa(e.tag) || function (e) { for (; e.parent;) { if ("template" !== (e = e.parent).tag) return !1; if (e.for) return !0 } return !1 }(e) || !Object.keys(e).every($a))) }(t); if (1 === t.type) { if (!wa(t.tag) && "slot" !== t.tag && null == t.attrsMap["inline-template"]) return; for (var n = 0, r = t.children.length; n < r; n++) { var i = t.children[n]; e(i), i.static || (t.static = !1) } if (t.ifConditions) for (var o = 1, a = t.ifConditions.length; o < a; o++) { var s = t.ifConditions[o].block; e(s), s.static || (t.static = !1) } } }(e), function e(t, n) { if (1 === t.type) { if ((t.static || t.once) && (t.staticInFor = n), t.static && t.children.length && (1 !== t.children.length || 3 !== t.children[0].type)) return void (t.staticRoot = !0); if (t.staticRoot = !1, t.children) for (var r = 0, i = t.children.length; r < i; r++)e(t.children[r], n || !!t.for); if (t.ifConditions) for (var o = 1, a = t.ifConditions.length; o < a; o++)e(t.ifConditions[o].block, n) } }(e, !1)) } var Aa = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/, Oa = /\([^)]*?\);*$/, Sa = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/, Ta = { esc: 27, tab: 9, enter: 13, space: 32, up: 38, left: 37, right: 39, down: 40, delete: [8, 46] }, Ea = { esc: ["Esc", "Escape"], tab: "Tab", enter: "Enter", space: [" ", "Spacebar"], up: ["Up", "ArrowUp"], left: ["Left", "ArrowLeft"], right: ["Right", "ArrowRight"], down: ["Down", "ArrowDown"], delete: ["Backspace", "Delete", "Del"] }, Na = function (e) { return "if(" + e + ")return null;" }, ja = { stop: "$event.stopPropagation();", prevent: "$event.preventDefault();", self: Na("$event.target !== $event.currentTarget"), ctrl: Na("!$event.ctrlKey"), shift: Na("!$event.shiftKey"), alt: Na("!$event.altKey"), meta: Na("!$event.metaKey"), left: Na("'button' in $event && $event.button !== 0"), middle: Na("'button' in $event && $event.button !== 1"), right: Na("'button' in $event && $event.button !== 2") }; function Da(e, t) { var n = t ? "nativeOn:" : "on:", r = "", i = ""; for (var o in e) { var a = La(e[o]); e[o] && e[o].dynamic ? i += o + "," + a + "," : r += '"' + o + '":' + a + "," } return r = "{" + r.slice(0, -1) + "}", i ? n + "_d(" + r + ",[" + i.slice(0, -1) + "])" : n + r } function La(e) { if (!e) return "function(){}"; if (Array.isArray(e)) return "[" + e.map(function (e) { return La(e) }).join(",") + "]"; var t = Sa.test(e.value), n = Aa.test(e.value), r = Sa.test(e.value.replace(Oa, "")); if (e.modifiers) { var i = "", o = "", a = []; for (var s in e.modifiers) if (ja[s]) o += ja[s], Ta[s] && a.push(s); else if ("exact" === s) { var c = e.modifiers; o += Na(["ctrl", "shift", "alt", "meta"].filter(function (e) { return !c[e] }).map(function (e) { return "$event." + e + "Key" }).join("||")) } else a.push(s); return a.length && (i += function (e) { return "if(!$event.type.indexOf('key')&&" + e.map(Ma).join("&&") + ")return null;" }(a)), o && (i += o), "function($event){" + i + (t ? "return " + e.value + "($event)" : n ? "return (" + e.value + ")($event)" : r ? "return " + e.value : e.value) + "}" } return t || n ? e.value : "function($event){" + (r ? "return " + e.value : e.value) + "}" } function Ma(e) { var t = parseInt(e, 10); if (t) return "$event.keyCode!==" + t; var n = Ta[e], r = Ea[e]; return "_k($event.keyCode," + JSON.stringify(e) + "," + JSON.stringify(n) + ",$event.key," + JSON.stringify(r) + ")" } var Ia = { on: function (e, t) { e.wrapListeners = function (e) { return "_g(" + e + "," + t.value + ")" } }, bind: function (e, t) { e.wrapData = function (n) { return "_b(" + n + ",'" + e.tag + "'," + t.value + "," + (t.modifiers && t.modifiers.prop ? "true" : "false") + (t.modifiers && t.modifiers.sync ? ",true" : "") + ")" } }, cloak: S }, Fa = function (e) { this.options = e, this.warn = e.warn || Sr, this.transforms = Tr(e.modules, "transformCode"), this.dataGenFns = Tr(e.modules, "genData"), this.directives = A(A({}, Ia), e.directives); var t = e.isReservedTag || T; this.maybeComponent = function (e) { return !!e.component || !t(e.tag) }, this.onceId = 0, this.staticRenderFns = [], this.pre = !1 }; function Pa(e, t) { var n = new Fa(t); return { render: "with(this){return " + (e ? Ra(e, n) : '_c("div")') + "}", staticRenderFns: n.staticRenderFns } } function Ra(e, t) { if (e.parent && (e.pre = e.pre || e.parent.pre), e.staticRoot && !e.staticProcessed) return Ha(e, t); if (e.once && !e.onceProcessed) return Ba(e, t); if (e.for && !e.forProcessed) return za(e, t); if (e.if && !e.ifProcessed) return Ua(e, t); if ("template" !== e.tag || e.slotTarget || t.pre) { if ("slot" === e.tag) return function (e, t) { var n = e.slotName || '"default"', r = qa(e, t), i = "_t(" + n + (r ? "," + r : ""), o = e.attrs || e.dynamicAttrs ? Ga((e.attrs || []).concat(e.dynamicAttrs || []).map(function (e) { return { name: b(e.name), value: e.value, dynamic: e.dynamic } })) : null, a = e.attrsMap["v-bind"]; !o && !a || r || (i += ",null"); o && (i += "," + o); a && (i += (o ? "" : ",null") + "," + a); return i + ")" }(e, t); var n; if (e.component) n = function (e, t, n) { var r = t.inlineTemplate ? null : qa(t, n, !0); return "_c(" + e + "," + Va(t, n) + (r ? "," + r : "") + ")" }(e.component, e, t); else { var r; (!e.plain || e.pre && t.maybeComponent(e)) && (r = Va(e, t)); var i = e.inlineTemplate ? null : qa(e, t, !0); n = "_c('" + e.tag + "'" + (r ? "," + r : "") + (i ? "," + i : "") + ")" } for (var o = 0; o < t.transforms.length; o++)n = t.transforms[o](e, n); return n } return qa(e, t) || "void 0" } function Ha(e, t) { e.staticProcessed = !0; var n = t.pre; return e.pre && (t.pre = e.pre), t.staticRenderFns.push("with(this){return " + Ra(e, t) + "}"), t.pre = n, "_m(" + (t.staticRenderFns.length - 1) + (e.staticInFor ? ",true" : "") + ")" } function Ba(e, t) { if (e.onceProcessed = !0, e.if && !e.ifProcessed) return Ua(e, t); if (e.staticInFor) { for (var n = "", r = e.parent; r;) { if (r.for) { n = r.key; break } r = r.parent } return n ? "_o(" + Ra(e, t) + "," + t.onceId++ + "," + n + ")" : Ra(e, t) } return Ha(e, t) } function Ua(e, t, n, r) { return e.ifProcessed = !0, function e(t, n, r, i) { if (!t.length) return i || "_e()"; var o = t.shift(); return o.exp ? "(" + o.exp + ")?" + a(o.block) + ":" + e(t, n, r, i) : "" + a(o.block); function a(e) { return r ? r(e, n) : e.once ? Ba(e, n) : Ra(e, n) } }(e.ifConditions.slice(), t, n, r) } function za(e, t, n, r) { var i = e.for, o = e.alias, a = e.iterator1 ? "," + e.iterator1 : "", s = e.iterator2 ? "," + e.iterator2 : ""; return e.forProcessed = !0, (r || "_l") + "((" + i + "),function(" + o + a + s + "){return " + (n || Ra)(e, t) + "})" } function Va(e, t) { var n = "{", r = function (e, t) { var n = e.directives; if (!n) return; var r, i, o, a, s = "directives:[", c = !1; for (r = 0, i = n.length; r < i; r++) { o = n[r], a = !0; var u = t.directives[o.name]; u && (a = !!u(e, o, t.warn)), a && (c = !0, s += '{name:"' + o.name + '",rawName:"' + o.rawName + '"' + (o.value ? ",value:(" + o.value + "),expression:" + JSON.stringify(o.value) : "") + (o.arg ? ",arg:" + (o.isDynamicArg ? o.arg : '"' + o.arg + '"') : "") + (o.modifiers ? ",modifiers:" + JSON.stringify(o.modifiers) : "") + "},") } if (c) return s.slice(0, -1) + "]" }(e, t); r && (n += r + ","), e.key && (n += "key:" + e.key + ","), e.ref && (n += "ref:" + e.ref + ","), e.refInFor && (n += "refInFor:true,"), e.pre && (n += "pre:true,"), e.component && (n += 'tag:"' + e.tag + '",'); for (var i = 0; i < t.dataGenFns.length; i++)n += t.dataGenFns[i](e); if (e.attrs && (n += "attrs:" + Ga(e.attrs) + ","), e.props && (n += "domProps:" + Ga(e.props) + ","), e.events && (n += Da(e.events, !1) + ","), e.nativeEvents && (n += Da(e.nativeEvents, !0) + ","), e.slotTarget && !e.slotScope && (n += "slot:" + e.slotTarget + ","), e.scopedSlots && (n += function (e, t, n) { var r = e.for || Object.keys(t).some(function (e) { var n = t[e]; return n.slotTargetDynamic || n.if || n.for || Ka(n) }), i = !!e.if; if (!r) for (var o = e.parent; o;) { if (o.slotScope && o.slotScope !== ca || o.for) { r = !0; break } o.if && (i = !0), o = o.parent } var a = Object.keys(t).map(function (e) { return Ja(t[e], n) }).join(","); return "scopedSlots:_u([" + a + "]" + (r ? ",null,true" : "") + (!r && i ? ",null,false," + function (e) { var t = 5381, n = e.length; for (; n;)t = 33 * t ^ e.charCodeAt(--n); return t >>> 0 }(a) : "") + ")" }(e, e.scopedSlots, t) + ","), e.model && (n += "model:{value:" + e.model.value + ",callback:" + e.model.callback + ",expression:" + e.model.expression + "},"), e.inlineTemplate) { var o = function (e, t) { var n = e.children[0]; if (n && 1 === n.type) { var r = Pa(n, t.options); return "inlineTemplate:{render:function(){" + r.render + "},staticRenderFns:[" + r.staticRenderFns.map(function (e) { return "function(){" + e + "}" }).join(",") + "]}" } }(e, t); o && (n += o + ",") } return n = n.replace(/,$/, "") + "}", e.dynamicAttrs && (n = "_b(" + n + ',"' + e.tag + '",' + Ga(e.dynamicAttrs) + ")"), e.wrapData && (n = e.wrapData(n)), e.wrapListeners && (n = e.wrapListeners(n)), n } function Ka(e) { return 1 === e.type && ("slot" === e.tag || e.children.some(Ka)) } function Ja(e, t) { var n = e.attrsMap["slot-scope"]; if (e.if && !e.ifProcessed && !n) return Ua(e, t, Ja, "null"); if (e.for && !e.forProcessed) return za(e, t, Ja); var r = e.slotScope === ca ? "" : String(e.slotScope), i = "function(" + r + "){return " + ("template" === e.tag ? e.if && n ? "(" + e.if + ")?" + (qa(e, t) || "undefined") + ":undefined" : qa(e, t) || "undefined" : Ra(e, t)) + "}", o = r ? "" : ",proxy:true"; return "{key:" + (e.slotTarget || '"default"') + ",fn:" + i + o + "}" } function qa(e, t, n, r, i) { var o = e.children; if (o.length) { var a = o[0]; if (1 === o.length && a.for && "template" !== a.tag && "slot" !== a.tag) { var s = n ? t.maybeComponent(a) ? ",1" : ",0" : ""; return "" + (r || Ra)(a, t) + s } var c = n ? function (e, t) { for (var n = 0, r = 0; r < e.length; r++) { var i = e[r]; if (1 === i.type) { if (Wa(i) || i.ifConditions && i.ifConditions.some(function (e) { return Wa(e.block) })) { n = 2; break } (t(i) || i.ifConditions && i.ifConditions.some(function (e) { return t(e.block) })) && (n = 1) } } return n }(o, t.maybeComponent) : 0, u = i || Za; return "[" + o.map(function (e) { return u(e, t) }).join(",") + "]" + (c ? "," + c : "") } } function Wa(e) { return void 0 !== e.for || "template" === e.tag || "slot" === e.tag } function Za(e, t) { return 1 === e.type ? Ra(e, t) : 3 === e.type && e.isComment ? (r = e, "_e(" + JSON.stringify(r.text) + ")") : "_v(" + (2 === (n = e).type ? n.expression : Xa(JSON.stringify(n.text))) + ")"; var n, r } function Ga(e) { for (var t = "", n = "", r = 0; r < e.length; r++) { var i = e[r], o = Xa(i.value); i.dynamic ? n += i.name + "," + o + "," : t += '"' + i.name + '":' + o + "," } return t = "{" + t.slice(0, -1) + "}", n ? "_d(" + t + ",[" + n.slice(0, -1) + "])" : t } function Xa(e) { return e.replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029") } new RegExp("\\b" + "do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b") + "\\b"); function Ya(e, t) { try { return new Function(e) } catch (n) { return t.push({ err: n, code: e }), S } } function Qa(e) { var t = Object.create(null); return function (n, r, i) { (r = A({}, r)).warn; delete r.warn; var o = r.delimiters ? String(r.delimiters) + n : n; if (t[o]) return t[o]; var a = e(n, r), s = {}, c = []; return s.render = Ya(a.render, c), s.staticRenderFns = a.staticRenderFns.map(function (e) { return Ya(e, c) }), t[o] = s } } var es, ts, ns = (es = function (e, t) { var n = la(e.trim(), t); !1 !== t.optimize && ka(n, t); var r = Pa(n, t); return { ast: n, render: r.render, staticRenderFns: r.staticRenderFns } }, function (e) { function t(t, n) { var r = Object.create(e), i = [], o = []; if (n) for (var a in n.modules && (r.modules = (e.modules || []).concat(n.modules)), n.directives && (r.directives = A(Object.create(e.directives || null), n.directives)), n) "modules" !== a && "directives" !== a && (r[a] = n[a]); r.warn = function (e, t, n) { (n ? o : i).push(e) }; var s = es(t.trim(), r); return s.errors = i, s.tips = o, s } return { compile: t, compileToFunctions: Qa(t) } })(Ca), rs = (ns.compile, ns.compileToFunctions); function is(e) { return (ts = ts || document.createElement("div")).innerHTML = e ? '<a href="\n"/>' : '<div a="\n"/>', ts.innerHTML.indexOf("&#10;") > 0 } var os = !!z && is(!1), as = !!z && is(!0), ss = g(function (e) { var t = Yn(e); return t && t.innerHTML }), cs = wn.prototype.$mount; return wn.prototype.$mount = function (e, t) { if ((e = e && Yn(e)) === document.body || e === document.documentElement) return this; var n = this.$options; if (!n.render) { var r = n.template; if (r) if ("string" == typeof r) "#" === r.charAt(0) && (r = ss(r)); else { if (!r.nodeType) return this; r = r.innerHTML } else e && (r = function (e) { if (e.outerHTML) return e.outerHTML; var t = document.createElement("div"); return t.appendChild(e.cloneNode(!0)), t.innerHTML }(e)); if (r) { var i = rs(r, { outputSourceRange: !1, shouldDecodeNewlines: os, shouldDecodeNewlinesForHref: as, delimiters: n.delimiters, comments: n.comments }, this), o = i.render, a = i.staticRenderFns; n.render = o, n.staticRenderFns = a } } return cs.call(this, e, t) }, wn.compile = rs, wn });
(function e(t, n, r) { function s(o, u) { if (!n[o]) { if (!t[o]) { var a = typeof require == "function" && require; if (!u && a) return a(o, !0); if (i) return i(o, !0); var f = new Error("Cannot find module '" + o + "'"); throw f.code = "MODULE_NOT_FOUND", f } var l = n[o] = { exports: {} }; t[o][0].call(l.exports, function (e) { var n = t[o][1][e]; return s(n ? n : e) }, l, l.exports, e, t, n, r) } return n[o].exports } var i = typeof require == "function" && require; for (var o = 0; o < r.length; o++)s(r[o]); return s })({
  1: [function (require, module, exports) {
    !function (e, o) { if ("function" == typeof define && define.amd) define(["exports"], o); else if ("undefined" != typeof exports) o(exports); else { var t = {}; o(t), e.bodyScrollLock = t } }(this, function (exports) { "use strict"; Object.defineProperty(exports, "__esModule", { value: !0 }); var t = !1; if ("undefined" != typeof window) { var e = { get passive() { t = !0 } }; window.addEventListener("testPassive", null, e), window.removeEventListener("testPassive", null, e) } function l(o) { return c.some(function (e) { return !(!e.options.allowTouchMove || !e.options.allowTouchMove(o)) }) } function d(e) { var o = e || window.event; return !!l(o.target) || (1 < o.touches.length || (o.preventDefault && o.preventDefault(), !1)) } function n() { void 0 !== v && (document.body.style.paddingRight = v, v = void 0), void 0 !== s && (document.body.style.overflow = s, s = void 0) } var i = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || "MacIntel" === window.navigator.platform && 1 < window.navigator.maxTouchPoints), c = [], a = !1, u = -1, s = void 0, v = void 0; exports.disableBodyScroll = function (r, e) { if (r) { if (!c.some(function (e) { return e.targetElement === r })) { var o = { targetElement: r, options: e || {} }; c = [].concat(function (e) { if (Array.isArray(e)) { for (var o = 0, t = Array(e.length); o < e.length; o++)t[o] = e[o]; return t } return Array.from(e) }(c), [o]), i ? (r.ontouchstart = function (e) { 1 === e.targetTouches.length && (u = e.targetTouches[0].clientY) }, r.ontouchmove = function (e) { var o, t, n, i; 1 === e.targetTouches.length && (t = r, i = (o = e).targetTouches[0].clientY - u, l(o.target) || (t && 0 === t.scrollTop && 0 < i || (n = t) && n.scrollHeight - n.scrollTop <= n.clientHeight && i < 0 ? d(o) : o.stopPropagation())) }, a || (document.addEventListener("touchmove", d, t ? { passive: !1 } : void 0), a = !0)) : function (e) { if (void 0 === v) { var o = !!e && !0 === e.reserveScrollBarGap, t = window.innerWidth - document.documentElement.clientWidth; o && 0 < t && (v = document.body.style.paddingRight, document.body.style.paddingRight = t + "px") } void 0 === s && (s = document.body.style.overflow, document.body.style.overflow = "hidden") }(e) } } else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.") }, exports.clearAllBodyScrollLocks = function () { i ? (c.forEach(function (e) { e.targetElement.ontouchstart = null, e.targetElement.ontouchmove = null }), a && (document.removeEventListener("touchmove", d, t ? { passive: !1 } : void 0), a = !1), u = -1) : n(), c = [] }, exports.enableBodyScroll = function (o) { o ? (c = c.filter(function (e) { return e.targetElement !== o }), i ? (o.ontouchstart = null, o.ontouchmove = null, a && 0 === c.length && (document.removeEventListener("touchmove", d, t ? { passive: !1 } : void 0), a = !1)) : c.length || n()) : console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.") } });

  }, {}], 2: [function (require, module, exports) {
    'use strict';

    var requestAnimFrame = (function () {
      return window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        function (callback) {
          window.setTimeout(callback, 1000 / 60);
        };
    }());

    function decouple(node, event, fn) {
      var eve,
        tracking = false;

      function captureEvent(e) {
        eve = e;
        track();
      }

      function track() {
        if (!tracking) {
          requestAnimFrame(update);
          tracking = true;
        }
      }

      function update() {
        fn.call(node, eve);
        tracking = false;
      }

      node.addEventListener(event, captureEvent, false);

      return captureEvent;
    }

    /**
     * Expose decouple
     */
    module.exports = decouple;

  }, {}], 3: [function (require, module, exports) {
    "use strict";

    var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

    exports.__esModule = true;
    /**
     * Creates a new instance of Emitter.
     * @class
     * @returns {Object} Returns a new instance of Emitter.
     * @example
     * // Creates a new instance of Emitter.
     * var Emitter = require('emitter');
     *
     * var emitter = new Emitter();
     */

    var Emitter = (function () {
      function Emitter() {
        _classCallCheck(this, Emitter);
      }

      /**
       * Adds a listener to the collection for the specified event.
       * @memberof! Emitter.prototype
       * @function
       * @param {String} event - The event name.
       * @param {Function} listener - A listener function to add.
       * @returns {Object} Returns an instance of Emitter.
       * @example
       * // Add an event listener to "foo" event.
       * emitter.on('foo', listener);
       */

      Emitter.prototype.on = function on(event, listener) {
        // Use the current collection or create it.
        this._eventCollection = this._eventCollection || {};

        // Use the current collection of an event or create it.
        this._eventCollection[event] = this._eventCollection[event] || [];

        // Appends the listener into the collection of the given event
        this._eventCollection[event].push(listener);

        return this;
      };

      /**
       * Adds a listener to the collection for the specified event that will be called only once.
       * @memberof! Emitter.prototype
       * @function
       * @param {String} event - The event name.
       * @param {Function} listener - A listener function to add.
       * @returns {Object} Returns an instance of Emitter.
       * @example
       * // Will add an event handler to "foo" event once.
       * emitter.once('foo', listener);
       */

      Emitter.prototype.once = function once(event, listener) {
        var self = this;

        function fn() {
          self.off(event, fn);
          listener.apply(this, arguments);
        }

        fn.listener = listener;

        this.on(event, fn);

        return this;
      };

      /**
       * Removes a listener from the collection for the specified event.
       * @memberof! Emitter.prototype
       * @function
       * @param {String} event - The event name.
       * @param {Function} listener - A listener function to remove.
       * @returns {Object} Returns an instance of Emitter.
       * @example
       * // Remove a given listener.
       * emitter.off('foo', listener);
       */

      Emitter.prototype.off = function off(event, listener) {

        var listeners = undefined;

        // Defines listeners value.
        if (!this._eventCollection || !(listeners = this._eventCollection[event])) {
          return this;
        }

        listeners.forEach(function (fn, i) {
          if (fn === listener || fn.listener === listener) {
            // Removes the given listener.
            listeners.splice(i, 1);
          }
        });

        // Removes an empty event collection.
        if (listeners.length === 0) {
          delete this._eventCollection[event];
        }

        return this;
      };

      /**
       * Execute each item in the listener collection in order with the specified data.
       * @memberof! Emitter.prototype
       * @function
       * @param {String} event - The name of the event you want to emit.
       * @param {...Object} data - Data to pass to the listeners.
       * @returns {Object} Returns an instance of Emitter.
       * @example
       * // Emits the "foo" event with 'param1' and 'param2' as arguments.
       * emitter.emit('foo', 'param1', 'param2');
       */

      Emitter.prototype.emit = function emit(event) {
        var _this = this;

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var listeners = undefined;

        // Defines listeners value.
        if (!this._eventCollection || !(listeners = this._eventCollection[event])) {
          return this;
        }

        // Clone listeners
        listeners = listeners.slice(0);

        listeners.forEach(function (fn) {
          return fn.apply(_this, args);
        });

        return this;
      };

      return Emitter;
    })();

    /**
     * Exports Emitter
     */
    exports["default"] = Emitter;
    module.exports = exports["default"];
  }, {}], 4: [function (require, module, exports) {
    (function (global, factory) {
      typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
        typeof define === 'function' && define.amd ? define(factory) :
          (factory());
    }(this, (function () {
      'use strict';

      /**
       * https://github.com/WICG/focus-visible
       */
      function init() {
        var hadKeyboardEvent = true;
        var hadFocusVisibleRecently = false;
        var hadFocusVisibleRecentlyTimeout = null;

        var inputTypesWhitelist = {
          text: true,
          search: true,
          url: true,
          tel: true,
          email: true,
          password: true,
          number: true,
          date: true,
          month: true,
          week: true,
          time: true,
          datetime: true,
          'datetime-local': true
        };

        /**
         * Helper function for legacy browsers and iframes which sometimes focus
         * elements like document, body, and non-interactive SVG.
         * @param {Element} el
         */
        function isValidFocusTarget(el) {
          if (
            el &&
            el !== document &&
            el.nodeName !== 'HTML' &&
            el.nodeName !== 'BODY' &&
            'classList' in el &&
            'contains' in el.classList
          ) {
            return true;
          }
          return false;
        }

        /**
         * Computes whether the given element should automatically trigger the
         * `focus-visible` class being added, i.e. whether it should always match
         * `:focus-visible` when focused.
         * @param {Element} el
         * @return {boolean}
         */
        function focusTriggersKeyboardModality(el) {
          var type = el.type;
          var tagName = el.tagName;

          if (tagName == 'INPUT' && inputTypesWhitelist[type] && !el.readOnly) {
            return true;
          }

          if (tagName == 'TEXTAREA' && !el.readOnly) {
            return true;
          }

          if (el.isContentEditable) {
            return true;
          }

          return false;
        }

        /**
         * Add the `focus-visible` class to the given element if it was not added by
         * the author.
         * @param {Element} el
         */
        function addFocusVisibleClass(el) {
          if (el.classList.contains('focus-visible')) {
            return;
          }
          el.classList.add('focus-visible');
          el.setAttribute('data-focus-visible-added', '');
        }

        /**
         * Remove the `focus-visible` class from the given element if it was not
         * originally added by the author.
         * @param {Element} el
         */
        function removeFocusVisibleClass(el) {
          if (!el.hasAttribute('data-focus-visible-added')) {
            return;
          }
          el.classList.remove('focus-visible');
          el.removeAttribute('data-focus-visible-added');
        }

        /**
         * Treat `keydown` as a signal that the user is in keyboard modality.
         * Apply `focus-visible` to any current active element and keep track
         * of our keyboard modality state with `hadKeyboardEvent`.
         * @param {Event} e
         */
        function onKeyDown(e) {
          if (isValidFocusTarget(document.activeElement)) {
            addFocusVisibleClass(document.activeElement);
          }

          hadKeyboardEvent = true;
        }

        /**
         * If at any point a user clicks with a pointing device, ensure that we change
         * the modality away from keyboard.
         * This avoids the situation where a user presses a key on an already focused
         * element, and then clicks on a different element, focusing it with a
         * pointing device, while we still think we're in keyboard modality.
         * @param {Event} e
         */
        function onPointerDown(e) {
          hadKeyboardEvent = false;
        }

        /**
         * On `focus`, add the `focus-visible` class to the target if:
         * - the target received focus as a result of keyboard navigation, or
         * - the event target is an element that will likely require interaction
         *   via the keyboard (e.g. a text box)
         * @param {Event} e
         */
        function onFocus(e) {
          // Prevent IE from focusing the document or HTML element.
          if (!isValidFocusTarget(e.target)) {
            return;
          }

          if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
            addFocusVisibleClass(e.target);
          }
        }

        /**
         * On `blur`, remove the `focus-visible` class from the target.
         * @param {Event} e
         */
        function onBlur(e) {
          if (!isValidFocusTarget(e.target)) {
            return;
          }

          if (
            e.target.classList.contains('focus-visible') ||
            e.target.hasAttribute('data-focus-visible-added')
          ) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            hadFocusVisibleRecently = true;
            window.clearTimeout(hadFocusVisibleRecentlyTimeout);
            hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
              hadFocusVisibleRecently = false;
              window.clearTimeout(hadFocusVisibleRecentlyTimeout);
            }, 100);
            removeFocusVisibleClass(e.target);
          }
        }

        /**
         * If the user changes tabs, keep track of whether or not the previously
         * focused element had .focus-visible.
         * @param {Event} e
         */
        function onVisibilityChange(e) {
          if (document.visibilityState == 'hidden') {
            // If the tab becomes active again, the browser will handle calling focus
            // on the element (Safari actually calls it twice).
            // If this tab change caused a blur on an element with focus-visible,
            // re-apply the class when the user switches back to the tab.
            if (hadFocusVisibleRecently) {
              hadKeyboardEvent = true;
            }
            addInitialPointerMoveListeners();
          }
        }

        /**
         * Add a group of listeners to detect usage of any pointing devices.
         * These listeners will be added when the polyfill first loads, and anytime
         * the window is blurred, so that they are active when the window regains
         * focus.
         */
        function addInitialPointerMoveListeners() {
          document.addEventListener('mousemove', onInitialPointerMove);
          document.addEventListener('mousedown', onInitialPointerMove);
          document.addEventListener('mouseup', onInitialPointerMove);
          document.addEventListener('pointermove', onInitialPointerMove);
          document.addEventListener('pointerdown', onInitialPointerMove);
          document.addEventListener('pointerup', onInitialPointerMove);
          document.addEventListener('touchmove', onInitialPointerMove);
          document.addEventListener('touchstart', onInitialPointerMove);
          document.addEventListener('touchend', onInitialPointerMove);
        }

        function removeInitialPointerMoveListeners() {
          document.removeEventListener('mousemove', onInitialPointerMove);
          document.removeEventListener('mousedown', onInitialPointerMove);
          document.removeEventListener('mouseup', onInitialPointerMove);
          document.removeEventListener('pointermove', onInitialPointerMove);
          document.removeEventListener('pointerdown', onInitialPointerMove);
          document.removeEventListener('pointerup', onInitialPointerMove);
          document.removeEventListener('touchmove', onInitialPointerMove);
          document.removeEventListener('touchstart', onInitialPointerMove);
          document.removeEventListener('touchend', onInitialPointerMove);
        }

        /**
         * When the polfyill first loads, assume the user is in keyboard modality.
         * If any event is received from a pointing device (e.g. mouse, pointer,
         * touch), turn off keyboard modality.
         * This accounts for situations where focus enters the page from the URL bar.
         * @param {Event} e
         */
        function onInitialPointerMove(e) {
          // Work around a Safari quirk that fires a mousemove on <html> whenever the
          // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
          if (e.target.nodeName.toLowerCase() === 'html') {
            return;
          }

          hadKeyboardEvent = false;
          removeInitialPointerMoveListeners();
        }

        document.addEventListener('keydown', onKeyDown, true);
        document.addEventListener('mousedown', onPointerDown, true);
        document.addEventListener('pointerdown', onPointerDown, true);
        document.addEventListener('touchstart', onPointerDown, true);
        document.addEventListener('focus', onFocus, true);
        document.addEventListener('blur', onBlur, true);
        document.addEventListener('visibilitychange', onVisibilityChange, true);
        addInitialPointerMoveListeners();

        document.body.classList.add('js-focus-visible');
      }

      /**
       * Subscription when the DOM is ready
       * @param {Function} callback
       */
      function onDOMReady(callback) {
        var loaded;

        /**
         * Callback wrapper for check loaded state
         */
        function load() {
          if (!loaded) {
            loaded = true;

            callback();
          }
        }

        if (['interactive', 'complete'].indexOf(document.readyState) >= 0) {
          callback();
        } else {
          loaded = false;
          document.addEventListener('DOMContentLoaded', load, false);
          window.addEventListener('load', load, false);
        }
      }

      if (typeof document !== 'undefined') {
        onDOMReady(init);
      }

    })));

  }, {}], 5: [function (require, module, exports) {
    (function (global, factory) {
      typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
          (global = global || self, global.MicroModal = factory());
    }(this, (function () {
      'use strict';

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
      }

      function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
      }

      function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
      }

      function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(n);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
      }

      function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;

        for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

        return arr2;
      }

      function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      var MicroModal = function () {

        var FOCUSABLE_ELEMENTS = ['a[href]', 'area[href]', 'input:not([disabled]):not([type="hidden"]):not([aria-hidden])', 'select:not([disabled]):not([aria-hidden])', 'textarea:not([disabled]):not([aria-hidden])', 'button:not([disabled]):not([aria-hidden])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'];

        var Modal = /*#__PURE__*/function () {
          function Modal(_ref) {
            var targetModal = _ref.targetModal,
              _ref$triggers = _ref.triggers,
              triggers = _ref$triggers === void 0 ? [] : _ref$triggers,
              _ref$onShow = _ref.onShow,
              onShow = _ref$onShow === void 0 ? function () { } : _ref$onShow,
              _ref$onClose = _ref.onClose,
              onClose = _ref$onClose === void 0 ? function () { } : _ref$onClose,
              _ref$openTrigger = _ref.openTrigger,
              openTrigger = _ref$openTrigger === void 0 ? 'data-micromodal-trigger' : _ref$openTrigger,
              _ref$closeTrigger = _ref.closeTrigger,
              closeTrigger = _ref$closeTrigger === void 0 ? 'data-micromodal-close' : _ref$closeTrigger,
              _ref$openClass = _ref.openClass,
              openClass = _ref$openClass === void 0 ? 'is-open' : _ref$openClass,
              _ref$disableScroll = _ref.disableScroll,
              disableScroll = _ref$disableScroll === void 0 ? false : _ref$disableScroll,
              _ref$disableFocus = _ref.disableFocus,
              disableFocus = _ref$disableFocus === void 0 ? false : _ref$disableFocus,
              _ref$awaitCloseAnimat = _ref.awaitCloseAnimation,
              awaitCloseAnimation = _ref$awaitCloseAnimat === void 0 ? false : _ref$awaitCloseAnimat,
              _ref$awaitOpenAnimati = _ref.awaitOpenAnimation,
              awaitOpenAnimation = _ref$awaitOpenAnimati === void 0 ? false : _ref$awaitOpenAnimati,
              _ref$debugMode = _ref.debugMode,
              debugMode = _ref$debugMode === void 0 ? false : _ref$debugMode;

            _classCallCheck(this, Modal);

            // Save a reference of the modal
            this.modal = document.getElementById(targetModal); // Save a reference to the passed config

            this.config = {
              debugMode: debugMode,
              disableScroll: disableScroll,
              openTrigger: openTrigger,
              closeTrigger: closeTrigger,
              openClass: openClass,
              onShow: onShow,
              onClose: onClose,
              awaitCloseAnimation: awaitCloseAnimation,
              awaitOpenAnimation: awaitOpenAnimation,
              disableFocus: disableFocus
            }; // Register click events only if pre binding eventListeners

            if (triggers.length > 0) this.registerTriggers.apply(this, _toConsumableArray(triggers)); // pre bind functions for event listeners

            this.onClick = this.onClick.bind(this);
            this.onKeydown = this.onKeydown.bind(this);
          }
          /**
           * Loops through all openTriggers and binds click event
           * @param  {array} triggers [Array of node elements]
           * @return {void}
           */


          _createClass(Modal, [{
            key: "registerTriggers",
            value: function registerTriggers() {
              var _this = this;

              for (var _len = arguments.length, triggers = new Array(_len), _key = 0; _key < _len; _key++) {
                triggers[_key] = arguments[_key];
              }

              triggers.filter(Boolean).forEach(function (trigger) {
                trigger.addEventListener('click', function (event) {
                  return _this.showModal(event);
                });
              });
            }
          }, {
            key: "showModal",
            value: function showModal() {
              var _this2 = this;

              var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              this.activeElement = document.activeElement;
              this.modal.setAttribute('aria-hidden', 'false');
              this.modal.classList.add(this.config.openClass);
              this.scrollBehaviour('disable');
              this.addEventListeners();

              if (this.config.awaitOpenAnimation) {
                var handler = function handler() {
                  _this2.modal.removeEventListener('animationend', handler, false);

                  _this2.setFocusToFirstNode();
                };

                this.modal.addEventListener('animationend', handler, false);
              } else {
                this.setFocusToFirstNode();
              }

              this.config.onShow(this.modal, this.activeElement, event);
            }
          }, {
            key: "closeModal",
            value: function closeModal() {
              var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var modal = this.modal;
              this.modal.setAttribute('aria-hidden', 'true');
              this.removeEventListeners();
              this.scrollBehaviour('enable');

              if (this.activeElement && this.activeElement.focus) {
                this.activeElement.focus();
              }

              this.config.onClose(this.modal, this.activeElement, event);

              if (this.config.awaitCloseAnimation) {
                var openClass = this.config.openClass; // <- old school ftw

                this.modal.addEventListener('animationend', function handler() {
                  modal.classList.remove(openClass);
                  modal.removeEventListener('animationend', handler, false);
                }, false);
              } else {
                modal.classList.remove(this.config.openClass);
              }
            }
          }, {
            key: "closeModalById",
            value: function closeModalById(targetModal) {
              this.modal = document.getElementById(targetModal);
              if (this.modal) this.closeModal();
            }
          }, {
            key: "scrollBehaviour",
            value: function scrollBehaviour(toggle) {
              if (!this.config.disableScroll) return;
              var body = document.querySelector('body');

              switch (toggle) {
                case 'enable':
                  Object.assign(body.style, {
                    overflow: ''
                  });
                  break;

                case 'disable':
                  Object.assign(body.style, {
                    overflow: 'hidden'
                  });
                  break;
              }
            }
          }, {
            key: "addEventListeners",
            value: function addEventListeners() {
              this.modal.addEventListener('touchstart', this.onClick);
              this.modal.addEventListener('click', this.onClick);
              document.addEventListener('keydown', this.onKeydown);
            }
          }, {
            key: "removeEventListeners",
            value: function removeEventListeners() {
              this.modal.removeEventListener('touchstart', this.onClick);
              this.modal.removeEventListener('click', this.onClick);
              document.removeEventListener('keydown', this.onKeydown);
            }
          }, {
            key: "onClick",
            value: function onClick(event) {
              if (event.target.hasAttribute(this.config.closeTrigger)) {
                this.closeModal(event);
              }
            }
          }, {
            key: "onKeydown",
            value: function onKeydown(event) {
              if (event.keyCode === 27) this.closeModal(event); // esc

              if (event.keyCode === 9) this.retainFocus(event); // tab
            }
          }, {
            key: "getFocusableNodes",
            value: function getFocusableNodes() {
              var nodes = this.modal.querySelectorAll(FOCUSABLE_ELEMENTS);
              return Array.apply(void 0, _toConsumableArray(nodes));
            }
            /**
             * Tries to set focus on a node which is not a close trigger
             * if no other nodes exist then focuses on first close trigger
             */

          }, {
            key: "setFocusToFirstNode",
            value: function setFocusToFirstNode() {
              var _this3 = this;

              if (this.config.disableFocus) return;
              var focusableNodes = this.getFocusableNodes(); // no focusable nodes

              if (focusableNodes.length === 0) return; // remove nodes on whose click, the modal closes
              // could not think of a better name :(

              var nodesWhichAreNotCloseTargets = focusableNodes.filter(function (node) {
                return !node.hasAttribute(_this3.config.closeTrigger);
              });
              if (nodesWhichAreNotCloseTargets.length > 0) nodesWhichAreNotCloseTargets[0].focus();
              if (nodesWhichAreNotCloseTargets.length === 0) focusableNodes[0].focus();
            }
          }, {
            key: "retainFocus",
            value: function retainFocus(event) {
              var focusableNodes = this.getFocusableNodes(); // no focusable nodes

              if (focusableNodes.length === 0) return;
              /**
               * Filters nodes which are hidden to prevent
               * focus leak outside modal
               */

              focusableNodes = focusableNodes.filter(function (node) {
                return node.offsetParent !== null;
              }); // if disableFocus is true

              if (!this.modal.contains(document.activeElement)) {
                focusableNodes[0].focus();
              } else {
                var focusedItemIndex = focusableNodes.indexOf(document.activeElement);

                if (event.shiftKey && focusedItemIndex === 0) {
                  focusableNodes[focusableNodes.length - 1].focus();
                  event.preventDefault();
                }

                if (!event.shiftKey && focusableNodes.length > 0 && focusedItemIndex === focusableNodes.length - 1) {
                  focusableNodes[0].focus();
                  event.preventDefault();
                }
              }
            }
          }]);

          return Modal;
        }();
        /**
         * Modal prototype ends.
         * Here on code is responsible for detecting and
         * auto binding event handlers on modal triggers
         */
        // Keep a reference to the opened modal


        var activeModal = null;
        /**
         * Generates an associative array of modals and it's
         * respective triggers
         * @param  {array} triggers     An array of all triggers
         * @param  {string} triggerAttr The data-attribute which triggers the module
         * @return {array}
         */

        var generateTriggerMap = function generateTriggerMap(triggers, triggerAttr) {
          var triggerMap = [];
          triggers.forEach(function (trigger) {
            var targetModal = trigger.attributes[triggerAttr].value;
            if (triggerMap[targetModal] === undefined) triggerMap[targetModal] = [];
            triggerMap[targetModal].push(trigger);
          });
          return triggerMap;
        };
        /**
         * Validates whether a modal of the given id exists
         * in the DOM
         * @param  {number} id  The id of the modal
         * @return {boolean}
         */


        var validateModalPresence = function validateModalPresence(id) {
          if (!document.getElementById(id)) {
            console.warn("MicroModal: \u2757Seems like you have missed %c'".concat(id, "'"), 'background-color: #f8f9fa;color: #50596c;font-weight: bold;', 'ID somewhere in your code. Refer example below to resolve it.');
            console.warn("%cExample:", 'background-color: #f8f9fa;color: #50596c;font-weight: bold;', "<div class=\"modal\" id=\"".concat(id, "\"></div>"));
            return false;
          }
        };
        /**
         * Validates if there are modal triggers present
         * in the DOM
         * @param  {array} triggers An array of data-triggers
         * @return {boolean}
         */


        var validateTriggerPresence = function validateTriggerPresence(triggers) {
          if (triggers.length <= 0) {
            console.warn("MicroModal: \u2757Please specify at least one %c'micromodal-trigger'", 'background-color: #f8f9fa;color: #50596c;font-weight: bold;', 'data attribute.');
            console.warn("%cExample:", 'background-color: #f8f9fa;color: #50596c;font-weight: bold;', "<a href=\"#\" data-micromodal-trigger=\"my-modal\"></a>");
            return false;
          }
        };
        /**
         * Checks if triggers and their corresponding modals
         * are present in the DOM
         * @param  {array} triggers   Array of DOM nodes which have data-triggers
         * @param  {array} triggerMap Associative array of modals and their triggers
         * @return {boolean}
         */


        var validateArgs = function validateArgs(triggers, triggerMap) {
          validateTriggerPresence(triggers);
          if (!triggerMap) return true;

          for (var id in triggerMap) {
            validateModalPresence(id);
          }

          return true;
        };
        /**
         * Binds click handlers to all modal triggers
         * @param  {object} config [description]
         * @return void
         */


        var init = function init(config) {
          // Create an config object with default openTrigger
          var options = Object.assign({}, {
            openTrigger: 'data-micromodal-trigger'
          }, config); // Collects all the nodes with the trigger

          var triggers = _toConsumableArray(document.querySelectorAll("[".concat(options.openTrigger, "]"))); // Makes a mappings of modals with their trigger nodes


          var triggerMap = generateTriggerMap(triggers, options.openTrigger); // Checks if modals and triggers exist in dom

          if (options.debugMode === true && validateArgs(triggers, triggerMap) === false) return; // For every target modal creates a new instance

          for (var key in triggerMap) {
            var value = triggerMap[key];
            options.targetModal = key;
            options.triggers = _toConsumableArray(value);
            activeModal = new Modal(options); // eslint-disable-line no-new
          }
        };
        /**
         * Shows a particular modal
         * @param  {string} targetModal [The id of the modal to display]
         * @param  {object} config [The configuration object to pass]
         * @return {void}
         */


        var show = function show(targetModal, config) {
          var options = config || {};
          options.targetModal = targetModal; // Checks if modals and triggers exist in dom

          if (options.debugMode === true && validateModalPresence(targetModal) === false) return; // clear events in case previous modal wasn't close

          if (activeModal) activeModal.removeEventListeners(); // stores reference to active modal

          activeModal = new Modal(options); // eslint-disable-line no-new

          activeModal.showModal();
        };
        /**
         * Closes the active modal
         * @param  {string} targetModal [The id of the modal to close]
         * @return {void}
         */


        var close = function close(targetModal) {
          targetModal ? activeModal.closeModalById(targetModal) : activeModal.closeModal();
        };

        return {
          init: init,
          show: show,
          close: close
        };
      }();
      window.MicroModal = MicroModal;

      return MicroModal;

    })));

  }, {}], 6: [function (require, module, exports) {
    /*!
      * $script.js JS loader & dependency manager
      * https://github.com/ded/script.js
      * (c) Dustin Diaz 2014 | License MIT
      */

    (function (name, definition) {
      if (typeof module != 'undefined' && module.exports) module.exports = definition()
      else if (typeof define == 'function' && define.amd) define(definition)
      else this[name] = definition()
    })('$script', function () {
      var doc = document
        , head = doc.getElementsByTagName('head')[0]
        , s = 'string'
        , f = false
        , push = 'push'
        , readyState = 'readyState'
        , onreadystatechange = 'onreadystatechange'
        , list = {}
        , ids = {}
        , delay = {}
        , scripts = {}
        , scriptpath
        , urlArgs

      function every(ar, fn) {
        for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
        return 1
      }
      function each(ar, fn) {
        every(ar, function (el) {
          fn(el)
          return 1
        })
      }

      function $script(paths, idOrDone, optDone) {
        paths = paths[push] ? paths : [paths]
        var idOrDoneIsDone = idOrDone && idOrDone.call
          , done = idOrDoneIsDone ? idOrDone : optDone
          , id = idOrDoneIsDone ? paths.join('') : idOrDone
          , queue = paths.length
        function loopFn(item) {
          return item.call ? item() : list[item]
        }
        function callback() {
          if (!--queue) {
            list[id] = 1
            done && done()
            for (var dset in delay) {
              every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
            }
          }
        }
        setTimeout(function () {
          each(paths, function loading(path, force) {
            if (path === null) return callback()

            if (!force && !/^https?:\/\//.test(path) && scriptpath) {
              path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
            }

            if (scripts[path]) {
              if (id) ids[id] = 1
              return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
            }

            scripts[path] = 1
            if (id) ids[id] = 1
            create(path, callback)
          })
        }, 0)
        return $script
      }

      function create(path, fn) {
        var el = doc.createElement('script'), loaded
        el.onload = el.onerror = el[onreadystatechange] = function () {
          if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
          el.onload = el[onreadystatechange] = null
          loaded = 1
          scripts[path] = 2
          fn()
        }
        el.async = 1
        el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
        head.insertBefore(el, head.lastChild)
      }

      $script.get = create

      $script.order = function (scripts, id, done) {
        (function callback(s) {
          s = scripts.shift()
          !scripts.length ? $script(s, id, done) : $script(s, callback)
        }())
      }

      $script.path = function (p) {
        scriptpath = p
      }
      $script.urlArgs = function (str) {
        urlArgs = str;
      }
      $script.ready = function (deps, ready, req) {
        deps = deps[push] ? deps : [deps]
        var missing = [];
        !each(deps, function (dep) {
          list[dep] || missing[push](dep);
        }) && every(deps, function (dep) { return list[dep] }) ?
          ready() : !function (key) {
            delay[key] = delay[key] || []
            delay[key][push](ready)
            req && req(missing)
          }(deps.join('|'))
        return $script
      }

      $script.done = function (idOrDone) {
        $script([null], idOrDone)
      }

      return $script
    });

  }, {}], 7: [function (require, module, exports) {
    'use strict';

    /**
     * Module dependencies
     */
    var decouple = require('decouple');
    var Emitter = require('emitter');

    /**
     * Privates
     */
    var scrollTimeout;
    var scrolling = false;
    var doc = window.document;
    var html = doc.documentElement;
    var msPointerSupported = window.navigator.msPointerEnabled;
    var touch = {
      'start': msPointerSupported ? 'MSPointerDown' : 'touchstart',
      'move': msPointerSupported ? 'MSPointerMove' : 'touchmove',
      'end': msPointerSupported ? 'MSPointerUp' : 'touchend'
    };
    var prefix = (function prefix() {
      var regex = /^(Webkit|Khtml|Moz|ms|O)(?=[A-Z])/;
      var styleDeclaration = doc.getElementsByTagName('script')[0].style;
      for (var prop in styleDeclaration) {
        if (regex.test(prop)) {
          return '-' + prop.match(regex)[0].toLowerCase() + '-';
        }
      }
      // Nothing found so far? Webkit does not enumerate over the CSS properties of the style object.
      // However (prop in style) returns the correct value, so we'll have to test for
      // the precence of a specific property
      if ('WebkitOpacity' in styleDeclaration) { return '-webkit-'; }
      if ('KhtmlOpacity' in styleDeclaration) { return '-khtml-'; }
      return '';
    }());
    function extend(destination, from) {
      for (var prop in from) {
        if (from[prop]) {
          destination[prop] = from[prop];
        }
      }
      return destination;
    }
    function inherits(child, uber) {
      child.prototype = extend(child.prototype || {}, uber.prototype);
    }
    function hasIgnoredElements(el) {
      while (el.parentNode) {
        if (el.getAttribute('data-slideout-ignore') !== null) {
          return el;
        }
        el = el.parentNode;
      }
      return null;
    }

    /**
     * Slideout constructor
     */
    function Slideout(options) {
      options = options || {};

      // Sets default values
      this._startOffsetX = 0;
      this._currentOffsetX = 0;
      this._opening = false;
      this._moved = false;
      this._opened = false;
      this._preventOpen = false;
      this._touch = options.touch === undefined ? true : options.touch && true;
      this._side = options.side || 'left';

      // Sets panel
      this.panel = options.panel;
      this.menu = options.menu;

      // Sets  classnames
      if (!this.panel.classList.contains('slideout-panel')) {
        this.panel.classList.add('slideout-panel');
      }
      if (!this.panel.classList.contains('slideout-panel-' + this._side)) {
        this.panel.classList.add('slideout-panel-' + this._side);
      }
      if (!this.menu.classList.contains('slideout-menu')) {
        this.menu.classList.add('slideout-menu');
      }
      if (!this.menu.classList.contains('slideout-menu-' + this._side)) {
        this.menu.classList.add('slideout-menu-' + this._side);
      }

      // Sets options
      this._fx = options.fx || 'ease';
      this._duration = parseInt(options.duration, 10) || 300;
      this._tolerance = parseInt(options.tolerance, 10) || 70;
      this._padding = this._translateTo = parseInt(options.padding, 10) || 256;
      this._orientation = this._side === 'right' ? -1 : 1;
      this._translateTo *= this._orientation;

      // Init touch events
      if (this._touch) {
        this._initTouchEvents();
      }
    }

    /**
     * Inherits from Emitter
     */
    inherits(Slideout, Emitter);

    /**
     * Opens the slideout menu.
     */
    Slideout.prototype.open = function () {
      var self = this;
      this.emit('beforeopen');
      if (!html.classList.contains('slideout-open')) {
        html.classList.add('slideout-open');
      }
      this._setTransition();
      this._translateXTo(this._translateTo);
      this._opened = true;
      setTimeout(function () {
        self.panel.style.transition = self.panel.style['-webkit-transition'] = '';
        self.emit('open');
      }, this._duration + 50);
      return this;
    };

    /**
     * Closes slideout menu.
     */
    Slideout.prototype.close = function () {
      var self = this;
      if (!this.isOpen() && !this._opening) {
        return this;
      }
      this.emit('beforeclose');
      this._setTransition();
      this._translateXTo(0);
      this._opened = false;
      setTimeout(function () {
        html.classList.remove('slideout-open');
        self.panel.style.transition = self.panel.style['-webkit-transition'] = self.panel.style[prefix + 'transform'] = self.panel.style.transform = '';
        self.emit('close');
      }, this._duration + 50);
      return this;
    };

    /**
     * Toggles (open/close) slideout menu.
     */
    Slideout.prototype.toggle = function () {
      return this.isOpen() ? this.close() : this.open();
    };

    /**
     * Returns true if the slideout is currently open, and false if it is closed.
     */
    Slideout.prototype.isOpen = function () {
      return this._opened;
    };

    /**
     * Translates panel and updates currentOffset with a given X point
     */
    Slideout.prototype._translateXTo = function (translateX) {
      this._currentOffsetX = translateX;
      this.panel.style[prefix + 'transform'] = this.panel.style.transform = 'translateX(' + translateX + 'px)';
      return this;
    };

    /**
     * Set transition properties
     */
    Slideout.prototype._setTransition = function () {
      this.panel.style[prefix + 'transition'] = this.panel.style.transition = prefix + 'transform ' + this._duration + 'ms ' + this._fx;
      return this;
    };

    /**
     * Initializes touch event
     */
    Slideout.prototype._initTouchEvents = function () {
      var self = this;

      /**
       * Decouple scroll event
       */
      this._onScrollFn = decouple(doc, 'scroll', function () {
        if (!self._moved) {
          clearTimeout(scrollTimeout);
          scrolling = true;
          scrollTimeout = setTimeout(function () {
            scrolling = false;
          }, 250);
        }
      });

      /**
       * Prevents touchmove event if slideout is moving
       */
      this._preventMove = function (eve) {
        if (self._moved) {
          eve.preventDefault();
        }
      };

      doc.addEventListener(touch.move, this._preventMove);

      /**
       * Resets values on touchstart
       */
      this._resetTouchFn = function (eve) {
        if (typeof eve.touches === 'undefined') {
          return;
        }

        self._moved = false;
        self._opening = false;
        self._startOffsetX = eve.touches[0].pageX;
        self._preventOpen = (!self._touch || (!self.isOpen() && self.menu.clientWidth !== 0));
      };

      this.panel.addEventListener(touch.start, this._resetTouchFn);

      /**
       * Resets values on touchcancel
       */
      this._onTouchCancelFn = function () {
        self._moved = false;
        self._opening = false;
      };

      this.panel.addEventListener('touchcancel', this._onTouchCancelFn);

      /**
       * Toggles slideout on touchend
       */
      this._onTouchEndFn = function () {
        if (self._moved) {
          self.emit('translateend');
          (self._opening && Math.abs(self._currentOffsetX) > self._tolerance) ? self.open() : self.close();
        }
        self._moved = false;
      };

      this.panel.addEventListener(touch.end, this._onTouchEndFn);

      /**
       * Translates panel on touchmove
       */
      this._onTouchMoveFn = function (eve) {
        if (
          scrolling ||
          self._preventOpen ||
          typeof eve.touches === 'undefined' ||
          hasIgnoredElements(eve.target)
        ) {
          return;
        }

        var dif_x = eve.touches[0].clientX - self._startOffsetX;
        var translateX = self._currentOffsetX = dif_x;

        if (Math.abs(translateX) > self._padding) {
          return;
        }

        if (Math.abs(dif_x) > 20) {

          self._opening = true;

          var oriented_dif_x = dif_x * self._orientation;

          if (self._opened && oriented_dif_x > 0 || !self._opened && oriented_dif_x < 0) {
            return;
          }

          if (!self._moved) {
            self.emit('translatestart');
          }

          if (oriented_dif_x <= 0) {
            translateX = dif_x + self._padding * self._orientation;
            self._opening = false;
          }

          if (!(self._moved && html.classList.contains('slideout-open'))) {
            html.classList.add('slideout-open');
          }

          self.panel.style[prefix + 'transform'] = self.panel.style.transform = 'translateX(' + translateX + 'px)';
          self.emit('translate', translateX);
          self._moved = true;
        }

      };

      this.panel.addEventListener(touch.move, this._onTouchMoveFn);

      return this;
    };

    /**
     * Enable opening the slideout via touch events.
     */
    Slideout.prototype.enableTouch = function () {
      this._touch = true;
      return this;
    };

    /**
     * Disable opening the slideout via touch events.
     */
    Slideout.prototype.disableTouch = function () {
      this._touch = false;
      return this;
    };

    /**
     * Destroy an instance of slideout.
     */
    Slideout.prototype.destroy = function () {
      // Close before clean
      this.close();

      // Remove event listeners
      doc.removeEventListener(touch.move, this._preventMove);
      this.panel.removeEventListener(touch.start, this._resetTouchFn);
      this.panel.removeEventListener('touchcancel', this._onTouchCancelFn);
      this.panel.removeEventListener(touch.end, this._onTouchEndFn);
      this.panel.removeEventListener(touch.move, this._onTouchMoveFn);
      doc.removeEventListener('scroll', this._onScrollFn);

      // Remove methods
      this.open = this.close = function () { };

      // Return the instance so it can be easily dereferenced
      return this;
    };

    /**
     * Expose Slideout
     */
    module.exports = Slideout;

  }, { "decouple": 2, "emitter": 3 }], 8: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _globalLoadData = require('./global/loadData');

    var Sections = (function () {
      function Sections() {
        _classCallCheck(this, Sections);

        this.sections = {};
        this.handlers = {};
        this._onSectionEvent = this._onSectionEvent.bind(this);

        document.addEventListener('shopify:section:load', this._onSectionEvent);
        document.addEventListener('shopify:section:unload', this._onSectionEvent);
        document.addEventListener('shopify:section:select', this._onSectionEvent);
        document.addEventListener('shopify:section:deselect', this._onSectionEvent);
        document.addEventListener('shopify:section:reorder', this._onSectionEvent);
        document.addEventListener('shopify:block:select', this._onSectionEvent);
        document.addEventListener('shopify:block:deselect', this._onSectionEvent);
      }

      Sections.prototype.unbind = function unbind() {
        document.removeEventListener('shopify:section:load', this._onSectionEvent);
        document.removeEventListener('shopify:section:unload', this._onSectionEvent);
        document.removeEventListener('shopify:section:select', this._onSectionEvent);
        document.removeEventListener('shopify:section:deselect', this._onSectionEvent);
        document.removeEventListener('shopify:section:reorder', this._onSectionEvent);
        document.removeEventListener('shopify:block:select', this._onSectionEvent);
        document.removeEventListener('shopify:block:deselect', this._onSectionEvent);

        this.sections = {};
        this.handlers = {};
      };

      Sections.prototype._onSectionEvent = function _onSectionEvent(event) {
        var el = event.target;
        var sectionId = event.detail.sectionId;
        var blockId = event.detail.blockId;
        var section = this.sections[sectionId];

        switch (event.type) {
          case 'shopify:section:load':
            this._loadSection(el, sectionId);
            break;

          case 'shopify:section:unload':
            this._triggerSectionEvent(section, 'unloadSection');
            delete this.sections[section];
            break;

          case 'shopify:section:select':
            this._triggerSectionEvent(section, 'selectSection', { sectionId: sectionId });
            break;

          case 'shopify:section:deselect':
            this._triggerSectionEvent(section, 'deselectSection');
            break;

          case 'shopify:section:reorder':
            this._triggerSectionEvent(section, 'reorderSection');
            break;

          case 'shopify:block:select':
            this._triggerSectionEvent(section, 'selectBlock', { blockId: blockId });
            break;

          case 'shopify:block:deselect':
            this._triggerSectionEvent(section, 'deselectBlock', { blockId: blockId });
            break;
        }
      };

      Sections.prototype._loadSection = function _loadSection(el, sectionId) {
        var scriptEl = el.querySelector('[data-section-id="' + sectionId + '"]');
        if (!scriptEl) return;

        var type = scriptEl.getAttribute('data-section-type');

        if (!this.handlers[type]) return;

        var handler = this.handlers[type];
        var data = _globalLoadData.loadData(scriptEl);

        this.sections[sectionId] = handler({
          el: el,
          data: data
        });
      };

      Sections.prototype._triggerSectionEvent = function _triggerSectionEvent(section, eventName) {
        if (section && section[eventName]) {
          for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          }

          section[eventName].apply(section, args);
        }
      };

      Sections.prototype.initSection = function initSection(type, handler) {
        var _this = this;

        if (!this.handlers[type]) this.handlers[type] = handler;
        var scriptEls = document.querySelectorAll('[data-section-type="' + type + '"]');

        Array.prototype.forEach.call(scriptEls, function (scriptEl) {
          var el = scriptEl.parentNode;
          var sectionId = scriptEl.getAttribute('data-section-id');
          var data = _globalLoadData.loadData(scriptEl);

          _this.sections[sectionId] = handler({
            el: el,
            data: data
          });
        });
      };

      return Sections;
    })();

    exports['default'] = Sections;
    module.exports = exports['default'];

  }, { "./global/loadData": 19 }], 9: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    require('focus-visible');

    require('./global/customEvent');

    var _globalImage = require('./global/image');

    var _globalImage2 = _interopRequireDefault(_globalImage);

    var _templatesAccount = require('./templates/Account');

    var _templatesAccount2 = _interopRequireDefault(_templatesAccount);

    var _templatesBlog = require('./templates/Blog');

    var _templatesBlog2 = _interopRequireDefault(_templatesBlog);

    var _templatesCart = require('./templates/Cart');

    var _templatesCart2 = _interopRequireDefault(_templatesCart);

    var _templatesCollection = require('./templates/Collection');

    var _templatesCollection2 = _interopRequireDefault(_templatesCollection);

    var _templatesHome = require('./templates/Home');

    var _templatesHome2 = _interopRequireDefault(_templatesHome);

    var _templatesProduct = require('./templates/Product');

    var _templatesProduct2 = _interopRequireDefault(_templatesProduct);

    var _snippetsProductItem = require('./snippets/ProductItem');

    var _snippetsProductItem2 = _interopRequireDefault(_snippetsProductItem);

    var _snippetsHeader = require('./snippets/Header');

    var _snippetsHeader2 = _interopRequireDefault(_snippetsHeader);

    var _snippetsFooter = require('./snippets/Footer');

    var _snippetsFooter2 = _interopRequireDefault(_snippetsFooter);

    var _snippetsMailingList = require('./snippets/MailingList');

    var _snippetsMailingList2 = _interopRequireDefault(_snippetsMailingList);

    var _snippetsNavigation = require('./snippets/Navigation');

    var _snippetsNavigation2 = _interopRequireDefault(_snippetsNavigation);

    var _snippetsNavigationMobile = require('./snippets/NavigationMobile');

    var _snippetsNavigationMobile2 = _interopRequireDefault(_snippetsNavigationMobile);

    var _globalRte = require('./global/Rte');

    var _globalRte2 = _interopRequireDefault(_globalRte);

    var _globalRightDrawer = require('./global/RightDrawer');

    var _globalRightDrawer2 = _interopRequireDefault(_globalRightDrawer);

    var _snippetsFooterTapbar = require('./snippets/FooterTapbar');

    var _snippetsFooterTapbar2 = _interopRequireDefault(_snippetsFooterTapbar);

    var _globalPopup = require('./global/Popup');

    var _globalPopup2 = _interopRequireDefault(_globalPopup);

    var _Sections = require('./Sections');

    var _Sections2 = _interopRequireDefault(_Sections);

    var _components2 = require('./components');

    var _components3 = _interopRequireDefault(_components2);

    var _sectionsSlideshow = require('./sections/Slideshow');

    var _sectionsSlideshow2 = _interopRequireDefault(_sectionsSlideshow);

    var TOGGLE_RIGHT_DRAWER_EVENT = 'wetheme-toggle-right-drawer';
    exports.TOGGLE_RIGHT_DRAWER_EVENT = TOGGLE_RIGHT_DRAWER_EVENT;
    var CART_UPDATE_EVENT = 'wetheme-cart-update';

    exports.CART_UPDATE_EVENT = CART_UPDATE_EVENT;

    var Theme = (function () {
      function Theme() {
        _classCallCheck(this, Theme);

        this.$ = $;
        this.name = 'Capital';
        this.$window = $(window);
        this.$body = $(document.body);
        this.navigationMobile = null;
        this.cartDrawerIcon = document.querySelector('.slide-menu-cart');

        var sections = new _Sections2['default']();
        if (!this.$body.hasClass('template-password')) {
          sections.initSection('header', function (section) {
            return new _snippetsHeader2['default'](section);
          });
          sections.initSection('slideshow', function (section) {
            return new _sectionsSlideshow2['default'](section);
          });
          sections.initSection('footer', function (section) {
            return new _snippetsFooter2['default'](section);
          });
        }

        // Initialize lazysizes customMedia
        _globalImage2['default']();

        this._checkMobile();
        this._initTemplates();
        this._bindEvents();
        this._loadComponents();
      }

      Theme.prototype._bindEvents = function _bindEvents() {
        $(document.body).on('shopify:section:load shopify:section:unload shopify:section:reorder shopify:section:select shopify:block:select', this._handleSettingsUpdate.bind(this));

        // Prevent clicks on cart drawer going to cart page during loading.
        if (this.cartDrawerIcon) {
          this.cartDrawerIcon.addEventListener('click', function (e) {
            e.preventDefault();
            return false;
          });
        }

        window.addEventListener('load', window.AOS.refresh);
        window.addEventListener('load', this._initDrawer.bind(this));
      };

      Theme.prototype._initDrawer = function _initDrawer() {
        this.drawer = new _globalRightDrawer2['default']();
      };

      Theme.prototype._checkMobile = function _checkMobile() {
        if (navigator.userAgent.match(/Mobile/i)) {
          $(document.body).addClass('is-mobile').trigger('bindMobile');
        }
      };

      Theme.prototype._initTemplates = function _initTemplates() {
        this.hasProductItems = $('[data-product-item-wrapper]').length;

        var isAccount = this.$body.hasClass('template-customers'),
          isBlog = this.$body.hasClass('template-blog'),
          isCart = this.$body.hasClass('template-cart'),
          isCollection = this.$body.hasClass('template-collection'),
          isHome = this.$body.hasClass('template-index'),
          isPassword = this.$body.hasClass('template-password'),
          isProduct = this.$body.hasClass('template-product');

        if (!isPassword) {
          new _snippetsNavigation2['default']('[data-main-navigation]');
          this.navigationMobile = new _snippetsNavigationMobile2['default']('[data-mobile-navigation]');

          if (isAccount) {
            new _templatesAccount2['default']('[data-account]');
          }

          if (isBlog) {
            new _templatesBlog2['default']('[data-blog]');
          }

          if (isCart) {
            new _templatesCart2['default']('[data-cart]');
          }

          if (isCollection) {
            new _templatesCollection2['default']('.collection-main-wrapper');
          }

          if (isHome) {
            this.Home = new _templatesHome2['default']();
          }

          if (isProduct) {
            new _templatesProduct2['default']('[data-product]');
          }

          if ($('.rich-text').length) {
            new _globalRte2['default']('.page-wrapper');
          }

          if (this.hasProductItems) {
            var productItemWrappers = $('[data-product-item-wrapper]');
            $.each(productItemWrappers, function (i, item) {
              new _snippetsProductItem2['default'](item);
            });
          }

          new _snippetsFooterTapbar2['default']('[data-footer-tapbar]');
        }

        if ($('[data-mailing-list]').length) {
          new _snippetsMailingList2['default']('[data-mailing-list]');
        }

        var popupEl = document.querySelector('#popup');
        // Don't show popup on CAPTCHA page
        if (popupEl && window.location.pathname != '/challenge') {
          this.popup = new _globalPopup2['default']();
        }

        window.AOS.init({
          once: true
        });
      };

      Theme.prototype._handleSettingsUpdate = function _handleSettingsUpdate(event) {
        var eventType = event.originalEvent.type;
        var sectionId = event.originalEvent.detail.sectionId;
        var $section = $('[data-section-id="' + sectionId + '"]');

        if ($section.length) {
          var type = $section.data('section-type');

          if (eventType === 'shopify:section:load') {
            this._loadSection(type, sectionId);
          }

          if (eventType === 'shopify:section:unload') {
            this._unloadSection(type, sectionId);
          }

          if (eventType === 'shopify:block:select') {
            var blockId = event.originalEvent.detail.blockId;
            this._selectBlock(type, $section, blockId);
          }

          if (eventType === 'shopify:section:select') {
            this._selectSection(type, sectionId);
          }
        }
      };

      Theme.prototype._loadSection = function _loadSection(type, sectionId) {
        switch (type) {
          case 'navigation':
          case 'header':
            new _snippetsNavigation2['default']('[data-main-navigation]');
            this.navigationMobile = new _snippetsNavigationMobile2['default']('[data-mobile-navigation]');
            this._initDrawer();
            break;
          case 'footer':
            new _snippetsMailingList2['default']('[data-mailing-list]');
            this.navigationMobile = new _snippetsNavigationMobile2['default']('[data-mobile-navigation]');
            break;
          case 'home':
            {
              var childType = $('[data-section-id="' + sectionId + '"]').data('section-child');
              switch (childType) {
                case 'departments':
                  this.Home.initDepartments();
                  break;
                case 'featured-products':
                  this.Home.initCollectionSlider();
                  if (this.hasProductItems) {
                    new _snippetsProductItem2['default']('[data-product-item-wrapper]');
                  }
                  break;
                case 'slideshow':
                  this.Home.initSlideshow(sectionId);
                  break;
                case 'video':
                  this.Home.initVideo(sectionId);
                  break;
                case 'map':
                  this.Home.initMaps(sectionId);
                  break;
                case 'featured-product':
                  this.Home.initFeaturedProduct(sectionId);
                  break;
                case 'video-hero':
                  this.Home.initVideoHero(sectionId);
                  break;
                case 'sliding-text':
                  this.Home.initSlidingText(sectionId);
                  break;
                case 'shop-the-look':
                  this.Home.initShopTheLook(sectionId);
                  break;
              }
              break;
            }
          case 'collection':
            new _templatesCollection2['default']('.collection-main-wrapper');
            if (this.hasProductItems) {
              new _snippetsProductItem2['default']('[data-product-item-wrapper]');
            }
            break;
          case 'password':
            new _snippetsMailingList2['default']('[data-mailing-list]');
            break;
          case 'product':
            new _templatesProduct2['default']('[data-product]');
            this.$window.trigger('resize.product');
            if (this.hasProductItems) {
              new _snippetsProductItem2['default']('[data-product-item-wrapper]');
            }
            break;
          case 'cart':
            new _templatesCart2['default']('[data-cart]');

            if (this.hasProductItems) {
              new _snippetsProductItem2['default']('[data-products-recent]');
            }
            break;
        }
        this._loadComponents();
      };

      Theme.prototype._unloadSection = function _unloadSection(type, sectionId) {
        this.$window.off('.' + type);
        this.$body.off('.' + type);

        switch (type) {
          case 'home':
            {
              var childType = $('[data-section-id="' + sectionId + '"]').data('section-child');

              switch (childType) {
                case 'departments':
                  if (window.innerWidth > 600) {
                    $('[data-departments-slideshow]').slick('unslick');
                  }
                  break;

                case 'featured-product':
                  this.Home.unloadFeaturedProduct(sectionId);
                  break;
              }
              break;
            }
          case 'product':
            if (window.innerWidth > 600 && $('[data-product-thumbnail-index]').length > 1) {
              $('[data-product-images]').slick('unslick');
            }
            break;

          case 'footer':
            if (this.navigationMobile) {
              this.navigationMobile.unloadSection();
              this.navigationMobile = null;
            }
            break;
        }
      };

      Theme.prototype._selectSection = function _selectSection(type, sectionId) {
        switch (type) {
          case 'footer':
            if (this.navigationMobile.layout === 'mobile') {
              this.navigationMobile._openMenu();
            }
            break;
          case 'video-hero':
            this.Home.initVideoHero(sectionId);
            break;
        }
      };

      Theme.prototype._selectBlock = function _selectBlock(type, $section, blockId) {
        switch (type) {
          case 'home':
            {
              var childType = $section.data('section-child');

              switch (childType) {
                case 'departments':
                  if (window.innerWidth > 600) {
                    var $block = $section.find('[data-block-id="' + blockId + '"]');
                    var slideIndex = $block.data('department-slide');
                    $section.find('[data-departments-slideshow]').slick('slickGoTo', slideIndex);
                  }
                  break;
              }
              break;
            }
        }
      };

      Theme.prototype._loadComponent = function _loadComponent(name, Component) {
        Array.prototype.forEach.call(document.querySelectorAll(name), function (el) {
          var _components;

          new Vue({
            el: el,
            components: (_components = {}, _components[name] = Component, _components)
          });
        });
      };

      Theme.prototype._loadComponents = function _loadComponents() {
        var _this = this;

        _components3['default'].forEach(function (_ref) {
          var name = _ref[0];
          var Component = _ref[1];
          return _this._loadComponent(name, Component);
        });
      };

      return Theme;
    })();

    exports['default'] = Theme;

    $(function () {
      window.wetheme = new Theme();
      // return new Theme();
    });

  }, { "./Sections": 8, "./components": 12, "./global/Popup": 13, "./global/RightDrawer": 14, "./global/Rte": 15, "./global/customEvent": 17, "./global/image": 18, "./sections/Slideshow": 32, "./snippets/Footer": 36, "./snippets/FooterTapbar": 37, "./snippets/Header": 38, "./snippets/MailingList": 41, "./snippets/Navigation": 42, "./snippets/NavigationMobile": 43, "./snippets/ProductItem": 45, "./templates/Account": 47, "./templates/Blog": 48, "./templates/Cart": 49, "./templates/Collection": 50, "./templates/Home": 51, "./templates/Product": 52, "focus-visible": 4 }], 10: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var Filters = (function () {
      function Filters(el, collection) {
        _classCallCheck(this, Filters);

        this.$el = $(el);
        this.$window = $(window);
        this.$body = $(document.body);
        this.$sidebar = this.$body.find('[data-collection-sidebar]');
        this.collection = collection;
        this.collectionUrl = '/collections/' + this.collection;
        this.tags = this._getTags();
        this._bindEvents();
      }

      Filters.prototype._bindEvents = function _bindEvents() {
        var _this = this;

        this.$el.on('click', '[data-filter-tag]', function (event) {
          event.preventDefault();
          _this._updateTags(event);
        });

        this.$el.on('click', '[data-filter-toggle]', function (event) {
          _this._toggleFilterSection(event);
        });

        this.$el.on('click', '[data-filters-submit]', function () {
          window.location.pathname = _this.collectionUrl + '/' + _this.tags.join('+');
        });

        this.$body.on('click', '[data-collection-filters-toggle]', function (event) {
          event.preventDefault();
          _this._toggleFilters();
        });

        this.$body.on('click', '[data-collection-sidebar]', function (event) {
          if (!$(event.target).closest('[data-collection-filters]').length) {
            _this._toggleFilters();
          }
        });

        this.$window.on('load', function () {
          _this._findActiveTags();
        });
      };

      Filters.prototype._findActiveTags = function _findActiveTags() {
        // Add 'active' class if 'tagname' is in 'current_tags', case insensitive.
        this.tags.forEach(function (tag) {
          $('.form-filter-wrapper.' + tag.toLowerCase()).find('a.collection-filter').addClass('active');
        });
      };

      Filters.prototype._toggleFilters = function _toggleFilters() {
        if (window.innerWidth < 721) {
          this.$sidebar.revealer('toggle');
          this.$body.toggleClass('scroll-locked');
        }
      };

      Filters.prototype._getTags = function _getTags() {
        var url = window.location.pathname.toLowerCase();
        var tags = url.split(this.collectionUrl)[1];

        if (tags.substring(0, 1) == '/') {
          tags = tags.substring(1);
        }

        if (tags.length && tags.indexOf('+') !== -1) {
          tags = tags.split('+');
        } else if (tags.length) {
          tags = [tags];
        } else {
          tags = [];
        }

        return tags;
      };

      Filters.prototype._updateTags = function _updateTags(event) {
        var $target = $(event.currentTarget);
        var $targetWrapper = $target.closest('[data-filter-wrapper]');
        var $activeTag = $targetWrapper.find('.active').length ? $targetWrapper.find('.active') : false;
        var activeTag = $activeTag.length ? $activeTag.data('filter-tag') : false;
        var tag = $target.data('filter-tag');
        var removeTag = !!$target.data('filter');

        if (removeTag) {
          this._removeTag($target, this.tags, tag);
          $targetWrapper.data('filter-wrapper', '');
        } else {
          this._addTag($target, this.tags, tag);
          $targetWrapper.data('filter-wrapper', tag);
        }

        if (window.innerWidth > 120) {
          window.location = this.collectionUrl + '/' + this.tags.join('+');
        }
      };

      Filters.prototype._addTag = function _addTag($target, tags, tag) {
        $target.addClass('active').data('filter', 'true');

        var filter = $target.text();
        var group = $target.closest('[data-filter-wrapper]').find('[data-filter-toggle]').text();
        var text = group + ': ' + filter;

        tags.push('' + tag);

        this.$el.find('[data-filter-tag-boxes]').append('\n      <span class="collection-filters-tag-box" data-filter-tag-box="' + tag + '">\n        ' + filter + '\n        <span>&times;</span>\n        <a href="' + tag + '"></a>\n      </span>\n    ');
      };

      Filters.prototype._removeTag = function _removeTag($target, tags, tag) {
        var tagIndex = tags.indexOf(tag);
        tags.splice(tagIndex, 1);

        $target.removeClass('active').data('filter', '');

        this.$el.find('[data-filter-tag-box="' + tag + '"]').remove();
      };

      Filters.prototype._toggleFilterSection = function _toggleFilterSection(event) {
        var $target = $(event.currentTarget).closest('[data-filter-wrapper]');
        $target.toggleClass('active');
      };

      return Filters;
    })();

    exports['default'] = Filters;
    module.exports = exports['default'];

  }, {}], 11: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    var dropdown_last_id = 0;

    function getElementWidth(el) {
      var clone = el.cloneNode(true);
      clone.style.cssText = 'position: fixed; top: 0; left: 0; overflow: auto; visibility: hidden; pointer-events: none; height: unset; max-height: unset';
      document.body.appendChild(clone);
      var width = clone.getBoundingClientRect().width;
      document.body.removeChild(clone);
      return width;
    }

    var Dropdown = {
      props: {
        fit: {
          type: String,
          'default': 'parent',
          validator: function validator(value) {
            return ['parent', 'current', 'longest'].indexOf(value) !== -1;
          }
        },
        direction: {
          type: String,
          'default': 'down',
          validator: function validator(value) {
            return ['down', 'up'].indexOf(value) !== -1;
          }
        }
      },
      data: function data() {
        return {
          id: '',
          title: '',
          open: false,
          options: [],
          selectedOption: undefined,
          // focusedIndex is index of option that user navigated to using keyboard,
          // it's equal to index of selected option when keyboard was not used
          focusedIndex: 0,
          selectComponent: undefined
        };
      },
      beforeMount: function beforeMount() {
        // Convert a <select> and <label> into options and other properties
        var select = this.$root.$el.querySelector('select');
        if (select.id) {
          this.id = select.id;
        } else {
          dropdown_last_id += 1;
          this.id = 'wetheme-dropdown-' + dropdown_last_id;
        }
        var labelEl = this.$root.$el.querySelector('label');
        this.title = labelEl ? labelEl.textContent : undefined;
        var options = [];
        Array.prototype.forEach.call(select.querySelectorAll('option'), (function (option, index) {
          options.push({
            value: option.value,
            label: option.textContent
          });
          if (option.defaultSelected) {
            this.selectedOption = option;
            this.focusedIndex = index;
          }
        }).bind(this));
        this.options = options;
        if (!this.selectedOption) {
          this.selectedOption = options[0];
          this.focusedIndex = 0;
        }
        this.selectWidth = getElementWidth(select);
        this.selectComponent = select;
        this.selectComponent.style.display = 'none';
      },
      mounted: function mounted() {
        if (this.fit === 'longest') {
          var w = this.selectWidth + 20; // 20px for caret
          this.$el.style.width = w + 'px';
          this.$refs.ul.style.width = w + 'px';
        }
        this.$el.appendChild(this.selectComponent);
      },
      computed: {
        dropdownId: function dropdownId() {
          return this.id + '-dropdown';
        }
      },
      methods: {
        findOptionIndex: function findOptionIndex(option) {
          var index;
          this.options.forEach(function (o, i) {
            if (o.value === option.value) {
              index = i;
            }
          });
          return index;
        },
        optionClicked: function optionClicked(option) {
          this.selectedOption = option;
          this.focusedIndex = this.findOptionIndex(option);
          this.selectComponent.value = option.value;
          this.$nextTick(function () {
            // Emit the event when input value is already changed
            var e = new CustomEvent('change');
            this.selectComponent.dispatchEvent(e);
          });
        },
        moveFocusedIndex: function moveFocusedIndex(offset) {
          var focusedIndex = this.focusedIndex + offset;
          if (focusedIndex >= 0 && focusedIndex < this.options.length) {
            this.focusedIndex = focusedIndex;
          }
          if (!this.open) {
            this.applyFocused(true);
          }
        },
        applyFocused: function applyFocused() {
          var force = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

          if (!this.open && !force) {
            this.open = true;
            return;
          }
          this.optionClicked(this.options[this.focusedIndex]);
          this.open = false;
        },
        close: function close() {
          this.open = false;
        },
        focusButton: function focusButton() {
          this.$refs.button.focus();
        }
      },
      template: '\n    <div class="wetheme-dropdown" ref="component" :class="[\'fit-\' + this.fit, open ? \'wetheme-dropdown--open\' : \'wetheme-dropdown--closed\', \'wetheme-dropdown--\' + direction]">\n      <label v-if="title" :for="id" v-text="title"></label>\n      <div class="wetheme-dropdown__wrapper">\n        <button\n          ref="button"\n          type="button"\n          autocomplete="off"\n          readonly="true"\n          :id="id"\n          :aria-controls="dropdownId"\n          :aria-expanded="open"\n          @focus="open = true"\n          @blur="open = false"\n          @click="focusButton"\n          @keydown.up.prevent="moveFocusedIndex(-1)"\n          @keydown.down.prevent="moveFocusedIndex(1)"\n          @keydown.enter.prevent="applyFocused(false)"\n          @keydown.space.prevent="applyFocused(false)"\n          @keydown.esc.prevent="close"\n        >\n          <span v-text="selectedOption.label || \' \'"></span>\n        </button>\n        <transition name="wetheme-dropdown-fade">\n          <ul :id="dropdownId" ref="ul" v-show="open">\n            <li\n              v-for="option in options"\n              :key="option.value"\n              :value="option.value"\n              :class="{ selected: option.value === options[focusedIndex].value }"\n              @mousedown="optionClicked(option)"\n              v-text="option.label"\n            ></li>\n          </ul>\n        </transition>\n      </div>\n    </div>\n  '
    };

    exports['default'] = Dropdown;
    module.exports = exports['default'];

  }, {}], 12: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    var _DropDown = require('./DropDown');

    var _DropDown2 = _interopRequireDefault(_DropDown);

    exports['default'] = [['wetheme-dropdown', _DropDown2['default']]];
    module.exports = exports['default'];

  }, { "./DropDown": 11 }], 13: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _micromodal = require('micromodal');

    var _micromodal2 = _interopRequireDefault(_micromodal);

    var Popup = (function () {
      function Popup() {
        _classCallCheck(this, Popup);

        this.popupContainer = document.querySelector('#popup');
        this.testMode = this.popupContainer.dataset.popupTestMode === 'true';
        this.popupSkipDays = parseInt(this.popupContainer.dataset.popupTime, 10);
        this.popupDelay = parseInt(this.popupContainer.dataset.popupDelay, 10);

        this.LOCAL_STORAGE_KEY = 'wetheme-popup';

        this._load();
      }

      Popup.prototype._load = function _load() {
        var _this = this;

        _micromodal2['default'].init({
          awaitOpenAnimation: true
        });

        if (this.testMode) {
          // popup is in test mode - will show immediately in editor and on live site
          _micromodal2['default'].show('popup', {
            awaitCloseAnimation: true
          });
        } else if (this._isExpiredOrNotSet()) {
          // popup is expired in local storage or was not set - will show after delay
          setTimeout(function () {
            _this._setExpiry(_this.popupSkipDays);
            _micromodal2['default'].show('popup', {
              awaitCloseAnimation: true
            });
          }, 1000 * this.popupDelay);
        }

        // hide focus outline when page first loads
        document.body.classList.add('using-mouse');
      };

      Popup.prototype._isExpiredOrNotSet = function _isExpiredOrNotSet() {
        var expired = true;

        if (!this._isLocalStorageSupported(function () {
          return localStorage;
        })) {
          return expired;
        }

        var popupInfo = window.localStorage.getItem(this.LOCAL_STORAGE_KEY);
        if (popupInfo) {
          try {
            var expiry = Date.parse(JSON.parse(popupInfo).expiry);
            if (expiry > Date.now()) {
              expired = false;
            }
          } catch (e) {
            console.warn('Unable to read popup expiry date', e);
          }
        }
        return expired;
      };

      Popup.prototype._setExpiry = function _setExpiry(days) {
        var expiry = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
        try {
          localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify({
            expiry: expiry.toISOString()
          }));
        } catch (e) {
          console.warn('Unable to set popup expiry', e);
        }
      };

      Popup.prototype._isLocalStorageSupported = function _isLocalStorageSupported(getStorage) {
        try {
          var key = "__random_key_name___e__";
          getStorage().setItem(key, key);
          getStorage().removeItem(key);
          return true;
        } catch (e) {
          return false;
        }
      };

      return Popup;
    })();

    exports['default'] = Popup;
    module.exports = exports['default'];

  }, { "micromodal": 5 }], 14: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _Theme = require('../Theme');

    var _slideoutFocusTrap = require('./slideoutFocusTrap');

    var _slideout = require('slideout');

    var _slideout2 = _interopRequireDefault(_slideout);

    var RightDrawer = (function () {
      function RightDrawer() {
        _classCallCheck(this, RightDrawer);

        this.$window = $(window);
        this.type = _Theme.TOGGLE_RIGHT_DRAWER_EVENT;
        this.data = null;
        this.theme = window.wetheme;
        this.cartIcon = document.querySelector('.slide-menu-cart');
        this.slideoutRight = null;
        this.rightSlideout = document.querySelector('#cartSlideoutWrapper');
        this.overlay = document.querySelector('#slideout-overlay');
        this.mainBody = document.querySelector('#main-body');
        this.lastFocus = document.activeElement;
        this.mobileDrawerSize = 375;
        this.desktopDrawerSize = 580;
        this.isDesktop = window.innerWidth > 768 ? true : false;
        this.isMobile = !this.isDesktop;
        this.bodyTopPadding = 0;

        this._load();
      }

      RightDrawer.prototype._bindEvents = function _bindEvents() {
        var self = this;

        document.documentElement.addEventListener(_Theme.TOGGLE_RIGHT_DRAWER_EVENT, this.handleToggle.bind(this), false);

        this.$window.on('resize', _.debounce(this._onWindowResize.bind(this), 100));

        // Toggle cart button
        $('.slide-menu-cart').off('click').on('click', function (e) {
          self.slideoutRight.toggle();
          var slideoutID = self.slideoutRight.menu.id;
          _slideoutFocusTrap.trapFocus(slideoutID, self.slideoutRight.isOpen());

          e.preventDefault();
          return false;
        });

        $('.cart-menu-close').on('click', function (e) {
          self.slideoutRight.close();
          e.preventDefault();
          return false;
        });
      };

      RightDrawer.prototype._load = function _load() {
        if (!this.rightSlideout) return;

        if (this.slideoutRight) {
          this.slideoutRight.close();
        }

        this._setInitialCart();

        this.slideoutRight = this.createDrawer(this.rightSlideout, this.overlay);

        this._bindEvents();
      };

      RightDrawer.prototype._onWindowResize = function _onWindowResize() {
        var wasMobile = this.isMobile;
        this.isDesktop = window.innerWidth > 768 ? true : false;

        // Cart slider is disabled.
        if (!this.rightSlideout) return;

        // Resize right drawer based on window width.
        var slideout = this.slideoutRight;
        var padding = this.isDesktop ? this.desktopDrawerSize : this.mobileDrawerSize;
        slideout._translateTo = slideout._padding = padding * slideout._orientation;

        if (slideout._opened) {
          document.body.style.paddingTop = '0px';
          var transform = "translateX(" + padding * slideout._orientation + "px)";
          slideout.panel.style.webkitTransform = transform;
          slideout.panel.style.transform = transform;
        }
      };

      RightDrawer.prototype._toggleRightDrawer = function _toggleRightDrawer() {
        var type = arguments.length <= 0 || arguments[0] === undefined ? 'cart' : arguments[0];
        var forceOpen = arguments.length <= 1 || arguments[1] === undefined ? undefined : arguments[1];
        var params = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

        var event = new CustomEvent(_Theme.TOGGLE_RIGHT_DRAWER_EVENT, {
          detail: {
            type: type,
            forceOpen: forceOpen,
            params: params
          }
        });

        document.documentElement.dispatchEvent(event);
      };

      RightDrawer.prototype.handleToggle = function handleToggle(event) {
        var _event$detail = event.detail;
        var type = _event$detail.type;
        var forceOpen = _event$detail.forceOpen;
        var params = _event$detail.params;

        if (params) {
          if (params.cart) {
            this.updateCartDrawer(params.cart);
          }
        }

        this.slideoutRight.toggle();
      };

      RightDrawer.prototype._setInitialCart = function _setInitialCart() {
        var initial = document.querySelector('#initial-cart');
        if (!initial) return;

        this.data = JSON.parse(initial.textContent);
        this.updateCartDrawer(this.data);
      };

      RightDrawer.prototype.createDrawer = function createDrawer(drawer) {
        var self = this;
        var padding = this.mobileDrawerSize;
        if (this.isDesktop) padding = this.desktopDrawerSize;

        var side = 'right';
        var dir = -1;

        var slideout = new _slideout2['default']({
          'panel': this.mainBody,
          'menu': drawer,
          'padding': padding,
          'tolerance': 70,
          'side': side,
          'touch': false
        });

        drawer.classList.add('slideout-panel-hidden');

        var $overlay = $(this.overlay);
        this.overlay.addEventListener('click', slideout.close.bind(slideout));

        // Handle slide to close
        var touch_start = null;
        this.overlay.addEventListener('touchstart', function (event) {
          if (!slideout.isOpen()) {
            return;
          }
          event.preventDefault();
          touch_start = event.touches[0].pageX;
        });

        this.overlay.addEventListener('touchmove', function (event) {
          if (!slideout.isOpen()) {
            return;
          }
          var offset = touch_start - event.touches[0].pageX;
          var translate = dir * padding - offset;
          if (Math.abs(translate) > padding) {
            translate = dir * padding;
          }
          self.mainBody.style.webkitTransform = 'translateX(' + translate + 'px)';
          self.mainBody.style.transform = 'translateX(' + translate + 'px)';
        });

        this.overlay.addEventListener('touchend', function (event) {
          if (!slideout.isOpen()) {
            return;
          }
          var offset = touch_start - event.changedTouches[0].pageX;
          if (offset === 0 || Math.abs(offset) > 70) {
            slideout.close();
          } else {
            self.mainBody.style.webkitTransform = 'translateX(' + dir * padding + 'px)';
            self.mainBody.style.transform = 'translateX(' + dir * padding + 'px)';
          }
        });

        slideout.on('beforeopen', function () {
          drawer.classList.remove('slideout-panel-hidden');

          $overlay.fadeIn();
          var $cart_close = $('.cart-menu-close');
          if ($cart_close.length > 0) $cart_close.focus();

          // Lock scrolling.
          var marginTop = $(window).scrollTop() + 'px';
          self.mainBody.style.position = 'fixed';
          self.mainBody.style.marginTop = '-' + marginTop;

          this.bodyTopPadding = document.body.style.paddingTop;
          document.body.style.paddingTop = '0px';
        });

        slideout.on('beforeclose', function () {
          $overlay.fadeOut();
          $('.js-cart-drawer-status').text('');

          // Unlock scrolling.
          var scrollTop = -parseInt(self.mainBody.style.marginTop);
          self.mainBody.style.position = '';
          self.mainBody.style.marginTop = '';
          $(window).scrollTop(scrollTop);
        });

        slideout.on('close', function () {
          drawer.classList.add('slideout-panel-hidden');
          document.body.style.paddingTop = this.bodyTopPadding;
        });

        slideout.on('translate', function (translated) {
          var hidden = false;
          if (translated === 0) {
            hidden = true;
          } else if (side === 'left') {
            hidden = translated <= 0;
          } else if (side === 'right') {
            hidden = translated >= 0;
          }
          drawer.classList.toggle('slideout-panel-hidden', hidden);
        });

        return slideout;
      };

      /** @param {Cart} cart */

      RightDrawer.prototype.updateCartDrawer = function updateCartDrawer(cart) {
        var _this = this;

        var self = this;

        $('.cart-error-box').text('');

        if (cart.items.length === 0) {
          $('.cart-empty-box,.ajax-cart--total-price').removeClass('hide');
          $('.ajax-cart--total-price,.cart-button-checkout,.additional-checkout-buttons').addClass('hide');
        } else {
          $('.cart-empty-box').addClass('hide');
          $('.ajax-cart--total-price,.cart-button-checkout,.additional-checkout-buttons').removeClass('hide');
        }

        var template = $('#cart-item-template').html();
        var $cart_items = $('.cart-items');
        $cart_items.empty();

        var $cart_drawer_status = $('.js-cart-drawer-status');
        var cart_title = $('.cart-drawer--title').text();
        var updateStatus = function updateStatus() {
          $cart_drawer_status.html('<span>' + Theme.localization.cart.cart_item + ' ' + self.status_string + ' ' + cart_title + ', ' + Shopify.formatMoney(cart.total_price, Theme.moneyFormat) + '</span>').appendTo('.cart-drawer__top');
        };

        cart.items.forEach(function (item, index) {
          var $cart_item = $(template);
          if (item.image) {
            $cart_item.find('.cart-item-image').attr({
              src: item.image,
              alt: item.title
            });
          } else {
            $cart_item.find('.cart-item-image').css('display', 'none');
          }
          $cart_item.find('.cart-item-link').attr({ href: item.url });
          $cart_item.find('.cart-item-product-title').text(item.product_title);
          if (item.variant_title) {
            $cart_item.find('.cart-item-variant-title').removeClass('hide').text(item.variant_title);
          }
          $cart_item.find('.cart-item-price').html(Shopify.formatMoney(item.final_line_price, Theme.moneyFormat));
          if (item.unit_price_measurement) {
            $cart_item.find('.cart-item-price-per-unit').html('<span class="price">(' + Shopify.formatMoney(item.unit_price, Theme.moneyFormat) + ' / ' + (item.unit_price_measurement.reference_value != 1 ? item.unit_price_measurement.reference_value : '') + ' ' + item.unit_price_measurement.reference_unit + ')');
          } else {
            $cart_item.find('.cart-item-price-per-unit').text('');
          }

          var selling_plan_name = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : null;
          if (selling_plan_name) {
            $cart_item.find('.cart-item-selling-plan').removeClass('hide').html(item.selling_plan_allocation.selling_plan.name);
          }

          var $original_price = $cart_item.find('.cart-item-price-original');
          if (item.original_line_price > item.final_line_price) {
            $original_price.html(Shopify.formatMoney(item.original_line_price, Theme.moneyFormat)).show();
          } else {
            $original_price.hide();
          }

          var quantity = $cart_item.find('.cart-item-quantity');
          var quantity_wrapper = quantity.closest('.cart-item--quantity-wrapper');

          var update_quantity = function update_quantity(quantity) {
            quantity_wrapper.addClass('cart-item-quantity-active');

            var fade = quantity <= 0;
            var delay = fade ? 250 : 0;

            _this.cartSetQuantity(delay).always(function () {
              quantity_wrapper.removeClass('cart-item-quantity-active');

              if (fade) {
                $cart_item.addClass('fadeOut animated fast');
                setTimeout(function () {
                  $cart_item.remove();
                }, 250);
              }
            });
          };

          quantity.on('change', function () {
            var new_q = parseInt($(this).val().toString(), 10);
            update_quantity(new_q);
          });
          quantity.val(item.quantity);
          quantity.attr('name', 'updates[]');

          $cart_item.find('.cart-item-quantity-button').on('click', function () {
            var current = parseInt(quantity.val().toString(), 10);
            var change = parseInt(this.dataset.amount, 10);
            var new_q = current + change;
            self.status_string = change > 0 ? Theme.localization.cart.added_to_cart : Theme.localization.cart.removed_from_cart;

            quantity.val(new_q);
            update_quantity(new_q);
          });

          $cart_item.find('#cart-item-remove-button').on('click', function () {
            self.status_string = Theme.localization.cart.removed_from_cart;
            var new_q = 0;
            quantity.val(new_q);
            update_quantity(new_q);
          });

          var $discounts = $cart_item.find('.order-discount--cart-list').empty();

          item.line_level_discount_allocations.forEach(function (discount_allocation) {
            var $item = $('<li class="order-discount--item"></li>');
            $('<span class="order-discount--item-title"></span>').text(discount_allocation.discount_application.title).appendTo($item);
            $('<span class="order-discount--cart-amount"></span>').html('<span class="sr-only">' + Theme.localization.cart.saving + '</span> (-' + Shopify.formatMoney(discount_allocation.amount, Theme.moneyFormat) + ')').appendTo($item);
            $discounts.append($item);
          });

          $cart_item.appendTo($cart_items);
        });

        if (self.status_string) updateStatus();

        $('.cart-item-count, .cart-item-count-header--quantity').text(cart.item_count);
        $('.cart-total-price, .cart-item-count-header--total').html(Shopify.formatMoney(cart.total_price, Theme.moneyFormat));

        var $original_price = $('.cart-item-original-total-price');
        if (cart.original_total_price > cart.total_price) {
          $original_price.html(Shopify.formatMoney(cart.original_total_price, Theme.moneyFormat)).show();
        } else {
          $original_price.hide();
        }

        var $cart_discount = $('.ajax-cart-discount-wrapper').empty();
        cart.cart_level_discount_applications.forEach(function (discount_application) {
          var $item = $('<div class="cart--order-discount-wrapper--indiv"></div>');
          $('<span class="order-discount"></span>').html('-' + self.theme.formatMoney(discount_application.total_allocated_amount)).appendTo($item);
          $('<span class="order-discount--cart-title"></span>').text(discount_application.title).appendTo($item);
          $cart_discount.append($item);
        });

        return;
      };

      RightDrawer.prototype.cartSetQuantity = function cartSetQuantity(delay) {
        var _this2 = this;

        var deferred = $.Deferred();
        $('.cart-error-box').text('');

        $.ajax({
          type: "POST",
          url: '/cart/update.js',
          dataType: 'json',
          data: $('.cart-drawer-form').serialize()
        }).then(function (data) {
          deferred.resolve();
          setTimeout(function () {
            _this2.updateCartDrawer(data);
          }, delay);
        }).fail(function (jqXHR, textStatus, errorThrown) {
          deferred.reject();
          console.error('Cart ', textStatus, jqXHR, errorThrown);
          var errorText = jqXHR.responseJSON ? jqXHR.responseJSON.description : '';
          $('.cart-error-box').empty().text('Unable to update item quantity: ' + errorText);
        });

        return deferred;
      };

      return RightDrawer;
    })();

    exports['default'] = RightDrawer;
    module.exports = exports['default'];

  }, { "../Theme": 9, "./slideoutFocusTrap": 25, "slideout": 7 }], 15: [function (require, module, exports) {
    "use strict";

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

    var Rte = function Rte(el) {
      _classCallCheck(this, Rte);

      this.$el = $(el);
      this.$el.fitVids();
    };

    exports["default"] = Rte;
    module.exports = exports["default"];

  }, {}], 16: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    exports['default'] = function () {
      Shopify.getCart(function (data) {
        var itemCount = data.item_count > 0 ? data.item_count : '';
        $('[data-header-cart-count]').text(itemCount);
      });
    };

    module.exports = exports['default'];

  }, {}], 17: [function (require, module, exports) {
    // Polyfill for CustomEvent in IE
    "use strict";

    (function () {
      if (typeof window.CustomEvent === "function") return false;

      function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
      }

      window.CustomEvent = CustomEvent;
    })();

  }, {}], 18: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;
    exports['default'] = image;

    function image() {
      window.lazySizesConfig = window.lazySizesConfig || {};
      window.lazySizesConfig.customMedia = {
        '--xs': '(max-width: 500px)',
        '--s': '(max-width: 720px)',
        '--m': '(max-width: 960px)',
        '--l': '(max-width: 1060px)'
      };
    }

    module.exports = exports['default'];

  }, {}], 19: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;
    function loadData(el) {
      if (el.hasAttribute('data-section-data') && el.innerHTML) {
        return JSON.parse(el.innerHTML);
      }
      return false;
    }

    exports.loadData = loadData;

  }, {}], 20: [function (require, module, exports) {
    "use strict";

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

    var VideoAPIs = (function () {
      function VideoAPIs() {
        _classCallCheck(this, VideoAPIs);
      }

      VideoAPIs.prototype.loadYoutubeApi = function loadYoutubeApi() {
        var self = this;
        return new Promise(function (resolve) {
          if (window.YT) {
            // We already have youtube API loaded.
            resolve();
          } else if (!document.querySelector('#youtube_api')) {
            // Resolve once youtube is loaded
            window.youtube_loaded_callbacks.push(resolve);

            // Youtube API is not yet loaded, create script that loads it
            self.create_script("youtube_api", "https://www.youtube.com/player_api");
          } else {
            // Script for loading youtube API is there, but youtube is not yet loaded
            window.youtube_loaded_callbacks.push(resolve);
          }
        });
      };

      VideoAPIs.prototype.loadVimeoApi = function loadVimeoApi() {
        var self = this;
        return new Promise(function (resolve) {
          if (!document.querySelector('#vimeo_api')) {
            // Vimeo API is not yet loaded, create script that loads it
            var script = self.create_script("vimeo_api", "https://player.vimeo.com/api/player.js");

            // Other browsers
            script.onload = function () {
              resolve();
            };
          } else if (!window.Vimeo) {
            // Script for loading vimeo API is there, but vimeo is not yet loaded.
            // Promise will be resolved when script finishes loading
          } else {
            // We already have vimeo API loaded.
            resolve();
          }
        });
      };

      VideoAPIs.prototype.create_script = function create_script(id, src) {
        var tag = document.createElement('script');
        tag.id = id;
        tag.src = src;
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        return tag;
      };

      return VideoAPIs;
    })();

    exports["default"] = VideoAPIs;

    window.youtube_loaded_callbacks = [];

    window.onYouTubePlayerAPIReady = function () {
      window.youtube_loaded_callbacks.forEach(function (callback) {
        callback();
      });
      window.youtube_loaded_callbacks.splice(0);
    };
    module.exports = exports["default"];

  }, {}], 21: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var ProductBadges = (function () {
      function ProductBadges(el, scope) {
        _classCallCheck(this, ProductBadges);

        this.$el = $(el);
        this.scope = scope;
        this.$badgeScrollers = this.$el.find('.product-item-banners.animated');

        if (this.$badgeScrollers.length > 0) {
          this._handleBadgeScroller();
        }
      }

      ProductBadges.prototype._addBadgeClones = function _addBadgeClones(scroller) {
        var parentWidth = $(scroller).parent().width();
        var minWidth = parentWidth * 1.5;

        if ($(scroller)[0].scrollWidth >= minWidth) return;

        var $badgeWrapper = $(scroller).find('.badges-wrapper:not(.cloned)');
        var $badges = $badgeWrapper.find('.product-item-banner:not(.cloned)');

        // Clone all the existing badges once.
        $.each($badges, function (i, badge) {
          $(badge).clone().addClass('cloned').attr('aria-hidden', 'true').appendTo($badgeWrapper);
        });

        // Clone inner badges more times until minimum width met.
        if ($(scroller)[0].scrollWidth < minWidth) {
          this._addBadgeClones(scroller);
        }
      };

      ProductBadges.prototype._handleBadgeScroller = function _handleBadgeScroller() {
        var _this = this;

        $.each(this.$badgeScrollers, function (i, scroller) {
          // Scrolling badges should be minimum width. Add clones of the badge/s until
          // min width is met.
          _this._addBadgeClones(scroller);

          // Clone the wrapper for the infinite looping illusion.
          $(scroller).find('.badges-wrapper:not(.cloned)').clone().addClass('cloned').attr('aria-hidden', 'true').appendTo($(scroller));

          var autoplay = false;

          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            autoplay = true;
          }

          // Edge does not have reduced motion capabilities, so keep the animation.
          if (navigator.appVersion.indexOf("Edg/") > -1 || navigator.appVersion.indexOf("Edge") > -1 || window.navigator.userAgent.indexOf("Edge") > -1) {
            autoplay = true;
          }

          if (autoplay) {
            $(scroller).find('.badges-wrapper').css('animation-play-state', 'running');
          } else {
            // Remove clones, set back to static badge style.
            $(scroller).find('.badges-wrapper').remove('.cloned');
            $(scroller).find('.product-item-banner').remove('.cloned');
            $(scroller).removeClass('animated').parent().removeClass('contains-animated');
          }
        });
      };

      return ProductBadges;
    })();

    exports['default'] = ProductBadges;
    module.exports = exports['default'];

  }, {}], 22: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _loadVideoAPIs = require('../loadVideoAPIs');

    var _loadVideoAPIs2 = _interopRequireDefault(_loadVideoAPIs);

    var ProductMedia = (function () {
      function ProductMedia(parent, playOnLoad) {
        _classCallCheck(this, ProductMedia);

        this.$window = $(window);
        this.parent = parent;
        this.$parent = $(parent);
        this.media_id = parent.dataset.mediaId;
        this.type = parent.dataset.mediaType;
        this.$images = $(parent).closest('[data-product-images]');
        this.playOnLoad = playOnLoad;
        this.loaded = false;
        this.active = false;
        this.controller = null;
        this._loadXr($(parent));
        this.videoAPIs = new _loadVideoAPIs2['default']();

        if (this.type != 'image') {
          if (this.parent.classList.contains('product-single__media--selected')) {
            this.load().then(function () {
              if (playOnLoad) {
                this.play.bind(this);
              }
            });
          }
        }

        this._bindEvents();
      }

      // Let the document know when the mouse is being used

      ProductMedia.prototype._bindEvents = function _bindEvents() {
        var _this = this;

        this.events = [this.$parent.off('click.' + this.scope).on('click.' + this.scope, function (event) {
          if (_this.type == 'video' || _this.type == 'external_video') {
            _this.togglePlay();
          }
        })];

        Shopify.onError = function (XMLHttpRequest) {
          _this._handleErrors(XMLHttpRequest);
        };
      };

      ProductMedia.prototype._loadXr = function _loadXr($el) {
        if ($el.find('.product-single__view-in-space').length > 0) {
          // The "View in your space" button is there => we have a model. Load XR library so
          // it can show/hide the button based on browser/device support
          window.Shopify.loadFeatures([{
            name: 'shopify-xr',
            version: '1.0'
          }]);
          document.addEventListener('shopify_xr_launch', function () {
            // The launch of XR viewer triggers beforeload event, we need to reappear page content
            setTimeout(function () {
              document.body.classList.remove('unloading');
            }, 100);
          });

          // Make sure other media doesn't activate.
          $el.on('click', '.product-single__view-in-space', function (e) {
            e.stopImmediatePropagation();
          });
        }
      };

      ProductMedia.prototype.load = function load() {
        return new Promise((function (resolve) {
          if (this.loaded) {
            resolve();
            return;
          }

          switch (this.type) {
            case 'model':
              window.Shopify.loadFeatures([{
                name: 'model-viewer-ui',
                version: '1.0'
              }], (function () {
                this.controller = new Shopify.ModelViewerUI(this.parent.querySelector('model-viewer'));

                // Don't interact with the rest of the page when model is active
                this.controller.viewer.parentElement.addEventListener('mouseup', (function (e) {
                  e.stopPropagation = function () { };
                }).bind(this), {
                  capture: true
                });

                // Prevent activating the viewer right after it was paused when clicked in position of the button
                this.controller.elements.controlButton.addEventListener('click', (function (e) {
                  e.stopImmediatePropagation();
                }).bind(this), { capture: true });

                this.controller.viewer.addEventListener('shopify_model_viewer_ui_toggle_pause', this.on_pause.bind(this));
                this.controller.viewer.addEventListener('shopify_model_viewer_ui_toggle_play', this.on_play.bind(this));

                this.on_load();
                resolve();
              }).bind(this));
              break;
            case 'video':
              window.Shopify.loadFeatures([{
                name: 'video-ui',
                version: '1.0',
                onLoad: (function () {
                  var video = this.parent.querySelector('video');
                  var loop = video.parentNode.dataset.videoLoop === 'true';
                  this.controller = new Shopify.Plyr(video, {
                    loop: {
                      active: loop
                    }
                  });
                  video.addEventListener('play', this.on_play.bind(this));
                  video.addEventListener('pause', this.on_pause.bind(this));
                  video.addEventListener('ended', this.on_pause.bind(this));

                  this.on_load();
                  resolve();
                }).bind(this)
              }]);
              break;
            case 'external_video':
              this.videoAPIs.loadYoutubeApi().then((function () {
                var iframe = this.parent.querySelector('iframe');
                var loop = iframe.parentNode.dataset.videoLoop === 'true';
                new window.YT.Player(iframe, {
                  events: {
                    onReady: (function (event) {
                      this.controller = event.target;
                      this.on_load();
                      resolve();
                    }).bind(this),
                    onStateChange: (function (event) {
                      if (event.data === window.YT.PlayerState.PLAYING) {
                        this.on_play();
                      } else if (event.data === window.YT.PlayerState.PAUSED) {
                        this.on_pause();
                      } else if (event.data === window.YT.PlayerState.ENDED) {
                        if (loop) {
                          this.controller.playVideo();
                        } else {
                          this.on_pause();
                        }
                      }
                    }).bind(this),
                    onError: (function (event) {
                      console.warn('Youtube video error', event, event.data);
                      this.on_pause();
                    }).bind(this)
                  }
                });
              }).bind(this));
              break;
            case 'image':
              this.parent.querySelector('img').addEventListener('load', (function () {
                this.on_load();
                resolve();
              }).bind(this));
              break;
            default:
              this.on_load();
              resolve();
          }
        }).bind(this));
      };

      ProductMedia.prototype.on_load = function on_load() {
        this.loaded = true;
        this.parent.classList.add('product-single__media--loaded');
        var e = new CustomEvent('media-load', {
          detail: {
            parent: this.parent,
            media: this
          }
        });
        this.parent.dispatchEvent(e);
        if (window.ShopifyXR && window.ShopifyXR.setupXRElements) {
          window.ShopifyXR.setupXRElements();
        }
      };

      ProductMedia.prototype.play = function play() {
        if (this.type == 'image') return;
        if (!this.loaded) {
          var self = this;
          this.load().then(function () {
            self.loaded = true;
            if (self.playOnLoad) {
              self._play();
            }
          });
        } else {
          this._play();
        }
      };

      ProductMedia.prototype._play = function _play() {
        switch (this.type) {
          case 'model':
            this.parent.getElementsByTagName('model-viewer')[0].tabIndex = 0;
            this.controller.play();
            this.on_play();
            break;
          case 'video':
            this.controller.play().then(this.on_play.bind(this))['catch'](console.warn);
            break;
          case 'external_video':
            this.parent.getElementsByTagName('iframe')[0].tabIndex = 0;
            this.controller.playVideo();
            this.on_play();
            break;
        }
      };

      ProductMedia.prototype.on_play = function on_play() {
        this.active = true;
        document.body.classList.add('media-playing');
        this.slick_disable_swipe();
        this.parent.classList.add('product-single__media--active');
        if (!this.loaded) {
          this.loaded = true;
          this.parent.classList.add('product-single__media--loaded');
        }
        var e = new CustomEvent('media-play', {
          detail: {
            parent: this.parent,
            media: this
          }
        });
        this.parent.dispatchEvent(e);
      };

      ProductMedia.prototype.autoplay = function autoplay() {
        if ($(window).width() > 768) {
          this.play();
        }
      };

      ProductMedia.prototype.pause = function pause() {
        if (!this.active) {
          return;
        }
        switch (this.type) {
          case 'model':
            this.controller.viewer.pause();
            this.controller.pause();
            break;
          case 'video':
            this.controller.pause();
            break;
          case 'external_video':
            this.controller.pauseVideo();
            break;
        }
        this.on_pause();
      };

      ProductMedia.prototype.togglePlay = function togglePlay() {
        if (this.active) {
          this.pause();
        } else {
          this.play();
        }
      };

      ProductMedia.prototype.on_pause = function on_pause() {
        this.active = false;
        document.body.classList.remove('media-playing');
        this.slick_allow_swipe();
        this.parent.classList.remove('product-single__media--active');
        var e = new CustomEvent('media-pause', {
          detail: {
            parent: this.parent,
            media: this
          }
        });
        this.parent.dispatchEvent(e);
      };

      ProductMedia.prototype.slick_disable_swipe = function slick_disable_swipe() {
        if (!this.$images) return;
        if (!this.$images.slick('getSlick')) return;

        // Allow swipe gestures to be registered by slick again.
        this.$images.slick('slickSetOption', 'draggable', false, false);
        this.$images.slick('slickSetOption', 'swipe', false, false);
        this.$images.slick('slickSetOption', 'touchMove', false, false);
      };

      ProductMedia.prototype.slick_allow_swipe = function slick_allow_swipe() {
        if (!this.$images) return;
        if (!this.$images.slick('getSlick')) return;

        // Allow swipe gestures to be registered by slick again.
        this.$images.slick('slickSetOption', 'draggable', true, false);
        this.$images.slick('slickSetOption', 'swipe', true, false);
        this.$images.slick('slickSetOption', 'touchMove', true, false);
      };

      ProductMedia.prototype.unload = function unload() {
        var _this2 = this;

        this.events.forEach(function (el, i) {
          return $(el).off('.' + _this2.scope);
        });
      };

      return ProductMedia;
    })();

    exports['default'] = ProductMedia;
    document.body.addEventListener('mousedown', function () {
      document.body.classList.add('using-mouse');
      document.body.classList.remove('using-keyboard');
    });

    // Re-enable focus styling when Tab is pressed
    document.body.addEventListener('keydown', function (event) {
      if (event.keyCode === 9) {
        document.body.classList.remove('using-mouse');
        document.body.classList.add('using-keyboard');
      }
    });
    module.exports = exports['default'];

  }, { "../loadVideoAPIs": 20 }], 23: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _cartUpdateCartCount = require('../cart/updateCartCount');

    var _cartUpdateCartCount2 = _interopRequireDefault(_cartUpdateCartCount);

    var _ProductMedia = require('./ProductMedia');

    var _ProductMedia2 = _interopRequireDefault(_ProductMedia);

    var _bodyScrollLock = require('body-scroll-lock');

    var ProductUtils = (function () {
      function ProductUtils(el, scope) {
        var _this = this;

        _classCallCheck(this, ProductUtils);

        this.$window = $(window);
        this.$body = $(document.body);
        this.theme = window.wetheme;
        this.$el = $(el);
        this.scope = scope;
        this.addInProgress = false;
        this.productHandle = this.$el.data('product');
        this.product = this.$el.data('product-json');
        this.currentVariant = this.$el.data('product-current-variant');
        this.hasDeepLinking = this.$el.data('product-deeplinking') ? true : false;
        this.cartUrl = this.$body.find('[data-product-carturl]').data('product-carturl');
        this.storeAvailabilityContainer = this.$el.find('[data-store-availability-container]');
        this.sectionId = this.$el[0].dataset.sectionId;
        this.currentSection = document.getElementById('shopify-section-' + this.sectionId);
        this.cartMethod = document.querySelector('.main-content').dataset.cartAction;

        // Product elements
        this.$images = this.$el.find('[data-product-images]');
        this.$medias = this.$el.find('.product-media-item');
        this.$thumbnails = this.$el.find('[data-product-thumbnails]'), this.$lightbox = this.$el.find('[data-product-images-lightbox-wrapper]');
        this.$options = this.$el.find('[data-product-options]');
        this.$price = this.$el.find('[data-product-price]');
        this.$reviewsLink = this.$el.find('.product-details__reviews');
        this.$priceCompare = this.$el.find('[data-product-price-compare]');
        this.$stockWrapper = this.$options.find('[data-product-stock-wrapper]');
        this.$addToCart = this.$options.find('[data-product-add]');
        this.$message = $('[data-product-message]');
        this.$zoomBtn = null;
        this.$quantityButton = this.$el.find('.qty-selector__btn');

        this.$el.find('.product-media-first').allLazyLoaded().on('containerlazyloaded', function () {
          _this.initSlick();
          _this._setInitialVariant();
          _this._checkScroll(el);
          _this._checkSlick();
        });

        this._setupMedia(el);
        this._bindEvents();
      }

      // Change tabindex to -1 so videos can't be tabbed to directly.
      // They can be accessed via the Slick carousel.

      ProductUtils.prototype._bindEvents = function _bindEvents() {
        var _this2 = this;

        this.events = [this.$quantityButton.on('click', function (event) {
          _this2._updateQuantity(event);
        }), this.$addToCart.on('click.' + this.scope, function (event) {
          event.preventDefault();
          _this2._closeMessage();
          _this2._addToCart();
        }), this.$options.on('change.' + this.scope, '[data-product-swatch-input]', function (event) {
          _this2._getCurrentVariant();
        }), this.$images.on('click.' + this.scope, 'img', function (event) {
          _this2._showLightbox(event);

          setTimeout(function () {
            var lightboxModal = document.querySelector('.product-images-lightbox');
            document.getElementById('product_images_lightbox_close').focus();

            lightboxModal.addEventListener('keydown', function (e) {
              var isTabPressed = e.key === 'Tab';

              if (isTabPressed) {
                e.preventDefault();
                return;
              }
            });
          }, 100);
        }), this.$thumbnails.on('click', 'img', function (event) {
          var imgSrc = $(event.currentTarget).data('product-thumbnail-src');
          if ($(event.target).closest('.change-variant--enabled').length) {
            _this2._changeToAvailableVariant(imgSrc);
            // We also want the image to switch when 'change variant based on thumbnail' is enabled
            _this2._switchImage(imgSrc);
          } else {
            _this2._switchImage(imgSrc);
          }
        }), this.$thumbnails.on('click', '.product-thumbnail-media-icon', function (event) {
          $(event.target).closest('.product-thumbnail-wrap').find('img.product-thumbnail').click();
        }), this.$el.on('click.' + this.scope, '[data-product-images-lightbox-close]', function () {
          _this2._hideLightbox();
        }), this.$reviewsLink.on('click', this.onReviewClick), this.$lightbox.on('click.' + this.scope, function (event) {
          if (!$(event.target).closest('[data-product-images-lightbox]').length) {
            _this2._hideLightbox();
          }
        })];

        Shopify.onError = function (XMLHttpRequest) {
          _this2._handleErrors(XMLHttpRequest);
        };
      };

      ProductUtils.prototype.unload = function unload() {
        var _this3 = this;

        this.events.forEach(function (el, i) {
          return $(el).off('.' + _this3.scope);
        });
      };

      ProductUtils.prototype._setupMedia = function _setupMedia(el) {
        if (this.scope == 'home') this.productEl = el; else this.productEl = document.querySelector(el);
        this.media_by_id = new Map();
        var playOnLoad = !window.matchMedia('only screen and (max-width: 767px)').matches;
        var isFirst = true;
        var media = null;

        Array.prototype.forEach.call(this.productEl.querySelectorAll('.product-media-item'), (function (media_root) {
          // Don't autoplay the first media.
          if (isFirst) {
            isFirst = false;
            media = new _ProductMedia2['default'](media_root, false);
          } else {
            media = new _ProductMedia2['default'](media_root, playOnLoad);
          }
          this.media_by_id.set(media_root.dataset.mediaId, media);
        }).bind(this));

        $(this.productEl).closest('[data-page-wrapper]').on('product-media-select', this.on_media_select.bind(this));
      };

      ProductUtils.prototype._isScrolledIntoView = function _isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
        var elemTop = $(elem).offset().top;
        return elemTop <= docViewBottom && elemTop >= docViewTop;
      };

      ProductUtils.prototype._checkScroll = function _checkScroll(elem) {
        var self = this;

        $(window).on('scroll', _.debounce(function () {
          if (self._isScrolledIntoView(elem)) {
            if (self.$images && self.$images.slick('getSlick')) {
              self.$images.slick('reinit');
            }
          }
        }, 300));
      };

      ProductUtils.prototype._checkSlick = function _checkSlick() {
        var _this4 = this;

        setTimeout(function () {
          if (_this4.$images && _this4.$images.slick('getSlick')) {
            _this4.$images.slick('reinit');
            _this4._removeTabIndexes(true);
          }
        }, 500);
      };

      ProductUtils.prototype._escapeString = function _escapeString(string) {
        var str = string.replace(/'/g, "\\'");
        return string.replace(/"/g, '\\"');
      };

      ProductUtils.prototype._setInitialVariant = function _setInitialVariant() {
        this.storeAvailability(this.currentVariant.id, this.product.title);

        for (var i in this.product.options) {
          var optionIndex = 'option' + (parseInt(i, 10) + 1),
            $option = this.$options.find('[data-product-swatch="' + i + '"]'),
            optionValue = this._escapeString(this.currentVariant[optionIndex]);
          var $optionItem = $option.find('[data-product-swatch-value="' + optionValue + '"]');

          $optionItem.find('input').prop('checked', 'checked');
        }

        if (!(this.product.variants.length === 1 && this.product.variants[0].title === 'Default Title')) {
          Shopify.linkOptionSelectors(this.product, this.product.id);
        }

        this._selectCallback(this.currentVariant);
      };

      ProductUtils.prototype._getCurrentVariant = function _getCurrentVariant() {
        var options = this.product.options,
          variants = this.product.variants,
          selectedOptions = [];

        for (var i in options) {
          selectedOptions.push(this.$options.find('[data-product-swatch="' + i + '"] input:checked').val());
        }

        for (var i in variants) {
          if (selectedOptions[0] === variants[i].option1) {
            if (options.length > 1) {
              if (selectedOptions[1] === variants[i].option2) {
                if (options.length === 3) {
                  if (selectedOptions[2] === variants[i].option3) {
                    this.currentVariant = variants[i];
                  }
                } else {
                  this.currentVariant = variants[i];
                }
              }
            } else {
              this.currentVariant = variants[i];
            }
          }
        }

        this.storeAvailability(this.currentVariant.id, this.product.title);

        this._selectCallback(this.currentVariant);
      };

      ProductUtils.prototype._changeVariant = function _changeVariant(imgSrc) {
        var options = this.product.options;
        var variants = this.product.variants;
        var strNewImage = getFilename(imgSrc);
        var hasChanged = false;

        for (var i in variants) {
          if (variants[i].featured_image == null) continue;
          var fileFromUrl = getFilename(variants[i].featured_image.src);

          if (fileFromUrl == strNewImage) {
            this.currentVariant = variants[i];
            this._selectCallback(variants[i]);

            for (var j in this.product.options) {
              var optionIndex = 'option' + (parseInt(j, 10) + 1),
                $option = this.$options.find('[data-product-swatch="' + j + '"]'),
                optionValue = this._escapeString(this.currentVariant[optionIndex]);
              var $optionItem = $option.find('[data-product-swatch-value="' + optionValue + '"]');

              Shopify.updateOptionsInSelector(Number(j), this.product.id, Shopify.optionsMap[this.product.id]);

              var $checkedInputParent = $optionItem.find('input').prop('checked', true).closest("[data-product-swatch-value]");
              $checkedInputParent.addClass("option--active").siblings().removeClass("option--active");
              hasChanged = true;
            }
          }
        }

        if (!hasChanged) {
          this._switchImage(imgSrc);
        }
      };

      ProductUtils.prototype._changeToAvailableVariant = function _changeToAvailableVariant(imgSrc) {
        var options = this.product.options;
        var variants = this.product.variants;
        var strNewImage = getFilename(imgSrc);
        var hasChanged = false;

        // Remove unavailable variants.
        var filteredVariants = variants.filter(function (e) {
          return e.available !== false;
        });

        for (var i in filteredVariants) {
          if (filteredVariants[i].featured_image == null) continue;
          var fileFromUrl = getFilename(filteredVariants[i].featured_image.src);

          if (fileFromUrl == strNewImage) {
            this.currentVariant = filteredVariants[i];
            this._selectCallback(filteredVariants[i]);

            for (var j in this.product.options) {
              var optionIndex = 'option' + (parseInt(j, 10) + 1);
              var $option = this.$options.find('[data-product-swatch="' + j + '"]');
              var optionValue = this._escapeString(this.currentVariant[optionIndex]);
              var $optionItem = $option.find('[data-product-swatch-value="' + optionValue + '"]');

              Shopify.updateOptionsInSelector(Number(j), this.product.id, Shopify.optionsMap[this.product.id]);

              var $checkedInputParent = $optionItem.find('input').prop('checked', true).closest("[data-product-swatch-value]");
              $checkedInputParent.addClass("option--active").siblings().removeClass("option--active");
              hasChanged = true;
            }
          }
        }

        // If we couldn't find an available variant, try with all of them.
        if (!hasChanged) {
          this._changeVariant(imgSrc);
        }
      };

      ProductUtils.prototype._selectCallback = function _selectCallback(variant) {
        var priceFormatted = Shopify.formatMoney(variant.price, Theme.moneyFormat);
        var compareAtPriceFormatted = Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat);

        this.$options.find('#product-select-simple').val(variant.id);
        this.$price.html(priceFormatted);

        if (variant.compare_at_price > variant.price) {
          this.$priceCompare.removeClass('hidden').html(compareAtPriceFormatted);
        } else {
          this.$priceCompare.addClass('hidden');
        }

        // Unit prices
        if (variant.unit_price && variant.unit_price_measurement) {
          this.$el.find('.unit-price').removeClass('hide');
          this.$el.find('.unit-price__price').html('<span class="money">' + Shopify.formatMoney(variant.unit_price, Theme.moneyFormat) + '</span>');
          this.$el.find('.unit-price__ref-value').html(variant.unit_price_measurement.reference_value);
          this.$el.find('.unit-price__ref-unit').html(variant.unit_price_measurement.reference_unit);
        } else {
          this.$el.find('.unit-price').addClass('hide');
        }

        this._closeMessage();

        if (this.$stockWrapper.length) {
          this._updateStock();
        }

        if (variant.featured_image) {
          this._switchImage(variant.featured_image.src);
        }

        if (this.hasDeepLinking) {
          this._updateVariantDeepLink(variant);
        }

        if (variant.available) {
          this._updateButtonText(Theme.localization.product.addToCart, true);
        } else {
          this._updateButtonText(Theme.localization.product.soldOut, false);
        }

        // Ensure the change event is fired on the form when variants changed (for Shop Pay Installments)
        this.productForm = this.$el.find('.shopify-product-form')[0];
        var self = this;
        setTimeout(function () {
          var event = new Event('change');
          self.productForm.dispatchEvent(event);
        });
      };

      ProductUtils.prototype._updateButtonText = function _updateButtonText(text, isEnabled, $button) {
        this.$addToCart.prop('disabled', !isEnabled).toggleClass('button-disabled', !isEnabled).children('.button-text').text(text);
      };

      ProductUtils.prototype._updateVariantDeepLink = function _updateVariantDeepLink(variant) {
        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, document.title, "?variant=" + variant.id);
        }
      };

      ProductUtils.prototype._updateStock = function _updateStock() {
        var $currentStock = this.$stockWrapper.find('[data-product-stock-variant="' + this.currentVariant.id + '"]');
        var stockIndex = $currentStock.data('product-stock-index');

        $currentStock.addClass('visible').siblings().removeClass('visible');

        var $stockVisual = this.$stockWrapper.find('[data-product-stock-variant-visual]');
        var inventory = $stockVisual.data('product-stock-variant-visual');

        $stockVisual.width(inventory[stockIndex]);
      };

      ProductUtils.prototype._updateQuantity = function _updateQuantity(event) {
        var quantity = this.$options.find('[data-product-quantity]');

        if ($(event.currentTarget).hasClass('qty-selector__btn--add')) {
          quantity.val(+quantity.val() + 1);
        } else if ($(event.currentTarget).hasClass('qty-selector__btn--minus') && quantity.val() > 1) {
          quantity.val(+quantity.val() - 1);
        }
      };

      ProductUtils.prototype._addToCart = function _addToCart(event) {
        var formId, data, response, quantity, response1, response2, cart;
        return regeneratorRuntime.async(function _addToCart$(context$2$0) {
          while (1) switch (context$2$0.prev = context$2$0.next) {
            case 0:
              if (this.addInProgress) {
                context$2$0.next = 34;
                break;
              }

              this.addInProgress = true;

              if (this.cartMethod != 'page') {
                this._toggleLoader(true);
              }

              formId = 'product_form_' + this.product.id;
              data = $('#' + formId).serialize();
              context$2$0.next = 7;
              return regeneratorRuntime.awrap(window.fetch('/cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: data
              }));

            case 7:
              response = context$2$0.sent;
              quantity = this.$options.find('[data-product-quantity]').val();
              context$2$0.next = 11;
              return regeneratorRuntime.awrap(response.json());

            case 11:
              response1 = context$2$0.sent;

              if (response.ok) {
                context$2$0.next = 17;
                break;
              }

              // Handle various errors, quantity etc.
              // See: https://shopify.dev/docs/themes/ajax-api/reference/cart
              if (response1.status == 422) {
                this._updateMessage(response1.description);
              }
              this.addInProgress = false;
              this._toggleLoader();
              return context$2$0.abrupt('return');

            case 17:
              if (!(this.cartMethod == 'page')) {
                context$2$0.next = 20;
                break;
              }

              window.location.href = '/cart';
              return context$2$0.abrupt('return');

            case 20:

              _cartUpdateCartCount2['default']();
              this._toggleLoader();
              this.addInProgress = false;

              context$2$0.next = 25;
              return regeneratorRuntime.awrap(window.fetch('/cart.js'));

            case 25:
              response2 = context$2$0.sent;

              if (response2.ok) {
                context$2$0.next = 30;
                break;
              }

              this._toggleLoader();
              console.warn(response);
              return context$2$0.abrupt('return');

            case 30:
              context$2$0.next = 32;
              return regeneratorRuntime.awrap(response2.json());

            case 32:
              cart = context$2$0.sent;

              window.wetheme.drawer._toggleRightDrawer('cart', true, { cart: cart });

            case 34:
            case 'end':
              return context$2$0.stop();
          }
        }, null, this);
      };

      ProductUtils.prototype._handleErrors = function _handleErrors(errors) {
        var _this5 = this;

        var error = $.parseJSON(errors.responseText);

        setTimeout(function () {
          if (error.message === 'Cart Error') {
            _this5._updateMessage(error.description, true);
          }

          _this5._toggleLoader();
          _this5.addInProgress = false;
        }, 500);
      };

      ProductUtils.prototype._updateMessage = function _updateMessage(message, isError) {
        var _this6 = this;

        if (isError) {
          this.$message.addClass('error');
        } else {
          message = '<a href="' + this.cartUrl + '">' + message + '</a>';
        }

        this.$message.html(message).revealer('show');

        setTimeout(function () {
          _this6._closeMessage();
        }, 5000);
      };

      ProductUtils.prototype._closeMessage = function _closeMessage() {
        var _this7 = this;

        this.$message.revealer('hide');

        setTimeout(function () {
          _this7.$message.removeClass('error');
        }, 200);
      };

      ProductUtils.prototype._toggleLoader = function _toggleLoader(start) {
        var _this8 = this;

        if (start) {
          this.$addToCart.addClass('option--active').one('trend', function () {
            _this8.$addToCart.addClass('loading');
          });
        } else {
          this.$addToCart.removeClass('loading').one('trend', function () {
            _this8.$addToCart.removeClass('option--active');
          });
        }
      };

      ProductUtils.prototype.initSlick = function initSlick() {
        var _this9 = this;

        if (this.$images.children().length) {
          this.$images.slick({
            infinite: true,
            fade: true,
            speed: 50,
            adaptiveHeight: true,
            focusOnSelect: true,
            accessibility: false,
            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"></button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"></button>'
          }).init(function () {
            _this9.$thumbnails.parent().removeClass('visibly-hidden');
            _this9.slickKeyboardNav();
            _this9.slickEvents();
            _this9._removeTabIndexes(true);

            _this9.addZoomBtn();
          });
        }
      };

      ProductUtils.prototype.slickKeyboardNav = function slickKeyboardNav() {
        var self = this;

        this.$body.off('keydown').on('keydown', function (e) {
          var $active = $(document.activeElement);

          if ($active.closest('.product-media-item').length) {
            var element = $active.closest('.product-media-item')[0];
            var media = self.media_by_id.get(element.dataset.mediaId);
          }

          // Enter key.
          if (e.keyCode === 13) {
            // Focussed on a media thumbnail, go to that slide.
            if ($active.find('.product-thumbnail').data('productThumbnailIndex') !== undefined) {
              var sIndex = $active.find('.product-thumbnail').data('productThumbnailIndex') - 1;
              self.$images.slick('slickGoTo', sIndex);
            } else if ($active.is('.plyr.plyr--video')) {
              // Play / pause video when the wrapper container has focus.
              if ($active.hasClass('plyr--playing')) media.controller.pause(); else if ($active.hasClass('plyr--paused')) media.controller.play(); else media.controller.play();
            } else if ($active.is('model-viewer')) {
              // If model is active, pause it.
              media.controller.pause();
            } else if ($active.hasClass('product-media-inner')) {
              // We have to focus on the image's wrapper div.
              // Simulate click on image to open lightbox
              $active.find('.product-media-item > img').click();
              self.$lightbox.attr('tabindex', -1);
              setTimeout(function () {
                self.$lightbox.focus();
              }, 300);
            } else if ($active.hasClass('product-images-lightbox')) {
              self._hideLightbox();
            }
          }

          // If the element in focus is an active media item, give it access
          // to key presses until it no longer has focus.
          if ($active.is('model-viewer') || $active.is('iframe') || $active.is('video')) {
            if (media.active) {
              return;
            }
          }

          // Esc key.
          if (e.keyCode === 27) {
            self._hideLightbox();
          }

          // Tab.
          if (e.keyCode === 9) {
            // Remove .plyr__tab-focus from .plyr--video if not focussed on a plyr video
            // or child control of one
            if ($('.plyr--video').has(document.activeElement).length) {
              $('.plyr--video').has(document.activeElement).removeClass('.plyr__tab-focus');
            }
          }
        });
      };

      ProductUtils.prototype.addZoomBtn = function addZoomBtn() {
        if (document.querySelector('.slick-zoom')) return;

        var parentDiv = document.querySelector('.product-media-inner');
        var prevBtn = document.querySelector('.slick-prev');
        this.$zoomBtn = document.createElement("button");

        this.$zoomBtn.setAttribute('aria-label', 'Zoom image');
        this.$zoomBtn.setAttribute('id', 'zoom_slick');
        this.$zoomBtn.setAttribute('class', 'slick-zoom');
        this.$zoomBtn.setAttribute('type', 'button');

        document.addEventListener('click', function (e) {
          if (e.target && e.target.id == 'zoom_slick') {
            if (document.querySelector('.slick-active video')) {
              e.target.classList.add('is-disabled').setAttribute('tabIndex', '-1');
              return;
            }

            document.querySelector('.slick-active img').click();
          }
        });

        parentDiv.insertBefore(this.$zoomBtn, prevBtn.nextSibling);
      };

      ProductUtils.prototype.handleControlsForVideo = function handleControlsForVideo() {
        if (!document.querySelector('.slick-active video')) return;
        document.querySelector('.slick-next').classList.add('has-video-controls');
        document.querySelector('.slick-prev').classList.add('has-video-controls');
        this.$zoomBtn.classList.add('is-disabled');
        this.$zoomBtn.setAttribute('tabIndex', '-1');

        setTimeout(function () {
          var $targets = $('.plyr--video button, input[id^="plyr-"], .external-video-button');
          $targets.attr('tabindex', '0');
        }, 100);
      };

      ProductUtils.prototype.handleControlsFor3d = function handleControlsFor3d() {
        if (!document.querySelector('.slick-active model-viewer')) return;

        var all3dModelButtons = document.querySelectorAll('.slick-active .shopify-model-viewer-ui__controls-overlay button');

        for (var i = 0; i < all3dModelButtons.length; ++i) {
          all3dModelButtons[i].setAttribute('tabIndex', '0');
        }

        document.querySelector('.slick-next').classList.add('has-3d-controls');
        this.$zoomBtn.classList.add('is-disabled');
        this.$zoomBtn.setAttribute('tabIndex', '-1');
      };

      ProductUtils.prototype.enableControls = function enableControls() {
        this.$zoomBtn = document.getElementById('zoom_slick');

        if (this.$zoomBtn) {
          this.$zoomBtn.classList.remove('is-disabled');
          this.$zoomBtn.setAttribute('tabIndex', '0');
        }

        document.querySelector('.slick-next').classList.remove('has-3d-controls');
        document.querySelector('.slick-next').classList.remove('has-video-controls');
        document.querySelector('.slick-prev').classList.remove('has-video-controls');
      };

      ProductUtils.prototype.disable3dControls = function disable3dControls() {
        var all3dModelButtons = document.querySelectorAll('.shopify-model-viewer-ui__controls-overlay button');

        for (var i = 0; i < all3dModelButtons.length; ++i) {
          all3dModelButtons[i].setAttribute('tabIndex', '-1');
        }
      };

      ProductUtils.prototype.slickEvents = function slickEvents() {
        var self = this;

        this.$images.off('swipe').on('swipe', function (event, slick, direction) {
          var currentSlide = $(slick).slick('slickCurrentSlide');

          // Change variant if enabled.
          var imgSrc = $(slick.$slides[currentSlide]).data('product-image-src');
          if ($(event.target).closest('.change-variant--enabled').length) {
            self._changeVariant(imgSrc);
          }
        });

        // On thumbnail click / slide change.
        this.$images.off('afterChange').on('afterChange', function (event, slick, currentSlide) {
          self.disable3dControls.apply(self);
          self.enableControls.apply(self);
          self.handleControlsFor3d.apply(self);
          self.handleControlsForVideo.apply(self);

          self._removeTabIndexes();
          var isDesktop = !window.matchMedia('only screen and (max-width: 767px)').matches;

          // If Slick slide has changed, user is interacting with media so
          // we know that we can safely autoplay videos. We're not allowed to
          // autoplay the first video e.g. if that is the featured media item.
          var evt = new CustomEvent('product-media-select', {
            detail: {
              index: currentSlide,
              forceLoad: true,
              forcePlay: isDesktop
            },
            bubbles: true
          });
          self.$images.closest('[data-page-wrapper]')[0].dispatchEvent(evt);

          // Keep viewport in a sensible place.
          if (!self._isScrolledIntoView(self.$el.find('.product-images'))) {
            var new_position = self.$el.find('.product-images').offset();
            $('html, body').stop().animate({ scrollTop: new_position.top }, 10);
          }
        });
      };

      ProductUtils.prototype.unloadSlick = function unloadSlick() {
        if (this.$images && this.$images.slick('getSlick')) {
          this.$images.slick('unslick');
        }
      };

      ProductUtils.prototype._switchImage = function _switchImage(src) {
        var img_src = src.indexOf('?v=') != -1 ? src.split('?v=')[0] : src;
        img_src = img_src.indexOf('products/') != -1 ? img_src.split('products/')[1] : src;
        img_src = 'products/' + img_src;

        var $image = this.$images.find('[data-product-image-src="' + img_src + '"]');
        var index = $image.closest('.slick-slide').data('slick-index');

        this.$images.slick('slickGoTo', index);
      };

      ProductUtils.prototype._scrollLockToggle = function _scrollLockToggle(lock) {
        this.$body.toggleClass('scroll-locked', lock);
      };

      ProductUtils.prototype._showLightbox = function _showLightbox(event) {
        var imgSrc = $(event.currentTarget).data('high-res');

        this._scrollLockToggle(true);
        this.$lightbox.find('img').attr('src', imgSrc);
        this.$lightbox.revealer('show');
        this.$lightbox.focus();
      };

      ProductUtils.prototype._hideLightbox = function _hideLightbox() {
        this._scrollLockToggle();
        this.$lightbox.revealer('hide');
      };

      ProductUtils.prototype._removeTabIndexes = function _removeTabIndexes(keepActive) {
        if (typeof keepActive == undefined) {
          keepActive = false;
        }

        // Set all tabindex on media back to -1.
        // This is to avoid lots of 'hidden' tabbing to controls on
        // media elements that aren't visible.
        var $targets = $('video, model-viewer, iframe[src^="https://www.youtube.com/embed/"], .plyr--video, .plyr--video button, input[id^="plyr-"], .external-video-button');

        if (keepActive) {
          $targets = $targets.filter(function () {
            return $(this).parents(".product-single__media--selected").length == 0;
          });
        }

        $targets.attr("tabindex", -1);
        this.$images.attr("tabindex", -1);
      };

      ProductUtils.prototype.on_media_select = function on_media_select(e) {
        var isMobile = window.matchMedia('only screen and (max-width: 767px)').matches;
        var element = this.$el.find('.product-media-item')[e.detail.index];
        if (!element) return;

        var media = this.media_by_id.get(element.dataset.mediaId);
        this.on_media_element_select(element, {
          load: e.detail.forceLoad,
          forcePlay: !isMobile // Autoplay video on non-mobile
        });
      };

      ProductUtils.prototype.onReviewClick = function onReviewClick(e) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $("#shopify-product-reviews").offset().top
        }, 800);
      };

      ProductUtils.prototype.on_media_element_select = function on_media_element_select(element, options) {
        if (!element) {
          return;
        }
        var media = this.media_by_id.get(element.dataset.mediaId);
        switch (media.type) {
          case 'model':
            element.getElementsByTagName('model-viewer')[0].classList.add('focus-visible');
            setTimeout(function () {
              element.getElementsByTagName('model-viewer')[0].focus();
            }, 100);
            break;
          case 'video':
            element.getElementsByTagName('video')[0].focus();
            break;
          case 'external_video':
            element.getElementsByTagName('iframe')[0].focus();
            break;
        }

        // Pause all others.
        this.media_by_id.forEach(function (otherMedia) {
          if (otherMedia.media_id !== media.media_id) {
            if (otherMedia.loaded == true) {
              otherMedia.pause();
            }
          } else {
            $(otherMedia).removeAttr('tabindex');
            $(otherMedia).find('button').removeAttr('tabindex');
          }
        });
        this.$medias.not(element).removeClass('product-single__media--selected');

        element.classList.add('product-single__media--selected');

        if (options.forcePlay) {
          media.play();
        } else if (options.togglePlay) {
          media.togglePlay();
        } else if (options.load) {
          media.load();
        }
      };

      ProductUtils.prototype.storeAvailability = function storeAvailability(variantId, productTitle) {
        var variantSectionUrl = '/variants/' + variantId + '/?section_id=store-availability';

        var self = this;

        var storePickupEnabled = this.currentSection.querySelector('.store-pickup-enabled');
        if (!storePickupEnabled) return;

        var productSoldOut = !this.product.available;
        if (productSoldOut) return;

        var availabilityContainer = this.currentSection.querySelector('.product__store__availability__container');
        var availabilityModal = this.currentSection.querySelector('#StoreAvailabilityModal');

        if (!availabilityContainer) return;

        availabilityContainer.innerHTML = '';

        fetch(variantSectionUrl).then(function (response) {
          return response.text();
        }).then(function (storeAvailabilityHTML) {

          if (storeAvailabilityHTML.trim() === '' || !storeAvailabilityHTML.includes('"store-availability-information"')) {
            return;
          }

          availabilityContainer.innerHTML = storeAvailabilityHTML;
          availabilityContainer.innerHTML = availabilityContainer.firstElementChild.innerHTML;

          // Place modal after product details container
          var productDetailsContainer = self.currentSection.querySelector('.product-details');
          availabilityModal = self.currentSection.querySelector('#StoreAvailabilityModal');
          productDetailsContainer.parentNode.insertBefore(availabilityModal, productDetailsContainer.nextSibling);

          var storeAvailabilityModalOpen = self.currentSection.querySelector('a[data-store-availability-modal-open]');
          var storeAvailabilityModalProductTitle = self.currentSection.querySelector('h2[data-store-availability-modal-product-title]');

          // Only create modal if open modal element exists
          if (!storeAvailabilityModalOpen) {
            return;
          } else {
            // Open modal
            storeAvailabilityModalOpen.addEventListener('click', function () {
              // Trap focus within modal
              setTimeout(function () {
                var focusableEls = availabilityModal.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
                var firstFocusableEl = focusableEls[0];
                var lastFocusableEl = focusableEls[focusableEls.length - 1];
                var KEYCODE_TAB = 9;

                availabilityModal.focus();

                availabilityModal.addEventListener('keydown', function (e) {
                  var isTabPressed = e.key === 'Tab';

                  if (!isTabPressed) {
                    return;
                  }

                  if (e.shiftKey) /* shift + tab */ {
                    if (document.activeElement === firstFocusableEl) {
                      lastFocusableEl.focus();
                      e.preventDefault();
                    }
                  } else /* tab */ {
                    if (document.activeElement === lastFocusableEl) {
                      firstFocusableEl.focus();
                      e.preventDefault();
                    }
                  }
                });
              }, 500);

              var modalContainer = self.currentSection.querySelector('div[data-store-availability-modal-container]');
              var availabilityModal = self.currentSection.querySelector('#StoreAvailabilityModal');
              var htmlBody = document.querySelector('body');
              _bodyScrollLock.disableBodyScroll(availabilityModal);
              modalContainer.classList.add('store-availabilities-modal--open');
              modalContainer.addEventListener('click', self._handleLocationsClickOutside);
              availabilityModal.classList.add('open');
              availabilityModal.style = 'visibility: visible;';

              // Modal close button
              var availabilityModalCloseButton = self.currentSection.querySelector('.store-availabilities-modal__close');
              if (availabilityModalCloseButton) {
                // Close modal
                availabilityModalCloseButton.addEventListener('click', function () {
                  modalContainer.classList.remove('store-availabilities-modal--open');
                  _bodyScrollLock.enableBodyScroll(availabilityModal);
                  modalContainer.removeEventListener('click', self._handleLocationsClickOutside);
                  availabilityModal.classList.remove('open');
                  availabilityModal.style = 'visibility: hidden;';
                });
              }
            });
          }

          // Update product title
          if (!storeAvailabilityModalProductTitle) {
            return;
          } else {
            storeAvailabilityModalProductTitle.textContent = productTitle;
          }
        });
      };

      ProductUtils.prototype._handleLocationsClickOutside = function _handleLocationsClickOutside() {
        var modalContainer = this.currentSection.querySelector('div[data-store-availability-modal-container]');
        var availabilityModal = this.currentSection.querySelector('#StoreAvailabilityModal');

        modalContainer.classList.remove('store-availabilities-modal--open');
        _bodyScrollLock.enableBodyScroll(availabilityModal);
        modalContainer.removeEventListener('click', self._handleLocationsClickOutside);
        availabilityModal.classList.remove('open');
        availabilityModal.style = 'visibility: hidden;';
      };

      return ProductUtils;
    })();

    exports['default'] = ProductUtils;
    $(document).ready(function () {
      $('video').attr("tabindex", -1);
      $('model-viewer').attr("tabindex", -1);
      $('iframe[src^="https://www.youtube.com/embed/"]').attr("tabindex", -1);
    });

    function getFilename(url) {
      // get the part after last /, then replace any query and hash part
      url = url.split('/').pop().replace(/\#(.*?)$/, '').replace(/\?(.*?)$/, ''); // eslint-disable-line
      return url;
    }
    module.exports = exports['default'];

  }, { "../cart/updateCartCount": 16, "./ProductMedia": 22, "body-scroll-lock": 1 }], 24: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _snippetsProductItem = require('../../snippets/ProductItem');

    var _snippetsProductItem2 = _interopRequireDefault(_snippetsProductItem);

    var RecentlyViewed = (function () {
      function RecentlyViewed(el) {
        _classCallCheck(this, RecentlyViewed);

        this.$window = $(window);
        this.$body = $(document.body);
        this.$el = $(el);
        this.el = document.querySelector(el);
        this.$grid = this.$el.find('.grid');
        this.swiper = null;

        this.handle = this.$el.data('products-recent-handle');
        this.productUrl = this.$el.data('product-url');

        this.PLACEHOLDER = 'PLACEHOLDER';
        this.LOCAL_STORAGE_KEY = 'recentlyVisited';

        this._bindEvents();
      }

      RecentlyViewed.prototype._bindEvents = function _bindEvents() {
        this.$window.on('load', this._updateRecentlyViewed());
        this.$window.on('scroll', _.debounce(this._isVisible.bind(this), 300));
      };

      RecentlyViewed.prototype._updateRecentlyViewed = function _updateRecentlyViewed() {
        var recentlyViewedJSON = localStorage.getItem(this.LOCAL_STORAGE_KEY);
        var recentlyViewed = recentlyViewedJSON != null ? JSON.parse(recentlyViewedJSON) : [];

        if (this.handle) {
          var item = {
            'handle': this.handle
          };

          recentlyViewed.unshift(item);
        }

        var uniqueArray = recentlyViewed.length ? this._getUniqueArray(recentlyViewed) : recentlyViewed;

        if (uniqueArray.length > 5) {
          uniqueArray = uniqueArray.slice(0, 5);
        }

        localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(uniqueArray));

        if (uniqueArray.length > 1 || uniqueArray.length === 1 && uniqueArray[0]['handle'] !== this.handle) {
          this._buildRecentlyViewed(uniqueArray);
        } else {
          this.$el.closest('[data-products-recent-wrapper]').remove();
        }
      };

      RecentlyViewed.prototype._getUniqueArray = function _getUniqueArray(array) {
        var newArray = new Array();
        var handleArray = new Array();

        for (var i = 0; i < array.length; i++) {
          var handle = array[i]['handle'];
          if (handleArray.indexOf(handle) === -1) {
            newArray.push(array[i]);
            handleArray.push(handle);
          }
        }

        return newArray;
      };

      RecentlyViewed.prototype._buildRecentlyViewed = function _buildRecentlyViewed(recentlyViewed) {
        var _$,
          _this = this;

        var promises = recentlyViewed.map(function (rv) {
          return $.get(_this.productUrl.replace(_this.PLACEHOLDER, rv.handle));
        });
        (_$ = $).when.apply(_$, promises).then(function () {
          var allOK = true;
          promises.forEach(function (promise) {
            if (promise.status === 200) {
              _this._addProduct(promise.responseText);
            } else {
              console.warn('Unable to fetch recently visited product: ', promise.status, promise.responseText);
              allOK = false;
            }
          });
          if (allOK) {
            (function () {
              _this.$arrowIcon = _this.$el.find('.icon-arrow')[0].innerHTML;
              _this.$grid.parent().append('<div class="swiper-button-next">' + _this.$arrowIcon + '</div><div class="swiper-button-prev">' + _this.$arrowIcon + '</div><div class="swiper-scrollbar"></div>');
              _this.$el.addClass('visible');
              _this._initSwiper(_this.$el);
              _this._resizeProductDetails(_this.$el);

              // Position swiper buttons on mouse enter
              var self = _this;
              var swiperWrapper = _this.el.querySelector('.swiper-wrapper');
              swiperWrapper.addEventListener('mouseenter', function () {
                self._positionSwiperButtons(self.el);
              });
            })();
          }
        });
        return;
      };

      RecentlyViewed.prototype._addProduct = function _addProduct(pageHtml) {
        var container = document.createElement("div");
        container.innerHTML = pageHtml;
        container.querySelector(".main-content .product-item").classList.add('swiper-slide');
        this.$grid.append(container.querySelector('.main-content .product-item').outerHTML);
      };

      RecentlyViewed.prototype._initSwiper = function _initSwiper(el) {
        var self = this;
        this.swiper = new Swiper('.products-recent.swiper-container', {
          scrollbar: {
            el: '.products-recent .swiper-scrollbar',
            hide: false,
            draggable: true
          },
          breakpoints: {
            300: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 0
            },
            500: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 8
            },
            720: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              spaceBetween: 8
            },
            1200: {
              slidesPerView: 4,
              slidesPerGroup: 4,
              spaceBetween: 8
            },
            1400: {
              slidesPerView: 5,
              slidesPerGroup: 5,
              spaceBetween: 8
            }
          },
          roundLengths: true,
          speed: 500,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          on: {
            init: function init(swiper) {
              new _snippetsProductItem2['default'](el);
            }
          }
        });
      };

      RecentlyViewed.prototype._isVisible = function _isVisible() {
        if (!this.el || !this.swiper) return false;

        if (this._isInViewport(this.el)) {
          this.swiper.update();
        }
      };

      RecentlyViewed.prototype._isInViewport = function _isInViewport(elem) {
        var _elem$getBoundingClientRect = elem.getBoundingClientRect();

        var top = _elem$getBoundingClientRect.top;
        var bottom = _elem$getBoundingClientRect.bottom;

        var vHeight = window.innerHeight || document.documentElement.clientHeight;

        return (top > 0 || bottom > 0) && top < vHeight;
      };

      RecentlyViewed.prototype._resizeProductDetails = function _resizeProductDetails(elem) {
        var productDetails = elem[0].querySelectorAll('.product-item-details');

        // Get array of heights of all product details in swiper
        var productDetailsHeights = [];
        productDetails.forEach(function (details) {
          productDetailsHeights.push(details.offsetHeight);
        });

        // Set height of all product details to the max height
        var maxHeight = productDetailsHeights.reduce(function (accum, current) {
          return accum > current ? accum : current;
        });
        productDetails.forEach(function (details) {
          details.style.height = maxHeight + 'px';
        });
      };

      RecentlyViewed.prototype._positionSwiperButtons = function _positionSwiperButtons(elem) {
        var swiperWrapper = elem.querySelector('.swiper-wrapper');
        var productDetails = elem.querySelectorAll('.product-item-details');
        var productItem = elem.querySelectorAll('.product-item')[0];
        var productImageWrapper = elem.querySelectorAll('.product-item__image-wrapper')[0];
        var swiperHeader = elem.getElementsByTagName('h2')[0];
        var swiperButtons = elem.querySelectorAll('.swiper-button-next, .swiper-button-prev');

        // Derive image height (taking account of vertical margins in swiper container)
        var swiperHeight = swiperWrapper.offsetHeight;
        var productDetailsHeight = productDetails[0].offsetHeight;
        var imageHeight = swiperHeight - productDetailsHeight - parseInt(window.getComputedStyle(productItem).marginBottom) - parseInt(window.getComputedStyle(productImageWrapper).marginBottom);

        // Position swiper buttons in vertical middle of images
        var headerHeight = swiperHeader.offsetHeight + parseInt(window.getComputedStyle(swiperHeader).marginBottom); // Include header margin bottom
        swiperButtons.forEach(function (button) {
          button.style.top = headerHeight + imageHeight / 2 + 'px';
        });
      };

      return RecentlyViewed;
    })();

    exports['default'] = RecentlyViewed;
    module.exports = exports['default'];

  }, { "../../snippets/ProductItem": 45 }], 25: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;
    exports.trapFocus = trapFocus;

    function trapFocus(slideout_id, is_initial_open) {
      var menu = document.getElementById(slideout_id);
      var inputs = menu.querySelectorAll('input:not([type=hidden]),\n    button:not([tabindex="-1"]),\n    a:not([tabindex="-1"]),\n    textarea,\n    div[role=button],\n    iframe');

      var firstInput = inputs[0];
      var lastInput = inputs[inputs.length - 1];
      if (is_initial_open) $(firstInput).focus();

      // Redirect last tab to first input
      lastInput.addEventListener('keydown', function (e) {
        if (e.keyCode === 9 && !e.shiftKey) {
          e.preventDefault();
          firstInput.focus();
        }
      });

      // Redirect first shift+tab to last input
      firstInput.addEventListener('keydown', function (e) {
        if (e.keyCode === 9 && e.shiftKey) {
          e.preventDefault();
          lastInput.focus();
        }
      });

      // Some external payment 'buttons' can be iframes, e.g.
      // PayPal. Those iframes don't register keydown events.
      document.addEventListener('focus', function () {
        // If panel is open and focus leaves the element,
        // refocus on the first element.
        if (is_initial_open && !menu.contains(document.activeElement)) {
          $(firstInput).focus();
        }
      }, true);
    }

  }, {}], 26: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var Departments = (function () {
      function Departments(el) {
        _classCallCheck(this, Departments);

        this.$el = $(el);
        this.$window = $(window);
        this.$body = $(document.body);
        this.slideCount = this.$el.find('.departments-slide').length;
        this.hasSlick = false;

        this._bindEvents();
        this._windowWidthCheck();
      }

      Departments.prototype._bindEvents = function _bindEvents() {
        this.$window.on('resize.home', _.debounce(this._windowWidthCheck.bind(this), 500));
      };

      Departments.prototype._bindSlickEvents = function _bindSlickEvents() {
        var _this = this;

        this.$el.on('init', function () {
          _this.hasSlick = true;
        });

        this.$el.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          var activeSlides = [nextSlide, nextSlide + 1];

          if (activeSlides[1] >= _this.slideCount) {
            activeSlides.push(0, -1);
          } else if (nextSlide === 0) {
            activeSlides.push(_this.slideCount, _this.slideCount + 1);
          }

          for (var i in activeSlides) {
            _this.$el.find('[data-slick-index=' + activeSlides[i] + ']').addClass('visible');
          }
        });

        this.$el.on('afterChange', function () {
          _this.$el.find('.slick-slide').removeClass('visible');
        });
      };

      Departments.prototype._windowWidthCheck = function _windowWidthCheck() {
        var windowWidth = window.innerWidth;
        if (windowWidth > 720 && !this.hasSlick) {
          this.hasSlick = true;
          this._setupSlideshow();
        } else if (windowWidth <= 720 && this.hasSlick) {
          this.hasSlick = false;
          this.$el.slick('unslick');
        }
      };

      Departments.prototype._setupSlideshow = function _setupSlideshow() {
        var $parent = this.$el.closest('[data-section-id]');
        var prev = $parent.find('[data-departments-slideshow-previous]');
        var next = $parent.find('[data-departments-slideshow-next]');

        this.$el.slick({
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow: prev,
          nextArrow: next
        });

        // Force fire of lazyload to catch cloned slick slides
        // created due to use of infinite option above
        this.slides = this.$el[0].querySelectorAll('.departments-slide figure');
        for (var i = 0; i < this.slides.length; i++) {
          lazySizes.loader.unveil(this.slides[i]);
        }

        this._bindSlickEvents();
      };

      return Departments;
    })();

    exports['default'] = Departments;
    module.exports = exports['default'];

  }, {}], 27: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _snippetsProductItem = require("../snippets/ProductItem");

    var _snippetsProductItem2 = _interopRequireDefault(_snippetsProductItem);

    var FeaturedProducts = (function () {
      function FeaturedProducts(el) {
        var _this = this;

        _classCallCheck(this, FeaturedProducts);

        this.$window = $(window);
        this.$el = $(el);
        this.el = el;
        this.$wrapper = this.$el.find('[data-featured-products-outer]');
        this.$container = this.$wrapper.find('.swiper-container')[0];
        this.$scrollbar = this.$wrapper.find('.swiper-scrollbar')[0];
        this.$prevButton = this.$wrapper.find('.swiper-button-prev')[0];
        this.$nextButton = this.$wrapper.find('.swiper-button-next')[0];
        this.$collection = this.$el.find('[data-featured-products]');
        this.productDetails = this.el.querySelectorAll('.product-item-details.below');
        this.swiperWrapper = this.el.querySelector('.swiper-wrapper');
        this.productItem = this.el.querySelectorAll('.product-item')[0];
        this.productImageWrapper = this.el.querySelectorAll('.product-item__image-wrapper')[0];
        this.swiperButtons = this.el.querySelectorAll('.swiper-button-next, .swiper-button-prev');
        this.styleType = this.$el.data('section-style');
        this.swiper = null;

        this.$collection.imagesLoaded(function () {
          _this._bindEvents();

          if (self.styleType != 'slider') {
            new _snippetsProductItem2['default'](_this.$collection);
          }
        });
      }

      FeaturedProducts.prototype._bindEvents = function _bindEvents() {
        var _this2 = this;

        var self = this;

        this.$window.on('scroll', _.debounce(this._isVisible.bind(this), 300));

        this.$el.on('click', '[data-featured-products-button]', function (event) {
          event.preventDefault();
        });

        if (this.styleType == 'slider') {
          this._initSwiper(this.$collection);
          this._resizeProductDetails();

          // Position swiper buttons on mouse enter
          this.swiperWrapper.addEventListener('mouseenter', function () {
            self._positionSwiperButtons();
          });
        }

        window.addEventListener('load', function (event) {
          if (self.styleType == 'slider') {
            self._initSwiper(_this2.$collection);
          }
        });
      };

      FeaturedProducts.prototype._initSwiper = function _initSwiper($collection) {
        var numProducts = $collection.data('products');

        this.swiper = new Swiper(this.$container, {
          scrollbar: {
            el: this.$scrollbar,
            hide: false,
            draggable: true
          },
          breakpoints: {
            300: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 0
            },
            500: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 8
            },
            720: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              spaceBetween: 8
            },
            1024: {
              slidesPerView: numProducts,
              slidesPerGroup: numProducts,
              spaceBetween: 8
            }
          },
          roundLengths: true,
          speed: 500,
          updateOnImagesReady: true,
          navigation: {
            nextEl: this.$nextButton,
            prevEl: this.$prevButton
          },
          on: {
            init: function init(swiper) {
              new _snippetsProductItem2['default']($collection);
            }
          }
        });
      };

      FeaturedProducts.prototype._isVisible = function _isVisible() {
        if (!this.el || !this.swiper) return false;

        if (this._isInViewport(this.el)) {
          this.swiper.update();
        }
      };

      FeaturedProducts.prototype._isInViewport = function _isInViewport(elem) {
        var _elem$getBoundingClientRect = elem.getBoundingClientRect();

        var top = _elem$getBoundingClientRect.top;
        var bottom = _elem$getBoundingClientRect.bottom;

        var vHeight = window.innerHeight || document.documentElement.clientHeight;

        return (top > 0 || bottom > 0) && top < vHeight;
      };

      FeaturedProducts.prototype._resizeProductDetails = function _resizeProductDetails() {

        // Get array of heights of all product details in swiper
        var productDetailsHeights = [];
        this.productDetails.forEach(function (details) {
          productDetailsHeights.push(details.offsetHeight);
        });

        // Set height of all product details to the max height
        var maxHeight = productDetailsHeights.reduce(function (accum, current) {
          return accum > current ? accum : current;
        });
        this.productDetails.forEach(function (details) {
          details.style.height = maxHeight + 'px';
        });
      };

      FeaturedProducts.prototype._positionSwiperButtons = function _positionSwiperButtons() {

        // Derive image height (taking account of vertical margins in swiper container)
        var swiperHeight = this.swiperWrapper.offsetHeight;
        var productDetailsHeight = this.productDetails[0].offsetHeight;
        var imageHeight = swiperHeight - productDetailsHeight - parseInt(window.getComputedStyle(this.productItem).marginBottom) - parseInt(window.getComputedStyle(this.productImageWrapper).marginBottom);

        // Position swiper buttons in vertical middle of images
        this.swiperButtons.forEach(function (button) {
          button.style.top = imageHeight / 2 + 'px';
        });
      };

      return FeaturedProducts;
    })();

    exports['default'] = FeaturedProducts;
    module.exports = exports['default'];

  }, { "../snippets/ProductItem": 45 }], 28: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var ImageWithTextOverlay = (function () {
      function ImageWithTextOverlay(element) {
        _classCallCheck(this, ImageWithTextOverlay);

        this.$window = $(window);
        this.element = element;

        this._init(this.element, false);
        this._bindEvents();
      }

      ImageWithTextOverlay.prototype._init = function _init(element, reset) {
        if (!element) return;

        this.sectionWrapper = /** @type {HTMLElement} */element.querySelector('.image-with-text-overlay__content');
        this.imageWrapper = /** @type {HTMLElement} */element.querySelector('.image-with-text-overlay__image');
        this.contentWrapper = /** @type {HTMLElement} */element.querySelector('.image-with-text-overlay__text-inner');
        this.imageElement = this.imageWrapper.querySelectorAll('img, svg')[0];
        this.sectionHeightSetToOriginal = element.classList.contains('size-original');

        if (reset) this.setToOriginalHeight();
      };

      ImageWithTextOverlay.prototype._bindEvents = function _bindEvents() {
        var _this = this;

        this.$window.on('resize', _.debounce(this.setToOriginalHeight.bind(this), 300));
        this.$window.on('load', this.setToOriginalHeight());

        // Re-init vars on theme editor interactions.
        document.addEventListener('shopify:section:load', function (e) {
          _this._init(e.target.querySelector('section.image-with-text-overlay__wrapper'), true);
        });
      };

      ImageWithTextOverlay.prototype.setToOriginalHeight = function setToOriginalHeight() {
        var _this2 = this;

        if (!this.sectionHeightSetToOriginal) return;

        this.toggleCoverClass();
        this.imageElement.style.height = 'auto';
        this.imageWrapper.style.height = '100%';

        this.contentIsTallerThanImage().then(function (isContentHigher) {

          if (isContentHigher) {
            _this2.toggleCoverClass(true);
            var textHeight = _this2.getContentHeight();
            _this2.imageElement.style.height = textHeight + 30 + 'px';
          }
        });
      };

      ImageWithTextOverlay.prototype.toggleCoverClass = function toggleCoverClass(contentIsTaller) {
        this.imageElement.classList.remove('image-cover');

        if (contentIsTaller) this.imageElement.classList.add('image-cover');
      };

      ImageWithTextOverlay.prototype.getContentHeight = function getContentHeight() {
        return this.contentWrapper ? this.contentWrapper.offsetHeight : 0;
      };

      ImageWithTextOverlay.prototype.getImageHeight = function getImageHeight() {
        var _this3 = this;

        return new Promise(function (resolve, reject) {
          if (_this3.imageElement) {
            var actualSrc = _this3.imageElement.src.replace('_%7Bwidth%7Dx', '');

            // Load a temp version to avoid lazyloading / srcset issues.
            _this3.getTempHeight(actualSrc).then(function (height) {
              resolve(height);
            });
          } else resolve(0);
        });
      };

      ImageWithTextOverlay.prototype.contentIsTallerThanImage = function contentIsTallerThanImage() {
        var _this4 = this;

        return new Promise(function (resolve, reject) {
          _this4.getImageHeight().then(function (imgHeight) {
            var contentHeight = _this4.getContentHeight();
            var isContentHigher = contentHeight > imgHeight;
            resolve(isContentHigher);
          });
        });
      };

      ImageWithTextOverlay.prototype.getTempHeight = function getTempHeight(src) {
        return new Promise(function (resolve, reject) {
          var img = new Image();
          img.onload = function () {
            return resolve(img.height);
          };
          img.onerror = reject;
          img.src = src;
        });
      };

      return ImageWithTextOverlay;
    })();

    exports['default'] = ImageWithTextOverlay;
    module.exports = exports['default'];

  }, {}], 29: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var Map = (function () {
      function Map(el) {
        var _this = this;

        _classCallCheck(this, Map);

        var $el = $(el);
        var key = $el.data('map-api');
        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key).then(function () {
          $el.each(function (i, el) {
            _this.buildMap(el);
          });
        });
      }

      Map.prototype.buildMap = function buildMap(el) {
        var _this2 = this;

        var $el = $(el);
        var sectionId = $el.data('section-id');
        var apiKey = $el.data('map-api');
        var address = $el.data('map-address');
        var hours = $el.data('map-hours') != '' ? $el.data('map-hours') : false;
        var style = $el.data('map-style') != '' ? JSON.parse($el.data('map-style')) : false;
        var image = $el.data('map-image') ? $el.data('map-image') : false;
        var info = undefined;

        var geocoder = new google.maps.Geocoder();

        if (hours) {
          info = new google.maps.InfoWindow({
            content: hours
          });
        }

        geocoder.geocode({ 'address': address }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            (function () {

              var mapOptions = {
                zoom: 12,
                center: results[0].geometry.location,
                styles: style
              };

              var map = new google.maps.Map(document.getElementById('index-map-' + sectionId), mapOptions);

              var marker = new google.maps.Marker({
                map: map,
                position: results[0].geometry.location
              });

              if (hours) {
                marker.addListener('click', function () {
                  info.open(map, marker);
                });
              }

              $('.index-map-wrapper .svg-placeholder').hide();
            })();
          } else {
            console.error('Google Maps geocode was not successful for the following reason: ' + status);

            if (image) {
              var $map = _this2.$el.find('[data-map-content]');
              var newImg = new Image();
              newImg.src = _this2.image;
              $map[0].appendChild(newImg);
            }
          }
        });
      };

      return Map;
    })();

    exports['default'] = Map;
    module.exports = exports['default'];

  }, {}], 30: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _snippetsProductItem = require("../snippets/ProductItem");

    var _snippetsProductItem2 = _interopRequireDefault(_snippetsProductItem);

    var ProductRecommendations = (function () {
      function ProductRecommendations() {
        _classCallCheck(this, ProductRecommendations);

        this._loadProductRecommendationsIntoSection();
        this.swiper = null;
        this.$window = $(window);
        this.$body = $(document.body);
        this.el = null;

        this._bindEvents();
      }

      ProductRecommendations.prototype._bindEvents = function _bindEvents() {
        this.$window.on('scroll', _.debounce(this._isVisible.bind(this), 300));
      };

      ProductRecommendations.prototype._loadProductRecommendationsIntoSection = function _loadProductRecommendationsIntoSection() {
        var self = this;
        var productRecommendationsSection = document.querySelector('.product-recommendations-wrapper');

        if (productRecommendationsSection === null) {
          return;
        }

        var productId = productRecommendationsSection.dataset.productId;
        var limit = productRecommendationsSection.dataset.limit;
        var baseUrl = productRecommendationsSection.dataset.recommendationsUrl;
        var requestUrl = baseUrl + '?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;

        var request = new XMLHttpRequest();
        request.open('GET', requestUrl);
        request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
            var container = document.createElement('div');
            container.innerHTML = request.response;
            productRecommendationsSection.innerHTML = container.querySelector('.product-recommendations-wrapper').innerHTML;

            self.el = productRecommendationsSection.querySelector('[data-product-recommendations-inner]');
            if (self.el) {
              (function () {
                self._initSwiper(self.el);
                self._resizeProductDetails(self.el);

                // Position swiper buttons on mouse enter
                var swiperWrapper = self.el.querySelector('.swiper-wrapper');
                swiperWrapper.addEventListener('mouseenter', function () {
                  self._positionSwiperButtons(swiperWrapper);
                });
              })();
            }
          }
        };
        request.send();
      };

      ProductRecommendations.prototype._initSwiper = function _initSwiper(elem) {
        this.swiper = new Swiper('.product-recommendations-wrapper .swiper-container', {
          scrollbar: {
            el: '.product-recommendations-wrapper .swiper-scrollbar',
            hide: false,
            draggable: true
          },
          breakpoints: {
            300: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 0
            },
            500: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 8
            },
            720: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              spaceBetween: 8
            },
            1200: {
              slidesPerView: 4,
              slidesPerGroup: 4,
              spaceBetween: 8
            },
            1400: {
              slidesPerView: 5,
              slidesPerGroup: 5,
              spaceBetween: 8
            },
            1800: {
              slidesPerView: 6,
              slidesPerGroup: 6,
              spaceBetween: 8
            }
          },
          roundLengths: true,
          speed: 500,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          on: {
            init: function init(swiper) {
              new _snippetsProductItem2['default'](elem);
            }
          }
        });
      };

      ProductRecommendations.prototype._isVisible = function _isVisible() {
        if (!this.el || !this.swiper) return false;

        if (this._isInViewport(this.el)) {
          this.swiper.update();
        }
      };

      ProductRecommendations.prototype._isInViewport = function _isInViewport(elem) {
        var _elem$getBoundingClientRect = elem.getBoundingClientRect();

        var top = _elem$getBoundingClientRect.top;
        var bottom = _elem$getBoundingClientRect.bottom;

        var vHeight = window.innerHeight || document.documentElement.clientHeight;

        return (top > 0 || bottom > 0) && top < vHeight;
      };

      ProductRecommendations.prototype._resizeProductDetails = function _resizeProductDetails(elem) {
        var productDetails = elem.querySelectorAll('.product-item-details');

        // Get array of heights of all product details in swiper
        var productDetailsHeights = [];
        productDetails.forEach(function (details) {
          productDetailsHeights.push(details.offsetHeight);
        });

        // Set height of all product details to the max height
        var maxHeight = productDetailsHeights.reduce(function (accum, current) {
          return accum > current ? accum : current;
        });
        productDetails.forEach(function (details) {
          details.style.height = maxHeight + 'px';
        });
      };

      ProductRecommendations.prototype._positionSwiperButtons = function _positionSwiperButtons(elem) {
        var productDetails = elem.querySelectorAll('.product-item-details');
        var productItem = elem.querySelectorAll('.product-item')[0];
        var productImageWrapper = elem.querySelectorAll('.product-item__image-wrapper')[0];
        var swiperHeader = elem.parentElement.getElementsByTagName('h2')[0];
        var swiperButtons = elem.parentElement.querySelectorAll('.swiper-button-next, .swiper-button-prev');

        // Derive image height (taking account of vertical margins in swiper container)
        var swiperHeight = elem.offsetHeight;
        var productDetailsHeight = productDetails[0].offsetHeight;
        var imageHeight = swiperHeight - productDetailsHeight - parseInt(window.getComputedStyle(productItem).marginBottom) - parseInt(window.getComputedStyle(productImageWrapper).marginBottom);

        // Position swiper buttons in vertical middle of images
        var headerHeight = swiperHeader.offsetHeight + parseInt(window.getComputedStyle(swiperHeader).marginBottom); // Include header margin bottom
        swiperButtons.forEach(function (button) {
          button.style.top = headerHeight + imageHeight / 2 + 'px';
        });
      };

      return ProductRecommendations;
    })();

    exports['default'] = ProductRecommendations;
    module.exports = exports['default'];

  }, { "../snippets/ProductItem": 45 }], 31: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _snippetsProductItem = require("../snippets/ProductItem");

    var _snippetsProductItem2 = _interopRequireDefault(_snippetsProductItem);

    var ShopTheLook = (function () {
      function ShopTheLook(el) {
        _classCallCheck(this, ShopTheLook);

        this.$window = $(window);
        this.$el = $(el);
        this.el = el;
        this.$wrapper = this.$el.find('[data-shop-the-look-inner]');

        this.dots = this.el.querySelectorAll('.stl__dot--container');
        this.products = this.el.querySelectorAll('.stl__products');

        this.descriptionElem = this.el.querySelector('.stl__description-inner');
        this.descriptionContent = this.descriptionElem.innerHTML;

        this._bindEvents();
      }

      ShopTheLook.prototype._bindEvents = function _bindEvents() {
        var self = this;

        for (var _iterator = this.dots, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
          var _ref;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
          }

          var dot = _ref;

          this._handleDot(dot);
        }

        document.addEventListener('click', function (e) {
          var parentCheck = e.target.closest('button');
          var productCheck = e.target.closest('.product-item');
          var minusSvg = e.target.closest('svg');
          var isMinus = false;
          if (minusSvg) isMinus = minusSvg.classList.contains('minus');

          if (!parentCheck || !parentCheck.hasAttribute('data-index') || isMinus) {
            if (!productCheck) {
              self._deactivateAllDots();
            }
          }
        });
      };

      ShopTheLook.prototype._handleDot = function _handleDot(dot) {
        var self = this;

        dot.addEventListener('click', function (e) {
          var parentBtn = e.target.closest('button');
          var num = parentBtn.dataset.index;

          self.$el.find('.plus, .minus').css('z-index', '');
          $(this).addClass('stl__dot--active').siblings().removeClass('stl__dot--active');
          $(this).find('.minus').css('z-index', 1);

          self._showProduct(num);
          parentBtn.blur();
        });
      };

      ShopTheLook.prototype._deactivateAllDots = function _deactivateAllDots() {
        for (var i = 0; i < this.dots.length; i++) {
          this.dots[i].classList.remove('stl__dot--active');
        }

        this.$el.find('.plus, .minus').css('z-index', '');
        this._replaceDescription();
      };

      ShopTheLook.prototype._showProduct = function _showProduct(index) {
        var _this = this;

        var productToShow = this.el.querySelector('.stl__outer-products-container #product_' + index);
        this.descriptionElem.innerHTML = productToShow.innerHTML;

        setTimeout(function () {
          new _snippetsProductItem2['default'](_this.descriptionElem);
        }, 100);
      };

      ShopTheLook.prototype._replaceDescription = function _replaceDescription() {
        this.descriptionElem.innerHTML = this.descriptionContent;
      };

      return ShopTheLook;
    })();

    exports['default'] = ShopTheLook;
    module.exports = exports['default'];

  }, { "../snippets/ProductItem": 45 }], 32: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var Slideshow = (function () {
      function Slideshow(section) {
        _classCallCheck(this, Slideshow);

        this.data = section.data;

        if (this.data.slideshowEnabled) {
          this.$el = $(section.el);
          this.$slideshow = this.$el.find('[data-slideshow]');

          this.$slideshow.fitVids();
          this.$slideshow.toggleClass('has-dots', this.data.hasDots);
          this._initSlideshow();
        }
      }

      Slideshow.prototype._initSlideshow = function _initSlideshow() {
        this.$slideshow.slick({
          autoplay: this.data.autoplay,
          autoplaySpeed: this.data.speed,
          arrows: this.data.slideshowEnabled,
          nextArrow: this.data.iconNext,
          prevArrow: this.data.iconPrevious,
          dots: this.data.hasDots,
          adaptiveHeight: false
        });
      };

      Slideshow.prototype.selectBlock = function selectBlock(_ref) {
        var blockId = _ref.blockId;

        var $slide = this.$slideshow.find('[data-slideshow-item="' + blockId + '"]');
        var slideIndex = $slide.data('slick-index');

        this.$slideshow.slick('slickGoTo', slideIndex);
        this.$slideshow.slick('slickPause');
      };

      Slideshow.prototype.deselectBlock = function deselectBlock() {
        if (this.data.autoplay) {
          this.$slideshow.slick('slickPlay');
        }
      };

      Slideshow.prototype.unloadSection = function unloadSection() {
        if (this.data.slideshowEnabled) {
          this.$slideshow.slick('unslick');
        }
      };

      Slideshow.prototype.selectSection = function selectSection(_ref2) {
        var sectionId = _ref2.sectionId;

        if (sectionId === 'index-slideshow') {
          $('[data-header]').trigger('check-fullbleed');
        }
      };

      return Slideshow;
    })();

    exports['default'] = Slideshow;
    module.exports = exports['default'];

  }, {}], 33: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var SlidingText = (function () {
      function SlidingText(el) {
        _classCallCheck(this, SlidingText);

        this.$el = $(el);
        this.$wrapper = this.$el.find('.index-sliding-text__wrapper');
        this.$inner = this.$el.find('.index-sliding-text__wrapper__block');

        this._initSliding();
      }

      SlidingText.prototype._cloneText = function _cloneText($scroller) {
        var parentWidth = $scroller.parent().width();
        var minWidth = parentWidth * 1.5;

        if ($scroller.get(0).scrollWidth >= minWidth) return;

        var $textsWrapper = $scroller.find('.index-sliding-text__wrapper__block__inner');
        var $texts = $textsWrapper.find('.index-sliding-text__item:not(.cloned)');

        // Clone all the existing texts in this wrapper.
        $.each($texts, function (i, text) {
          $(text).clone().addClass('cloned').attr('aria-hidden', 'true').appendTo($textsWrapper);
        });

        // Clone texts more times until minimum width met.
        if ($scroller.get(0).scrollWidth < minWidth) {
          this._cloneText($scroller);
        }
      };

      SlidingText.prototype._initSliding = function _initSliding() {
        // Clone the wrapper for the infinite looping illusion.
        this._cloneText(this.$wrapper);
        this.$inner.find('.index-sliding-text__wrapper__block__inner:not(cloned)').clone().addClass('cloned').attr('aria-hidden', 'true').appendTo(this.$inner);

        var autoplay = false;

        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          autoplay = true;
        }

        // Edge does not have reduced motion capabilities, so keep the animation.
        if (navigator.appVersion.indexOf("Edg/") !== -1 && navigator.appVersion.indexOf("Edge") !== -1) {
          autoplay = true;
        }

        if (autoplay) {
          this.$inner.find('.index-sliding-text__wrapper__block__inner').css('animation-play-state', 'running');
        } else {
          // Remove clones.
          this.$inner.find('.index-sliding-text__wrapper__block__inner').remove('.cloned');
          this.$inner.find('.index-sliding-text__item').remove('.cloned');
          this.$wrapper.addClass('reduced-motion');
        }
      };

      return SlidingText;
    })();

    exports['default'] = SlidingText;
    module.exports = exports['default'];

  }, {}], 34: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _scriptjs = require('scriptjs');

    var _scriptjs2 = _interopRequireDefault(_scriptjs);

    var _globalLoadVideoAPIs = require('../global/loadVideoAPIs');

    var _globalLoadVideoAPIs2 = _interopRequireDefault(_globalLoadVideoAPIs);

    var Video = (function () {
      function Video(el) {
        _classCallCheck(this, Video);

        this.$el = $(el);
        this.$cover = this.$el.find('[data-video-cover]');
        this.$play = this.$el.find('[data-video-play]');
        this.sectionId = this.$el.data('section-id');
        this.id = this.$el.data('video-id');
        this.type = this.$el.data('video-type');
        this.videoAPIs = new _globalLoadVideoAPIs2['default']();

        this._initVideo();
        this._bindEvents();
      }

      Video.prototype._bindEvents = function _bindEvents() {
        var _this = this;

        this.$play.on('click.video', function () {
          _this._startVideo();
        });
      };

      Video.prototype._initVideo = function _initVideo() {
        var _this2 = this;

        if (this.type === 'youtube') {
          (function () {
            var videoOptions = {
              height: '390',
              width: '640',
              videoId: _this2.id
            };

            _this2.videoAPIs.loadYoutubeApi().then(function () {
              _this2._buildPlayer(videoOptions);
            });
          })();
        } else if (this.type === 'vimeo') {
          (function () {
            var videoOptions = {
              width: '640',
              id: _this2.id
            };

            _this2.videoAPIs.loadVimeoApi().then(function () {
              _this2._buildPlayer(videoOptions);
            });
          })();
        }
      };

      Video.prototype._buildPlayer = function _buildPlayer(videoOptions) {
        var _this3 = this;

        if (this.type === 'youtube') {
          this.player = new YT.Player('video-player-' + this.sectionId, videoOptions);
        } else if (this.type === 'vimeo') {
          this.player = new Vimeo.Player('video-player-' + this.sectionId, videoOptions);
        }

        setTimeout(function () {
          _this3.$el.fitVids();
        }, 200);
      };

      Video.prototype._startVideo = function _startVideo() {
        this.$cover.addClass('visibly-hidden');

        if (this.type === 'youtube') {
          this.player.playVideo();
        } else if (this.type === 'vimeo') {
          this.player.play();
        }
      };

      return Video;
    })();

    exports['default'] = Video;
    module.exports = exports['default'];

  }, { "../global/loadVideoAPIs": 20, "scriptjs": 6 }], 35: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _scriptjs = require('scriptjs');

    var _scriptjs2 = _interopRequireDefault(_scriptjs);

    var _globalLoadVideoAPIs = require('../global/loadVideoAPIs');

    var _globalLoadVideoAPIs2 = _interopRequireDefault(_globalLoadVideoAPIs);

    var VideoHero = (function () {
      function VideoHero(el) {
        _classCallCheck(this, VideoHero);

        this.$el = $(el);
        this.sectionId = this.$el.data('section-id');

        this.videoAPIs = new _globalLoadVideoAPIs2['default']();
        this.loadLibraries();
      }

      VideoHero.prototype.loadLibraries = function loadLibraries() {
        this.loadYouTube();
        this.loadVimeo();
        this.loadPlyr();
      };

      VideoHero.prototype.loadPlyr = function loadPlyr() {
        if (!document.querySelector('.video-hero-mp4')) {
          return;
        }

        window.Shopify.loadFeatures([{
          name: 'video-ui',
          version: '1.0',
          onLoad: this.onLoadVideoUI.bind(this)
        }]);
      };

      VideoHero.prototype.loadVimeo = function loadVimeo() {
        var _this = this;

        if (!document.querySelector('.video-hero-vimeo')) {
          return;
        }

        this.videoAPIs.loadVimeoApi().then(function () {
          _this.onLoadVideoUI();
        });
      };

      VideoHero.prototype.loadYouTube = function loadYouTube() {
        var _this2 = this;

        if (!document.querySelector('.homepage-hero-youtube-video') && !document.querySelector('.video-hero-youtube')) {
          return;
        }

        this.videoAPIs.loadYoutubeApi().then(function () {
          _this2.onLoadVideoUI();
        });
      };

      VideoHero.prototype.onLoadVideoUI = function onLoadVideoUI() {
        $('.hero-video--media').each(this.onLoad.bind(this));
      };

      VideoHero.prototype.onLoad = function onLoad(index, el) {
        this.parentCont = $(el).closest('.hero-video--media').get(0);
        this.autoplay = true;
        this.loop = true;
        this.mute = true;
        this.hideControls = el.dataset.hideControls === 'true';

        // Edge doesn't support prefers-reduced-motion, so always returns TRUE.
        if (navigator.appVersion.indexOf("Edge") !== -1) {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.autoplay = false;
          }
        }

        if ("connection" in navigator) {
          if (navigator.connection.saveData) {
            this.autoplay = false;
          }
        }

        var videoType = false;
        if ($(el).find('.video-hero-mp4').length) videoType = 'mp4'; else if ($(el).find('.video-hero-youtube').length) videoType = 'youtube'; else if ($(el).find('.video-hero-vimeo').length) videoType = 'vimeo';

        if (videoType == 'mp4') {
          this.playPlyr(el);
        } else if (videoType == 'youtube') {
          this.playYoutube(el);
        } else if (videoType == 'vimeo') {
          this.playVimeo(el);
        }
      };

      VideoHero.prototype.playYoutube = function playYoutube(el) {
        var self = this;
        var videoId = this.youtubeGetId(this.parentCont.dataset.videoid);
        var IframeTarget = $(el).find('.iframe-placeholder').get(0);
        var $overlay = $(el).parent().find('.hero-video--overlay');

        var player = new YT.Player(IframeTarget, {
          videoId: videoId,
          playerVars: {
            mute: this.mute ? 1 : 0,
            loop: this.loop ? 1 : 0,
            showinfo: 0,
            modestbranding: 1,
            rel: 0,
            autoplay: this.autoplay ? 1 : 0,
            controls: this.hideControls ? 0 : 1,
            playlist: videoId,
            cc_load_policy: 0,
            fs: 0,
            iv_load_policy: 3,
            playsinline: 1,
            branding: 0,
            origin: window.location.origin
          },
          events: {
            onReady: function onReady(event) {
              // Prevent focus, it makes the video jump offscreen when the logo is focussed on.
              $('.video-hero-youtube').attr('tabindex', -1);

              // Autoplay if Save-Data is not set
              if ("connection" in navigator) {
                if (navigator.connection.saveData !== true) {
                  event.target.playVideo();
                }
              } else {
                event.target.playVideo();
              }
            },
            onError: function onError(e) {
              console.log(e);
            },
            onStateChange: function onStateChange(event) {
              if (event.data === window.YT.PlayerState.PLAYING) {
                if ($overlay.is(':visible')) {
                  $overlay.fadeOut('fast');
                }
                $(self.parentCont).addClass('media-playing');
              }
            }
          }
        });
      };

      VideoHero.prototype.playVimeo = function playVimeo(el) {
        var self = this;
        var videoId = this.vimeoGetId(this.parentCont.dataset.videoid);
        var iframe = $(el).find('iframe').get(0);
        var vimeoUrl = this.vimeoGetUrl(this.parentCont.dataset.videoid);
        iframe.setAttribute('src', vimeoUrl);
        var player = new Vimeo.Player(iframe, {
          id: videoId,
          autoplay: this.autoplay,
          controls: this.hideControls,
          muted: true,
          loop: this.loop
        });

        player.ready().then(function () {
          player.setVolume(0);

          // Autoplay if Save-Data is not set
          if ("connection" in navigator) {
            if (navigator.connection.saveData === true) {
              player.pause();
            }
          }
        })['catch'](function (e) {
          document.getElementById(iframe).innerText = e;
        });
      };

      VideoHero.prototype.playPlyr = function playPlyr(el) {
        var plyrElement = $(el).find('.video-hero-mp4').get(0);

        var player = new Shopify.Plyr(plyrElement, {
          loop: {
            active: this.loop
          },
          autoplay: this.autoplay,
          muted: this.mute,
          fullscreen: {
            enabled: false
          }
        });

        player.on('ready', function (event) {
          var instance = event.detail.plyr;
          player.toggleControls(false);
        });
      };

      VideoHero.prototype.youtubeGetId = function youtubeGetId(url) {
        var ID = '';
        url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        if (url[2] !== undefined) {
          ID = url[2].split(/[^0-9a-z_\-]/i); // eslint-disable-line
          ID = ID[0];
        } else {
          ID = url;
        }
        return ID;
      };

      VideoHero.prototype.vimeoGetId = function vimeoGetId(url) {
        var regex = /(videos|video|channels|\.com)\/([\d]+)/;
        return url.match(regex)[2];
      };

      VideoHero.prototype.vimeoGetUrl = function vimeoGetUrl(url) {
        var regex = /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)(\d+)(?:|\/\?)/;
        var formattedUrl = url.match(regex)[0];
        return formattedUrl.replace("vimeo.com/", "player.vimeo.com/video/") + "?byline=0&amp;portrait=0&amp;title=0&amp;sidedock=0&amp;transparent=0&amp;gesture=media&amp;autoplay=1&amp;mute=1&amp;controls=0&amp;loop=1";
      };

      return VideoHero;
    })();

    exports['default'] = VideoHero;
    module.exports = exports['default'];

  }, { "../global/loadVideoAPIs": 20, "scriptjs": 6 }], 36: [function (require, module, exports) {
    "use strict";

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

    var _Localization = require("./Localization");

    var _Localization2 = _interopRequireDefault(_Localization);

    var Footer = function Footer(section) {
      _classCallCheck(this, Footer);

      this.$el = $(section.el);

      new _Localization2["default"](this.$el.find('.localization-selector-form')[0]);
    };

    exports["default"] = Footer;
    module.exports = exports["default"];

  }, { "./Localization": 40 }], 37: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var FooterTapbar = (function () {
      function FooterTapbar(el) {
        _classCallCheck(this, FooterTapbar);

        this.$el = $(el);
        this.$body = $(document.body);
        this.$window = $(window);
        this.$content = this.$el.find('[data-footer-content]');
        this.searchInput = document.querySelector('#footer-search');
        this.isSearchPredictive = this.searchInput.classList.contains('is-predictive');
        this.$searchResultsWrapper = this.$el.find('[data-footer-search-results-wrapper]');
        this.$searchResults = this.$searchResultsWrapper.children('[data-footer-search-results]');
        this.$searchClose = this.$el.find('[data-footer-search-results-close]');
        this.$searchClear = this.$el.find('.footer-search-clear');
        this.$searchToggle = document.querySelector('[data-footer-tapbar]');
        this.loaded = false;
        this.isPredictiveOpen = false;
        this.isOpen = false;
        this.speed = 500;
        this.searchTypes = this.searchInput.dataset.searchTypes.replace(/,$/, '');
        this.searchTypesNum = this.searchTypes.split(',').length;
        this.searchHasResults = false;

        // If there is more than 1 search type/group, restrict results to sensible amount.
        this.groupMax = 1;
        if (this.searchTypesNum == 1) this.groupMax = 4; else if (this.searchTypesNum == 2) this.groupMax = 3; else if (this.searchTypesNum == 3) this.groupMax = 2;

        this.showPrices = this.searchInput.dataset.showPrices == 'true';
        this.showVendor = this.searchInput.dataset.showVendor == 'true';

        this.currentSearch = undefined;

        this.contentOpen = false;
        this.layout = 'large';

        this._setAccountIcon();

        this._bindEvents();
      }

      FooterTapbar.prototype._bindEvents = function _bindEvents() {
        var _this = this;

        this.$el.on('click', '[data-footer-account-toggle]', function (event) {
          event.preventDefault();
          var wrapperIsVisible = document.querySelector('.footer-search-results-wrapper').classList.contains('visible');
          if (_this.isSearchPredictive && wrapperIsVisible) {
            return;
          } else {
            _this._toggleContent(event, 'account');
          }
        });

        this.$el.on('click', '[data-footer-search-toggle]', function (event) {
          event.preventDefault();
          _this.$searchToggle.classList.toggle('isOpen');
          var wrapperIsVisible = document.querySelector('.footer-search-results-wrapper').classList.contains('visible');
          if (_this.isSearchPredictive && wrapperIsVisible) {
            return;
          } else {
            _this._toggleContent(event, 'search');
            if (_this.isOpen) {
              _this.searchInput.focus();
            } else {
              _this.searchInput.blur();
            }
          }
        });

        $('#footer-search').on('click focus', function (event) {
          _this._focusPredictiveSearch();
        });

        this.$searchClear.on('click', function (event) {
          _this.searchInput.value = '';
          _this.$searchClear.css('visibility', 'hidden');
          _this._focusPredictiveSearch();
          _this.searchInput.focus();
        });

        this.$searchClear.on('keypress', function (event) {
          if (event.which == 13) {
            _this.searchInput.value = '';
            _this.$searchClear.css('visibility', 'hidden');
            _this._focusPredictiveSearch();
            _this.searchInput.focus();
          }
        });

        this.$searchClose.on('click', function (event) {
          _this._blurPredictiveSearch();
          _this.isPredictiveOpen = false;
        });

        this.$searchClose.on('keypress', function (event) {
          if (event.keyCode === 13) {
            _this._blurPredictiveSearch();
            _this.isPredictiveOpen = false;
          }
        });

        $(window).on('blur', function () {
          if (_this.isPredictiveOpen) {
            _this._blurPredictiveSearch();
            _this.isPredictiveOpen = false;
          }
        });

        var debounceSetup = function debounceSetup(event) {
          event.preventDefault();
          _this._getSearchTerm();
        };

        //Sometimes the mobile keybard covers the input
        var $htmlOrBody = $('html, body'),
          scrollTopPadding = 8; // scrollTop works on <body> for some browsers, <html> for others

        $('#footer-search').focus(function () {
          // get textarea's offset top position
          var inputTop = $(this).offset().top;
          // scroll to the textarea
          $htmlOrBody.scrollTop(inputTop - scrollTopPadding);
        });

        var self = this;

        this.$el.on('keyup.searchQuery', 'input', _.debounce(debounceSetup, 500));

        this.$el.on('keyup.searchQuery', 'input', function () {
          if (self.searchInput.value.length > 0) {
            self.$searchClear.css('visibility', 'visible');
          } else {
            self.$searchClear.css('visibility', 'hidden');
          }
        });

        this.$window.on('resize', _.debounce(this._moveAccountContent.bind(this), 50)).trigger('resize');
      };

      FooterTapbar.prototype._getAccountContentHeights = function _getAccountContentHeights(type) {
        var $item = this.$el.find('[data-footer-' + type + ']');
        return $item.outerHeight();
      };

      FooterTapbar.prototype._toggleContent = function _toggleContent(event, type) {
        var $target = $(event.currentTarget);
        var newHeight = this._getAccountContentHeights(type);
        var height = this.isOpen ? 0 : newHeight;
        var offset = undefined;
        this.$content.height(height);

        this.$content.children('[data-footer-content-item="' + type + '"]').addClass('active').siblings().removeClass('active');

        if (this.isOpen && this.contentOpen !== type) {
          this.$content.height(newHeight);
          this.isOpen = true;
        } else {
          this.isOpen = !this.isOpen;
        }

        $target.parent('li').toggleClass('active', this.isOpen).siblings().removeClass('active');

        this.contentOpen = this.isOpen ? type : false;
      };

      FooterTapbar.prototype._moveAccountContent = function _moveAccountContent() {
        var windowWidth = window.innerWidth;

        if (windowWidth > 720 && this.layout !== 'large') {
          var $accountContent = $('[data-footer-account] [data-account-dropdown]').detach();
          $accountContent.prependTo('[data-header-account-dropdown-wrapper]');
          this.layout = 'large';
        } else if (windowWidth <= 720 && this.layout !== 'small') {
          var $accountContent = $('[data-header-account-dropdown-wrapper] [data-account-dropdown]').detach();
          $accountContent.appendTo('[data-footer-account]');
          this.layout = 'small';
        }
      };

      FooterTapbar.prototype._setAccountIcon = function _setAccountIcon() {
        var $headerAccount = $(document.body).find('[data-header-account] > a use');
        if (!$headerAccount.length) return;

        var id = $headerAccount.attr('xlink:href');
        var $footerAccount = this.$el.find('[data-footer-account-toggle]');
        var iconStyle = id.split('#icon-account-')[1];

        $footerAccount.addClass('footer-account-toggle--style-' + iconStyle).find('use').attr('xlink:href', id);
      };

      FooterTapbar.prototype._focusPredictiveSearch = function _focusPredictiveSearch() {
        if (this.searchInput.value.length > 2 && this.searchHasResults) {
          $('.footer-tapbar').addClass('search-open');
          this.$content.addClass('search-open');
          this.$searchResultsWrapper.revealer('show');
        } else {
          this._cancelSearch();
          this.isPredictiveOpen = false;
        }
      };

      FooterTapbar.prototype._blurPredictiveSearch = function _blurPredictiveSearch() {
        var _this2 = this;

        this.$searchResultsWrapper.revealer('hide');

        setTimeout(function () {
          $('.footer-tapbar').removeClass('search-open');
          _this2.$content.removeClass('search-open');
          _this2.$body.removeClass('scroll-locked');
        }, this.speed);
      };

      FooterTapbar.prototype.getSearchQuery = function getSearchQuery() {
        return '/search/suggest.json?q=' + this.searchInput.value + '&resources[type]=' + this.searchTypes;
      };

      FooterTapbar.prototype.getSearchPageUrlWithQuery = function getSearchPageUrlWithQuery() {
        return '/search?type=' + this.searchTypes + '&q=' + encodeURIComponent(this.searchInput.value) + '*';
      };

      FooterTapbar.prototype._getSearchTerm = function _getSearchTerm() {
        var _this3 = this;

        this.searchComplete = false;
        this.searchResultsArray = [];

        var query = '';

        if (this.isSearchPredictive) {
          query = this.getSearchQuery();

          if (this.searchInput.value.length > 2) {
            this._performSearch(query);

            setTimeout(function () {
              if (!_this3.$searchResultsWrapper.revealer('isVisible') && _this3.searchHasResults) {
                _this3.$searchResultsWrapper.revealer('show');
              }
            }, this.speed);
          } else {
            this.searchHasResults = false;
            this._cancelSearch();
          }
        } else {
          query = this.getSearchPageUrlWithQuery();
        }
      };

      FooterTapbar.prototype._performSearch = function _performSearch(query) {
        var _this4 = this;

        var self = this;
        var searchResultsArrayTemp = [];
        this.searchHasResults = false;

        this.currentSearch = $.getJSON(query, function (data) {

          if (data && Object.keys(data.resources.results).length > 0) {

            // Each GROUP e.g. products, pages, articles, collections
            $.each(data.resources.results, function (index, resultGroup) {

              if (resultGroup.length > 0) {
                (function () {

                  // Give products a little more precedence.
                  if (index == 'products' && self.groupMax < 4) {
                    self.groupMax = self.groupMax++;
                  }

                  searchResultsArrayTemp.push('\n              <div class="predictive-search-group">\n                <h2 class="predictive-search-group__title">' + Theme.localization.search[index] + '</h2>\n            ');

                  var itemCount = 0;

                  // Each ITEM e.g. individual product, page etc
                  Object.keys(resultGroup).forEach(function (resultKey) {

                    if (itemCount < self.groupMax) {

                      var result = resultGroup[resultKey];
                      var infoColClass = 'grid-item-100';

                      searchResultsArrayTemp.push('<div class="grid">');

                      if (result.featured_image && result.featured_image.url > '') {
                        infoColClass = 'grid-item-80';

                        searchResultsArrayTemp.push('\n                    <div class="grid-item-20">\n                      <a href="' + result.url + '"><img src="' + result.featured_image.url + '" alt="' + result.featured_image.alt + '" /></a>\n                    </div>\n                  ');
                      } else {
                        infoColClass = 'grid-item-80 no-image';
                      }

                      searchResultsArrayTemp.push('<div class="' + infoColClass + '">');

                      if (self.showVendor && result.vendor) {
                        searchResultsArrayTemp.push('<div class="predictive-search__vendor">' + result.vendor + '</div>');
                      }

                      searchResultsArrayTemp.push('<h5 class="predictive-search__item-title"><a class="' + index + '" href="' + result.url + '">' + result.title + '</a></h5>');

                      if (!result.available && index == 'products') {
                        searchResultsArrayTemp.push('<div class="predictive-search__soldout">' + Theme.localization.product.soldOut + '</div>');
                      }

                      if (self.showPrices && result.price) {
                        searchResultsArrayTemp.push('<div class="predictive-search__price">' + Shopify.formatMoney(result.price, Theme.moneyFormat) + '</div>');
                      }

                      searchResultsArrayTemp.push('</div></div>'); // Close .grid, infoColClass
                      searchResultsArrayTemp.push('<span class="search-result-separator"><hr /></span>');

                      itemCount = itemCount + 1;
                    }
                  });

                  searchResultsArrayTemp.push('\n                </div>\n              </div>\n            ');

                  _this4.searchHasResults = true;
                  _this4.searchComplete = true;
                })();
              }
            });

            var viewAll = searchResultsArrayTemp.length > 1 ? '<div class="predictive-search__viewall"><a href="' + _this4.getSearchPageUrlWithQuery() + '">' + Theme.localization.search.viewAll + '</a></div>' : '';

            if (searchResultsArrayTemp.length) {
              _this4.searchResultsArray.push('\n            ' + searchResultsArrayTemp.join('') + '\n            ' + viewAll + '\n          ');
            }

            if (_this4.searchComplete && _this4.searchHasResults) {
              _this4._openResultsPanel();
            } else {
              _this4._cancelSearch();
            }
          }
        });
      };

      FooterTapbar.prototype._cancelSearch = function _cancelSearch() {
        if (this.currentSearch) {
          this.currentSearch.abort();
        }
        this.$searchResults.html('');
        this.$searchResults.removeAttr('class'); // removeClass 'visible' did not work
        this.$searchResultsWrapper.removeClass('visible');
        this.$searchClose.removeClass('visible');
        this.searchHasResults = false;
      };

      FooterTapbar.prototype._openResultsPanel = function _openResultsPanel() {
        $('.footer-tapbar').addClass('search-open');
        this.$searchResults.html('' + this.searchResultsArray.join(''));
        this.$searchResults.addClass('visible');
        this.$searchResultsWrapper.addClass('visible');
        this.$searchClose.addClass('visible');
      };

      return FooterTapbar;
    })();

    exports['default'] = FooterTapbar;
    module.exports = exports['default'];

  }, {}], 38: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _Search = require('./Search');

    var _Search2 = _interopRequireDefault(_Search);

    var _HeaderAccountDropdown = require('./HeaderAccountDropdown');

    var _HeaderAccountDropdown2 = _interopRequireDefault(_HeaderAccountDropdown);

    var _Localization = require('./Localization');

    var _Localization2 = _interopRequireDefault(_Localization);

    var Header = (function () {
      function Header(section) {
        _classCallCheck(this, Header);

        this.data = section.data;
        this.$window = $(window);
        this.$body = $(document.body);
        this.$el = $(section.el);
        this.$header = this.$el.closest('[data-header]');
        this.$tapbar = $('[data-footer-tapbar]');

        new _HeaderAccountDropdown2['default']('[data-header-account]');

        new _Localization2['default'](this.$el.find('.localization-selector-form')[0]);

        if (Modernizr.flexbox) {
          new _Search2['default']('[data-header-search-form]');
        }

        this._bindEvents();
        this._checkFullBleed();

        this.$window.on('load', this._onWindowResize.bind(this));
      }

      Header.prototype._bindEvents = function _bindEvents() {
        var _this = this;

        this._bindHeaderScroll();

        this.$window.on('bind-header-scroll', function () {
          _this._bindHeaderScroll();
        });

        this.$window.on('resize', _.debounce(this._onWindowResize.bind(this), 100));
        this.$header.on('check-fullbleed', this._checkFullBleed.bind(this));
      };

      Header.prototype._bindHeaderScroll = function _bindHeaderScroll() {
        var _this2 = this;

        this.$window.on('scroll.header', function () {
          if (window.innerWidth <= 720 && !_this2.checkingSticky && !_this2.$body.hasClass('scroll-locked')) {
            _this2.checkingSticky = true;
            setTimeout(_this2._checkSticky.bind(_this2), 250);
          }
        });
      };

      Header.prototype._onWindowResize = function _onWindowResize() {
        this._getDocumentHeights();
        this._setBodyPadding();
      };

      Header.prototype._getDocumentHeights = function _getDocumentHeights() {
        this.documentHeight = $(document).height();
        this.windowHeight = this.$window.height();
      };

      Header.prototype._setBodyPadding = function _setBodyPadding() {
        if (window.innerWidth <= 720) {
          this.$body.css({
            'padding-top': this.$header.outerHeight()
          });
        }
      };

      Header.prototype._checkSticky = function _checkSticky() {
        var topPosition = this.$window.scrollTop();
        var direction = this.topPosition > topPosition ? 'up' : 'down';
        var offset = 100;

        var distanceMoved = this.topPosition - topPosition;
        var adequateDistance = Math.abs(distanceMoved) > 40;
        var hideBars = direction === 'down' && topPosition > offset ? true : false;
        var hideTapbar = hideBars && this.documentHeight - offset > topPosition + this.$window.height() ? true : false;

        if (adequateDistance) {
          this.$header.toggleClass('out-of-view', hideBars);
          this.$tapbar.toggleClass('out-of-view', hideTapbar);
          if (direction === 'up') {
            $('.product-message.visible').css('bottom', '40px');
          } else {
            $('.product-message.visible').css('bottom', '0');
          }
        }

        this.topPosition = topPosition;
        this.checkingSticky = false;
      };

      Header.prototype._checkFullBleed = function _checkFullBleed() {
        var isIndex = this.$body.hasClass('template-index');

        if (isIndex) {
          var firstIndexElem = document.querySelector('.index-wrapper').firstElementChild;
          var hasHero = firstIndexElem.classList.contains('section-index-video-hero-wrapper') || firstIndexElem.classList.contains('section-index-slideshow');

          this.$header.toggleClass('is-fullbleed', this.data.isFullBleed && hasHero).toggleClass('no-border', !this.data.isFullBleed && hasHero);
        }
      };

      Header.prototype.selectBlock = function selectBlock(_ref) {
        var blockId = _ref.blockId;

        this._checkFullBleed();
      };

      Header.prototype.selectSection = function selectSection(_ref2) {
        var sectionId = _ref2.sectionId;

        this._checkFullBleed();
      };

      Header.prototype.reorderSection = function reorderSection() {
        this._checkFullBleed();
      };

      Header.prototype.unloadSection = function unloadSection() { };

      return Header;
    })();

    exports['default'] = Header;
    module.exports = exports['default'];

  }, { "./HeaderAccountDropdown": 39, "./Localization": 40, "./Search": 46 }], 39: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var HeaderAccountDropdown = (function () {
      function HeaderAccountDropdown(el) {
        _classCallCheck(this, HeaderAccountDropdown);

        this.$el = $(el);
        this.$recentlyViewed = this.$el.find('[data-header-account-recent-items]');

        this._setupAccessibility();
        this._checkRecentlyViewed();
        this._toggleHistory();
      }

      HeaderAccountDropdown.prototype._setupAccessibility = function _setupAccessibility() {
        var _this = this;

        this.$el.on('focus blur', '[data-header-account-dropdown-item]', function (event) {
          _this.$el.toggleClass('active', !_this.$el.hasClass('active'));
        });
      };

      HeaderAccountDropdown.prototype._checkRecentlyViewed = function _checkRecentlyViewed() {
        if (!this._isLocalStorageSupported(function () {
          return localStorage;
        })) return;

        var recentlyViewed = localStorage.getItem('recentlyViewed');
        recentlyViewed = recentlyViewed != null ? JSON.parse(recentlyViewed) : false;

        if (recentlyViewed) {
          this.$el.find('[data-header-account-recent]').addClass('visible');
          this._buildRecentlyViewed(recentlyViewed);
        } else {
          this.$el.find('[data-header-account-recent]').remove();
        }
      };

      HeaderAccountDropdown.prototype._toggleHistory = function _toggleHistory() {
        var _this2 = this;

        this.$el.on('click', '[data-toggle-account-history]', function (event) {
          _this2.$el.find('.header-account-history').toggleClass('header-account-history--closed');
        });
      };

      HeaderAccountDropdown.prototype._buildRecentlyViewed = function _buildRecentlyViewed(recentlyViewed) {
        var _this3 = this;

        var handle = recentlyViewed.shift();

        Shopify.getProduct(handle.handle, function (item) {
          var image = Shopify.resizeImage(item.media[0].preview_image, '100x');
          var priceMin = Shopify.formatMoney(item.price_min, Theme.moneyFormat);
          var price = item.price_varies ? priceMin + ' +' : priceMin;

          var sale = item.compare_at_price_min > item.price_min ? true : false;
          var percent = Theme.localization.header.percentOff.replace('*percent*', Math.round((1 - item.price / item.compare_at_price_min) * 100) + '%');
          var percentOff = sale ? '<span class="module-sale">' + percent + '</span>' : '';

          _this3.$recentlyViewed.append('\n        <li class="grid module-order-item">\n          <figure class="grid-item">\n            <a href="' + item.url + '" tabindex="-1">\n              <img src="' + image + '" alt="' + item.title + '">\n            </a>\n          </figure>\n          <div class="grid-item">\n            <span class="module-price"><a href="' + item.url + '" data-header-account-dropdown-item>' + item.title + '</a></span>\n            <span class="money">' + price + '</span>\n            ' + percentOff + '\n          </div>\n        </li>\n      ');
        });
      };

      HeaderAccountDropdown.prototype._isLocalStorageSupported = function _isLocalStorageSupported(getStorage) {
        try {
          var key = "__random_key_name___e__";
          getStorage().setItem(key, key);
          getStorage().removeItem(key);
          return true;
        } catch (e) {
          return false;
        }
      };

      return HeaderAccountDropdown;
    })();

    exports['default'] = HeaderAccountDropdown;
    module.exports = exports['default'];

  }, {}], 40: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var Localization = (function () {
      function Localization(el) {
        _classCallCheck(this, Localization);

        this.el = el;
        this.$el = $(el);

        this._bindEvents();
      }

      Localization.prototype._bindEvents = function _bindEvents() {
        this.$el.find('select').on('change', this._handleChange.bind(this));
      };

      Localization.prototype._handleChange = function _handleChange(e) {
        var $el = $(e.target);
        var $form = $el.closest('form');
        $form.submit();
      };

      return Localization;
    })();

    exports['default'] = Localization;
    module.exports = exports['default'];

  }, {}], 41: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var MailingList = (function () {
      function MailingList(el) {
        _classCallCheck(this, MailingList);

        this.$el = $(el);
        this.$body = $(document.body);

        this._bindEvents();
      }

      MailingList.prototype._bindEvents = function _bindEvents() {
        var _this = this;

        this.$el.on('change', 'select', function (event) {
          _this._updateFormTags(event);
        });
      };

      MailingList.prototype._updateFormTags = function _updateFormTags(event) {
        var tags = $(event.currentTarget).val();
        this.$el.find('[data-mailing-list-tags]').val(tags);
      };

      return MailingList;
    })();

    exports['default'] = MailingList;
    module.exports = exports['default'];

  }, {}], 42: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _NavigationSuper = require('./NavigationSuper');

    var _NavigationSuper2 = _interopRequireDefault(_NavigationSuper);

    var Navigation = (function () {
      function Navigation(el) {
        _classCallCheck(this, Navigation);

        this.$el = $(el);

        this._initMegaMenus();
        this._positionDropdowns();

        this._setupAccessibility();
        this._bindEvents();
        this._navigationScroll();

        if ($(document.body).hasClass('is-mobile')) {
          this._bindMobileEvents();
        }
      }

      Navigation.prototype._initMegaMenus = function _initMegaMenus() {
        var $megaMenu = this.$el.find('[data-navigation-super]');
        if ($megaMenu.length) {
          for (var i = 0; i < $megaMenu.length; i++) {
            new _NavigationSuper2['default']($megaMenu.eq(i));
          }
        }
      };

      Navigation.prototype._setupAccessibility = function _setupAccessibility() {
        this.$el.on('focus blur', '[data-navigation-dropdown-item]', function (event) {
          var $parent = $(event.currentTarget).closest('[data-navigation-item]');
          $parent.toggleClass('active', !$parent.hasClass('active'));
        });
      };

      Navigation.prototype._bindEvents = function _bindEvents() {
        $(window).on('resize', _.debounce(this._positionDropdowns.bind(this), 100));
      };

      Navigation.prototype._bindMobileEvents = function _bindMobileEvents() {
        var _this = this;

        this.$el.on('click', '.has-super-nav > a, .has-dropdown > a, [data-navigation-super] [data-navigation-dropdown-item]', function (event) {
          var $parent = $(event.currentTarget).closest('[data-navigation-item]');

          if (!$parent.hasClass('active')) {
            event.preventDefault();
          }

          $parent.toggleClass('active', !$parent.hasClass('active')).siblings().removeClass('active');
        });

        $(document.body).on('click', function (event) {
          if (!$(event.target).closest('[data-header]').length) {
            _this.$el.find('[data-navigation-item]').removeClass('active');
          }
        });
      };

      Navigation.prototype._positionDropdowns = function _positionDropdowns() {
        var $secondaryDropdown = this.$el.find('.navigation-dropdown-simple.secondary');

        if ($secondaryDropdown.length) {
          var containerRect = this.$el[0].getBoundingClientRect();

          for (var i = 0; i < $secondaryDropdown.length; i++) {
            var $currentDropdown = $secondaryDropdown.eq(i);
            var dropdownRect = $currentDropdown[0].getBoundingClientRect();

            if (dropdownRect.right > containerRect.right) {
              $currentDropdown.addClass('alt-alignment');
            } else if (containerRect.right > dropdownRect.right + dropdownRect.width * 2) {
              $currentDropdown.removeClass('alt-alignment');
            }
          }
        }
      };

      Navigation.prototype._navigationScroll = function _navigationScroll() {
        var $navigationList = this.$el.find('.navigation-list');
        var $mainNavigation = this.$el.closest('.main-navigation');
        var $scrollLeft = this.$el.find('.scroll-left');
        var $scrollRight = this.$el.find('.scroll-right');
        var maxMovement = 300;

        $scrollLeft.on('click', function (event) {
          var navMarginLeft = parseInt($navigationList.css('marginLeft'));
          var movementAmount = Math.abs(navMarginLeft);
          if (movementAmount > maxMovement) movementAmount = maxMovement; // Maximum 300px movement in one jump.

          if (movementAmount > 0) {
            $navigationList.animate({ marginLeft: '+=' + movementAmount }, 500, function () {
              if (parseInt($navigationList.css('marginLeft')) == 0) {
                $mainNavigation.addClass('not-left');
                $mainNavigation.removeClass('not-right');
              }
            });
          } else {
            $mainNavigation.removeClass('not-right');
          }
        });

        $scrollRight.on('click', function (event) {
          var visibleMenuWidth = $navigationList.outerWidth();
          var navMarginLeft = parseInt($navigationList.css('marginLeft'));
          var wholeMenuWidth = $navigationList[0].scrollWidth;
          var movementAmount = wholeMenuWidth - (Math.abs(navMarginLeft) + visibleMenuWidth);
          if (movementAmount > maxMovement) movementAmount = maxMovement; // Maximum 300px movement in one jump.

          if (movementAmount > 0) {
            $navigationList.animate({ marginLeft: '-=' + movementAmount }, 500, function () {
              if (Math.abs(parseInt($navigationList.css('marginLeft'))) + visibleMenuWidth >= wholeMenuWidth) {
                $mainNavigation.addClass('not-right');
              }
            });
          }
          $mainNavigation.removeClass('not-left');
        });

        var overflow = function overflow() {
          var navMarginLeft = parseInt($navigationList.css('marginLeft'));

          if ($navigationList[0].scrollWidth > $navigationList.width() + 15) {
            $mainNavigation.addClass('main-navigation--scrollable');
            if (navMarginLeft > 0) {
              $mainNavigation.addClass('not-right');
              $mainNavigation.removeClass('not-left');
            } else {
              $mainNavigation.addClass('not-left');
              $mainNavigation.removeClass('not-right');
            }
          } else {
            $mainNavigation.removeClass('main-navigation--scrollable not-left not-right');
          }
        };

        overflow();

        $(window).resize(function () {
          if ($navigationList[0].scrollWidth > $navigationList.width() + 15) {
            $mainNavigation.addClass('main-navigation--scrollable not-left');
            $mainNavigation.removeClass('not-right');
            $navigationList.css('margin-left', 0);
          } else {
            $mainNavigation.removeClass('main-navigation--scrollable not-left not-right');
          }
        });
      };

      return Navigation;
    })();

    exports['default'] = Navigation;
    module.exports = exports['default'];

  }, { "./NavigationSuper": 44 }], 43: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var NavigationMobile = (function () {
      function NavigationMobile(el) {
        _classCallCheck(this, NavigationMobile);

        this.$el = $(el);
        this.$window = $(window);
        this.$body = $(document.body);
        this.$header = $('[data-header]');
        this.$toggle = this.$header.find('[data-navigation-toggle]');
        this.layout = 'desktop';
        this.windowWidth = window.innerWidth;

        this._bindEvents();
      }

      NavigationMobile.prototype._bindEvents = function _bindEvents() {
        var _this = this;

        this.$header.on('click', '[data-navigation-toggle]', function (event) {
          event.preventDefault();
          if (_this.$el.revealer('isVisible')) {
            _this._closeMenu();
          } else {
            _this._openMenu();
          }
        });

        this.$el.on('click', '[data-navigation-dropdown-toggle]', function (event) {
          event.preventDefault();
          _this._toggleTier(event);
        });

        this.$window.on('resize.navigation-mobile', _.debounce(this._resize.bind(this), 100)).trigger('resize.navigation-mobile');
      };

      NavigationMobile.prototype._resize = function _resize() {

        if (this.windowWidth === window.innerWidth) {
          return false;
        }

        this._closeMenu();
      };

      NavigationMobile.prototype._openMenu = function _openMenu() {
        this.$header.addClass('mobile-navigation-open');
        this.$body.addClass('scroll-locked');
        this.$el.revealer('show');
        this.$toggle.addClass('active');

        this.$el.css({
          'height': '' + (this.$window.height() - this.$header.outerHeight())
        });
      };

      NavigationMobile.prototype._closeMenu = function _closeMenu() {
        this.$header.removeClass('mobile-navigation-open');
        this.$body.removeClass('scroll-locked');
        this.$el.revealer('hide');
        this.$toggle.removeClass('active');
      };

      NavigationMobile.prototype._toggleTier = function _toggleTier(event) {
        var $target = $(event.currentTarget);
        var $targetItem = $target.closest('[data-navigation-item]');
        var $use = $target.find('use');
        var $targetSubmenu = $targetItem.find('#' + $target.attr('aria-controls'));

        if ($targetItem.hasClass('active')) {
          $target.attr('aria-expanded', false);
          $use.attr('xlink:href', '#icon-plus');
          $targetItem.removeClass('active');
          $targetSubmenu.attr('aria-hidden', true);
        } else {
          $target.attr('aria-expanded', true);
          $use.attr('xlink:href', '#icon-minus');
          $targetItem.addClass('active');
          $targetSubmenu.attr('aria-hidden', false);
        }

        this._closeChildTiers($targetItem.siblings());
      };

      NavigationMobile.prototype._closeChildTiers = function _closeChildTiers($target) {
        $target.removeClass('active').find('.active').removeClass('active');

        $target.find('use').attr('xlink:href', '#icon-plus');
      };

      NavigationMobile.prototype.unloadSection = function unloadSection() {
        this.$header.off('click');
        this.$el.off('click');
        this.$window.off('resize.navigation-mobile');
      };

      return NavigationMobile;
    })();

    exports['default'] = NavigationMobile;
    module.exports = exports['default'];

  }, {}], 44: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var NavigationSuper = (function () {
      function NavigationSuper($el) {
        _classCallCheck(this, NavigationSuper);

        this.$body = $(document.body);
        this.$el = $el;
        this.$departments = this.$el.find('[data-navigation-super-departments]');
        this.$collections = this.$el.find('[data-navigation-super-collections]');
        this.$defaultContent = this.$el.find('[data-navigation-super-default]');
        this.loading = false;
        this.$currentDepartment = this.$defaultContent;

        // this.$defaultContent.imagesLoaded(() => {
        //   this.departmentsHeight = this.$departments.outerHeight();

        //   this.$defaultContent.height(this.departmentsHeight);
        //   this.$collections.height(this.departmentsHeight);
        // });

        this._bindEvents();
        this._setupAccessibility();

        if (this.$body.hasClass('is-mobile')) {
          this._bindMobileEvents();
        }
      }

      NavigationSuper.prototype._bindEvents = function _bindEvents() {
        var _this = this;

        var timeout = undefined;
        var setupDepartmentSwitch = function setupDepartmentSwitch(event) {
          if (!_this.loading) {
            _this.loading = true;
            if ($(event.currentTarget).data('navigation-dropdown-item') === 'default') {
              _this._resetDepartments();
            } else {
              _this._switchDepartments(event);
            }
          }
        };

        this.$departments.on('mouseenter focus', '.navigation-super-department', function (event) {
          timeout = setTimeout(setupDepartmentSwitch.bind(_this, event), 200);
        });

        this.$departments.on('mouseleave blur', '.navigation-super-department', function () {
          clearTimeout(timeout);
        });

        $('.has-super-nav').on('mouseleave blur', function () {
          _this._resetDepartments(null);
        });

        $(window).on('resize', _.debounce(this._setNavContentHeight.bind(this), 100));
      };

      NavigationSuper.prototype._navTriggerOverride = function _navTriggerOverride(event) {
        var $target = $(event.currentTarget),
          targetHandle = $target.data('navigation-dropdown-item');

        if (targetHandle.length) {
          var $collectionNavItem = this.$el.find('[data-navigation-super-collection-parent]').find('#' + targetHandle);
          $collectionNavItem.toggleClass('focused', !$collectionNavItem.hasClass('focused'));

          var $departmentWrapper = $target.closest('[data-navigation-super-department-wrapper]');
          if (!$departmentWrapper.hasClass('active')) {
            if (!this.loading) {
              this.loading = true;
              var $department = $departmentWrapper.children('a');
              this._switchDepartments(null, $department);
            }
          }
        }
      };

      NavigationSuper.prototype._bindMobileEvents = function _bindMobileEvents() {
        var _this2 = this;

        this.$departments.on('click', '[data-navigation-dropdown-item]', function (event) {
          _this2._navTriggerOverride(event);
        });
      };

      NavigationSuper.prototype._setupAccessibility = function _setupAccessibility() {
        var _this3 = this;

        this.$departments.on('focus blur', '[data-navigation-dropdown-item]', function (event) {
          _this3._navTriggerOverride(event);
        });
      };

      NavigationSuper.prototype._switchDepartments = function _switchDepartments(event, $department) {
        var _this4 = this;

        var $target = $department ? $department : $(event.currentTarget);
        var newDepartmentKey = $target.data('navigation-dropdown-item');
        var $newDepartment = this.$collections.find('[data-navigation-super-collection-parent="' + newDepartmentKey + '"]');

        if (newDepartmentKey === 'default' && this.$currentDepartment.is('[data-navigation-super-default]')) {
          this.loading = false;
          return;
        }

        $target.parent().addClass('active').siblings().removeClass('active');

        var $this = this.$collections.find('.visible');

        if ($this.length) {
          $this.addClass('animating').removeClass('visible').one('trend', function () {
            $this.removeClass('animating');
            _this4._loadNewDepartment($newDepartment);
          });
        } else {
          this._loadNewDepartment($newDepartment);
        }
      };

      NavigationSuper.prototype._loadNewDepartment = function _loadNewDepartment($newDepartment) {
        var _this5 = this;

        $newDepartment.addClass('animating').attr('aria-hidden', false);

        this.$currentDepartment = $newDepartment;
        this._setNavContentHeight();

        setTimeout(function () {
          $newDepartment.toggleClass('animating visible');
          _this5.loading = false;
        }, 75);
      };

      NavigationSuper.prototype._resetDepartments = function _resetDepartments() {
        var _this6 = this;

        if (this.$defaultContent.is('.visible')) {
          this.loading = false;
          return;
        }

        this.$departments.find('[data-navigation-super-department-wrapper]').removeClass('active');
        this.$collections.find('.visible').removeClass('visible');

        this.$defaultContent.addClass('animating').one('trend', function () {
          _this6.$defaultContent.addClass('visible').removeClass('animating');
        });

        setTimeout(function () {
          _this6.$currentDepartment.attr('aria-hidden', true);

          _this6.$currentDepartment = _this6.$defaultContent;

          _this6.$currentDepartment.attr('aria-hidden', false);

          _this6._setNavContentHeight();
          _this6.loading = false;
        }, 150);
      };

      NavigationSuper.prototype._setNavContentHeight = function _setNavContentHeight() {
        var newHeight = this.$currentDepartment.outerHeight();

        if (this.$currentDepartment.hasClass('navigation-super-default')) {
          newHeight = this.$currentDepartment.height();
        }

        this.$collections.height(newHeight > this.departmentsHeight ? newHeight : this.departmentsHeight);
      };

      return NavigationSuper;
    })();

    exports['default'] = NavigationSuper;
    module.exports = exports['default'];

  }, {}], 45: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _globalProductProductBadges = require('../global/product/ProductBadges');

    var _globalProductProductBadges2 = _interopRequireDefault(_globalProductProductBadges);

    var ProductItem = (function () {
      function ProductItem(el) {
        _classCallCheck(this, ProductItem);

        this.$window = $(window);
        this.$body = $(document.body);
        this.$el = $(el);
        this.el = el;

        if (this.$el.length) {
          this._setupAccessibility();
          this._setupReviews();
          this._positionDetailsOnHover();
          this.ProductBadges = new _globalProductProductBadges2['default'](el);
        }
      }

      ProductItem.prototype._setupAccessibility = function _setupAccessibility() {
        this.$el.on('focus blur', '*', function (event) {
          var $target = $(event.currentTarget);
          $target.toggleClass('active', !$target.hasClass('active'));
        });
      };

      ProductItem.prototype._setupReviews = function _setupReviews() {
        if (window.SPR) {
          window.SPR.$ = $;
          window.SPR.initDomEls();
          window.SPR.loadBadges();
        }
      };

      ProductItem.prototype._positionDetailsOnHover = function _positionDetailsOnHover() {
        var showOnHover = this.$el.find('.product-item-details').hasClass('show-on-hover');

        if (showOnHover) {
          this.$el.find('[data-product-item]').each(function (i, el) {
            var $badges = $(el).find('.product-item-banners.animated');

            if ($badges.length) {
              var badgesHeight = $badges[0].getBoundingClientRect().height;
              var $productDetails = $(el).find('.product-item-details');
              $productDetails.css('bottom', badgesHeight + 16 + 'px');
            }
          });
        }
      };

      return ProductItem;
    })();

    exports['default'] = ProductItem;
    module.exports = exports['default'];

  }, { "../global/product/ProductBadges": 21 }], 46: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var Search = (function () {
      function Search(el) {
        _classCallCheck(this, Search);

        this.$el = $(el);
        this.el = document.querySelector(el);
        this.$body = $(document.body);

        this.$header = $('[data-header]');
        this.$headerSearch = this.$header.find('.header-search-form-wrapper');
        this.$overlay = this.$header.find('[data-overlay]');

        this.searchInput = this.el.querySelector('#header-search');
        this.searchWrapper = document.querySelector('.header-search-form-wrapper');
        this.isSearchMinimal = this.searchWrapper.classList.contains('header-search-form-style-minimal');
        this.isSearchPredictive = this.searchInput.classList.contains('is-predictive');
        this.$searchResultsWrapper = this.$el.children('[data-header-search-results-wrapper]');
        this.$searchResults = this.$searchResultsWrapper.children('[data-header-search-results]');
        this.$searchPlaceholderLinks = this.$searchResults.html();
        this.$searchResultsWrapper = this.$el.children('[data-header-search-results-wrapper]');
        this.$searchClose = this.$el.find('[data-header-search-results-close]');
        this.$searchClear = this.$el.find('.header-search-clear');
        this.$searchIcon = this.$el.find('.header-search-submit--minimal');
        this.$searchText = this.$el.find('.header-search-text');
        this.loaded = false;
        this.isOpen = false;
        this.speed = 500;
        this.searchTypes = this.searchInput.dataset.searchTypes.replace(/,$/, '');
        this.searchTypesNum = this.searchTypes.split(',').length;
        this.searchHasResults = false;

        // If there is more than 1 search type/group, restrict results to sensible amount.
        this.groupMax = 1;
        if (this.searchTypesNum == 1) this.groupMax = 4; else if (this.searchTypesNum == 2) this.groupMax = 3; else if (this.searchTypesNum == 3) this.groupMax = 2;

        this.showPrices = this.searchInput.dataset.showPrices == 'true';
        this.showVendor = this.searchInput.dataset.showVendor == 'true';

        this.currentSearch = undefined;

        this._bindEvents();
      }

      Search.prototype._bindEvents = function _bindEvents() {
        var _this = this;

        this.$el.on('focus', 'input', function () {
          if (_this.isSearchPredictive) {
            _this._focusSearch();
            _this.isOpen = true;
          }
        });

        this.$body.on('click', function (event) {
          if (!$(event.target).closest('[data-header-search-form]').length && _this.isOpen) {
            _this._blurSearch();
            _this.isOpen = false;
          }
        });

        this.$searchIcon.on('click', function (event) {
          event.preventDefault();
          _this._toggleSearch();
        });

        this.$searchText.on('click', function (event) {
          event.preventDefault();
          _this._toggleSearch();
        });

        this.$searchClear.on('click', function (event) {
          _this.searchInput.value = '';
          _this._focusSearch();
        });

        this.$searchClear.on('keypress', function (event) {
          if (event.which == 13) {
            _this.searchInput.value = '';
            _this.searchInput.focus();
          }
        });

        this.$searchClose.on('click', function (event) {
          _this._blurSearch();
          _this.isOpen = false;
        });

        this.$searchClose.on('keypress', function (event) {
          if (event.keyCode === 13) {
            _this._blurSearch();
            _this.isOpen = false;
          }
        });

        $(window).on('blur', function () {
          if (_this.isOpen) {
            _this._blurSearch();
            _this.isOpen = false;
          }
        });

        var debounceSetup = function debounceSetup(event) {
          event.preventDefault();
          if (event.which <= 90 && event.which >= 48 || event.which == 8) {
            _this._getSearchTerm();
          }
        };

        var self = this;

        this.$el.on('keyup.searchQuery', 'input', _.debounce(debounceSetup, 500));

        this.$el.on('keyup.searchQuery', 'input', function () {
          if (self.searchInput.value.length > 0) {
            self.$searchClear.css('visibility', 'visible');
          } else {
            self.$searchClear.css('visibility', 'hidden');
          }
        });
      };

      Search.prototype._focusSearch = function _focusSearch() {
        if (this.searchInput.value.length > 2 && this.searchHasResults) {
          this.$header.addClass('search-open');
          this.$headerSearch.addClass('active');
          this.$searchResultsWrapper.revealer('show');
        } else {
          this._cancelSearch();
          this.isOpen = false;
        }
      };

      Search.prototype._blurSearch = function _blurSearch() {
        var _this2 = this;

        this.$searchResultsWrapper.revealer('hide');

        setTimeout(function () {
          _this2.$header.removeClass('search-open');
          _this2.$headerSearch.removeClass('active');
          _this2.$body.removeClass('scroll-locked');
        }, this.speed);
      };

      Search.prototype.getSearchQuery = function getSearchQuery() {
        return '/search/suggest.json?q=' + this.searchInput.value + '&resources[type]=' + this.searchTypes;
      };

      Search.prototype.getSearchPageUrlWithQuery = function getSearchPageUrlWithQuery() {
        return '/search?type=' + this.searchTypes + '&q=' + encodeURIComponent(this.searchInput.value) + '*';
      };

      Search.prototype._getSearchTerm = function _getSearchTerm() {
        var _this3 = this;

        this.searchComplete = false;
        this.searchResultsArray = [];

        var query = '';

        if (this.isSearchPredictive) {
          query = this.getSearchQuery();

          if (this.searchInput.value.length > 2) {
            this._performSearch(query);

            setTimeout(function () {
              if (!_this3.$searchResultsWrapper.revealer('isVisible') && _this3.searchHasResults) {
                _this3.$searchResultsWrapper.revealer('show');
              }
            }, this.speed);
          } else {
            this.searchHasResults = false;
            this._cancelSearch();
          }
        } else {
          query = this.getSearchPageUrlWithQuery();
        }
      };

      Search.prototype._performSearch = function _performSearch(query) {
        var _this4 = this;

        var self = this;
        var searchResultsArrayTemp = [];
        this.searchHasResults = false;

        this.currentSearch = $.getJSON(query, function (data) {

          if (data && Object.keys(data.resources.results).length > 0) {

            // Each GROUP e.g. products, pages, articles, collections
            $.each(data.resources.results, function (index, resultGroup) {

              if (resultGroup.length > 0) {
                (function () {

                  // Give products a little more precedence.
                  if (index == 'products' && self.groupMax < 4) {
                    self.groupMax = self.groupMax++;
                  }

                  searchResultsArrayTemp.push('\n              <div class="predictive-search-group">\n                <h2 class="predictive-search-group__title">' + Theme.localization.search[index] + '</h2>\n            ');

                  var itemCount = 0;

                  // Each ITEM e.g. individual product, page etc
                  Object.keys(resultGroup).forEach(function (resultKey) {

                    if (itemCount < self.groupMax) {

                      var result = resultGroup[resultKey];
                      var infoColClass = 'grid-item-100';

                      searchResultsArrayTemp.push('<div class="grid">');

                      if (result.featured_image && result.featured_image.url > '') {
                        infoColClass = 'grid-item-80';

                        searchResultsArrayTemp.push('\n                    <div class="grid-item-20">\n                      <a href="' + result.url + '"><img src="' + result.featured_image.url + '" alt="' + result.featured_image.alt + '" /></a>\n                    </div>\n                  ');
                      }

                      searchResultsArrayTemp.push('<div class="' + infoColClass + '">');

                      if (self.showVendor && result.vendor) {
                        searchResultsArrayTemp.push('<div class="predictive-search__vendor">' + result.vendor + '</div>');
                      }

                      searchResultsArrayTemp.push('<h5 class="predictive-search__item-title"><a href="' + result.url + '">' + result.title + '</a></h5>');

                      if (!result.available && index == 'products') {
                        searchResultsArrayTemp.push('<div class="predictive-search__soldout">' + Theme.localization.product.soldOut + '</div>');
                      }

                      if (self.showPrices && result.price) {
                        searchResultsArrayTemp.push('<div class="predictive-search__price">' + Shopify.formatMoney(result.price, Theme.moneyFormat) + '</div>');
                      }

                      searchResultsArrayTemp.push('</div></div>'); // Close .grid, infoColClass
                      searchResultsArrayTemp.push('<span class="search-result-separator"><hr /></span>');

                      itemCount = itemCount + 1;
                    }
                  });

                  searchResultsArrayTemp.push('\n                </div>\n              </div>\n            ');

                  _this4.searchHasResults = true;
                  _this4.searchComplete = true;
                })();
              }
            });

            var viewAll = searchResultsArrayTemp.length > 1 ? '<div class="predictive-search__viewall"><a href="' + _this4.getSearchPageUrlWithQuery() + '">' + Theme.localization.search.viewAll + '</a></div>' : '';

            if (searchResultsArrayTemp.length) {
              _this4.searchResultsArray.push('\n            ' + searchResultsArrayTemp.join('') + '\n            ' + viewAll + '\n          ');
            }

            if (_this4.searchComplete && _this4.searchHasResults) {
              _this4._openResultsPanel();
            } else {
              _this4._cancelSearch();
            }
          }
        });
      };

      Search.prototype._cancelSearch = function _cancelSearch() {
        if (this.currentSearch) {
          this.currentSearch.abort();
        }
        this.$searchResults.html('');
        this.$searchResults.removeAttr('class'); // removeClass 'visible' did not work
        this.$searchResultsWrapper.removeClass('visible');
        this.$searchClose.removeClass('visible');
        this.searchHasResults = false;
      };

      Search.prototype._openResultsPanel = function _openResultsPanel() {
        this.$searchResults.html('' + this.searchResultsArray.join(''));
        this.$searchResults.addClass('visible');
        this.$searchResultsWrapper.addClass('visible');
        this.$searchClose.addClass('visible');
      };

      Search.prototype._toggleSearch = function _toggleSearch() {
        if (this.isSearchMinimal) {
          var searchText = document.querySelector('.header-search-text');

          // If search is already open then close it, otherwise open search
          if (searchText.classList.contains('hidden')) {
            searchText.classList.remove('hidden');
            this.searchInput.classList.add('hidden');
            this.$searchClear.css('visibility', 'hidden');
            this._blurSearch();
            this.searchInput.blur();
          } else {
            if (this.searchInput.value.length > 0) {
              this.$searchClear.css('visibility', 'visible');
            }
            this.searchInput.classList.remove('hidden');
            searchText.classList.add('hidden');
            this.searchInput.focus();
            this._focusSearch();
          }
        }
      };

      return Search;
    })();

    exports['default'] = Search;
    module.exports = exports['default'];

  }, {}], 47: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var Account = (function () {
      function Account(el) {
        _classCallCheck(this, Account);

        this.$el = $(el);
        this._bindEvents();

        if ($(document.body).hasClass('template-addresses')) {
          this._setupProvinceSelectors();
        }

        if (window.location.hash === '#recover') {
          this._toggleResetPasswordForm();
        }
      }

      Account.prototype._bindEvents = function _bindEvents() {
        var _this = this;

        this.$el.on('click', '[data-account-reset-password-toggle]', function (event) {
          event.preventDefault();
          _this._toggleResetPasswordForm();
        });

        this.$el.on('click', '[data-addresses-new-toggle]', function (event) {
          event.preventDefault();
          _this._toggleNewAddressForm();
        });

        this.$el.on('click', '[data-address-edit-toggle]', function (event) {
          event.preventDefault();
          _this._toggleEditAddressForm(event);
        });

        this.$el.on('click', '[data-address-delete]', function (event) {
          event.preventDefault();
          _this._deleteAddress(event);
        });

        this.$el.find('[data-address-country-select]').on('change', function (event) {
          _this._prependSelect(event);
        });
      };

      Account.prototype._toggleResetPasswordForm = function _toggleResetPasswordForm() {
        var $login = this.$el.find('[data-account-login]');
        var $resetPassword = this.$el.find('[data-account-reset-password]');

        window.location.hash = '#recover';

        $resetPassword.add($login).toggleClass('visible');

        if ($resetPassword.hasClass('visible')) {
          $resetPassword.find('.form-input').focus();
        } else {
          $login.find('.form-input').first().focus();
          window.location.hash = '';
        }
      };

      Account.prototype._toggleNewAddressForm = function _toggleNewAddressForm() {
        this.$el.find('[data-addresses]').add(this.$el.find('[data-addresses-new]')).toggleClass('visible');
      };

      Account.prototype._toggleEditAddressForm = function _toggleEditAddressForm(event) {
        var addressId = $(event.currentTarget).data('address-id');

        this.$el.find('[data-addresses]').add(this.$el.find('[data-addresses-edit]')).toggleClass('visible');

        this.$el.find('#address_form_' + addressId).toggleClass('visible').siblings().removeClass('visible');
      };

      Account.prototype._deleteAddress = function _deleteAddress(event) {
        var addressId = $(event.currentTarget).data('address-id');

        Shopify.CustomerAddress.destroy = function (addressId, confirm_msg) {
          if (confirm(confirm_msg || Theme.localization.account.addressConfirmDelete)) {
            Shopify.postLink('/account/addresses/' + addressId, { 'parameters': { '_method': 'delete' } });
          }
        };
      };

      Account.prototype._setupProvinceSelectors = function _setupProvinceSelectors() {
        new Shopify.CountryProvinceSelector('address-country-new', 'address-province-new', {
          hideElement: 'address-province-new-wrapper'
        });

        var $addressEditForm = this.$el.find('.address-edit-form');

        $addressEditForm.each(function (index, element) {
          var addressId = $(element).children('[data-address-id]').data('address-id');

          new Shopify.CountryProvinceSelector('address-country-' + addressId, 'address-province-' + addressId, {
            hideElement: 'address-province-' + addressId + '-wrapper'
          });
        });
      };

      return Account;
    })();

    exports['default'] = Account;
    module.exports = exports['default'];

  }, {}], 48: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var Blog = function Blog(el) {
      var _this = this;

      _classCallCheck(this, Blog);

      this.$el = $(el);

      this.$el.allLazyLoaded().on('containerlazyloaded', function () {
        _this.$el.masonry({
          itemSelector: '[data-blog-item]',
          transitionDuration: 0
        });
      });
    };

    exports['default'] = Blog;
    module.exports = exports['default'];

  }, {}], 49: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _globalProductRecentlyViewed = require('../global/product/RecentlyViewed');

    var _globalProductRecentlyViewed2 = _interopRequireDefault(_globalProductRecentlyViewed);

    var Cart = (function () {
      function Cart(el) {
        _classCallCheck(this, Cart);

        this.$el = $(el);

        if (this.$el.find('[data-shipping]').length) {
          this.$shipping = this.$el.find('[data-shipping]');
          this.$shippingButton = this.$shipping.find('[data-shipping-rates-submit]');

          this._initShipping();
          this._bindShippingEvents();
        }

        if ($('[data-products-recent-wrapper]').length) {
          new _globalProductRecentlyViewed2['default']('[data-products-recent-wrapper]');
        }

        this._bindEvents();
      }

      Cart.prototype._bindEvents = function _bindEvents() {
        var _this = this;

        this.$el.on('click', '[data-cart-module-toggle]', function (event) {
          event.preventDefault();
          _this._toggleModule(event);
        });

        this.$el.on('click', '[data-cart-item-quantity-edit]:not(.active)', function (event) {
          event.preventDefault();
          _this._focusQuantityInput(event);
        });

        this.$el.on('click', '[data-cart-item-quantity-edit].active', function (event) {
          event.preventDefault();
          _this._updateCart();
        });

        this.$el.on('click', '.qty-selector__btn', function (event) {
          _this._updateQuantity(event);
        });
      };

      Cart.prototype._bindShippingEvents = function _bindShippingEvents() {
        var _this2 = this;

        this.$shippingButton.on('click', function (event) {
          event.preventDefault();
          _this2._getShippingRates();
        });

        this.$shipping.on('change', '[data-shipping-country]', function (event) {
          _this2._updateProvince('[data-shipping-province]');
        });

        this.$el.on('click', '[data-cart-module-toggle]', function (event) {
          _this2.$shipping.find('[data-shipping-country]').trigger('change');
        });

        Shopify.onError = function (XMLHttpRequest) {
          _this2._handleErrors(XMLHttpRequest);
        };
      };

      Cart.prototype._focusQuantityInput = function _focusQuantityInput(event) {
        var $target = $(event.currentTarget);
        var quantityInput = $target.closest('.cart-item-price').find('.cart-item-quantity');
        $target.addClass('active').text($target.data('text-update'));
        quantityInput.select();
      };

      Cart.prototype._updateQuantity = function _updateQuantity(event) {
        var quantity = $(event.currentTarget).closest('.qty-selector').find('[data-cart-quantity]');

        if ($(event.currentTarget).hasClass('qty-selector__btn--add')) {
          quantity.val(+quantity.val() + 1);
        } else if ($(event.currentTarget).hasClass('qty-selector__btn--minus') && quantity.val() > 1) {
          quantity.val(+quantity.val() - 1);
        }
      };

      Cart.prototype._updateCart = function _updateCart() {
        this.$el.find('[data-cart-update]').trigger('click');
      };

      Cart.prototype._initShipping = function _initShipping() {
        this.shippingStrings = Theme.localization.cart.shipping;

        Shopify.Cart.ShippingCalculator.show({
          submitButton: this.shippingStrings.submit,
          submitButtonDisabled: this.shippingStrings.calculating,
          customerIsLoggedIn: Theme.hasCustomer,
          moneyFormat: Theme.moneyFormat
        });
      };

      Cart.prototype._getShippingRates = function _getShippingRates() {
        var _this3 = this;

        this.$shippingButton.val(this.shippingStrings.calculating);

        this.$response = this.$shipping.find('[data-shipping-response]');
        this.$response.empty().append('<p class="shipping-message" data-shipping-message /><ul class="shipping-rates" data-shipping-rates />');

        var shippingAddress = {};
        shippingAddress.zip = this.$shipping.find('[data-shipping-zip]').val() || '';
        shippingAddress.country = this.$shipping.find('[data-shipping-country]').val() || '';
        shippingAddress.province = this.$shipping.find('[data-shipping-province]').val() || '';

        Shopify.getCartShippingRatesForDestination(shippingAddress, function (rates) {
          var address = undefined;
          if (shippingAddress.zip.length) address = shippingAddress.zip;
          if (shippingAddress.province.length) address = address + ', ' + shippingAddress.province;
          if (shippingAddress.country.length) address = address + ', ' + shippingAddress.country;

          var response = undefined;
          if (rates.length > 1) {
            var firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);
            response = _this3.shippingStrings.rateMultiple.replace('*address*', address).replace('*number_of_rates*', rates.length).replace('*rate*', '<span class="money">' + firstRate + '</span>');
          } else if (rates.length === 1) {
            response = _this3.shippingStrings.rate.replace('*address*', address);
          } else {
            response = _this3.shippingStrings.rateEmpty;
          }

          _this3.$response.find('[data-shipping-message]').html(response);

          $.each(rates, function (index, rate) {
            var price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
            var rateValues = _this3.shippingStrings.rateValues.replace('*rate_title*', rate.name).replace('*rate*', '<span class="money">' + price + '</span>');
            _this3.$shipping.find('[data-shipping-rates]').append('<li>' + rateValues + '</li>');
          });

          _this3.$shippingButton.val(_this3.shippingStrings.submit);
        });
      };

      Cart.prototype._updateProvince = function _updateProvince(select) {
        var $select = $(select);
        var selectedVariant = $select.find('option:selected').val();
        $select.prev('.selected-text').text(selectedVariant);
      };

      Cart.prototype._handleErrors = function _handleErrors(errors) {
        var $rates = this.$response.find('[data-shipping-rates]');
        $rates.empty();
        errors = $.parseJSON(errors.responseText);

        $.each(errors, function (index, value) {
          var error = index + ' ' + value;
          $rates.append('<li>' + error + '</li>');
        });

        this.$shippingButton.val(this.shippingStrings.submit);
      };

      Cart.prototype._toggleModule = function _toggleModule(event) {
        var $target = $(event.currentTarget);

        $target.closest('[data-cart-module]').toggleClass('active').siblings('[data-cart-module]').removeClass('active');
      };

      return Cart;
    })();

    exports['default'] = Cart;
    module.exports = exports['default'];

  }, { "../global/product/RecentlyViewed": 24 }], 50: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _collectionFilters = require('../collection/Filters');

    var _collectionFilters2 = _interopRequireDefault(_collectionFilters);

    var Collection = (function () {
      function Collection(el) {
        _classCallCheck(this, Collection);

        this.$el = $(el);
        this.$collection = this.$el.find('[data-collection]');

        new _collectionFilters2['default']('[data-collection-filters]', this.$collection.data('collection'));

        this._bindEvents();
        this._customFilters();
      }

      Collection.prototype._bindEvents = function _bindEvents() {
        var _this = this;

        $('.medium .collection-sort').on('change', 'select', function (event) {
          _this._sortProducts(event);
        });
      };

      Collection.prototype._sortProducts = function _sortProducts(event) {
        var Sorting = {};
        Sorting.sort_by = this.$el.find('.medium .collection-sort select').val();

        if ($(event.currentTarget).closest('.collection-sort').hasClass('vendor-page')) {
          (function () {
            var currentSearch = location.search;
            var searchParts = currentSearch.split('&');

            $.each(searchParts, function (index, part) {
              if (part.indexOf('sort_by') !== -1) {
                searchParts.splice(index, 1);
              }
            });

            var search = searchParts.join('&');
            location.search = search + '&' + jQuery.param(Sorting);
          })();
        } else {
          location.search = jQuery.param(Sorting);
        }
      };

      Collection.prototype._customFilters = function _customFilters() {
        var _this2 = this;

        var allTags = document.getElementById("wetheme-collection-all-tags");
        var customTags = document.getElementById("wetheme-collection-custom-tags");

        if (allTags && customTags) {
          var allTagsArray = JSON.parse(allTags.textContent).all_collection_tags;
          var customTagsJSON = JSON.parse(customTags.textContent);
          var allTagsLowercase = [];

          for (var i = 0; i < allTagsArray.length; i++) {
            allTagsLowercase.push(allTagsArray[i].toLowerCase());
          }

          // Each group.
          $.each(customTagsJSON, function (index_group, custom_tag_group) {
            var num_hidden = 0;
            var custom_tags = custom_tag_group.custom_tags;

            // Each tag within group.
            $.each(custom_tags, function (index_tag, custom_tag) {

              if (!allTagsLowercase.includes(custom_tag.toLowerCase())) {
                $('.form-filter-wrapper.' + _this2._slugify(custom_tag)).hide();
                num_hidden++;
              }

              // If all tags in a group are hidden, hide the title of the group too.
              if (num_hidden == custom_tags.length) {
                var group_num = Number(index_group.replace('block-', '') - 1);
                $('.collection-sidebar-filter:eq(' + group_num + ')').hide();
              }
            });
          });
        }
      };

      Collection.prototype._slugify = function _slugify(text) {
        return text.toString() // Cast to string
          .toLowerCase() // Convert the string to lowercase letters
          .normalize('NFD') // Returns the Unicode Normalization Form of a given string.
          .trim() // Remove whitespace from both sides of a string
          .replace(/\s+/g, '-') // Replace spaces with -
          .replace(/[^\w\-]+/g, '-') // eslint-disable-line
          .replace(/\-\-+/g, '-') // eslint-disable-line
          .replace(/^-/g, '') // Replace - at beginning of string with ''
          .replace(/-$/g, ''); // Replace - at end of string with ''
      };

      return Collection;
    })();

    exports['default'] = Collection;
    module.exports = exports['default'];

  }, { "../collection/Filters": 10 }], 51: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _sectionsVideo = require('../sections/Video');

    var _sectionsVideo2 = _interopRequireDefault(_sectionsVideo);

    var _sectionsVideoHero = require('../sections/VideoHero');

    var _sectionsVideoHero2 = _interopRequireDefault(_sectionsVideoHero);

    var _sectionsDepartments = require('../sections/Departments');

    var _sectionsDepartments2 = _interopRequireDefault(_sectionsDepartments);

    var _sectionsFeaturedProducts = require('../sections/FeaturedProducts');

    var _sectionsFeaturedProducts2 = _interopRequireDefault(_sectionsFeaturedProducts);

    var _sectionsShopTheLook = require('../sections/ShopTheLook');

    var _sectionsShopTheLook2 = _interopRequireDefault(_sectionsShopTheLook);

    var _sectionsMap = require('../sections/Map');

    var _sectionsMap2 = _interopRequireDefault(_sectionsMap);

    var _globalProductProductUtils = require('../global/product/ProductUtils');

    var _globalProductProductUtils2 = _interopRequireDefault(_globalProductProductUtils);

    var _snippetsProductItem = require('../snippets/ProductItem');

    var _snippetsProductItem2 = _interopRequireDefault(_snippetsProductItem);

    var _sectionsSlidingText = require('../sections/SlidingText');

    var _sectionsSlidingText2 = _interopRequireDefault(_sectionsSlidingText);

    var _sectionsImageWithTextOverlay = require('../sections/ImageWithTextOverlay');

    var _sectionsImageWithTextOverlay2 = _interopRequireDefault(_sectionsImageWithTextOverlay);

    var Home = (function () {
      function Home() {
        _classCallCheck(this, Home);

        this.initDepartments();
        this.initCollectionSlider();
        this.initVideo();
        this.initVideoHero();
        this.initMaps();
        this.initFeaturedProduct();
        this.initSlidingText();
        this.initImageWithTextOverlay();
        this.initShopTheLook();
      }

      Home.prototype.initDepartments = function initDepartments() {
        var $departments = $('[data-departments-slideshow]');
        if ($departments.length) {
          $departments.each(function (i, el) {
            new _sectionsDepartments2['default'](el);
          });
        }
      };

      Home.prototype.initCollectionSlider = function initCollectionSlider() {
        var $featuredProducts = $('[data-section-child="featured-products"]');
        if ($featuredProducts.length) {
          $featuredProducts.each(function (i, el) {
            new _sectionsFeaturedProducts2['default'](el);
          });
        }
      };

      Home.prototype.initVideo = function initVideo(sectionId) {
        var _this = this;

        if (sectionId) {
          this.videos[sectionId] = new _sectionsVideo2['default']($('[data-section-id="' + sectionId + '"]'));
        } else {
          this.videos = this.videos ? this.videos : {};
          var $video = $('[data-video]');
          if ($video.length) {
            $video.each(function (i, el) {
              var id = $(el).data('section-id');
              _this.videos[id] = new _sectionsVideo2['default'](el);
            });
          }
        }
      };

      Home.prototype.initVideoHero = function initVideoHero(sectionId) {
        var _this2 = this;

        if (sectionId) {
          this.videoheroes[sectionId] = new _sectionsVideoHero2['default']($('[data-section-id="' + sectionId + '"]'));
        } else {
          this.videoheroes = this.videoheroes ? this.videoheroes : {};
          var $video = $('[data-video-hero]');
          if ($video.length) {
            $video.each(function (i, el) {
              var id = $(el).data('section-id');
              _this2.videoheroes[id] = new _sectionsVideoHero2['default'](el);
            });
          }
        }
      };

      Home.prototype.initMaps = function initMaps(sectionId) {
        if (this.maps) {
          this.maps.buildMap('[data-section-id="' + sectionId + '"]');
        } else {
          var $map = $('[data-section-child="map"]');
          var $loadMap = $('[data-map-loadMap]');
          if ($map.length && $loadMap.length) {
            this.maps = new _sectionsMap2['default']('[data-section-child="map"]');
          }
        }
      };

      Home.prototype.initFeaturedProduct = function initFeaturedProduct(sectionId) {
        var _this3 = this;

        if (sectionId) {
          this.products[sectionId] = new _globalProductProductUtils2['default']($('[data-section-id="' + sectionId + '"]')[0], 'home');
          new _snippetsProductItem2['default']($('[data-section-id="' + sectionId + '"]')[0]);
        } else {
          this.products = this.products ? this.products : {};
          var $product = $('[data-section-child="featured-product"]');
          if ($product.length) {
            $product.each(function (i, el) {
              var id = $(el).data('section-id');
              _this3.products[id] = new _globalProductProductUtils2['default'](el, 'home');
              new _snippetsProductItem2['default'](el);
            });
          }
        }
      };

      Home.prototype.initShopTheLook = function initShopTheLook(sectionId) {
        var $shopTheLooks = $('[data-section-child="shop-the-look"]');
        if ($shopTheLooks.length) {
          $shopTheLooks.each(function (i, el) {
            new _sectionsShopTheLook2['default'](el);
          });
        }
      };

      Home.prototype.initSlidingText = function initSlidingText(sectionId) {
        var $slidingTexts = $('[data-section-child="sliding-text"]');
        if ($slidingTexts.length) {
          $slidingTexts.each(function (i, el) {
            new _sectionsSlidingText2['default'](el);
          });
        }
      };

      Home.prototype.unloadFeaturedProduct = function unloadFeaturedProduct(sectionId) {
        this.products[sectionId].unload();
      };

      Home.prototype.initImageWithTextOverlay = function initImageWithTextOverlay(sectionId) {
        var $imageWithTextOverlay = $('[data-section-child="image-with-text-overlay"]');
        if ($imageWithTextOverlay.length) {
          $imageWithTextOverlay.each(function (i, el) {
            new _sectionsImageWithTextOverlay2['default'](el);
          });
        }
      };

      return Home;
    })();

    exports['default'] = Home;
    module.exports = exports['default'];

  }, { "../global/product/ProductUtils": 23, "../sections/Departments": 26, "../sections/FeaturedProducts": 27, "../sections/ImageWithTextOverlay": 28, "../sections/Map": 29, "../sections/ShopTheLook": 31, "../sections/SlidingText": 33, "../sections/Video": 34, "../sections/VideoHero": 35, "../snippets/ProductItem": 45 }], 52: [function (require, module, exports) {
    'use strict';

    exports.__esModule = true;

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var _globalProductProductUtils = require('../global/product/ProductUtils');

    var _globalProductProductUtils2 = _interopRequireDefault(_globalProductProductUtils);

    var _globalProductRecentlyViewed = require('../global/product/RecentlyViewed');

    var _globalProductRecentlyViewed2 = _interopRequireDefault(_globalProductRecentlyViewed);

    var _sectionsProductRecommendations = require('../sections/ProductRecommendations');

    var _sectionsProductRecommendations2 = _interopRequireDefault(_sectionsProductRecommendations);

    var _globalProductProductBadges = require('../global/product/ProductBadges');

    var _globalProductProductBadges2 = _interopRequireDefault(_globalProductProductBadges);

    var Product = function Product(el) {
      _classCallCheck(this, Product);

      if (!el) return;
      this.el = el;
      this.$el = $(this.el);
      this.ProductUtils = new _globalProductProductUtils2['default'](el);
      this.ProductRecommendations = new _sectionsProductRecommendations2['default']();
      this.ProductBadges = new _globalProductProductBadges2['default'](el);

      if ($('[data-products-recent-wrapper]').length) {
        new _globalProductRecentlyViewed2['default']('[data-products-recent-wrapper]');
      }
    };

    exports['default'] = Product;
    module.exports = exports['default'];

  }, { "../global/product/ProductBadges": 21, "../global/product/ProductUtils": 23, "../global/product/RecentlyViewed": 24, "../sections/ProductRecommendations": 30 }]
}, {}, [9]);
